export default [
  {
    id: 0,
    user_face: "0-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 21:53:41 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "532",
  },
  {
    id: 1,
    user_face: "1-user-face.png",
    user_id: "CHANELv",
    is_op: false,
    create_at: "2022-11-26 20:07:36 澳大利亚",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "来啦来啦",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 2,
    user_face: "2-user-face.png",
    user_id: "UPUP",
    is_op: false,
    create_at: "2022-11-26 20:09:23 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "男女都在一个场地打球，但比赛时间应该是分开的。\n赛制是奥运团体赛制就是第一盘双打",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "82",
  },
  {
    id: 3,
    user_face: "3-user-face.png",
    user_id: "我不叫momo",
    is_op: false,
    create_at: "2022-11-26 20:12:09 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "男女队各自大循环。。。大循环后去积分前四的队伍进第二阶段。。。第二阶段两两淘汰制。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "34",
  },
  {
    id: 4,
    user_face: "4-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-11-26 20:25:28 上海",
    quote: {
      quote_status: true,
      quote_content:
        "男女都在一个场地打球，但比赛时间应该是分开的。\n赛制是奥运团体赛制就是第一盘双打",
      quote_user_id: "UPUP",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "那少了好多乐子。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 5,
    user_face: "5-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-11-26 20:25:34 上海",
    quote: {
      quote_status: true,
      quote_content:
        "男女队各自大循环。。。大循环后去积分前四的队伍进第二阶段。。。第二阶段两两淘汰制。。。",
      quote_user_id: "我不叫momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "谢谢哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 6,
    user_face: "6-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 13:50:46 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "d",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 7,
    user_face: "7-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 13:51:17 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "如果不算。。。那她就出来讲了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "49",
  },
  {
    id: 8,
    user_face: "8-user-face.png",
    user_id: "mоmо",
    is_op: false,
    create_at: "2022-12-28 13:51:38 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "俺觉得不算。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 9,
    user_face: "9-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 13:51:53 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "完全不算。。哥哥等你。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "77",
  },
  {
    id: 10,
    user_face: "10-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 13:52:06 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "想看。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 11,
    user_face: "11-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 13:53:56 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 12,
    user_face: "12-user-face.png",
    user_id: "范丞丞",
    is_op: false,
    create_at: "2022-12-28 13:54:13 日本",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算。。吧。。。让我听听👂🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 13,
    user_face: "13-user-face.png",
    user_id: "再说吧",
    is_op: false,
    create_at: "2022-12-28 13:54:21 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 14,
    user_face: "14-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-28 13:54:42 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "🥺👉👈这种乐子怎么能算呢（我也不知道后面来的哥哥说一下算不算）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "172",
  },
  {
    id: 15,
    user_face: "15-user-face.png",
    user_id: "Accio Felix",
    is_op: false,
    create_at: "2022-12-28 13:54:48 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不知道算不算。。。但是想看。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 16,
    user_face: "16-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 13:57:11 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "👂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 17,
    user_face: "17-user-face.png",
    user_id: "Wardo",
    is_op: false,
    create_at: "2022-12-28 13:57:11 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快更。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 18,
    user_face: "18-user-face.png",
    user_id: "脸滚键盘",
    is_op: false,
    create_at: "2022-12-28 13:58:04 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我来蹲下",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 19,
    user_face: "19-user-face.png",
    user_id: "最迷人班长",
    is_op: false,
    create_at: "2022-12-28 13:58:22 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算吧。。。。。让我听听求求了。。。👉🏻👈🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 20,
    user_face: "20-user-face.png",
    user_id: "富得流油007",
    is_op: false,
    create_at: "2022-12-28 13:58:50 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "乐子人火速赶到",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 21,
    user_face: "21-user-face.png",
    user_id: "张家族长(已婚",
    is_op: false,
    create_at: "2022-12-28 13:58:56 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 22,
    user_face: "22-user-face.png",
    user_id: "yzbwly",
    is_op: false,
    create_at: "2022-12-28 13:59:27 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 23,
    user_face: "23-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 13:59:28 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算！！！快更！！！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "222",
  },
  {
    id: 24,
    user_face: "24-user-face.png",
    user_id: "。",
    is_op: false,
    create_at: "2022-12-28 14:00:25 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我要看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 25,
    user_face: "25-user-face.png",
    user_id: "顿顿火锅🍲",
    is_op: false,
    create_at: "2022-12-28 14:00:26 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 26,
    user_face: "26-user-face.png",
    user_id: "宋亚轩(毛绒版)",
    is_op: false,
    create_at: "2022-12-28 14:00:56 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算吧。。。rwkk",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 27,
    user_face: "27-user-face.png",
    user_id: "说什么妖蛾子",
    is_op: false,
    create_at: "2022-12-28 14:01:02 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "一分钟内也就进了这个帖子三次吧。。。哥哥，速。。。球球了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "222",
  },
  {
    id: 28,
    user_face: "28-user-face.png",
    user_id: "钕童艺梅",
    is_op: false,
    create_at: "2022-12-28 14:01:18 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 29,
    user_face: "29-user-face.png",
    user_id: "归",
    is_op: false,
    create_at: "2022-12-28 14:01:20 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快说啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 30,
    user_face: "30-user-face.png",
    user_id: "四五四六",
    is_op: false,
    create_at: "2022-12-28 14:01:45 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快说",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 31,
    user_face: "31-user-face.png",
    user_id: "四五四六",
    is_op: false,
    create_at: "2022-12-28 14:01:53 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我看乐子等不了明天",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "31",
  },
  {
    id: 32,
    user_face: "32-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-28 14:02:00 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🉑️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 33,
    user_face: "33-user-face.png",
    user_id: "累的半死",
    is_op: false,
    create_at: "2022-12-28 14:02:13 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快说求你了🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 34,
    user_face: "34-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:03:48 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。别吊胃口了。。。。。速速",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 35,
    user_face: "35-user-face.png",
    user_id: "sweetnothing",
    is_op: false,
    create_at: "2022-12-28 14:04:07 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快说。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 36,
    user_face: "36-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:04:13 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我想听听",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 37,
    user_face: "37-user-face.png",
    user_id: "叮叮",
    is_op: false,
    create_at: "2022-12-28 14:04:35 内蒙古",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 38,
    user_face: "38-user-face.png",
    user_id: "TNT-风销销",
    is_op: false,
    create_at: "2022-12-28 14:05:55 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。请讲。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 39,
    user_face: "39-user-face.png",
    user_id: "躲躲匆匆喝乌龙",
    is_op: false,
    create_at: "2022-12-28 14:06:36 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快说快说",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 40,
    user_face: "40-user-face.png",
    user_id: "嘻嘻",
    is_op: false,
    create_at: "2022-12-28 14:06:45 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "求你了。。想听。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 41,
    user_face: "41-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:07:04 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我想听",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 42,
    user_face: "42-user-face.png",
    user_id: "归海一刀🥷",
    is_op: false,
    create_at: "2022-12-28 14:07:13 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "这明明磕死我了 怎么算呢",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 43,
    user_face: "43-user-face.png",
    user_id: "拆拆礼拜天",
    is_op: false,
    create_at: "2022-12-28 14:07:14 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快啊哥哥。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 44,
    user_face: "44-user-face.png",
    user_id: "斑点狗",
    is_op: false,
    create_at: "2022-12-28 14:07:15 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 45,
    user_face: "45-user-face.png",
    user_id: "蒂特洛伊木马",
    is_op: false,
    create_at: "2022-12-28 14:07:27 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。。。。快发。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 46,
    user_face: "46-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-28 14:07:44 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "乐子人来咯。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 47,
    user_face: "47-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-28 14:08:04 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "👂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 48,
    user_face: "48-user-face.png",
    user_id: "工藤新1️⃣",
    is_op: false,
    create_at: "2022-12-28 14:08:21 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算 我喜欢听 多来点",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 49,
    user_face: "49-user-face.png",
    user_id: "菩萨兵（已拔枪",
    is_op: false,
    create_at: "2022-12-28 14:08:23 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "让我听听。。让我听听。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 50,
    user_face: "50-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:08:47 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "让我听听。。。。求你哥哥。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 51,
    user_face: "51-user-face.png",
    user_id: "江瑚骗子",
    is_op: false,
    create_at: "2022-12-28 14:08:50 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "😋😋😋快喂饭。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 52,
    user_face: "52-user-face.png",
    user_id: "奥雷里亚糯不糯",
    is_op: false,
    create_at: "2022-12-28 14:09:56 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 53,
    user_face: "53-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-28 14:10:27 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈。。。。多来点。。。我爱看。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 54,
    user_face: "54-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 14:12:02 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "我朋友说的。。。她正在快速码字。。。哥哥们等等。。。有些故事。。。太细节了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "180",
  },
  {
    id: 55,
    user_face: "55-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:12:41 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算哥哥快开！！！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 56,
    user_face: "56-user-face.png",
    user_id: "张婧怡（期末版",
    is_op: false,
    create_at: "2022-12-28 14:14:00 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 57,
    user_face: "57-user-face.png",
    user_id: ".",
    is_op: false,
    create_at: "2022-12-28 14:14:27 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 58,
    user_face: "58-user-face.png",
    user_id: "可乐要加冰！",
    is_op: false,
    create_at: "2022-12-28 14:16:29 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 59,
    user_face: "59-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:18:23 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 60,
    user_face: "60-user-face.png",
    user_id: "想吃红烧肉",
    is_op: false,
    create_at: "2022-12-28 14:20:34 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 61,
    user_face: "61-user-face.png",
    user_id: "Tethys💫",
    is_op: false,
    create_at: "2022-12-28 14:22:09 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "放个屁股",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 62,
    user_face: "62-user-face.png",
    user_id: "不粘人豆包",
    is_op: false,
    create_at: "2022-12-28 14:23:12 广西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "优雅置臀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 63,
    user_face: "63-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:24:23 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 64,
    user_face: "64-user-face.png",
    user_id: "邢鹿男",
    is_op: false,
    create_at: "2022-12-28 14:24:47 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "唱红日我笑出猪叫",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 65,
    user_face: "65-user-face.png",
    user_id: "拉 微",
    is_op: false,
    create_at: "2022-12-28 14:25:21 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 66,
    user_face: "66-user-face.png",
    user_id: "樱桃肉丸丸-",
    is_op: false,
    create_at: "2022-12-28 14:26:43 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "👂🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 67,
    user_face: "67-user-face.png",
    user_id: "TFBOYS-管国林",
    is_op: false,
    create_at: "2022-12-28 14:30:40 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "置臀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 68,
    user_face: "68-user-face.png",
    user_id: "珠三角在逃杰瑞",
    is_op: false,
    create_at: "2022-12-28 14:31:29 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 69,
    user_face: "69-user-face.png",
    user_id: "toto",
    is_op: false,
    create_at: "2022-12-28 14:32:56 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 70,
    user_face: "70-user-face.png",
    user_id: "柠檬挞",
    is_op: false,
    create_at: "2022-12-28 14:35:00 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 71,
    user_face: "71-user-face.png",
    user_id: "榴莲小姐",
    is_op: false,
    create_at: "2022-12-28 14:38:27 美国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 72,
    user_face: "72-user-face.png",
    user_id: "樱桃肉丸丸-",
    is_op: false,
    create_at: "2022-12-28 14:39:18 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "👂🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 73,
    user_face: "73-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:39:36 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算。。。我爱听。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 74,
    user_face: "74-user-face.png",
    user_id: "🍰",
    is_op: false,
    create_at: "2022-12-28 14:45:57 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 75,
    user_face: "75-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-28 14:47:34 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "随便来点“暴躁蟹姐”。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "242",
  },
  {
    id: 76,
    user_face: "76-user-face.png",
    user_id: "mojo",
    is_op: false,
    create_at: "2022-12-28 14:47:46 甘肃",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 77,
    user_face: "77-user-face.png",
    user_id: "高太太",
    is_op: false,
    create_at: "2022-12-28 14:47:49 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "红日真的笑死。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 78,
    user_face: "78-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:47:54 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 79,
    user_face: "79-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-28 14:48:12 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "产姐暴怒。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "281",
  },
  {
    id: 80,
    user_face: "80-user-face.png",
    user_id: "MBWS*",
    is_op: false,
    create_at: "2022-12-28 14:49:41 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "d",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 81,
    user_face: "81-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 14:50:19 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算吧。。。想听👂🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 82,
    user_face: "82-user-face.png",
    user_id: "不想被人发现",
    is_op: false,
    create_at: "2022-12-28 14:50:40 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 83,
    user_face: "83-user-face.png",
    user_id: "没人替你上班",
    is_op: false,
    create_at: "2022-12-28 14:57:55 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 84,
    user_face: "84-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 14:58:46 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "都是我朋友说的。。。和我没有关系。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "118",
  },
  {
    id: 85,
    user_face: "85-user-face.png",
    user_id: "糖醋橙子",
    is_op: false,
    create_at: "2022-12-28 14:59:59 江苏",
    quote: {
      quote_status: true,
      quote_content: "都是我朋友说的。。。和我没有关系。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "85-quote.png",
      },
    },
    cmt: {
      cmt_content: "但是我记得彩虹鞋是问了造型师的 造型师说是他们两自己搭的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "338",
  },
  {
    id: 86,
    user_face: "86-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:00:26 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "我朋友本来想和大家骂骂给子。。。分享一下自己的初恋追星被wjk按头嗑药。。。但是小作文一写起来就停不下来了。。。忍不住和大家复盘了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "180",
  },
  {
    id: 87,
    user_face: "87-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:02:02 广东",
    quote: {
      quote_status: true,
      quote_content: "但是我记得彩虹鞋是问了造型师的 造型师说是他们两自己搭的",
      quote_user_id: "糖醋橙子",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "自己搭的。。。未必懂。。。没有说不甜的意思。。。只是说那个时候没有敢在机场告诉所有人。。。老子是给子的勇气。。。甚至连他们自己对很多东西是茫然的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "261",
  },
  {
    id: 88,
    user_face: "88-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:03:09 山东",
    quote: {
      quote_status: true,
      quote_content:
        "自己搭的。。。未必懂。。。没有说不甜的意思。。。只是说那个时候没有敢在机场告诉所有人。。。老子是给子的勇气。。。甚至连他们自己对很多东西是茫然的。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "或许楼主不知道。。。不光造型师否认了。。。这个鞋前一天就穿了。。。第二天💙又特地换了🌈鞋带。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "385",
  },
  {
    id: 89,
    user_face: "89-user-face.png",
    user_id: "豆友",
    is_op: false,
    create_at: "2022-12-28 15:03:46 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "同意彩虹鞋这个点。。小时候可能只是觉得彩虹鞋好看，不一定真的有lgbt pride意识，但也可以看出两个人关系就是很好，且一直都很好。。。尤其他俩那年八月天天被路人偶遇到处逛街，之后就彩虹鞋了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "352",
  },
  {
    id: 90,
    user_face: "90-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:06:05 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "楼主的更新速度我i了，楼里住下了😋",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 91,
    user_face: "91-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:06:14 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "我朋友说的。。。图片发不出去我就发文字了。。。\n\n以下正文：\n\n他们的关系转变大概分为几个阶段吧\n1中二掌控时期   \n2尴尬转变+成长痛   \n3发疯成年人\n\n\n那个时候我是铁血i3，我前后追过33几十次现场，其中很多次也都（被迫）是团活动，经年累月，对22和33的关系每一次都有新的认知（就像绿光一样）\n\n\n1⃣️ 中二掌控时期\n成年之前，最早期的观察日记和少年go（类tf团综的东西）里面，wjk总是说：“我要管着wy，我是哥哥，我要管wy吃饭。给他Wi-Fi他就打游戏就不好好吃饭了。”以及走机场用充电宝牵着wy，给wy绑鞋带，等等诸如此类的话和事情吧。\n\n我用头担保wjk自己现在回看也觉得很羞耻很中二。\n\n因为当时他们的团队给他的人设就是大哥哥，若有似无引导着他变成对wy掌控者的角色，甚至那个时候那些管不管的，那些亲昵的行为，都真的很像男女朋友，男生兄弟之间是不会有这么黏腻的东西的，哥哥们应该懂我在说什么。\n\n这个状态大致持续到超少年密码拍摄结束，那个时候wjk背wy的一场戏，wy还能在他背上大大方方说：“你是开了氮气吗这么猛。”说他老公背他十几次下一条却还能跑得这么快呢哈哈😅😅😅这条视频我刷了20多遍，当时气得要死，wy这个小妖精，狐狸精，这么会夸男人呢呵呵😅😅😅但是隐约有点子嗑到（唉毕竟人类是不能拒绝爱情的🙏）\n\n\n\n\n2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "274",
  },
  {
    id: 92,
    user_face: "92-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:08:56 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "小时候wjk真的对wy照顾过度。。。而且和四字比很双标（对四字也有队长的团员的照顾，但和wy比差太多了。。。。）wy也是对wjk各种直球夸赞。。。。很难不磕到。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "338",
  },
  {
    id: 93,
    user_face: "93-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:08:59 广东",
    quote: {
      quote_status: true,
      quote_content:
        "同意彩虹鞋这个点。。小时候可能只是觉得彩虹鞋好看，不一定真的有lgbt pride意识，但也可以看出两个人关系就是很好，且一直都很好。。。尤其他俩那年八月天天被路人偶遇到处逛街，之后就彩虹鞋了",
      quote_user_id: "豆友",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "对。。。哥哥你懂得。。。就是这个意思。。。不是说不甜。。。只是理解不一样。。。在我朋友心里。。。真正戳人的是后面的拉扯。。。和成年后的几次发疯。。。正所谓。。。我知道世界和人心是什么之后。。。仍然克制不住对你的冲动。。。习惯也好爱意也好。。。我只知道我克制不住。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "337",
  },
  {
    id: 94,
    user_face: "94-user-face.png",
    user_id: "豆友",
    is_op: false,
    create_at: "2022-12-28 15:10:05 北京",
    quote: {
      quote_status: true,
      quote_content:
        "对。。。哥哥你懂得。。。就是这个意思。。。不是说不甜。。。只是理解不一样。。。在我朋友心里。。。真正戳人的是后面的拉扯。。。和成年后的几次发疯。。。正所谓。。。我知道世界和人心是什么之后。。。仍然克制不住对你的冲动。。。习惯也好爱意也好。。。我只知道我克制不住。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "完全同意。。。哥哥你朋友蚝油品味。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "65",
  },
  {
    id: 95,
    user_face: "95-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:10:51 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "对。。。哥哥你懂得。。。就是这个意思。。。不是说不甜。。。只是理解不一样。。。在我朋友心里。。。真正戳人的是后面的拉扯。。。和成年后的几次发疯。。。正所谓。。。我知道世界和人心是什么之后。。。仍然克制不住对你的冲动。。。习惯也好爱意也好。。。我只知道我克制不住。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好渴。。。。。。。。。。😱",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 96,
    user_face: "96-user-face.png",
    user_id: "L君·小🐷仔",
    is_op: false,
    create_at: "2022-12-28 15:11:12 美国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "摩多摩多",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 97,
    user_face: "97-user-face.png",
    user_id: "草莓味",
    is_op: false,
    create_at: "2022-12-28 15:11:42 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "17",
  },
  {
    id: 98,
    user_face: "98-user-face.png",
    user_id: "钮祜禄甄嬛",
    is_op: false,
    create_at: "2022-12-28 15:13:50 福建",
    quote: {
      quote_status: true,
      quote_content: "俺觉得不算。。。",
      quote_user_id: "mоmо",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "住下了。。。等楼主哥哥",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 99,
    user_face: "99-user-face.png",
    user_id: "TFBOYS-管国林",
    is_op: false,
    create_at: "2022-12-28 15:14:34 贵州",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友说的。。。图片发不出去我就发文字了。。。\n\n以下正文：\n\n他们的关系转变大概分为几个阶段吧\n1中二掌控时期   \n2尴尬转变+成长痛   \n3发疯成年人\n\n\n那个时候我是铁血i3，我前后追过33几十次现场，其中很多次也都（被迫）是团活动，经年累月，对22和33的关系每一次都有新的认知（就像绿光一样）\n\n\n1⃣️ 中二掌控时期\n成年之前，最早期的观察日记和少年go（类tf团综的东西）里面，wjk总是说：“我要管着wy，我是哥哥，我要管wy吃饭。给他Wi-Fi他就打游戏就不好好吃饭了。”以及走机场用充电宝牵着wy，给wy绑鞋带，等等诸如此类的话和事情吧。\n\n我用头担保wjk自己现在回看也觉得很羞耻很中二。\n\n因为当时他们的团队给他的人设就是大哥哥，若有似无引导着他变成对wy掌控者的角色，甚至那个时候那些管不管的，那些亲昵的行为，都真的很像男女朋友，男生兄弟之间是不会有这么黏腻的东西的，哥哥们应该懂我在说什么。\n\n这个状态大致持续到超少年密码拍摄结束，那个时候wjk背wy的一场戏，wy还能在他背上大大方方说：“你是开了氮气吗这么猛。”说他老公背他十几次下一条却还能跑得这么快呢哈哈😅😅😅这条视频我刷了20多遍，当时气得要死，wy这个小妖精，狐狸精，这么会夸男人呢呵呵😅😅😅但是隐约有点子嗑到（唉毕竟人类是不能拒绝爱情的🙏）\n\n\n\n\n2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "人类是不能拒绝爱情的。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "126",
  },
  {
    id: 100,
    user_face: "100-user-face.png",
    user_id: "豆子",
    is_op: false,
    create_at: "2022-12-28 15:15:20 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲一个",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 101,
    user_face: "101-user-face.png",
    user_id: "oomm",
    is_op: false,
    create_at: "2022-12-28 15:17:11 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 102,
    user_face: "102-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:17:37 广西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 103,
    user_face: "103-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:17:42 上海",
    quote: {
      quote_status: true,
      quote_content:
        "对。。。哥哥你懂得。。。就是这个意思。。。不是说不甜。。。只是理解不一样。。。在我朋友心里。。。真正戳人的是后面的拉扯。。。和成年后的几次发疯。。。正所谓。。。我知道世界和人心是什么之后。。。仍然克制不住对你的冲动。。。习惯也好爱意也好。。。我只知道我克制不住。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。。会磕。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "15",
  },
  {
    id: 104,
    user_face: "104-user-face.png",
    user_id: "梁博（已私奔",
    is_op: false,
    create_at: "2022-12-28 15:18:12 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友说的。。。图片发不出去我就发文字了。。。\n\n以下正文：\n\n他们的关系转变大概分为几个阶段吧\n1中二掌控时期   \n2尴尬转变+成长痛   \n3发疯成年人\n\n\n那个时候我是铁血i3，我前后追过33几十次现场，其中很多次也都（被迫）是团活动，经年累月，对22和33的关系每一次都有新的认知（就像绿光一样）\n\n\n1⃣️ 中二掌控时期\n成年之前，最早期的观察日记和少年go（类tf团综的东西）里面，wjk总是说：“我要管着wy，我是哥哥，我要管wy吃饭。给他Wi-Fi他就打游戏就不好好吃饭了。”以及走机场用充电宝牵着wy，给wy绑鞋带，等等诸如此类的话和事情吧。\n\n我用头担保wjk自己现在回看也觉得很羞耻很中二。\n\n因为当时他们的团队给他的人设就是大哥哥，若有似无引导着他变成对wy掌控者的角色，甚至那个时候那些管不管的，那些亲昵的行为，都真的很像男女朋友，男生兄弟之间是不会有这么黏腻的东西的，哥哥们应该懂我在说什么。\n\n这个状态大致持续到超少年密码拍摄结束，那个时候wjk背wy的一场戏，wy还能在他背上大大方方说：“你是开了氮气吗这么猛。”说他老公背他十几次下一条却还能跑得这么快呢哈哈😅😅😅这条视频我刷了20多遍，当时气得要死，wy这个小妖精，狐狸精，这么会夸男人呢呵呵😅😅😅但是隐约有点子嗑到（唉毕竟人类是不能拒绝爱情的🙏）\n\n\n\n\n2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "果然还是唯解最会嗑。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "68",
  },
  {
    id: 105,
    user_face: "105-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:18:23 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 106,
    user_face: "106-user-face.png",
    user_id: "安安安安",
    is_op: false,
    create_at: "2022-12-28 15:18:41 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 107,
    user_face: "107-user-face.png",
    user_id: "小鱼鱼鹿鹿",
    is_op: false,
    create_at: "2022-12-28 15:23:30 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "人类是不能拒绝爱情的。。。。💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "79",
  },
  {
    id: 108,
    user_face: "108-user-face.png",
    user_id: "ς(>‿<.)",
    is_op: false,
    create_at: "2022-12-28 15:23:36 内蒙古",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕晕了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 109,
    user_face: "109-user-face.png",
    user_id: "马上审判",
    is_op: false,
    create_at: "2022-12-28 15:25:39 吉林",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 110,
    user_face: "110-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:27:24 四川",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友说的。。。图片发不出去我就发文字了。。。\n\n以下正文：\n\n他们的关系转变大概分为几个阶段吧\n1中二掌控时期   \n2尴尬转变+成长痛   \n3发疯成年人\n\n\n那个时候我是铁血i3，我前后追过33几十次现场，其中很多次也都（被迫）是团活动，经年累月，对22和33的关系每一次都有新的认知（就像绿光一样）\n\n\n1⃣️ 中二掌控时期\n成年之前，最早期的观察日记和少年go（类tf团综的东西）里面，wjk总是说：“我要管着wy，我是哥哥，我要管wy吃饭。给他Wi-Fi他就打游戏就不好好吃饭了。”以及走机场用充电宝牵着wy，给wy绑鞋带，等等诸如此类的话和事情吧。\n\n我用头担保wjk自己现在回看也觉得很羞耻很中二。\n\n因为当时他们的团队给他的人设就是大哥哥，若有似无引导着他变成对wy掌控者的角色，甚至那个时候那些管不管的，那些亲昵的行为，都真的很像男女朋友，男生兄弟之间是不会有这么黏腻的东西的，哥哥们应该懂我在说什么。\n\n这个状态大致持续到超少年密码拍摄结束，那个时候wjk背wy的一场戏，wy还能在他背上大大方方说：“你是开了氮气吗这么猛。”说他老公背他十几次下一条却还能跑得这么快呢哈哈😅😅😅这条视频我刷了20多遍，当时气得要死，wy这个小妖精，狐狸精，这么会夸男人呢呵呵😅😅😅但是隐约有点子嗑到（唉毕竟人类是不能拒绝爱情的🙏）\n\n\n\n\n2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "金桔来了:人类是不能拒绝爱情的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "224",
  },
  {
    id: 111,
    user_face: "111-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:27:38 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。\n\n很大的一个差别就是，小时候他们经常有双人的大大方方的合照，自拍。但是少年时代梧桐和班小松的官方双人剧照却被岛看作发糖了大糖了，这也是粉丝对他们关系的不同反应。那个时候也是他们有自己的个人资源的开始，wjkwy都有了自己的个综，就是自己出去上综艺而不是打包，那个时候一切都是新鲜的，即有点不习惯，但是结识更多娱乐圈的人脉让他们也是满足的，快乐的，他们整体看着还是高兴的。\n\nwjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。\n\n也随着所谓的单飞，他们越来越明白什么是正常的“兄弟”之间的相处方式，也做出过一些啼笑皆非的事情，比如wy一天天嚷嚷要当刚哥，我记得那个时候我首页的xpx天天转粉见骂他当刚哥的通稿。那段时间他们的关系怎么样都别扭，特别别扭，也让岛鸡稍微能窥探到一点他俩单独的与xxxx无关的事情就当糖就放鞭炮，比如xxxx在前面走他俩走后面都算。wjk也在这个时期彻底收回了他的“过度照顾”\n\n那段时间也随着xxxx准备登机（大概是拍摄着抄袭的你的时间）想要独美，整个tfb都像是不认识一样。。。臭名昭著的五周年就是那个时候发生的。那场演唱会，我也在现场，每个人出来都没有笑脸，好像粉丝欠他们八百万一样，🍀被打击的七零八落伤心不已，因为🍀是非常看重五年的，他们认为这是十年之约的一半进程，结束之后直呼诈骗。那场演唱会确实很诈骗连ending都没有正式的。\n\n那段时间粉丝的情绪也好，他们的关系也好，都非常混乱。\n\n他们冰冷的关系出现互动和转折就是22决定出国了。\n\n\n\n补完。。。第二阶段",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "213",
  },
  {
    id: 112,
    user_face: "112-user-face.png",
    user_id: "蒂特洛伊木马",
    is_op: false,
    create_at: "2022-12-28 15:29:35 北京",
    quote: {
      quote_status: true,
      quote_content:
        "2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。\n\n很大的一个差别就是，小时候他们经常有双人的大大方方的合照，自拍。但是少年时代梧桐和班小松的官方双人剧照却被岛看作发糖了大糖了，这也是粉丝对他们关系的不同反应。那个时候也是他们有自己的个人资源的开始，wjkwy都有了自己的个综，就是自己出去上综艺而不是打包，那个时候一切都是新鲜的，即有点不习惯，但是结识更多娱乐圈的人脉让他们也是满足的，快乐的，他们整体看着还是高兴的。\n\nwjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。\n\n也随着所谓的单飞，他们越来越明白什么是正常的“兄弟”之间的相处方式，也做出过一些啼笑皆非的事情，比如wy一天天嚷嚷要当刚哥，我记得那个时候我首页的xpx天天转粉见骂他当刚哥的通稿。那段时间他们的关系怎么样都别扭，特别别扭，也让岛鸡稍微能窥探到一点他俩单独的与xxxx无关的事情就当糖就放鞭炮，比如xxxx在前面走他俩走后面都算。wjk也在这个时期彻底收回了他的“过度照顾”\n\n那段时间也随着xxxx准备登机（大概是拍摄着抄袭的你的时间）想要独美，整个tfb都像是不认识一样。。。臭名昭著的五周年就是那个时候发生的。那场演唱会，我也在现场，每个人出来都没有笑脸，好像粉丝欠他们八百万一样，🍀被打击的七零八落伤心不已，因为🍀是非常看重五年的，他们认为这是十年之约的一半进程，结束之后直呼诈骗。那场演唱会确实很诈骗连ending都没有正式的。\n\n那段时间粉丝的情绪也好，他们的关系也好，都非常混乱。\n\n他们冰冷的关系出现互动和转折就是22决定出国了。\n\n\n\n补完。。。第二阶段",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这个前i3哥哥。。。是有点子懂的。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "126",
  },
  {
    id: 113,
    user_face: "113-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:31:33 广东",
    quote: {
      quote_status: true,
      quote_content:
        "小时候wjk真的对wy照顾过度。。。而且和四字比很双标（对四字也有队长的团员的照顾，但和wy比差太多了。。。。）wy也是对wjk各种直球夸赞。。。。很难不磕到。。。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "对。。。那个阶段其实骂战最严重。。。i2骂wjk掌控欲管闲事大煞笔。。。i3骂wy巨婴。。。他俩也努力维持和四字的关系。。。但是相同的口味相同的习惯相同的乡音更多年的情谊就是让他们更愿意靠近彼此。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "404",
  },
  {
    id: 114,
    user_face: "114-user-face.png",
    user_id: "林奚",
    is_op: false,
    create_at: "2022-12-28 15:31:51 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 115,
    user_face: "115-user-face.png",
    user_id: "七纳",
    is_op: false,
    create_at: "2022-12-28 15:32:47 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好帖子",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 116,
    user_face: "116-user-face.png",
    user_id: "积家富人江予夺",
    is_op: false,
    create_at: "2022-12-28 15:33:17 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "人类是不能拒绝爱情的哈哈哈哈哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "37",
  },
  {
    id: 117,
    user_face: "117-user-face.png",
    user_id: "雪王宝贝",
    is_op: false,
    create_at: "2022-12-28 15:34:22 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "多来点多来点",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 118,
    user_face: "118-user-face.png",
    user_id: "中午吃啥",
    is_op: false,
    create_at: "2022-12-28 15:36:07 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 119,
    user_face: "119-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:36:20 北京",
    quote: {
      quote_status: true,
      quote_content:
        "2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。\n\n很大的一个差别就是，小时候他们经常有双人的大大方方的合照，自拍。但是少年时代梧桐和班小松的官方双人剧照却被岛看作发糖了大糖了，这也是粉丝对他们关系的不同反应。那个时候也是他们有自己的个人资源的开始，wjkwy都有了自己的个综，就是自己出去上综艺而不是打包，那个时候一切都是新鲜的，即有点不习惯，但是结识更多娱乐圈的人脉让他们也是满足的，快乐的，他们整体看着还是高兴的。\n\nwjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。\n\n也随着所谓的单飞，他们越来越明白什么是正常的“兄弟”之间的相处方式，也做出过一些啼笑皆非的事情，比如wy一天天嚷嚷要当刚哥，我记得那个时候我首页的xpx天天转粉见骂他当刚哥的通稿。那段时间他们的关系怎么样都别扭，特别别扭，也让岛鸡稍微能窥探到一点他俩单独的与xxxx无关的事情就当糖就放鞭炮，比如xxxx在前面走他俩走后面都算。wjk也在这个时期彻底收回了他的“过度照顾”\n\n那段时间也随着xxxx准备登机（大概是拍摄着抄袭的你的时间）想要独美，整个tfb都像是不认识一样。。。臭名昭著的五周年就是那个时候发生的。那场演唱会，我也在现场，每个人出来都没有笑脸，好像粉丝欠他们八百万一样，🍀被打击的七零八落伤心不已，因为🍀是非常看重五年的，他们认为这是十年之约的一半进程，结束之后直呼诈骗。那场演唱会确实很诈骗连ending都没有正式的。\n\n那段时间粉丝的情绪也好，他们的关系也好，都非常混乱。\n\n他们冰冷的关系出现互动和转折就是22决定出国了。\n\n\n\n补完。。。第二阶段",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "“wjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。”呜呜呜呜呜呜呜呜呜渴死我了。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "161",
  },
  {
    id: 120,
    user_face: "120-user-face.png",
    user_id: "犬来八荒",
    is_op: false,
    create_at: "2022-12-28 15:37:47 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好懂。。。磕。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 121,
    user_face: "121-user-face.png",
    user_id: "太古达人",
    is_op: false,
    create_at: "2022-12-28 15:37:54 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "人类是不能拒绝爱情的 蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "14",
  },
  {
    id: 122,
    user_face: "122-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 15:38:00 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "太想看了。。。我跪下来求你了哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 123,
    user_face: "123-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:38:12 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "补一点东西，其实踩组说粉丝什么都知道，是真的。\n32之间有一件事情让我朋友一个铁血i3真的怀疑他俩有一腿（这个我朋友会按照叙述线在后面提到）但33和22的曾经绯闻女友根据我朋友掌握的消息其实也很锤。。。\n说实话，这也是我朋友至今都很怀疑到底他俩是不是真给子的原因。\n但无论如何，可以给出肯定答案的就是💙💚关系真的就是很好，绝对不用怀疑他俩的关系不合，他们和44的关系才是很难说的。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "309",
  },
  {
    id: 124,
    user_face: "124-user-face.png",
    user_id: "cheetah🐆",
    is_op: false,
    create_at: "2022-12-28 15:39:01 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哈哈。。我同学从i3wf变岛姐。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 125,
    user_face: "125-user-face.png",
    user_id: "想吃红烧肉",
    is_op: false,
    create_at: "2022-12-28 15:39:27 北京",
    quote: {
      quote_status: true,
      quote_content:
        "补一点东西，其实踩组说粉丝什么都知道，是真的。\n32之间有一件事情让我朋友一个铁血i3真的怀疑他俩有一腿（这个我朋友会按照叙述线在后面提到）但33和22的曾经绯闻女友根据我朋友掌握的消息其实也很锤。。。\n说实话，这也是我朋友至今都很怀疑到底他俩是不是真给子的原因。\n但无论如何，可以给出肯定答案的就是💙💚关系真的就是很好，绝对不用怀疑他俩的关系不合，他们和44的关系才是很难说的。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "绯闻女友。。。。。是哪位。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "57",
  },
  {
    id: 126,
    user_face: "126-user-face.png",
    user_id: "仙人掌味橡皮糖",
    is_op: false,
    create_at: "2022-12-28 15:39:47 海南",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友说的。。。图片发不出去我就发文字了。。。\n\n以下正文：\n\n他们的关系转变大概分为几个阶段吧\n1中二掌控时期   \n2尴尬转变+成长痛   \n3发疯成年人\n\n\n那个时候我是铁血i3，我前后追过33几十次现场，其中很多次也都（被迫）是团活动，经年累月，对22和33的关系每一次都有新的认知（就像绿光一样）\n\n\n1⃣️ 中二掌控时期\n成年之前，最早期的观察日记和少年go（类tf团综的东西）里面，wjk总是说：“我要管着wy，我是哥哥，我要管wy吃饭。给他Wi-Fi他就打游戏就不好好吃饭了。”以及走机场用充电宝牵着wy，给wy绑鞋带，等等诸如此类的话和事情吧。\n\n我用头担保wjk自己现在回看也觉得很羞耻很中二。\n\n因为当时他们的团队给他的人设就是大哥哥，若有似无引导着他变成对wy掌控者的角色，甚至那个时候那些管不管的，那些亲昵的行为，都真的很像男女朋友，男生兄弟之间是不会有这么黏腻的东西的，哥哥们应该懂我在说什么。\n\n这个状态大致持续到超少年密码拍摄结束，那个时候wjk背wy的一场戏，wy还能在他背上大大方方说：“你是开了氮气吗这么猛。”说他老公背他十几次下一条却还能跑得这么快呢哈哈😅😅😅这条视频我刷了20多遍，当时气得要死，wy这个小妖精，狐狸精，这么会夸男人呢呵呵😅😅😅但是隐约有点子嗑到（唉毕竟人类是不能拒绝爱情的🙏）\n\n\n\n\n2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "kswl。。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 127,
    user_face: "127-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:39:54 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "对。。。那个阶段其实骂战最严重。。。i2骂wjk掌控欲管闲事大煞笔。。。i3骂wy巨婴。。。他俩也努力维持和四字的关系。。。但是相同的口味相同的习惯相同的乡音更多年的情谊就是让他们更愿意靠近彼此。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "怎么唯粉掐架也像在磕💊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "96",
  },
  {
    id: 128,
    user_face: "128-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:40:35 广东",
    quote: {
      quote_status: true,
      quote_content: "太想看了。。。我跪下来求你了哥哥。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "谢谢哥哥喜欢。。。我朋友也是想了很久才出来聊的。。。毕竟是初恋追星。。。虽然跑路了。。。但她真的见证了这对给子很多高甜时刻。。。就是wjk按着她的头让她知道凯源关系就是好（甚至是真的，给子的那种真的）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "173",
  },
  {
    id: 129,
    user_face: "129-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 15:41:27 云南",
    quote: {
      quote_status: true,
      quote_content:
        "谢谢哥哥喜欢。。。我朋友也是想了很久才出来聊的。。。毕竟是初恋追星。。。虽然跑路了。。。但她真的见证了这对给子很多高甜时刻。。。就是wjk按着她的头让她知道凯源关系就是好（甚至是真的，给子的那种真的）",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "听哥哥描述就已经磕死了啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 130,
    user_face: "130-user-face.png",
    user_id: "蒂特洛伊木马",
    is_op: false,
    create_at: "2022-12-28 15:44:45 北京",
    quote: {
      quote_status: true,
      quote_content:
        "补一点东西，其实踩组说粉丝什么都知道，是真的。\n32之间有一件事情让我朋友一个铁血i3真的怀疑他俩有一腿（这个我朋友会按照叙述线在后面提到）但33和22的曾经绯闻女友根据我朋友掌握的消息其实也很锤。。。\n说实话，这也是我朋友至今都很怀疑到底他俩是不是真给子的原因。\n但无论如何，可以给出肯定答案的就是💙💚关系真的就是很好，绝对不用怀疑他俩的关系不合，他们和44的关系才是很难说的。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "这个哥哥。。把哥哥们当一家人。。。什么都说呀。。。。牛牛哒。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "83",
  },
  {
    id: 131,
    user_face: "131-user-face.png",
    user_id: "拥抱毛茸茸",
    is_op: false,
    create_at: "2022-12-28 15:45:18 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "呃呃呃呃磕死。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 132,
    user_face: "132-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:47:07 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "后面的成年人阶段比较碎。。。也比较核弹。。。估计晚一点。。。大家如果有什么想问的。。。可以在回复聊聊问问我朋友。。。会知无不言的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "84",
  },
  {
    id: 133,
    user_face: "133-user-face.png",
    user_id: "把月亮摔碎",
    is_op: false,
    create_at: "2022-12-28 15:47:16 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@牧场 快看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 134,
    user_face: "134-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:47:55 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "后面的成年人阶段比较碎。。。也比较核弹。。。估计晚一点。。。大家如果有什么想问的。。。可以在回复聊聊问问我朋友。。。会知无不言的。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "问问楼主朋友是什么时候开始怀疑这俩是真给子而不是关系好的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 135,
    user_face: "135-user-face.png",
    user_id: "小白",
    is_op: false,
    create_at: "2022-12-28 15:48:55 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。等你。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 136,
    user_face: "136-user-face.png",
    user_id: "Keanu",
    is_op: false,
    create_at: "2022-12-28 15:49:52 山东",
    quote: {
      quote_status: true,
      quote_content:
        "补一点东西，其实踩组说粉丝什么都知道，是真的。\n32之间有一件事情让我朋友一个铁血i3真的怀疑他俩有一腿（这个我朋友会按照叙述线在后面提到）但33和22的曾经绯闻女友根据我朋友掌握的消息其实也很锤。。。\n说实话，这也是我朋友至今都很怀疑到底他俩是不是真给子的原因。\n但无论如何，可以给出肯定答案的就是💙💚关系真的就是很好，绝对不用怀疑他俩的关系不合，他们和44的关系才是很难说的。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "尊的。。。窝有一个在🥭台工作的好友。。。说23关系是真的好。。。而4有点。。。和他人设一个样。。。假清高。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "271",
  },
  {
    id: 137,
    user_face: "137-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 15:52:33 广东",
    quote: {
      quote_status: true,
      quote_content: "问问楼主朋友是什么时候开始怀疑这俩是真给子而不是关系好的",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "这个就后面大作文说，小作文说不完。。。我朋友说这个part她要图文并茂。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "127",
  },
  {
    id: 138,
    user_face: "138-user-face.png",
    user_id: "陈浩南（已坐牢",
    is_op: false,
    create_at: "2022-12-28 15:53:14 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "难道是地域差异的原因吗？作为川渝人来讲其实这边真的会觉得同不是什么很陌生的概念。。。。高一的时候班上就有男同女同了，那个时候直男也知道什么是同，还会和女生一起八卦开玩笑哈哈。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "234",
  },
  {
    id: 139,
    user_face: "139-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-28 15:53:46 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "其实种种迹象看来。。23关系应该是挺好的。。。但更想看关系变质后的23。。。跨年请疯个大的。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "229",
  },
  {
    id: 140,
    user_face: "140-user-face.png",
    user_id: "滚",
    is_op: false,
    create_at: "2022-12-28 15:54:47 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。多来点。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 141,
    user_face: "141-user-face.png",
    user_id: "荒里枯桃",
    is_op: false,
    create_at: "2022-12-28 15:55:15 吉林",
    quote: {
      quote_status: true,
      quote_content:
        "这个就后面大作文说，小作文说不完。。。我朋友说这个part她要图文并茂。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "图文并茂。。。哥哥的朋友。。。大大滴好人。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "115",
  },
  {
    id: 142,
    user_face: "142-user-face.png",
    user_id: "十七(已嗑拉)",
    is_op: false,
    create_at: "2022-12-28 15:58:05 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲。。爱看这种。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 143,
    user_face: "143-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:58:37 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "这个就后面大作文说，小作文说不完。。。我朋友说这个part她要图文并茂。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "图文并茂，我的妈，大工程啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "17",
  },
  {
    id: 144,
    user_face: "144-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:58:48 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 145,
    user_face: "145-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 15:59:01 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "难道是地域差异的原因吗？作为川渝人来讲其实这边真的会觉得同不是什么很陌生的概念。。。。高一的时候班上就有男同女同了，那个时候直男也知道什么是同，还会和女生一起八卦开玩笑哈哈。。。。",
      quote_user_id: "陈浩南（已坐牢",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "是的，川渝好像其实不觉得txl有什么，喜欢又不分性别",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "151",
  },
  {
    id: 146,
    user_face: "146-user-face.png",
    user_id: "吃太多了",
    is_op: false,
    create_at: "2022-12-28 16:02:33 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲 @Nbxscc",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 147,
    user_face: "147-user-face.png",
    user_id: "生气大赛冠军",
    is_op: false,
    create_at: "2022-12-28 16:02:52 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 148,
    user_face: "148-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:03:12 广东",
    quote: {
      quote_status: true,
      quote_content:
        "对。。。哥哥你懂得。。。就是这个意思。。。不是说不甜。。。只是理解不一样。。。在我朋友心里。。。真正戳人的是后面的拉扯。。。和成年后的几次发疯。。。正所谓。。。我知道世界和人心是什么之后。。。仍然克制不住对你的冲动。。。习惯也好爱意也好。。。我只知道我克制不住。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我也觉得。。。成年后好嗑超级加倍。。。。尤其是出国前后那段。。。有点小踩的嗑cp的味道（dddd",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "93",
  },
  {
    id: 149,
    user_face: "149-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:03:16 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲好了。。。哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 150,
    user_face: "150-user-face.png",
    user_id: "Byeol",
    is_op: false,
    create_at: "2022-12-28 16:03:55 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲。。。等会儿看。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 151,
    user_face: "151-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 16:04:00 广东",
    quote: {
      quote_status: true,
      quote_content:
        "难道是地域差异的原因吗？作为川渝人来讲其实这边真的会觉得同不是什么很陌生的概念。。。。高一的时候班上就有男同女同了，那个时候直男也知道什么是同，还会和女生一起八卦开玩笑哈哈。。。。",
      quote_user_id: "陈浩南（已坐牢",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我朋友的理解是。。。就是你年少成名。。。十五六岁。。。可能其实他这个时期都没捋清楚他对22到底是什么感情。。。自己都还觉得对22是好弟弟。。。wjk都没意识到他对22的很多举动其实是过度照顾，甚至对女朋友才那样。。。而在机场穿彩虹鞋表面自己txl身份这都几乎是发疯的程度了。。。就是说跨度太大。。。她认为有点不真实。。。仅此而已。。。这只是她的看法啦。。。完全不影响很多哥哥认可这是大🍬的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "217",
  },
  {
    id: 152,
    user_face: "152-user-face.png",
    user_id: "不要再吵啦",
    is_op: false,
    create_at: "2022-12-28 16:04:00 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 153,
    user_face: "153-user-face.png",
    user_id: "joji",
    is_op: false,
    create_at: "2022-12-28 16:05:12 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "那个那个 。。23是小时候一起约定考什么音乐学院吗？结果2最后选择出国3选择北电，2出国前剃了一个平头是打算从头开始的意思吗。。我现在有点混乱一直困扰我很久了忘记在哪听说了。。有没有哥哥给讲讲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "106",
  },
  {
    id: 154,
    user_face: "154-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 16:06:38 广东",
    quote: {
      quote_status: true,
      quote_content:
        "我也觉得。。。成年后好嗑超级加倍。。。。尤其是出国前后那段。。。有点小踩的嗑cp的味道（dddd",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "对。。。成年前都只是让我朋友破小防。。。成年后经常让我朋友破大防。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "145",
  },
  {
    id: 155,
    user_face: "155-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2022-12-28 16:07:20 新加坡",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 156,
    user_face: "156-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-28 16:07:22 广东",
    quote: {
      quote_status: true,
      quote_content:
        "那个那个 。。23是小时候一起约定考什么音乐学院吗？结果2最后选择出国3选择北电，2出国前剃了一个平头是打算从头开始的意思吗。。我现在有点混乱一直困扰我很久了忘记在哪听说了。。有没有哥哥给讲讲",
      quote_user_id: "joji",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是的，好像在天天向上说会选择音乐学院，但3先去了北电，2去了伯克利，或许就这时候开始，大家想要的已经不一样了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "174",
  },
  {
    id: 157,
    user_face: "157-user-face.png",
    user_id: "雾凛",
    is_op: false,
    create_at: "2022-12-28 16:07:39 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲，爱看🤗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 158,
    user_face: "158-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-28 16:08:16 广东",
    quote: {
      quote_status: true,
      quote_content:
        "尊的。。。窝有一个在🥭台工作的好友。。。说23关系是真的好。。。而4有点。。。和他人设一个样。。。假清高。。。。",
      quote_user_id: "Keanu",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "可之前小踩里的24我可以可以嗑到 他是他光亮的来源",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "44",
  },
  {
    id: 159,
    user_face: "159-user-face.png",
    user_id: "白雪👸跑路中",
    is_op: false,
    create_at: "2022-12-28 16:08:54 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "d磕死我",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 160,
    user_face: "160-user-face.png",
    user_id: "醪糟汤圆真好喝",
    is_op: false,
    create_at: "2022-12-28 16:10:15 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 161,
    user_face: "161-user-face.png",
    user_id: "陈韵如",
    is_op: false,
    create_at: "2022-12-28 16:11:55 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 162,
    user_face: "162-user-face.png",
    user_id: "哦豁",
    is_op: false,
    create_at: "2022-12-28 16:13:30 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 163,
    user_face: "163-user-face.png",
    user_id: "psyche",
    is_op: false,
    create_at: "2022-12-28 16:15:02 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 164,
    user_face: "164-user-face.png",
    user_id: "ʕ •ᴥ•ʔ",
    is_op: false,
    create_at: "2022-12-28 16:15:31 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好看。。。dd。。。等哥哥更新。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 165,
    user_face: "165-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 16:16:24 广东",
    quote: {
      quote_status: true,
      quote_content:
        "2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。\n\n很大的一个差别就是，小时候他们经常有双人的大大方方的合照，自拍。但是少年时代梧桐和班小松的官方双人剧照却被岛看作发糖了大糖了，这也是粉丝对他们关系的不同反应。那个时候也是他们有自己的个人资源的开始，wjkwy都有了自己的个综，就是自己出去上综艺而不是打包，那个时候一切都是新鲜的，即有点不习惯，但是结识更多娱乐圈的人脉让他们也是满足的，快乐的，他们整体看着还是高兴的。\n\nwjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。\n\n也随着所谓的单飞，他们越来越明白什么是正常的“兄弟”之间的相处方式，也做出过一些啼笑皆非的事情，比如wy一天天嚷嚷要当刚哥，我记得那个时候我首页的xpx天天转粉见骂他当刚哥的通稿。那段时间他们的关系怎么样都别扭，特别别扭，也让岛鸡稍微能窥探到一点他俩单独的与xxxx无关的事情就当糖就放鞭炮，比如xxxx在前面走他俩走后面都算。wjk也在这个时期彻底收回了他的“过度照顾”\n\n那段时间也随着xxxx准备登机（大概是拍摄着抄袭的你的时间）想要独美，整个tfb都像是不认识一样。。。臭名昭著的五周年就是那个时候发生的。那场演唱会，我也在现场，每个人出来都没有笑脸，好像粉丝欠他们八百万一样，🍀被打击的七零八落伤心不已，因为🍀是非常看重五年的，他们认为这是十年之约的一半进程，结束之后直呼诈骗。那场演唱会确实很诈骗连ending都没有正式的。\n\n那段时间粉丝的情绪也好，他们的关系也好，都非常混乱。\n\n他们冰冷的关系出现互动和转折就是22决定出国了。\n\n\n\n补完。。。第二阶段",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "420",
  },
  {
    id: 166,
    user_face: "166-user-face.png",
    user_id: "不止是粒米",
    is_op: false,
    create_at: "2022-12-28 16:16:26 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了哥哥",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 167,
    user_face: "167-user-face.png",
    user_id: "我叫啥不重要",
    is_op: false,
    create_at: "2022-12-28 16:16:45 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 168,
    user_face: "168-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:18:09 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲麻了哥哥",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 169,
    user_face: "169-user-face.png",
    user_id: "月亮缺失症.",
    is_op: false,
    create_at: "2022-12-28 16:19:03 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@iceinbottle",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 170,
    user_face: "170-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:19:05 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 171,
    user_face: "171-user-face.png",
    user_id: "我想喝绿豆粥",
    is_op: false,
    create_at: "2022-12-28 16:19:28 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@ssyil 啊啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 172,
    user_face: "172-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-28 16:21:23 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下啦",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 173,
    user_face: "173-user-face.png",
    user_id: "Leslie",
    is_op: false,
    create_at: "2022-12-28 16:22:08 澳大利亚",
    quote: {
      quote_status: true,
      quote_content:
        "“wjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。”呜呜呜呜呜呜呜呜呜渴死我了。。。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好家伙…真wf的角度果然和cpf不同…嗑亖",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "115",
  },
  {
    id: 174,
    user_face: "174-user-face.png",
    user_id: "茶山藏猫",
    is_op: false,
    create_at: "2022-12-28 16:22:13 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 175,
    user_face: "175-user-face.png",
    user_id: "张家族长(已婚",
    is_op: false,
    create_at: "2022-12-28 16:22:15 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "慢慢看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 176,
    user_face: "176-user-face.png",
    user_id: "😇",
    is_op: false,
    create_at: "2022-12-28 16:22:41 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "让我听",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 177,
    user_face: "177-user-face.png",
    user_id: "跑路女孩",
    is_op: false,
    create_at: "2022-12-28 16:25:39 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "留个屁股。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 178,
    user_face: "178-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:26:14 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 179,
    user_face: "179-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 16:26:32 云南",
    quote: {
      quote_status: true,
      quote_content:
        "对。。。哥哥你懂得。。。就是这个意思。。。不是说不甜。。。只是理解不一样。。。在我朋友心里。。。真正戳人的是后面的拉扯。。。和成年后的几次发疯。。。正所谓。。。我知道世界和人心是什么之后。。。仍然克制不住对你的冲动。。。习惯也好爱意也好。。。我只知道我克制不住。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥好会说啊啊啊。。。。。我知道世界和人心是什么之后。。。仍然克制不住对你的冲动。。。。😭😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "97",
  },
  {
    id: 180,
    user_face: "180-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 16:28:08 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哈。。。插播一条。。。不好放图大家当个乐子听。。。i3大站姐在puq在高价求阴着能去🇲🇴的人（算造谣吗 算就删掉。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "251",
  },
  {
    id: 181,
    user_face: "181-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:28:46 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "👂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 182,
    user_face: "182-user-face.png",
    user_id: "复杂人",
    is_op: false,
    create_at: "2022-12-28 16:29:43 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我继续蹲。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 183,
    user_face: "183-user-face.png",
    user_id: "御剑怜侍",
    is_op: false,
    create_at: "2022-12-28 16:29:59 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "算乐子。。。快更。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 184,
    user_face: "184-user-face.png",
    user_id: "沖繩啵啵牛乳",
    is_op: false,
    create_at: "2022-12-28 16:32:11 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "码住了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 185,
    user_face: "185-user-face.png",
    user_id: "养猫大户",
    is_op: false,
    create_at: "2022-12-28 16:33:38 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 186,
    user_face: "186-user-face.png",
    user_id: "杰克小麻雀",
    is_op: false,
    create_at: "2022-12-28 16:33:52 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友说的。。。图片发不出去我就发文字了。。。\n\n以下正文：\n\n他们的关系转变大概分为几个阶段吧\n1中二掌控时期   \n2尴尬转变+成长痛   \n3发疯成年人\n\n\n那个时候我是铁血i3，我前后追过33几十次现场，其中很多次也都（被迫）是团活动，经年累月，对22和33的关系每一次都有新的认知（就像绿光一样）\n\n\n1⃣️ 中二掌控时期\n成年之前，最早期的观察日记和少年go（类tf团综的东西）里面，wjk总是说：“我要管着wy，我是哥哥，我要管wy吃饭。给他Wi-Fi他就打游戏就不好好吃饭了。”以及走机场用充电宝牵着wy，给wy绑鞋带，等等诸如此类的话和事情吧。\n\n我用头担保wjk自己现在回看也觉得很羞耻很中二。\n\n因为当时他们的团队给他的人设就是大哥哥，若有似无引导着他变成对wy掌控者的角色，甚至那个时候那些管不管的，那些亲昵的行为，都真的很像男女朋友，男生兄弟之间是不会有这么黏腻的东西的，哥哥们应该懂我在说什么。\n\n这个状态大致持续到超少年密码拍摄结束，那个时候wjk背wy的一场戏，wy还能在他背上大大方方说：“你是开了氮气吗这么猛。”说他老公背他十几次下一条却还能跑得这么快呢哈哈😅😅😅这条视频我刷了20多遍，当时气得要死，wy这个小妖精，狐狸精，这么会夸男人呢呵呵😅😅😅但是隐约有点子嗑到（唉毕竟人类是不能拒绝爱情的🙏）\n\n\n\n\n2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "住下了。。。等更新。。。嗑死我了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 187,
    user_face: "187-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-28 16:33:56 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "摩多摩多。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 188,
    user_face: "188-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:34:01 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "哈。。。插播一条。。。不好放图大家当个乐子听。。。i3大站姐在puq在高价求阴着能去🇲🇴的人（算造谣吗 算就删掉。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "虽然很缺德。。。但是真的磕到了哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "72",
  },
  {
    id: 189,
    user_face: "189-user-face.png",
    user_id: "安某人---",
    is_op: false,
    create_at: "2022-12-28 16:34:03 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 190,
    user_face: "190-user-face.png",
    user_id: "蜜桃乌龙茶",
    is_op: false,
    create_at: "2022-12-28 16:35:05 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 191,
    user_face: "191-user-face.png",
    user_id: "御剑怜侍",
    is_op: false,
    create_at: "2022-12-28 16:35:29 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友说的。。。图片发不出去我就发文字了。。。\n\n以下正文：\n\n他们的关系转变大概分为几个阶段吧\n1中二掌控时期   \n2尴尬转变+成长痛   \n3发疯成年人\n\n\n那个时候我是铁血i3，我前后追过33几十次现场，其中很多次也都（被迫）是团活动，经年累月，对22和33的关系每一次都有新的认知（就像绿光一样）\n\n\n1⃣️ 中二掌控时期\n成年之前，最早期的观察日记和少年go（类tf团综的东西）里面，wjk总是说：“我要管着wy，我是哥哥，我要管wy吃饭。给他Wi-Fi他就打游戏就不好好吃饭了。”以及走机场用充电宝牵着wy，给wy绑鞋带，等等诸如此类的话和事情吧。\n\n我用头担保wjk自己现在回看也觉得很羞耻很中二。\n\n因为当时他们的团队给他的人设就是大哥哥，若有似无引导着他变成对wy掌控者的角色，甚至那个时候那些管不管的，那些亲昵的行为，都真的很像男女朋友，男生兄弟之间是不会有这么黏腻的东西的，哥哥们应该懂我在说什么。\n\n这个状态大致持续到超少年密码拍摄结束，那个时候wjk背wy的一场戏，wy还能在他背上大大方方说：“你是开了氮气吗这么猛。”说他老公背他十几次下一条却还能跑得这么快呢哈哈😅😅😅这条视频我刷了20多遍，当时气得要死，wy这个小妖精，狐狸精，这么会夸男人呢呵呵😅😅😅但是隐约有点子嗑到（唉毕竟人类是不能拒绝爱情的🙏）\n\n\n\n\n2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "啊啊啊啊啊啊啊啊wy这个狐狸精小妖精这么会夸男人呢呵呵啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "93",
  },
  {
    id: 192,
    user_face: "192-user-face.png",
    user_id: "草莓菠萝",
    is_op: false,
    create_at: "2022-12-28 16:38:50 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。。蹲后续。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 193,
    user_face: "193-user-face.png",
    user_id: "카와이균썅",
    is_op: false,
    create_at: "2022-12-28 16:39:39 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 194,
    user_face: "194-user-face.png",
    user_id: "失忆蝴蝶",
    is_op: false,
    create_at: "2022-12-28 16:39:55 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我来了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 195,
    user_face: "195-user-face.png",
    user_id: "嘻嘻",
    is_op: false,
    create_at: "2022-12-28 16:40:33 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "妈呀磕死我了啊啊啊啊啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 196,
    user_face: "196-user-face.png",
    user_id: "啊这",
    is_op: false,
    create_at: "2022-12-28 16:41:48 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "不算吧。。。rwkk。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 197,
    user_face: "197-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 16:42:30 云南",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友的理解是。。。就是你年少成名。。。十五六岁。。。可能其实他这个时期都没捋清楚他对22到底是什么感情。。。自己都还觉得对22是好弟弟。。。wjk都没意识到他对22的很多举动其实是过度照顾，甚至对女朋友才那样。。。而在机场穿彩虹鞋表面自己txl身份这都几乎是发疯的程度了。。。就是说跨度太大。。。她认为有点不真实。。。仅此而已。。。这只是她的看法啦。。。完全不影响很多哥哥认可这是大🍬的。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我感觉在这方面可能22比33先开窍。。。。谁懂。。。。33真的是横冲直撞地对人好。。。很“直男”的感觉。。。。。很多事情他根本不会多想。。。。22心思更细腻。。。搞不懂33对他到底是喜欢还是单纯照顾。。。。。在队友兼兄弟的身份下不好挑破。。。。。然后无尽的纠结拉扯。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "290",
  },
  {
    id: 198,
    user_face: "198-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:43:20 贵州",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "蜜桃乌龙茶",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "请问一下什么小作文！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 199,
    user_face: "199-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 16:48:02 云南",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "笑死我了。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 200,
    user_face: "200-user-face.png",
    user_id: "芥末丸子",
    is_op: false,
    create_at: "2022-12-28 16:48:13 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 201,
    user_face: "201-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 16:51:25 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 202,
    user_face: "202-user-face.png",
    user_id: "Sherry",
    is_op: false,
    create_at: "2022-12-28 16:53:32 上海",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我靠 没错 终于有人说出了我的心里话 那段时间22一直想要挣脱33 就是可能察觉到三字对他也许不是他想要的那种感情 所以他决然开始追寻自我 三字那时候感觉还没有醒悟 直到二字真的出国 他才开始懵逼 开始审视这段感情 那之前 就他拍天坑时候 感觉和jyy很暧昧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "190",
  },
  {
    id: 203,
    user_face: "203-user-face.png",
    user_id: "Sherry",
    is_op: false,
    create_at: "2022-12-28 16:58:31 上海",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好吧 原来我只看到了表面。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 204,
    user_face: "204-user-face.png",
    user_id: "我说",
    is_op: false,
    create_at: "2022-12-28 16:59:24 山东",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好伤😢",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 205,
    user_face: "205-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 17:00:56 宁夏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "救。。。。kswl。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 206,
    user_face: "206-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 17:04:34 广东",
    quote: {
      quote_status: true,
      quote_content:
        "我靠 没错 终于有人说出了我的心里话 那段时间22一直想要挣脱33 就是可能察觉到三字对他也许不是他想要的那种感情 所以他决然开始追寻自我 三字那时候感觉还没有醒悟 直到二字真的出国 他才开始懵逼 开始审视这段感情 那之前 就他拍天坑时候 感觉和jyy很暧昧",
      quote_user_id: "Sherry",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "和jyy真没啥。。。just陈述啊啊啊啊啊。。。本来就是跑路i3发言了再说这个真的怕被当粉丝举了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "207",
  },
  {
    id: 207,
    user_face: "207-user-face.png",
    user_id: "还行吧我觉得",
    is_op: false,
    create_at: "2022-12-28 17:04:46 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "有些话从唯粉嘴里说出来格外好嗑。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 208,
    user_face: "208-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 17:05:11 云南",
    quote: {
      quote_status: true,
      quote_content:
        "我靠 没错 终于有人说出了我的心里话 那段时间22一直想要挣脱33 就是可能察觉到三字对他也许不是他想要的那种感情 所以他决然开始追寻自我 三字那时候感觉还没有醒悟 直到二字真的出国 他才开始懵逼 开始审视这段感情 那之前 就他拍天坑时候 感觉和jyy很暧昧",
      quote_user_id: "Sherry",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。。我同意你的想法但是我觉得开窍时间没有那么晚诶。。。。哥哥磕过卡地亚吗。。。。天坑那会他一直戴着卡地亚拍戏没拿下来我觉得也挺好磕。。。。。然后我感觉22出国。。。他两之间更多是跨越半个地球追求梦想和四年异地的纠结🤔🤔。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "205",
  },
  {
    id: 209,
    user_face: "209-user-face.png",
    user_id: "花梨",
    is_op: false,
    create_at: "2022-12-28 17:05:14 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 210,
    user_face: "210-user-face.png",
    user_id: "最迷人班长",
    is_op: false,
    create_at: "2022-12-28 17:05:35 上海",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "wjk在这个时期的确收回这份偏爱非常彻底。😭😭😭😭🫵🏻🫵🏻🫵🏻🫵🏻🫵🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "114",
  },
  {
    id: 211,
    user_face: "211-user-face.png",
    user_id: "来一杯多肉葡萄",
    is_op: false,
    create_at: "2022-12-28 17:12:36 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 212,
    user_face: "212-user-face.png",
    user_id: "もも",
    is_op: false,
    create_at: "2022-12-28 17:13:47 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "求求哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 213,
    user_face: "213-user-face.png",
    user_id: "工藤新1️⃣",
    is_op: false,
    create_at: "2022-12-28 17:15:36 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "其实我还真没怀疑过他俩会和女生有什么。。。我觉得3对异性总是太疏离 2虽然看起来很暖但其实心挺硬的 毕竟好的姐这个杀伤力太大 要是真说私底下听料不同属性的帝国姐谁听的都不少 仔细一捋会发现锤的只有彼此",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "416",
  },
  {
    id: 214,
    user_face: "214-user-face.png",
    user_id: "芥末丸子",
    is_op: false,
    create_at: "2022-12-28 17:16:00 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "哈。。。插播一条。。。不好放图大家当个乐子听。。。i3大站姐在puq在高价求阴着能去🇲🇴的人（算造谣吗 算就删掉。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "。。sj了一下超话发现xpx甚至包大巴和住宿催能去的去。。。这对给子真是为爱发疯不顾粉丝了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "199",
  },
  {
    id: 215,
    user_face: "215-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 17:16:07 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 216,
    user_face: "216-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 17:18:07 广东",
    quote: {
      quote_status: true,
      quote_content:
        "其实我还真没怀疑过他俩会和女生有什么。。。我觉得3对异性总是太疏离 2虽然看起来很暖但其实心挺硬的 毕竟好的姐这个杀伤力太大 要是真说私底下听料不同属性的帝国姐谁听的都不少 仔细一捋会发现锤的只有彼此",
      quote_user_id: "工藤新1️⃣",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "绯闻女友不是说好的姐。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "59",
  },
  {
    id: 217,
    user_face: "217-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 17:19:46 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 218,
    user_face: "218-user-face.png",
    user_id: "工藤新1️⃣",
    is_op: false,
    create_at: "2022-12-28 17:20:03 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "我觉得💙💚好嗑在于懵懂少年时期的绝对亲密 成长时期的晦涩拉扯以及成年后很稳定的家庭幸福感 大家都是没差几岁的同龄人 我不觉得他们少年时期对情感有多懵懂 手机一搜什么没有啊 但是之间出现晦涩拉扯的相处模式就特别好嗑 就像是不断通过伤害自己和对方 最后发现还是非他不可的这种宿命感 到现在。。。我觉得已经是老夫老夫了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "323",
  },
  {
    id: 219,
    user_face: "219-user-face.png",
    user_id: "TWICE_崔秀彬",
    is_op: false,
    create_at: "2022-12-28 17:23:27 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 220,
    user_face: "220-user-face.png",
    user_id: "及川彻底疯狂",
    is_op: false,
    create_at: "2022-12-28 17:24:27 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 221,
    user_face: "221-user-face.png",
    user_id: "工藤新1️⃣",
    is_op: false,
    create_at: "2022-12-28 17:24:31 中国香港",
    quote: {
      quote_status: true,
      quote_content: "绯闻女友不是说好的姐。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我只是用这个举例一下他们和同龄异性的相处模式\n其实在我我本人主观看他俩都不可能是理想型。。。接受不了这样的男朋友。。。不过这很主观因为我确实没爱情也不想要爱情。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "57",
  },
  {
    id: 222,
    user_face: "222-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-28 17:25:08 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "这位前i3姐姐跟我对凯源感情线时间划分的差不多 虽然我嗑凯源后看大部分时间线都在很早很早成年之间 但我觉得至少也在高中尾巴 早期确实很没分寸很甜 也有可能自己都没摸清楚的心动 但是我心里的时间线和这位前i3姐差不多的 二字出国前的凯源 和二字出国凯源转变很大",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "153",
  },
  {
    id: 223,
    user_face: "223-user-face.png",
    user_id: "如花美眷",
    is_op: false,
    create_at: "2022-12-28 17:25:46 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥等你继续。。。我好爱看。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 224,
    user_face: "224-user-face.png",
    user_id: "抹茶巧克力",
    is_op: false,
    create_at: "2022-12-28 17:27:43 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "顶待会来看👀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 225,
    user_face: "225-user-face.png",
    user_id: "蜡笔小丸子",
    is_op: false,
    create_at: "2022-12-28 17:29:26 四川",
    quote: {
      quote_status: true,
      quote_content:
        "难道是地域差异的原因吗？作为川渝人来讲其实这边真的会觉得同不是什么很陌生的概念。。。。高一的时候班上就有男同女同了，那个时候直男也知道什么是同，还会和女生一起八卦开玩笑哈哈。。。。",
      quote_user_id: "陈浩南（已坐牢",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "川渝人表示你说的对。。。周围女同男同很多，尤其是女同，初中就有同学出柜，她谈恋爱连老师都知道。。。年纪越小，越早知道这些。。。零零后更不用说了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "139",
  },
  {
    id: 226,
    user_face: "226-user-face.png",
    user_id: "买个锤子",
    is_op: false,
    create_at: "2022-12-28 17:30:35 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 227,
    user_face: "227-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-28 17:34:50 河南",
    quote: {
      quote_status: true,
      quote_content:
        "2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。\n\n很大的一个差别就是，小时候他们经常有双人的大大方方的合照，自拍。但是少年时代梧桐和班小松的官方双人剧照却被岛看作发糖了大糖了，这也是粉丝对他们关系的不同反应。那个时候也是他们有自己的个人资源的开始，wjkwy都有了自己的个综，就是自己出去上综艺而不是打包，那个时候一切都是新鲜的，即有点不习惯，但是结识更多娱乐圈的人脉让他们也是满足的，快乐的，他们整体看着还是高兴的。\n\nwjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。\n\n也随着所谓的单飞，他们越来越明白什么是正常的“兄弟”之间的相处方式，也做出过一些啼笑皆非的事情，比如wy一天天嚷嚷要当刚哥，我记得那个时候我首页的xpx天天转粉见骂他当刚哥的通稿。那段时间他们的关系怎么样都别扭，特别别扭，也让岛鸡稍微能窥探到一点他俩单独的与xxxx无关的事情就当糖就放鞭炮，比如xxxx在前面走他俩走后面都算。wjk也在这个时期彻底收回了他的“过度照顾”\n\n那段时间也随着xxxx准备登机（大概是拍摄着抄袭的你的时间）想要独美，整个tfb都像是不认识一样。。。臭名昭著的五周年就是那个时候发生的。那场演唱会，我也在现场，每个人出来都没有笑脸，好像粉丝欠他们八百万一样，🍀被打击的七零八落伤心不已，因为🍀是非常看重五年的，他们认为这是十年之约的一半进程，结束之后直呼诈骗。那场演唱会确实很诈骗连ending都没有正式的。\n\n那段时间粉丝的情绪也好，他们的关系也好，都非常混乱。\n\n他们冰冷的关系出现互动和转折就是22决定出国了。\n\n\n\n补完。。。第二阶段",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "这个时期前段时间和朋友考古二字第一部个人团综王牌，帝国去的那一期，二字是主持人，其实现在看二字的表现有点用力过猛的尴尬，第一次独当一面当主持人也是有点紧张，帝国来的那期真的太好磕了。。。二字不管怎么耍宝或者有意在炫耀他和三字的关系，比如“有一次我和王俊凯睡觉”还有后面的游戏环节，但是三字就是非常宠他，说什么都顺着他，他不在游戏中还会絮絮叨叨二字的小事，说他老爱藏柜子里让人找啊，没人找一会自己又出来了，就整个感觉是去给二字撑场子的，甚至还领着台下的i3打趣二字小时候唱的儿歌。。。。就是好磕疯了。。。但是我记得那会俩人已经开始“兄弟化”，以前不觉得多好嗑现在嗑那时候的三字比小时候凯源里打直球又虎逼的三字更像长大了也知道他和二字关系中的暧昧和小尴尬但是还是会宠二字给二字撑场子。。。。\n没嗑过的哥哥记得嗑这个【【凯源】浪漫爱+冤家路窄（王牌对王牌糖点CUT）-哔哩哔哩】 https://b23.tv/21a32oG",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "283",
  },
  {
    id: 228,
    user_face: "228-user-face.png",
    user_id: "w慕安",
    is_op: false,
    create_at: "2022-12-28 17:36:55 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快更新",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 229,
    user_face: "229-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 17:41:58 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "想听",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 230,
    user_face: "230-user-face.png",
    user_id: "TNT—周风",
    is_op: false,
    create_at: "2022-12-28 17:42:54 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 231,
    user_face: "231-user-face.png",
    user_id: "漂亮美女戴👑",
    is_op: false,
    create_at: "2022-12-28 17:42:54 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "是真的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 232,
    user_face: "232-user-face.png",
    user_id: "TNT—周风",
    is_op: false,
    create_at: "2022-12-28 17:43:02 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@🧊🧊（养兔中 @矿泉水装箱大师 @TNT-风销销",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 233,
    user_face: "233-user-face.png",
    user_id: "月晕侵袭",
    is_op: false,
    create_at: "2022-12-28 17:45:18 英国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "出国真的是分水岭，那段时间太痛了。。无限拉扯之后看清内心然后感觉更加坚定了（蹲蹲更新",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "150",
  },
  {
    id: 234,
    user_face: "234-user-face.png",
    user_id: "我唯你小熊",
    is_op: false,
    create_at: "2022-12-28 17:46:47 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "1",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 235,
    user_face: "235-user-face.png",
    user_id: "Sherry",
    is_op: false,
    create_at: "2022-12-28 17:48:19 上海",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥。。。我同意你的想法但是我觉得开窍时间没有那么晚诶。。。。哥哥磕过卡地亚吗。。。。天坑那会他一直戴着卡地亚拍戏没拿下来我觉得也挺好磕。。。。。然后我感觉22出国。。。他两之间更多是跨越半个地球追求梦想和四年异地的纠结🤔🤔。。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "好像有道理。。。。总之出国真的是俩人一个大矛盾 之后二字在一个节目里周迅问他爱情的看法 他说俩人有了矛盾要去解决吧啦吧啦 当时就想到了他出国 俩人那段时间都很痛苦",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "193",
  },
  {
    id: 236,
    user_face: "236-user-face.png",
    user_id: "李一桐",
    is_op: false,
    create_at: "2022-12-28 17:49:37 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "1",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 237,
    user_face: "237-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 17:54:29 北京",
    quote: {
      quote_status: true,
      quote_content:
        "wjk在这个时期的确收回这份偏爱非常彻底。😭😭😭😭🫵🏻🫵🏻🫵🏻🫵🏻🫵🏻",
      quote_user_id: "最迷人班长",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "这份偏爱也不是wjk不想给。。。是wy不要。。（上三字顶腮动图。。。）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "256",
  },
  {
    id: 238,
    user_face: "238-user-face.png",
    user_id: "叮叮",
    is_op: false,
    create_at: "2022-12-28 17:54:49 内蒙古",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "1",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 239,
    user_face: "239-user-face.png",
    user_id: "月亮不打烊",
    is_op: false,
    create_at: "2022-12-28 17:55:49 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 240,
    user_face: "240-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2022-12-28 17:56:02 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 241,
    user_face: "241-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 17:58:12 四川",
    quote: {
      quote_status: true,
      quote_content:
        "wjk在这个时期的确收回这份偏爱非常彻底。😭😭😭😭🫵🏻🫵🏻🫵🏻🫵🏻🫵🏻",
      quote_user_id: "最迷人班长",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "其实也不是很彻底。。表面收回而已。。当时23表面发糖骤减。。但是帝国当时少年时代的采访。。主持人问4 3给他私下说高考什么相关的事情没有。。4说就是学习之类的。。但是2说。。3给他说高考完了很多人以后就再也见不到了。。那也是2第一次公开喊3俊凯。。。那段时间2也在开始纠结未来了。。他一开始并没有坚定出国的。。参加湖南台一个采访的时候还说以后可能会选影视。。那段说辞和3之前很像。。应该23私下是做过交流的。。后面开始改变是在青春旅社的时候。。在青春旅社2提过很多次3。。我为什么说表面3收回偏爱。。因为这个时候3已经没有小时候那么直来直去了。。很多情绪都掩埋的比较好。。包括2在青春旅社有一次3正好也去那边录演员的那个综艺。。2当时住山上。。有天晚上骑着自行车就不知道哪去了。。当时我记得是有人说3给他送厚衣服去了（说错了就是我记错了。。好像说是去的时候拿了行李箱回来就没了啥的忘记了）然后后面18年。。岛上很多事情都是18年发生的。。2那个时候还在纠结要不要出国。。当时发了首歌叫我不知道。。然后发微博。。3就在下面说出发去找答案。。从2纠结到真的决定期间2发的每次微博3当时回复的都很郑重。。也就是说3其实一直是支持的。。我也偏向这两个人私下肯定说了什么。。包括著名的机场未知事件和传说中的璀璨夺目善良天真都是这段时间发生的事情。。怎么越回顾事儿越多。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "379",
  },
  {
    id: 242,
    user_face: "242-user-face.png",
    user_id: "最迷人班长",
    is_op: false,
    create_at: "2022-12-28 18:01:32 上海",
    quote: {
      quote_status: true,
      quote_content:
        "这份偏爱也不是wjk不想给。。。是wy不要。。（上三字顶腮动图。。。）",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "😭😭😭😭😭🫵🏻🫵🏻🫵🏻🫵🏻🫵🏻你们两小子以后再也不准爱得这么痛了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "152",
  },
  {
    id: 243,
    user_face: "243-user-face.png",
    user_id: "淘气麻薯小丸子",
    is_op: false,
    create_at: "2022-12-28 18:01:48 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "1",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 244,
    user_face: "244-user-face.png",
    user_id: "懒羊羊（重生版",
    is_op: false,
    create_at: "2022-12-28 18:02:19 山东",
    quote: {
      quote_status: true,
      quote_content:
        "哈。。。插播一条。。。不好放图大家当个乐子听。。。i3大站姐在puq在高价求阴着能去🇲🇴的人（算造谣吗 算就删掉。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 245,
    user_face: "245-user-face.png",
    user_id: "沧笙踏歌",
    is_op: false,
    create_at: "2022-12-28 18:04:38 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 246,
    user_face: "246-user-face.png",
    user_id: "大鹦鹉",
    is_op: false,
    create_at: "2022-12-28 18:06:14 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 247,
    user_face: "247-user-face.png",
    user_id: "吃瓜的花花酱",
    is_op: false,
    create_at: "2022-12-28 18:06:24 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "就喜欢看唯粉说糖",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "15",
  },
  {
    id: 248,
    user_face: "248-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-28 18:08:48 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "十年过去，还是💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "49",
  },
  {
    id: 249,
    user_face: "249-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 18:09:01 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 250,
    user_face: "250-user-face.png",
    user_id: "观海",
    is_op: false,
    create_at: "2022-12-28 18:09:35 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。速度。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 251,
    user_face: "251-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-28 18:10:45 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。感觉帝国大姐就要在踩组开打了。。。。你快更。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "248",
  },
  {
    id: 252,
    user_face: "252-user-face.png",
    user_id: "咸蛋黄芋泥",
    is_op: false,
    create_at: "2022-12-28 18:12:30 浙江",
    quote: {
      quote_status: true,
      quote_content: "怎么唯粉掐架也像在磕💊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 253,
    user_face: "253-user-face.png",
    user_id: "🧐",
    is_op: false,
    create_at: "2022-12-28 18:13:03 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我蹲。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 254,
    user_face: "254-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 18:14:26 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这个就后面大作文说，小作文说不完。。。我朋友说这个part她要图文并茂。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "狠狠期待。。。好爱看。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 255,
    user_face: "255-user-face.png",
    user_id: "我美式",
    is_op: false,
    create_at: "2022-12-28 18:16:11 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 256,
    user_face: "256-user-face.png",
    user_id: "大象大象",
    is_op: false,
    create_at: "2022-12-28 18:20:09 河南",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我觉得是33可能没安全感，33\n不会开窍那么晚，17年开始发现22\n有时候走路一拐一拐还扶腰，也明显干了啥，如果说还在纠结不可能就直接做了，这么冲动?\n\n",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "130",
  },
  {
    id: 257,
    user_face: "257-user-face.png",
    user_id: "穆玄英",
    is_op: false,
    create_at: "2022-12-28 18:20:59 广西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "优雅置臀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 258,
    user_face: "258-user-face.png",
    user_id: "穆玄英",
    is_op: false,
    create_at: "2022-12-28 18:22:30 广西",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥。。感觉帝国大姐就要在踩组开打了。。。。你快更。。。。",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "山雨欲来了属于是。。。哥哥再不更感觉这个帖子下一秒要没了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "142",
  },
  {
    id: 259,
    user_face: "259-user-face.png",
    user_id: "观海",
    is_op: false,
    create_at: "2022-12-28 18:22:36 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 260,
    user_face: "260-user-face.png",
    user_id: "珍珠水晶",
    is_op: false,
    create_at: "2022-12-28 18:23:13 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑死我了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 261,
    user_face: "261-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 18:26:09 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "隐隐约约感觉风雨欲来了。。。。哥哥快更。。。靠你了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "95",
  },
  {
    id: 262,
    user_face: "262-user-face.png",
    user_id: "💦",
    is_op: false,
    create_at: "2022-12-28 18:27:06 黑龙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲了蹲了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 263,
    user_face: "263-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 18:27:46 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 264,
    user_face: "264-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 18:28:08 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥快点。。。感觉这个帖子危。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 265,
    user_face: "265-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-28 18:29:46 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥搞快搞快 要打起来了啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "52",
  },
  {
    id: 266,
    user_face: "266-user-face.png",
    user_id: "大花🌸",
    is_op: false,
    create_at: "2022-12-28 18:40:14 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "这份偏爱也不是wjk不想给。。。是wy不要。。（上三字顶腮动图。。。）",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "那时候wy开始发觉wjk给的可能不是他想要的，或者他自己也没想清自己想要的到底是哪种——或者他想清了，但他不知道wjk到底懂么懂——总感觉他会咬牙骂💙大傻杯，不爱何撩😂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "150",
  },
  {
    id: 267,
    user_face: "267-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 18:41:14 云南",
    quote: {
      quote_status: true,
      quote_content: "d",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥可以看下私信吗🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 268,
    user_face: "268-user-face.png",
    user_id: "be bad",
    is_op: false,
    create_at: "2022-12-28 18:43:12 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥抓紧时间，帝国唯粉大军要到了😂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "75",
  },
  {
    id: 269,
    user_face: "269-user-face.png",
    user_id: "got7主唱边伯贤",
    is_op: false,
    create_at: "2022-12-28 18:45:19 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥搞快点搞快点，让我看完！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 270,
    user_face: "270-user-face.png",
    user_id: "田柾国",
    is_op: false,
    create_at: "2022-12-28 18:46:43 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑拉了呀哥哥。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 271,
    user_face: "271-user-face.png",
    user_id: "Linné",
    is_op: false,
    create_at: "2022-12-28 18:48:01 内蒙古",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕拉了。。。被忽悠瘸了哥哥。。。不会真的是真给子吧。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 272,
    user_face: "272-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 18:48:27 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "有哥哥私信投稿的。。。非我原创。。。大家可以先嗑着。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "138",
  },
  {
    id: 273,
    user_face: "273-user-face.png",
    user_id: "嘻嘻",
    is_op: false,
    create_at: "2022-12-28 18:48:28 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。等着你。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 274,
    user_face: "274-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 18:48:39 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "接楼上。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "134",
  },
  {
    id: 275,
    user_face: "275-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 18:49:10 广东",
    quote: {
      quote_status: true,
      quote_content: "哥哥可以看下私信吗🥺",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "回你了哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 276,
    user_face: "276-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 18:51:13 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥，首页开始暗戳戳打架了！快啊！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "74",
  },
  {
    id: 277,
    user_face: "277-user-face.png",
    user_id: "一口好牙稀碎",
    is_op: false,
    create_at: "2022-12-28 18:56:15 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "喜欢",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 278,
    user_face: "278-user-face.png",
    user_id: "一口好牙稀碎",
    is_op: false,
    create_at: "2022-12-28 18:56:24 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。快。。。我还要克。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 279,
    user_face: "279-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 19:02:12 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "少年人的爱情总不会一帆风顺。。。最刻骨铭心的就是互相拉扯痛到最深处才好嗑。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "120",
  },
  {
    id: 280,
    user_face: "280-user-face.png",
    user_id: "日日树涉",
    is_op: false,
    create_at: "2022-12-28 19:04:40 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 281,
    user_face: "281-user-face.png",
    user_id: "想不出名字",
    is_op: false,
    create_at: "2022-12-28 19:07:43 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 282,
    user_face: "282-user-face.png",
    user_id: "minnnnnnnn",
    is_op: false,
    create_at: "2022-12-28 19:13:32 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 283,
    user_face: "283-user-face.png",
    user_id: "聪明勇敢有力气",
    is_op: false,
    create_at: "2022-12-28 19:14:06 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。朋友醒了没。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 284,
    user_face: "284-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 19:18:36 云南",
    quote: {
      quote_status: true,
      quote_content: "接楼上。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "284-quote.png",
      },
    },
    cmt: {
      cmt_content: "💚好爱💙。。。。🤤磕死",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "65",
  },
  {
    id: 285,
    user_face: "285-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 19:20:08 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥。。。。。还是想看你朋友的后续。。。想看唯粉姐视角。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "42",
  },
  {
    id: 286,
    user_face: "286-user-face.png",
    user_id: "聚光灯",
    is_op: false,
    create_at: "2022-12-28 19:20:28 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "大作文。。。想看。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 287,
    user_face: "287-user-face.png",
    user_id: "小乖乖",
    is_op: false,
    create_at: "2022-12-28 19:27:29 四川",
    quote: {
      quote_status: true,
      quote_content:
        "2⃣️尴尬转变+成长痛\n这个时间段就大概是以我们的少年时代开拍到22出国为界限的。\n\n我们的少年时代开拍是wjk高三的时候（前后吧，记不清了懒得去查了）当时时代fj要开这个戏，首页xpx都骂疯了因为会影响wjk高考，wjk是sdjf第一个养成系养到高考的，具体的时间规划都没有先例，大家都认为他应该是闭关一整年才行，当时连他考北电都没有定下来。\n\n其实严格来说这电视剧拍摄作为上一个阶段的收尾也不是不行，他们这个时候还是很亲密的，只是wy在面对wjk的一些“掌控”上，开始有一些微妙的回避，而wjk也对这种相处有些尴尬，但习惯已然多年，很多下意识玩笑和话语就像肌肉记忆一样，他们仍然是掌控和顺从的时候多，尴尬的时候少，但这已经是一个开始了。\n\n很大的一个差别就是，小时候他们经常有双人的大大方方的合照，自拍。但是少年时代梧桐和班小松的官方双人剧照却被岛看作发糖了大糖了，这也是粉丝对他们关系的不同反应。那个时候也是他们有自己的个人资源的开始，wjkwy都有了自己的个综，就是自己出去上综艺而不是打包，那个时候一切都是新鲜的，即有点不习惯，但是结识更多娱乐圈的人脉让他们也是满足的，快乐的，他们整体看着还是高兴的。\n\nwjk成年那天，我又在现场，那天wy的情绪和17岁wjk生日会是不太一样的，有点感动的欣喜，反正很不一样。\n\n也随着所谓的单飞，他们越来越明白什么是正常的“兄弟”之间的相处方式，也做出过一些啼笑皆非的事情，比如wy一天天嚷嚷要当刚哥，我记得那个时候我首页的xpx天天转粉见骂他当刚哥的通稿。那段时间他们的关系怎么样都别扭，特别别扭，也让岛鸡稍微能窥探到一点他俩单独的与xxxx无关的事情就当糖就放鞭炮，比如xxxx在前面走他俩走后面都算。wjk也在这个时期彻底收回了他的“过度照顾”\n\n那段时间也随着xxxx准备登机（大概是拍摄着抄袭的你的时间）想要独美，整个tfb都像是不认识一样。。。臭名昭著的五周年就是那个时候发生的。那场演唱会，我也在现场，每个人出来都没有笑脸，好像粉丝欠他们八百万一样，🍀被打击的七零八落伤心不已，因为🍀是非常看重五年的，他们认为这是十年之约的一半进程，结束之后直呼诈骗。那场演唱会确实很诈骗连ending都没有正式的。\n\n那段时间粉丝的情绪也好，他们的关系也好，都非常混乱。\n\n他们冰冷的关系出现互动和转折就是22决定出国了。\n\n\n\n补完。。。第二阶段",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥快更啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 288,
    user_face: "288-user-face.png",
    user_id: "我是葛朗台",
    is_op: false,
    create_at: "2022-12-28 19:29:22 葡萄牙",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 289,
    user_face: "289-user-face.png",
    user_id: "如花美眷",
    is_op: false,
    create_at: "2022-12-28 19:29:58 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥我下班晚饭都吃了。。。你准备更了吗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 290,
    user_face: "290-user-face.png",
    user_id: "蜂蜜芥末",
    is_op: false,
    create_at: "2022-12-28 19:33:26 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 291,
    user_face: "291-user-face.png",
    user_id: "贝壳儿（备考版",
    is_op: false,
    create_at: "2022-12-28 19:33:39 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 292,
    user_face: "292-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 19:37:08 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@momo @摇晃的红酒卑 @月长月长月半 请渴。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 293,
    user_face: "293-user-face.png",
    user_id: "一粒沙白",
    is_op: false,
    create_at: "2022-12-28 19:38:52 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "完了我觉得帖子我等不到更新就会寄了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "17",
  },
  {
    id: 294,
    user_face: "294-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 19:39:58 广东",
    quote: {
      quote_status: true,
      quote_content: "完了我觉得帖子我等不到更新就会寄了",
      quote_user_id: "一粒沙白",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我都保存了。。。寄了就再发。。。不过i3朋友们。。。也是一起🐶过的。。。手下留情吧哈哈哈哈。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "145",
  },
  {
    id: 295,
    user_face: "295-user-face.png",
    user_id: "一粒沙白",
    is_op: false,
    create_at: "2022-12-28 19:41:18 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哈哈哈哈哈哈哈哈那我要说打架上，帝国姐姐不到最后不知道输字怎么写，笑死",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "66",
  },
  {
    id: 296,
    user_face: "296-user-face.png",
    user_id: "匿名用户",
    is_op: false,
    create_at: "2022-12-28 19:42:03 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了，太好渴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 297,
    user_face: "297-user-face.png",
    user_id: "去月球🔭",
    is_op: false,
    create_at: "2022-12-28 19:45:21 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 298,
    user_face: "298-user-face.png",
    user_id: "不要再吵啦",
    is_op: false,
    create_at: "2022-12-28 19:48:35 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥，，，，快更呀，，，，，",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 299,
    user_face: "299-user-face.png",
    user_id: "这个芒果请你次",
    is_op: false,
    create_at: "2022-12-28 19:53:49 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "一分钟刷新80次。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 300,
    user_face: "300-user-face.png",
    user_id: "啊啊啊啊啊",
    is_op: false,
    create_at: "2022-12-28 19:55:26 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "等等哥哥。。。这个视角很有意思。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 301,
    user_face: "301-user-face.png",
    user_id: "Accio Felix",
    is_op: false,
    create_at: "2022-12-28 19:58:04 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "战火纷飞。。。我先嗑一口😋",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 302,
    user_face: "302-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 19:58:06 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥们。。。写了一半的来了。。。。\n\n3⃣️ 发疯成年人\n\n说到成年阶段了，这个阶段的开始所有人都不陌生，就是22留学。很多哥哥也分析过wjk的那条微博了，文案是：出发去找答案\n\n这个事情是下一个阶段的开启，但还没有开始发疯。\n\n这个时候其实ky是刚刚结束试探和折磨，至于他们试探出什么结果来了吗？其实我本身不是很确定，但是确实是因为出国留学而关系缓和了，wjk那段时间对wy对态度柔和了很多。\n\n因为那时候是i3，所以其实我对wjk发微博到底是什么语气等等的都很敏锐。\n\n众所周知，几年前开始明星的微博就像死人一样了，商务广告博就不涛了，他们彼此之间每年送生日祝福其实都有点套话，有点无聊。但是那一次那首歌的转发，大家都知道wy决定去伯克利了，所以那次的文案很特别，用头担保，这是wjk走心走脑子走情写的，很特别很好品。\n\n没错，于理他是队长，他应该要祝福弟弟，他是公众人物，要维护好tfb在外界面前的感情和形象。他怎么样都应该发条微博的，但是他说一切顺利也可以，说继续加油也可以，但他说的是：出发去找答案。这个文案绝对不是工作室给他写的，讲理的东西只要求他做到说“一切顺利未来加油”这种程度，但他做到了更多。\n\n这是wjk近几年为数不多在wb流露他对wy的真心的时刻，或者也只有这种时刻是被工作室允许的，被世俗允许的，被清理允许的。更多的东西，于团队，于粉丝，于世俗都是出格，因为他们已经不再是15岁了。\n\n2019年是22和33关系有些许缓和的时候，22对wjk的反应是连i3都会注意到的程度。\n\n\n先说深圳六周年吧。。。对，我又在现场。。。\n\nlove和123wjk两个大糖不用我多说了，不知道的哥哥可以去看其他哥哥的整理，图文并茂，说的都非常好嗑。\n\n我这里还是做分析，不做回顾了，另外我这里来分析的一些糖点都是作为辅助，唯饭看这些东西的视角和cp粉肯定不太一样的。因为心路历程不一样，我们都是实在接受不了才相信是真的。哥哥们如果认为我说的不对，就当是喂饭本身下意识就想为他找借口骗自己吧哈哈，毕竟人和人对不同的事情肯定有不同的看法，但是换个思路想想，连我都觉得骗不了自己的🍬我都被迫按着头嗑的🍬才是真的甜嘛哈哈哈\n\n言归正传，love这个点其实我觉得甜也甜的，但你说唱嗨了也能理解。真的好玩的是123王俊凯。\n\n那天22喊出来的时候，我在台下的心情是？？？你小子挺敢的，这么多人，不避嫌了吗，笑得跟多花一样。至于wjk的反应，我复看自己拍的图是，心情是🚬\n\n\nwjk比起wy的大方磊落，反应更像问心有愧的那一位。他是没想到22那么大胆的（废话谁想到了我也被吓死了好吧，全场尖叫声达到顶峰，岛鸡真有这么多人吗？i4是不是也偷偷嗑呢）wjk眼神有点慌乱，但是嘴是忍不住勾起来在笑的，他就是又害怕又欣喜又慌乱但是对于wy的大胆，千万人中呐喊你姓名的勇气，wjk的心口是火热的，心动的。\n\n对，连我都看得出来，他开心，妈的。\n\n不过不算破大防，这些天长日久的细碎事情其实只是让我明白的心理历程进化到下一步，💙💚关系就是真的很好。\n\n真破大防怀疑他们是不是真的有一🦵的是19年底。\n\n\n\n\n这个part未完。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "339",
  },
  {
    id: 303,
    user_face: "303-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 19:58:54 广东",
    quote: {
      quote_status: true,
      quote_content: "一分钟刷新80次。。。",
      quote_user_id: "这个芒果请你次",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。更了。。。能看到吗。。。发了三次了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "26",
  },
  {
    id: 304,
    user_face: "304-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 20:04:04 广东",
    quote: {
      quote_status: true,
      quote_content: "等等哥哥。。。这个视角很有意思。。",
      quote_user_id: "啊啊啊啊啊",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。。其实说起来可能很好玩。。。是33按着头让人嗑的。。。但是对初恋追星的唯饭确实有点残忍哈哈哈哈。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "146",
  },
  {
    id: 305,
    user_face: "305-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 20:04:49 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "是真的很不拿各位哥哥当外人了。。。女友的事儿别问了。。。否则帖子就没了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "99",
  },
  {
    id: 306,
    user_face: "306-user-face.png",
    user_id: "把月亮摔碎",
    is_op: false,
    create_at: "2022-12-28 20:05:33 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快。。。哥哥。。。快。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 307,
    user_face: "307-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 20:10:11 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快！快！快！哥哥我很急💕💕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 308,
    user_face: "308-user-face.png",
    user_id: "你午睡了吗",
    is_op: false,
    create_at: "2022-12-28 20:10:39 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "123wjk。。是什么啊啊啊啊啊有没有哥哥。。给我💊。。要疯了我必须嗑到。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 309,
    user_face: "309-user-face.png",
    user_id: "浪我随便",
    is_op: false,
    create_at: "2022-12-28 20:11:01 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。快。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 310,
    user_face: "310-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 20:12:44 广东",
    quote: {
      quote_status: true,
      quote_content:
        "123wjk。。是什么啊啊啊啊啊有没有哥哥。。给我💊。。要疯了我必须嗑到。。。",
      quote_user_id: "你午睡了吗",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "wy在六周年演唱会上让全场观众喊名字，跟我喊123王俊凯。。。差不多是这样。。。岛鸡天堂唯粉地狱反正。。。哥哥感兴趣随便搜搜就有。。。甜的很。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "254",
  },
  {
    id: 311,
    user_face: "311-user-face.png",
    user_id: "小菜菜菜菜",
    is_op: false,
    create_at: "2022-12-28 20:13:19 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "快。。。。更。。。。救。。。。命。。。不要卡在关键部分。。风雨欲来啊哥哥",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "41",
  },
  {
    id: 312,
    user_face: "312-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 20:13:49 广东",
    quote: {
      quote_status: true,
      quote_content:
        "快。。。。更。。。。救。。。。命。。。不要卡在关键部分。。风雨欲来啊哥哥",
      quote_user_id: "小菜菜菜菜",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "生产队。。。驴。。。不行了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "59",
  },
  {
    id: 313,
    user_face: "313-user-face.png",
    user_id: "吃口蛋挞🧁",
    is_op: false,
    create_at: "2022-12-28 20:16:48 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "田娜。。。。。这么好磕😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 314,
    user_face: "314-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-28 20:17:01 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥们感兴趣的话给点评论。。。以上全部我朋友纯靠记忆写的。。。他们的细节太多了年份太久了有时候一下子真的想不起来会漏掉。。。评论可以激发一点。。。创作灵感。。。\n写得也确实很辛苦。。。希望哥哥们嗑得开心。。。\n另外年份应该差不多，万一有出入的话希望大家。。。谅解。。。好几年前的事儿了。。。我朋友全靠脑子记忆写的没去一一查验。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "169",
  },
  {
    id: 315,
    user_face: "315-user-face.png",
    user_id: "百腕巨人的守卫",
    is_op: false,
    create_at: "2022-12-28 20:19:33 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。早不更。要没了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "15",
  },
  {
    id: 316,
    user_face: "316-user-face.png",
    user_id: "蒂特洛伊木马",
    is_op: false,
    create_at: "2022-12-28 20:22:11 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥朋友写得好渴。。。。比踩组一些龟得要亖的💙💚糖好渴多了。。。。。摩多摩多。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "121",
  },
  {
    id: 317,
    user_face: "317-user-face.png",
    user_id: "混入雨中",
    is_op: false,
    create_at: "2022-12-28 20:23:48 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "给我磕到了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 318,
    user_face: "318-user-face.png",
    user_id: "不要不理我嘛",
    is_op: false,
    create_at: "2022-12-28 20:24:10 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。快。。。嗑到兴头上。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "13",
  },
  {
    id: 319,
    user_face: "319-user-face.png",
    user_id: "🐽🐽冰箱",
    is_op: false,
    create_at: "2022-12-28 20:26:04 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 320,
    user_face: "320-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 20:26:16 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑死我了。。。嗑死我了。。。嗑死我了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 321,
    user_face: "321-user-face.png",
    user_id: "yyyyyi",
    is_op: false,
    create_at: "2022-12-28 20:27:02 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。谢谢。。。又给我嗑到 💙💚了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 322,
    user_face: "322-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-28 20:27:11 广东",
    quote: {
      quote_status: true,
      quote_content:
        "wy在六周年演唱会上让全场观众喊名字，跟我喊123王俊凯。。。差不多是这样。。。岛鸡天堂唯粉地狱反正。。。哥哥感兴趣随便搜搜就有。。。甜的很。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "但是 也喊了 123 yyqx（实事求是中",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "139",
  },
  {
    id: 323,
    user_face: "323-user-face.png",
    user_id: "邢鹿男",
    is_op: false,
    create_at: "2022-12-28 20:34:31 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "补321wjk的图一张",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "183",
  },
  {
    id: 324,
    user_face: "324-user-face.png",
    user_id: "momo（已上岸）",
    is_op: false,
    create_at: "2022-12-28 20:35:30 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥。。快更。。没有哥哥觉得17年3生日会的小天使好嗑吗。。从始至终。。他都不一样。。他是小天使。。被钙子吓晕。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "162",
  },
  {
    id: 325,
    user_face: "325-user-face.png",
    user_id: "momo（已上岸）",
    is_op: false,
    create_at: "2022-12-28 20:39:05 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "同补充类似“出发去找答案”这种比较郑重的语气的3转发2微博。。还有19年毕业季2那个事之后发滚烫的青春。。3转发说的是“青春，加油”。。磕糖要带第三人。。4发的就是“毕业快乐”。。因为2的文案也有毕业快乐。。怎么不算一种回应呢。。你要加油。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "164",
  },
  {
    id: 326,
    user_face: "326-user-face.png",
    user_id: "西兰开花",
    is_op: false,
    create_at: "2022-12-28 20:50:21 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嘴角一直没掉下来过。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 327,
    user_face: "327-user-face.png",
    user_id: "肌肉泡泡鱼",
    is_op: false,
    create_at: "2022-12-28 20:51:47 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑得想鼠。。哥哥快。。继续。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 328,
    user_face: "328-user-face.png",
    user_id: "💦",
    is_op: false,
    create_at: "2022-12-28 20:53:56 黑龙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥朋友写得真好。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 329,
    user_face: "329-user-face.png",
    user_id: "待到葡萄成熟时",
    is_op: false,
    create_at: "2022-12-28 21:03:43 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我要住在这个楼里。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 330,
    user_face: "330-user-face.png",
    user_id: "限定四月",
    is_op: false,
    create_at: "2022-12-28 21:04:27 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 331,
    user_face: "331-user-face.png",
    user_id: "我说",
    is_op: false,
    create_at: "2022-12-28 21:11:11 山东",
    quote: {
      quote_status: true,
      quote_content:
        "其实也不是很彻底。。表面收回而已。。当时23表面发糖骤减。。但是帝国当时少年时代的采访。。主持人问4 3给他私下说高考什么相关的事情没有。。4说就是学习之类的。。但是2说。。3给他说高考完了很多人以后就再也见不到了。。那也是2第一次公开喊3俊凯。。。那段时间2也在开始纠结未来了。。他一开始并没有坚定出国的。。参加湖南台一个采访的时候还说以后可能会选影视。。那段说辞和3之前很像。。应该23私下是做过交流的。。后面开始改变是在青春旅社的时候。。在青春旅社2提过很多次3。。我为什么说表面3收回偏爱。。因为这个时候3已经没有小时候那么直来直去了。。很多情绪都掩埋的比较好。。包括2在青春旅社有一次3正好也去那边录演员的那个综艺。。2当时住山上。。有天晚上骑着自行车就不知道哪去了。。当时我记得是有人说3给他送厚衣服去了（说错了就是我记错了。。好像说是去的时候拿了行李箱回来就没了啥的忘记了）然后后面18年。。岛上很多事情都是18年发生的。。2那个时候还在纠结要不要出国。。当时发了首歌叫我不知道。。然后发微博。。3就在下面说出发去找答案。。从2纠结到真的决定期间2发的每次微博3当时回复的都很郑重。。也就是说3其实一直是支持的。。我也偏向这两个人私下肯定说了什么。。包括著名的机场未知事件和传说中的璀璨夺目善良天真都是这段时间发生的事情。。怎么越回顾事儿越多。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "在出国前2还发了条微博，是一个他的背影，配文：这一次，你叫我就回头。啊啊啊啊我之前没想到这个可以嗑的😭后来他删掉了就越发显的欲盖弥彰了。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "297",
  },
  {
    id: 332,
    user_face: "332-user-face.png",
    user_id: "四冠选手叶不修",
    is_op: false,
    create_at: "2022-12-28 21:17:10 广西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "想起那个脱粉组著名脱粉帖。。。。他们两个的感情就像见不得光的苔藓一样那个。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "194",
  },
  {
    id: 333,
    user_face: "333-user-face.png",
    user_id: "你的王子",
    is_op: false,
    create_at: "2022-12-28 21:17:16 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑晕。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 334,
    user_face: "334-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-28 21:19:40 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "还没看楼主朋友分析的。。。但是一直这样觉得的。。。嗑凯源是一件包赢不亏的事情。。。就算以后各自欢喜了。。。总有前线粉出来放锤的。。。那些只听说过没见过的料说不定早晚有浮出水面的一天。。。就算是过期🍬也是好的。。。他们俩还有很神奇的一点在于总有那种两三年前的料两三年后才被锤。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "261",
  },
  {
    id: 335,
    user_face: "335-user-face.png",
    user_id: "四冠选手叶不修",
    is_op: false,
    create_at: "2022-12-28 21:21:36 广西",
    quote: {
      quote_status: true,
      quote_content:
        "对。。。那个阶段其实骂战最严重。。。i2骂wjk掌控欲管闲事大煞笔。。。i3骂wy巨婴。。。他俩也努力维持和四字的关系。。。但是相同的口味相同的习惯相同的乡音更多年的情谊就是让他们更愿意靠近彼此。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "磕死。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 336,
    user_face: "336-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-28 21:26:41 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "楼上哥哥说的是真的。。真的很多料。。。虽然假的也很多就是了。。。我印象最深是三字生日会彩排二字陪着去的 当着粉丝的面下车跑掉 三字在后面慢慢走 那是他俩被说be最凶的17年。。。我以为是滤料 直到前段时间看到视频。。。四五年。。。这帮人是真会藏啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "400",
  },
  {
    id: 337,
    user_face: "337-user-face.png",
    user_id: "芋泥仙草冻",
    is_op: false,
    create_at: "2022-12-28 21:26:54 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 338,
    user_face: "338-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-28 21:28:33 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕的发疯",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 339,
    user_face: "339-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-28 21:28:33 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "补图。。。。风风雨雨与我无关。。躲进此帖嗑。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "64",
  },
  {
    id: 340,
    user_face: "340-user-face.png",
    user_id: "四冠选手叶不修",
    is_op: false,
    create_at: "2022-12-28 21:30:30 广西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥你朋友的图文并茂大作文呢。。。。。等得我翻来覆去。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "47",
  },
  {
    id: 341,
    user_face: "341-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 21:32:13 云南",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥们。。。写了一半的来了。。。。\n\n3⃣️ 发疯成年人\n\n说到成年阶段了，这个阶段的开始所有人都不陌生，就是22留学。很多哥哥也分析过wjk的那条微博了，文案是：出发去找答案\n\n这个事情是下一个阶段的开启，但还没有开始发疯。\n\n这个时候其实ky是刚刚结束试探和折磨，至于他们试探出什么结果来了吗？其实我本身不是很确定，但是确实是因为出国留学而关系缓和了，wjk那段时间对wy对态度柔和了很多。\n\n因为那时候是i3，所以其实我对wjk发微博到底是什么语气等等的都很敏锐。\n\n众所周知，几年前开始明星的微博就像死人一样了，商务广告博就不涛了，他们彼此之间每年送生日祝福其实都有点套话，有点无聊。但是那一次那首歌的转发，大家都知道wy决定去伯克利了，所以那次的文案很特别，用头担保，这是wjk走心走脑子走情写的，很特别很好品。\n\n没错，于理他是队长，他应该要祝福弟弟，他是公众人物，要维护好tfb在外界面前的感情和形象。他怎么样都应该发条微博的，但是他说一切顺利也可以，说继续加油也可以，但他说的是：出发去找答案。这个文案绝对不是工作室给他写的，讲理的东西只要求他做到说“一切顺利未来加油”这种程度，但他做到了更多。\n\n这是wjk近几年为数不多在wb流露他对wy的真心的时刻，或者也只有这种时刻是被工作室允许的，被世俗允许的，被清理允许的。更多的东西，于团队，于粉丝，于世俗都是出格，因为他们已经不再是15岁了。\n\n2019年是22和33关系有些许缓和的时候，22对wjk的反应是连i3都会注意到的程度。\n\n\n先说深圳六周年吧。。。对，我又在现场。。。\n\nlove和123wjk两个大糖不用我多说了，不知道的哥哥可以去看其他哥哥的整理，图文并茂，说的都非常好嗑。\n\n我这里还是做分析，不做回顾了，另外我这里来分析的一些糖点都是作为辅助，唯饭看这些东西的视角和cp粉肯定不太一样的。因为心路历程不一样，我们都是实在接受不了才相信是真的。哥哥们如果认为我说的不对，就当是喂饭本身下意识就想为他找借口骗自己吧哈哈，毕竟人和人对不同的事情肯定有不同的看法，但是换个思路想想，连我都觉得骗不了自己的🍬我都被迫按着头嗑的🍬才是真的甜嘛哈哈哈\n\n言归正传，love这个点其实我觉得甜也甜的，但你说唱嗨了也能理解。真的好玩的是123王俊凯。\n\n那天22喊出来的时候，我在台下的心情是？？？你小子挺敢的，这么多人，不避嫌了吗，笑得跟多花一样。至于wjk的反应，我复看自己拍的图是，心情是🚬\n\n\nwjk比起wy的大方磊落，反应更像问心有愧的那一位。他是没想到22那么大胆的（废话谁想到了我也被吓死了好吧，全场尖叫声达到顶峰，岛鸡真有这么多人吗？i4是不是也偷偷嗑呢）wjk眼神有点慌乱，但是嘴是忍不住勾起来在笑的，他就是又害怕又欣喜又慌乱但是对于wy的大胆，千万人中呐喊你姓名的勇气，wjk的心口是火热的，心动的。\n\n对，连我都看得出来，他开心，妈的。\n\n不过不算破大防，这些天长日久的细碎事情其实只是让我明白的心理历程进化到下一步，💙💚关系就是真的很好。\n\n真破大防怀疑他们是不是真的有一🦵的是19年底。\n\n\n\n\n这个part未完。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "说起文案和出国。。。。。我又想起来33在自己生日和22生日博里两次提到让他在国外照顾好自己。。。。。回复22的祝福说一次自己给22祝福又说一次。。。。。。公开台面上都要这般。。。不知道私下要反反复复叮嘱多少次。。。。。。操心老妈子一样。。。。真的很不放心22自己一个人吧。。。。。🤤🤤🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "200",
  },
  {
    id: 342,
    user_face: "342-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-28 21:36:53 四川",
    quote: {
      quote_status: true,
      quote_content:
        "楼上哥哥说的是真的。。真的很多料。。。虽然假的也很多就是了。。。我印象最深是三字生日会彩排二字陪着去的 当着粉丝的面下车跑掉 三字在后面慢慢走 那是他俩被说be最凶的17年。。。我以为是滤料 直到前段时间看到视频。。。四五年。。。这帮人是真会藏啊。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "就像今年cp站姐在wjk生日那天发了一张wjk瑞士的照片。。。真的一个比一个能藏。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "229",
  },
  {
    id: 343,
    user_face: "343-user-face.png",
    user_id: ".",
    is_op: false,
    create_at: "2022-12-28 21:38:36 广东",
    quote: {
      quote_status: true,
      quote_content:
        "就像今年cp站姐在wjk生日那天发了一张wjk瑞士的照片。。。真的一个比一个能藏。。。",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这啥？？？？",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "15",
  },
  {
    id: 344,
    user_face: "344-user-face.png",
    user_id: "青山常在",
    is_op: false,
    create_at: "2022-12-28 21:39:56 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 345,
    user_face: "345-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-28 21:41:00 四川",
    quote: {
      quote_status: true,
      quote_content: "这啥？？？？",
      quote_user_id: ".",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "就这样而已。。。但是瑞士很难不想到瑞士游😂。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "91",
  },
  {
    id: 346,
    user_face: "346-user-face.png",
    user_id: "元气少女郭德纲",
    is_op: false,
    create_at: "2022-12-28 21:42:45 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "真滴好嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 347,
    user_face: "347-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 21:45:19 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "wy在六周年演唱会上让全场观众喊名字，跟我喊123王俊凯。。。差不多是这样。。。岛鸡天堂唯粉地狱反正。。。哥哥感兴趣随便搜搜就有。。。甜的很。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我有点子印象！。。。。当时这句321wjk一出来，整个豆瓣全是蓝绿贴。。。大家都get到了那种微妙情绪。。。。而且他喊4只喊了321qx，感觉就是，他喊了wjk之后现场炸了，他才在那儿有点慌的找补。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "284",
  },
  {
    id: 348,
    user_face: "348-user-face.png",
    user_id: "禁止生气",
    is_op: false,
    create_at: "2022-12-28 21:46:07 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "看完是能理解cpf为什么会发疯了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "75",
  },
  {
    id: 349,
    user_face: "349-user-face.png",
    user_id: "什么情况",
    is_op: false,
    create_at: "2022-12-28 21:46:26 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "唯粉姐姐视角确实好嗑。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 350,
    user_face: "350-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 21:46:35 重庆",
    quote: {
      quote_status: true,
      quote_content: "补图。。。。风风雨雨与我无关。。躲进此帖嗑。。",
      quote_user_id: "暹罗神偷高卿尘",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "350-quote.png",
      },
    },
    cmt: {
      cmt_content: "哥哥。。。这是动图吗？如果是。。。那冻住了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 351,
    user_face: "351-user-face.png",
    user_id: "Rr.",
    is_op: false,
    create_at: "2022-12-28 21:52:14 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "楼主快更，我好害怕这贴没了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 352,
    user_face: "352-user-face.png",
    user_id: "21世紀難民",
    is_op: false,
    create_at: "2022-12-28 22:00:48 四川",
    quote: {
      quote_status: true,
      quote_content:
        "补一点东西，其实踩组说粉丝什么都知道，是真的。\n32之间有一件事情让我朋友一个铁血i3真的怀疑他俩有一腿（这个我朋友会按照叙述线在后面提到）但33和22的曾经绯闻女友根据我朋友掌握的消息其实也很锤。。。\n说实话，这也是我朋友至今都很怀疑到底他俩是不是真给子的原因。\n但无论如何，可以给出肯定答案的就是💙💚关系真的就是很好，绝对不用怀疑他俩的关系不合，他们和44的关系才是很难说的。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "@我是1😚 磕鼠我了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 353,
    user_face: "353-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-28 22:02:48 江苏",
    quote: {
      quote_status: true,
      quote_content: "哥哥。。。这是动图吗？如果是。。。那冻住了",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这个应该动。。对唱l o v e",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "158",
  },
  {
    id: 354,
    user_face: "354-user-face.png",
    user_id: "寺",
    is_op: false,
    create_at: "2022-12-28 22:05:10 海南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "你最好是真的gay",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "50",
  },
  {
    id: 355,
    user_face: "355-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 22:10:11 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "刚刚有个组外的哥哥拜托补充的321wjk细节，kswlkswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "219",
  },
  {
    id: 356,
    user_face: "356-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 22:11:40 重庆",
    quote: {
      quote_status: true,
      quote_content: "刚刚有个组外的哥哥拜托补充的321wjk细节，kswlkswl",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "356-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "还有。。。。也是这位哥哥提供的视频，道济还有多少🍬。。。拿出来磕磕。。。。\n【【凯源】321 王俊凯！+第一次告白（6 focus）-哔哩哔哩】 https://b23.tv/REmHjSP",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "66",
  },
  {
    id: 357,
    user_face: "357-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 22:16:59 重庆",
    quote: {
      quote_status: true,
      quote_content: "这个应该动。。对唱l o v e",
      quote_user_id: "暹罗神偷高卿尘",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "357-quote.png",
      },
    },
    cmt: {
      cmt_content: "是隔着阿信。。。对。。。对方唱love吗？",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "80",
  },
  {
    id: 358,
    user_face: "358-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-28 22:17:19 云南",
    quote: {
      quote_status: true,
      quote_content: "刚刚有个组外的哥哥拜托补充的321wjk细节，kswlkswl",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "358-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "真的真的。。。22那个321完全是即兴发挥。。。。33一脸错愕+迷惑+震惊。。。最后又暗自窃喜。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "210",
  },
  {
    id: 359,
    user_face: "359-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-28 22:18:33 江苏",
    quote: {
      quote_status: true,
      quote_content: "是隔着阿信。。。对。。。对方唱love吗？",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "是的捏。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "96",
  },
  {
    id: 360,
    user_face: "360-user-face.png",
    user_id: "拥抱自由",
    is_op: false,
    create_at: "2022-12-28 22:24:11 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 361,
    user_face: "361-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-28 22:25:12 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "苔藓一样的感情。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "138",
  },
  {
    id: 362,
    user_face: "362-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 22:25:46 广东",
    quote: {
      quote_status: true,
      quote_content:
        "出国真的是分水岭，那段时间太痛了。。无限拉扯之后看清内心然后感觉更加坚定了（蹲蹲更新",
      quote_user_id: "月晕侵袭",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "出国前。。。22在生日会唱我怀念的。。。。太痛了。。成长太痛了。。。还有33的词不达意。。。。这两首歌。。。我每次听。。。都觉得。。太痛了。。。不爱会痛。。。太爱也会痛。。。是不是疼痛才是爱情真正的底色。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "253",
  },
  {
    id: 363,
    user_face: "363-user-face.png",
    user_id: "クリアー",
    is_op: false,
    create_at: "2022-12-28 22:29:25 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "她们i3心理状态真的还好吗。。。我puq搞内娱的不太多。。有个已经无语到爆炸。。。因为2去了江苏第一个排的江苏。。。没想到去了。。。她真的妙语连珠（真不是反串）。。。但是我不好截图。。。只能感慨一下全天下追星果然一个样。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "200",
  },
  {
    id: 364,
    user_face: "364-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 22:31:35 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "真的真的。。。22那个321完全是即兴发挥。。。。33一脸错愕+迷惑+震惊。。。最后又暗自窃喜。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "看来现场所有人。。。。都没有想到2会来这一出。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "46",
  },
  {
    id: 365,
    user_face: "365-user-face.png",
    user_id: "是爱要久久📢",
    is_op: false,
    create_at: "2022-12-28 22:43:11 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "😭😭😭哥哥。。。快继续。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 366,
    user_face: "366-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 22:46:51 英国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。加油更。。。在这里住下了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 367,
    user_face: "367-user-face.png",
    user_id: "ʕ •ᴥ•ʔ",
    is_op: false,
    create_at: "2022-12-28 22:50:38 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。蹲麻了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 368,
    user_face: "368-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2022-12-28 22:52:32 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 369,
    user_face: "369-user-face.png",
    user_id: "🚬",
    is_op: false,
    create_at: "2022-12-28 22:54:28 德国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥快更。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 370,
    user_face: "370-user-face.png",
    user_id: "限定四月",
    is_op: false,
    create_at: "2022-12-28 22:54:31 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 371,
    user_face: "371-user-face.png",
    user_id: "疯批美人",
    is_op: false,
    create_at: "2022-12-28 22:54:38 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "怎么十年了。。。还不停有料出来啊。。热恋十年是吧。。这对给自真的牛",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "179",
  },
  {
    id: 372,
    user_face: "372-user-face.png",
    user_id: "和光",
    is_op: false,
    create_at: "2022-12-28 22:57:50 黑龙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我的天 原来💙💚还有这么多我不知道的好东西 住在这栋楼里了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "97",
  },
  {
    id: 373,
    user_face: "373-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-28 22:58:13 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥我还等着",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 374,
    user_face: "374-user-face.png",
    user_id: "…………",
    is_op: false,
    create_at: "2022-12-28 22:58:40 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥，还有吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 375,
    user_face: "375-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-28 22:58:54 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥快更",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 376,
    user_face: "376-user-face.png",
    user_id: "极光辐能聚集",
    is_op: false,
    create_at: "2022-12-28 23:01:20 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "啊啊啊啊啊啊啊啊啊啊啊啊啊啊生产队的驴都不敢这么歇。。。速速。。快",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "26",
  },
  {
    id: 377,
    user_face: "377-user-face.png",
    user_id: "他即海中鸟",
    is_op: false,
    create_at: "2022-12-28 23:02:40 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕死我了555555",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 378,
    user_face: "378-user-face.png",
    user_id: "垃圾小狗",
    is_op: false,
    create_at: "2022-12-28 23:07:28 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 379,
    user_face: "379-user-face.png",
    user_id: "叶叶",
    is_op: false,
    create_at: "2022-12-28 23:11:43 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "太好磕。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 380,
    user_face: "380-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 23:12:42 山东",
    quote: {
      quote_status: true,
      quote_content: "接楼上。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "380-quote.png",
      },
    },
    cmt: {
      cmt_content: "kswl。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "10",
  },
  {
    id: 381,
    user_face: "381-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-28 23:12:50 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥等的我发疯。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 382,
    user_face: "382-user-face.png",
    user_id: "我美式",
    is_op: false,
    create_at: "2022-12-28 23:13:24 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥快更。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 383,
    user_face: "383-user-face.png",
    user_id: "🥺",
    is_op: false,
    create_at: "2022-12-28 23:14:09 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 384,
    user_face: "384-user-face.png",
    user_id: "MBWS*",
    is_op: false,
    create_at: "2022-12-28 23:14:24 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥 快更🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 385,
    user_face: "385-user-face.png",
    user_id: "hayake",
    is_op: false,
    create_at: "2022-12-28 23:16:07 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 386,
    user_face: "386-user-face.png",
    user_id: "不要再吵啦",
    is_op: false,
    create_at: "2022-12-28 23:16:22 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "快更哥哥",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 387,
    user_face: "387-user-face.png",
    user_id: "朴正洙(已养狗)",
    is_op: false,
    create_at: "2022-12-28 23:17:08 浙江",
    quote: {
      quote_status: true,
      quote_content: "苔藓一样的感情。。",
      quote_user_id: "暹罗神偷高卿尘",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "387-quote.png",
      },
    },
    cmt: {
      cmt_content: "虐到了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 388,
    user_face: "388-user-face.png",
    user_id: "TNT-风销销",
    is_op: false,
    create_at: "2022-12-28 23:17:34 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。住下了。。 ",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 389,
    user_face: "389-user-face.png",
    user_id: "TNT-风销销",
    is_op: false,
    create_at: "2022-12-28 23:17:57 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@TNT—周风 嗑啊。。。请嗑啊😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 390,
    user_face: "390-user-face.png",
    user_id: "Tartarus",
    is_op: false,
    create_at: "2022-12-28 23:28:01 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴亖我了，住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 391,
    user_face: "391-user-face.png",
    user_id: "明年重来姚景元",
    is_op: false,
    create_at: "2022-12-28 23:31:30 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@期末战神贺峻霖",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 392,
    user_face: "392-user-face.png",
    user_id: "椰叶果",
    is_op: false,
    create_at: "2022-12-28 23:34:54 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@淡季动物园 真的是十年了 盘的弯弯绕绕数不清楚的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 393,
    user_face: "393-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-28 23:37:23 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 394,
    user_face: "394-user-face.png",
    user_id: "籁也滴嘛",
    is_op: false,
    create_at: "2022-12-28 23:39:16 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "等个耳朵，我对于他们两吃瓜梦能成但回到现实又觉得有点荒谬但还是忍不住磕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "37",
  },
  {
    id: 395,
    user_face: "395-user-face.png",
    user_id: "旺旺仙贝",
    is_op: false,
    create_at: "2022-12-28 23:44:05 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "震惊 这么多年了ky还在给我源源不断喂💊 kswl呀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "21",
  },
  {
    id: 396,
    user_face: "396-user-face.png",
    user_id: "我没瘦",
    is_op: false,
    create_at: "2022-12-28 23:44:10 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "妈呀。。。乐死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 397,
    user_face: "397-user-face.png",
    user_id: "沧笙踏歌",
    is_op: false,
    create_at: "2022-12-28 23:50:19 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "还有。。。。也是这位哥哥提供的视频，道济还有多少🍬。。。拿出来磕磕。。。。\n【【凯源】321 王俊凯！+第一次告白（6 focus）-哔哩哔哩】 https://b23.tv/REmHjSP",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "看了视频才发现。。4是哑巴了吗。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "100",
  },
  {
    id: 398,
    user_face: "398-user-face.png",
    user_id: "暴走美玲",
    is_op: false,
    create_at: "2022-12-28 23:55:53 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 399,
    user_face: "399-user-face.png",
    user_id: "sowhat",
    is_op: false,
    create_at: "2022-12-28 23:58:28 广西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "19年底。。。。催更了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 400,
    user_face: "400-user-face.png",
    user_id: "TNT—周风",
    is_op: false,
    create_at: "2022-12-28 23:58:39 江苏",
    quote: {
      quote_status: true,
      quote_content: "@209169081 嗑啊。。。请嗑啊😭",
      quote_user_id: "TNT-风销销",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "今晚睡前看 我蹲过了🤭🤭🤭💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 401,
    user_face: "401-user-face.png",
    user_id: "豆友72054969",
    is_op: false,
    create_at: "2022-12-28 23:59:50 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "m",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 402,
    user_face: "402-user-face.png",
    user_id: "一般通过小兔",
    is_op: false,
    create_at: "2022-12-29 00:10:22 美国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕晕了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 403,
    user_face: "403-user-face.png",
    user_id: "小神吃火锅啦",
    is_op: false,
    create_at: "2022-12-29 00:24:03 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "11111",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 404,
    user_face: "404-user-face.png",
    user_id: "泽泽",
    is_op: false,
    create_at: "2022-12-29 00:27:15 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。你朋友睡了吗。。。我睡不着。。。快起来更新",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "29",
  },
  {
    id: 405,
    user_face: "405-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 00:31:15 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。因为你。。。我在b站磕一天了。。。。磕到崩溃",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "39",
  },
  {
    id: 406,
    user_face: "406-user-face.png",
    user_id: "刘华强",
    is_op: false,
    create_at: "2022-12-29 00:33:43 四川",
    quote: {
      quote_status: true,
      quote_content: "有哥哥私信投稿的。。。非我原创。。。大家可以先嗑着。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "406-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "😭哭死。。。天空是我寄给你的明信片。。。真的太小情侣了。。。，。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "61",
  },
  {
    id: 407,
    user_face: "407-user-face.png",
    user_id: "氧氟沙星滴眼液",
    is_op: false,
    create_at: "2022-12-29 00:34:13 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 408,
    user_face: "408-user-face.png",
    user_id: "阿门洲园丁🌸",
    is_op: false,
    create_at: "2022-12-29 00:36:56 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 409,
    user_face: "409-user-face.png",
    user_id: "不吃甜的🐷",
    is_op: false,
    create_at: "2022-12-29 00:39:05 河北",
    quote: {
      quote_status: true,
      quote_content:
        "楼上哥哥说的是真的。。真的很多料。。。虽然假的也很多就是了。。。我印象最深是三字生日会彩排二字陪着去的 当着粉丝的面下车跑掉 三字在后面慢慢走 那是他俩被说be最凶的17年。。。我以为是滤料 直到前段时间看到视频。。。四五年。。。这帮人是真会藏啊。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "我嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 410,
    user_face: "410-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 00:42:45 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "私信的都停一停。。。不会发的。。。不用私我问npy的事儿了。。。不会说的。。。贴子说出来只是后续方便大家判断。。。再问就是我造谣哈。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "61",
  },
  {
    id: 411,
    user_face: "411-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 00:43:42 广东",
    quote: {
      quote_status: true,
      quote_content: "哥哥。。。你朋友睡了吗。。。我睡不着。。。快起来更新",
      quote_user_id: "泽泽",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "明天了哥哥。。。朋友她今天太忙了。。。被33刺激到抽时间写小作文。。。明天会继续。。。睡吧哥哥。。。好好休息。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 412,
    user_face: "412-user-face.png",
    user_id: "顾兔",
    is_op: false,
    create_at: "2022-12-29 00:44:09 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。好好嗑。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 413,
    user_face: "413-user-face.png",
    user_id: "一寸灰",
    is_op: false,
    create_at: "2022-12-29 00:44:52 福建",
    quote: {
      quote_status: true,
      quote_content:
        "其实也不是很彻底。。表面收回而已。。当时23表面发糖骤减。。但是帝国当时少年时代的采访。。主持人问4 3给他私下说高考什么相关的事情没有。。4说就是学习之类的。。但是2说。。3给他说高考完了很多人以后就再也见不到了。。那也是2第一次公开喊3俊凯。。。那段时间2也在开始纠结未来了。。他一开始并没有坚定出国的。。参加湖南台一个采访的时候还说以后可能会选影视。。那段说辞和3之前很像。。应该23私下是做过交流的。。后面开始改变是在青春旅社的时候。。在青春旅社2提过很多次3。。我为什么说表面3收回偏爱。。因为这个时候3已经没有小时候那么直来直去了。。很多情绪都掩埋的比较好。。包括2在青春旅社有一次3正好也去那边录演员的那个综艺。。2当时住山上。。有天晚上骑着自行车就不知道哪去了。。当时我记得是有人说3给他送厚衣服去了（说错了就是我记错了。。好像说是去的时候拿了行李箱回来就没了啥的忘记了）然后后面18年。。岛上很多事情都是18年发生的。。2那个时候还在纠结要不要出国。。当时发了首歌叫我不知道。。然后发微博。。3就在下面说出发去找答案。。从2纠结到真的决定期间2发的每次微博3当时回复的都很郑重。。也就是说3其实一直是支持的。。我也偏向这两个人私下肯定说了什么。。包括著名的机场未知事件和传说中的璀璨夺目善良天真都是这段时间发生的事情。。怎么越回顾事儿越多。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "机场未知事件是什么。。。天真璀璨又是什么。。。得不到答案我会彻夜难眠。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 414,
    user_face: "414-user-face.png",
    user_id: "一寸灰",
    is_op: false,
    create_at: "2022-12-29 00:46:04 福建",
    quote: {
      quote_status: true,
      quote_content: "有哥哥私信投稿的。。。非我原创。。。大家可以先嗑着。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "414-quote.png",
      },
    },
    cmt: {
      cmt_content: "打牌，抽对。。。渴死我了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 415,
    user_face: "415-user-face.png",
    user_id: "刘华强",
    is_op: false,
    create_at: "2022-12-29 00:46:35 四川",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥们。。。写了一半的来了。。。。\n\n3⃣️ 发疯成年人\n\n说到成年阶段了，这个阶段的开始所有人都不陌生，就是22留学。很多哥哥也分析过wjk的那条微博了，文案是：出发去找答案\n\n这个事情是下一个阶段的开启，但还没有开始发疯。\n\n这个时候其实ky是刚刚结束试探和折磨，至于他们试探出什么结果来了吗？其实我本身不是很确定，但是确实是因为出国留学而关系缓和了，wjk那段时间对wy对态度柔和了很多。\n\n因为那时候是i3，所以其实我对wjk发微博到底是什么语气等等的都很敏锐。\n\n众所周知，几年前开始明星的微博就像死人一样了，商务广告博就不涛了，他们彼此之间每年送生日祝福其实都有点套话，有点无聊。但是那一次那首歌的转发，大家都知道wy决定去伯克利了，所以那次的文案很特别，用头担保，这是wjk走心走脑子走情写的，很特别很好品。\n\n没错，于理他是队长，他应该要祝福弟弟，他是公众人物，要维护好tfb在外界面前的感情和形象。他怎么样都应该发条微博的，但是他说一切顺利也可以，说继续加油也可以，但他说的是：出发去找答案。这个文案绝对不是工作室给他写的，讲理的东西只要求他做到说“一切顺利未来加油”这种程度，但他做到了更多。\n\n这是wjk近几年为数不多在wb流露他对wy的真心的时刻，或者也只有这种时刻是被工作室允许的，被世俗允许的，被清理允许的。更多的东西，于团队，于粉丝，于世俗都是出格，因为他们已经不再是15岁了。\n\n2019年是22和33关系有些许缓和的时候，22对wjk的反应是连i3都会注意到的程度。\n\n\n先说深圳六周年吧。。。对，我又在现场。。。\n\nlove和123wjk两个大糖不用我多说了，不知道的哥哥可以去看其他哥哥的整理，图文并茂，说的都非常好嗑。\n\n我这里还是做分析，不做回顾了，另外我这里来分析的一些糖点都是作为辅助，唯饭看这些东西的视角和cp粉肯定不太一样的。因为心路历程不一样，我们都是实在接受不了才相信是真的。哥哥们如果认为我说的不对，就当是喂饭本身下意识就想为他找借口骗自己吧哈哈，毕竟人和人对不同的事情肯定有不同的看法，但是换个思路想想，连我都觉得骗不了自己的🍬我都被迫按着头嗑的🍬才是真的甜嘛哈哈哈\n\n言归正传，love这个点其实我觉得甜也甜的，但你说唱嗨了也能理解。真的好玩的是123王俊凯。\n\n那天22喊出来的时候，我在台下的心情是？？？你小子挺敢的，这么多人，不避嫌了吗，笑得跟多花一样。至于wjk的反应，我复看自己拍的图是，心情是🚬\n\n\nwjk比起wy的大方磊落，反应更像问心有愧的那一位。他是没想到22那么大胆的（废话谁想到了我也被吓死了好吧，全场尖叫声达到顶峰，岛鸡真有这么多人吗？i4是不是也偷偷嗑呢）wjk眼神有点慌乱，但是嘴是忍不住勾起来在笑的，他就是又害怕又欣喜又慌乱但是对于wy的大胆，千万人中呐喊你姓名的勇气，wjk的心口是火热的，心动的。\n\n对，连我都看得出来，他开心，妈的。\n\n不过不算破大防，这些天长日久的细碎事情其实只是让我明白的心理历程进化到下一步，💙💚关系就是真的很好。\n\n真破大防怀疑他们是不是真的有一🦵的是19年底。\n\n\n\n\n这个part未完。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "“这是wjk近几年为数不多在wb流露他对wy的真心的时刻，或者也只有这种时刻是被工作室允许的，被世俗允许的，被清理允许的。更多的东西，于团队，于粉丝，于世俗都是出格，因为他们已经不再是15岁了。”😭😭😭😭😭😭😭😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "90",
  },
  {
    id: 416,
    user_face: "416-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 00:48:22 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "预告一下。。。一位i2哥哥也准备。。。审判女婿了。。。非常感谢她。。。期待她投稿的小作文。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "231",
  },
  {
    id: 417,
    user_face: "417-user-face.png",
    user_id: "甜酱少女-",
    is_op: false,
    create_at: "2022-12-29 00:51:21 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "预告一下。。。一位i2哥哥也准备。。。审判女婿了。。。非常感谢她。。。期待她投稿的小作文。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "417-quote.png",
      },
    },
    cmt: {
      cmt_content: "期待！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 418,
    user_face: "418-user-face.png",
    user_id: "刘华强",
    is_op: false,
    create_at: "2022-12-29 00:53:54 四川",
    quote: {
      quote_status: true,
      quote_content:
        "预告一下。。。一位i2哥哥也准备。。。审判女婿了。。。非常感谢她。。。期待她投稿的小作文。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "418-quote.png",
      },
    },
    cmt: {
      cmt_content: "狠狠期待。。。哥哥们快来建设小岛。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "32",
  },
  {
    id: 419,
    user_face: "419-user-face.png",
    user_id: "马上审判",
    is_op: false,
    create_at: "2022-12-29 00:54:19 吉林",
    quote: {
      quote_status: true,
      quote_content:
        "预告一下。。。一位i2哥哥也准备。。。审判女婿了。。。非常感谢她。。。期待她投稿的小作文。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "419-quote.png",
      },
    },
    cmt: {
      cmt_content: "好。。。期待。。组外哥哥快来。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 420,
    user_face: "420-user-face.png",
    user_id: "xesf",
    is_op: false,
    create_at: "2022-12-29 00:59:06 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "呜呜，住在这层了，321的时候我就在现场，简直了，气氛一下子疯狂了起来",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "93",
  },
  {
    id: 421,
    user_face: "421-user-face.png",
    user_id: "封心锁爱戒断中",
    is_op: false,
    create_at: "2022-12-29 01:00:38 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "希望明天醒来帖子还在🙏🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 422,
    user_face: "422-user-face.png",
    user_id: "卷卷毛猫",
    is_op: false,
    create_at: "2022-12-29 01:01:40 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "KDL",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 423,
    user_face: "423-user-face.png",
    user_id: ".",
    is_op: false,
    create_at: "2022-12-29 01:05:23 澳大利亚",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "我有个朋友最初是i2当时恨死三字了，现在已经成cpf了哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "104",
  },
  {
    id: 424,
    user_face: "424-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 01:05:23 广东",
    quote: {
      quote_status: true,
      quote_content: "希望明天醒来帖子还在🙏🏻",
      quote_user_id: "封心锁爱戒断中",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "其实一直不太明白有什么好举报的。。。当年一半的i3站姐都偷偷多开一个岛站。。。还都是大站子。。。换号嗑药。。。xpx姐姐们。。。手下留情吧。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "398",
  },
  {
    id: 425,
    user_face: "425-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 01:09:33 天津",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥说得好细哦…喜欢哥哥的文字",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 426,
    user_face: "426-user-face.png",
    user_id: "手打咸拧七",
    is_op: false,
    create_at: "2022-12-29 01:11:15 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "楼主。。你朋友既然说出。。。他在微博发出发去找答案，什么不顾工作室什么的，我只能说太底层了，他们那时候对自己的工作室可以说是绝对话语权了。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "116",
  },
  {
    id: 427,
    user_face: "427-user-face.png",
    user_id: "一寸灰",
    is_op: false,
    create_at: "2022-12-29 01:17:05 福建",
    quote: {
      quote_status: true,
      quote_content:
        "楼主。。你朋友既然说出。。。他在微博发出发去找答案，什么不顾工作室什么的，我只能说太底层了，他们那时候对自己的工作室可以说是绝对话语权了。",
      quote_user_id: "手打咸拧七",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "话筒，点烟",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "29",
  },
  {
    id: 428,
    user_face: "428-user-face.png",
    user_id: "甜美御姐",
    is_op: false,
    create_at: "2022-12-29 01:18:46 广东",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥们。。。写了一半的来了。。。。\n\n3⃣️ 发疯成年人\n\n说到成年阶段了，这个阶段的开始所有人都不陌生，就是22留学。很多哥哥也分析过wjk的那条微博了，文案是：出发去找答案\n\n这个事情是下一个阶段的开启，但还没有开始发疯。\n\n这个时候其实ky是刚刚结束试探和折磨，至于他们试探出什么结果来了吗？其实我本身不是很确定，但是确实是因为出国留学而关系缓和了，wjk那段时间对wy对态度柔和了很多。\n\n因为那时候是i3，所以其实我对wjk发微博到底是什么语气等等的都很敏锐。\n\n众所周知，几年前开始明星的微博就像死人一样了，商务广告博就不涛了，他们彼此之间每年送生日祝福其实都有点套话，有点无聊。但是那一次那首歌的转发，大家都知道wy决定去伯克利了，所以那次的文案很特别，用头担保，这是wjk走心走脑子走情写的，很特别很好品。\n\n没错，于理他是队长，他应该要祝福弟弟，他是公众人物，要维护好tfb在外界面前的感情和形象。他怎么样都应该发条微博的，但是他说一切顺利也可以，说继续加油也可以，但他说的是：出发去找答案。这个文案绝对不是工作室给他写的，讲理的东西只要求他做到说“一切顺利未来加油”这种程度，但他做到了更多。\n\n这是wjk近几年为数不多在wb流露他对wy的真心的时刻，或者也只有这种时刻是被工作室允许的，被世俗允许的，被清理允许的。更多的东西，于团队，于粉丝，于世俗都是出格，因为他们已经不再是15岁了。\n\n2019年是22和33关系有些许缓和的时候，22对wjk的反应是连i3都会注意到的程度。\n\n\n先说深圳六周年吧。。。对，我又在现场。。。\n\nlove和123wjk两个大糖不用我多说了，不知道的哥哥可以去看其他哥哥的整理，图文并茂，说的都非常好嗑。\n\n我这里还是做分析，不做回顾了，另外我这里来分析的一些糖点都是作为辅助，唯饭看这些东西的视角和cp粉肯定不太一样的。因为心路历程不一样，我们都是实在接受不了才相信是真的。哥哥们如果认为我说的不对，就当是喂饭本身下意识就想为他找借口骗自己吧哈哈，毕竟人和人对不同的事情肯定有不同的看法，但是换个思路想想，连我都觉得骗不了自己的🍬我都被迫按着头嗑的🍬才是真的甜嘛哈哈哈\n\n言归正传，love这个点其实我觉得甜也甜的，但你说唱嗨了也能理解。真的好玩的是123王俊凯。\n\n那天22喊出来的时候，我在台下的心情是？？？你小子挺敢的，这么多人，不避嫌了吗，笑得跟多花一样。至于wjk的反应，我复看自己拍的图是，心情是🚬\n\n\nwjk比起wy的大方磊落，反应更像问心有愧的那一位。他是没想到22那么大胆的（废话谁想到了我也被吓死了好吧，全场尖叫声达到顶峰，岛鸡真有这么多人吗？i4是不是也偷偷嗑呢）wjk眼神有点慌乱，但是嘴是忍不住勾起来在笑的，他就是又害怕又欣喜又慌乱但是对于wy的大胆，千万人中呐喊你姓名的勇气，wjk的心口是火热的，心动的。\n\n对，连我都看得出来，他开心，妈的。\n\n不过不算破大防，这些天长日久的细碎事情其实只是让我明白的心理历程进化到下一步，💙💚关系就是真的很好。\n\n真破大防怀疑他们是不是真的有一🦵的是19年底。\n\n\n\n\n这个part未完。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "谢谢哥哥。。。磕到了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 429,
    user_face: "429-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 01:20:28 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "其实一直不太明白有什么好举报的。。。当年一半的i3站姐都偷偷多开一个岛站。。。还都是大站子。。。换号嗑药。。。xpx姐姐们。。。手下留情吧。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哇。。。哥哥你这个回复。。。信息量有点大",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "45",
  },
  {
    id: 430,
    user_face: "430-user-face.png",
    user_id: "自然卷赏味期限",
    is_op: false,
    create_at: "2022-12-29 01:22:18 瑞士",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好喜欢。。住下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 431,
    user_face: "431-user-face.png",
    user_id: "年少不识心动",
    is_op: false,
    create_at: "2022-12-29 01:22:42 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 432,
    user_face: "432-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 01:22:57 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "吨",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 433,
    user_face: "433-user-face.png",
    user_id: "给口饭吃",
    is_op: false,
    create_at: "2022-12-29 01:24:06 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 434,
    user_face: "434-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 01:24:40 广东",
    quote: {
      quote_status: true,
      quote_content:
        "楼主。。你朋友既然说出。。。他在微博发出发去找答案，什么不顾工作室什么的，我只能说太底层了，他们那时候对自己的工作室可以说是绝对话语权了。",
      quote_user_id: "手打咸拧七",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "好的哥哥。。。我朋友只是个屏幕饭。。。绝对底层。。。以上都是我朋友臆想编的小故事的。。。哥哥别往心里去啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "153",
  },
  {
    id: 435,
    user_face: "435-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 01:27:30 广西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑亖在楼里。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 436,
    user_face: "436-user-face.png",
    user_id: "三九五六",
    is_op: false,
    create_at: "2022-12-29 01:34:19 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "好的哥哥。。。我朋友只是个屏幕饭。。。绝对底层。。。以上都是我朋友臆想编的小故事的。。。哥哥别往心里去啊。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥告诉我i2好姐姐的小作文今晚还能出现吗。。。这关系到我几点睡。。。。又怕再熬夜掉抵抗力又怕看不到小作文。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 437,
    user_face: "437-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 01:34:48 广东",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥告诉我i2好姐姐的小作文今晚还能出现吗。。。这关系到我几点睡。。。。又怕再熬夜掉抵抗力又怕看不到小作文。。。。。",
      quote_user_id: "三九五六",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "明天。。。i2哥哥发了一半给我了。。。明天还有。。。今晚没新东西了。。。哥哥安心睡。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "53",
  },
  {
    id: 438,
    user_face: "438-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 01:35:16 四川",
    quote: {
      quote_status: true,
      quote_content:
        "机场未知事件是什么。。。天真璀璨又是什么。。。得不到答案我会彻夜难眠。。。",
      quote_user_id: "一寸灰",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "3上飞机有站姐图，下飞机一张图都没有且站姐们纷纷破防，发“你还不如艹粉”等一系列破防微博，疑似是2在接机然后发生了什么事。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "179",
  },
  {
    id: 439,
    user_face: "439-user-face.png",
    user_id: "mоmо",
    is_op: false,
    create_at: "2022-12-29 01:35:47 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊啊啊啊啊啊啊快嗑晕了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 440,
    user_face: "440-user-face.png",
    user_id: "三九五六",
    is_op: false,
    create_at: "2022-12-29 01:35:48 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "明天。。。i2哥哥发了一半给我了。。。明天还有。。。今晚没新东西了。。。哥哥安心睡。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "感恩的心💙💚速速向身体忏悔睡觉了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 441,
    user_face: "441-user-face.png",
    user_id: "渡边小狗",
    is_op: false,
    create_at: "2022-12-29 01:39:57 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "放个屁股。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 442,
    user_face: "442-user-face.png",
    user_id: "很好笑吗",
    is_op: false,
    create_at: "2022-12-29 01:41:24 北京",
    quote: {
      quote_status: true,
      quote_content:
        "其实一直不太明白有什么好举报的。。。当年一半的i3站姐都偷偷多开一个岛站。。。还都是大站子。。。换号嗑药。。。xpx姐姐们。。。手下留情吧。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "确实哈哈哈哈哈哈。。。。我朋友也是当时i3开了岛站。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "134",
  },
  {
    id: 443,
    user_face: "443-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 01:49:20 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "等你哥哥。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 444,
    user_face: "444-user-face.png",
    user_id: "美丽冻人",
    is_op: false,
    create_at: "2022-12-29 02:11:22 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 445,
    user_face: "445-user-face.png",
    user_id: "zua子",
    is_op: false,
    create_at: "2022-12-29 02:22:13 云南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kdl。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 446,
    user_face: "446-user-face.png",
    user_id: "给口饭吃",
    is_op: false,
    create_at: "2022-12-29 02:36:22 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 447,
    user_face: "447-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 02:43:16 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蛙趣💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 448,
    user_face: "448-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 02:43:32 新加坡",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 449,
    user_face: "449-user-face.png",
    user_id: "螃蟹壳子",
    is_op: false,
    create_at: "2022-12-29 02:45:59 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚szd",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 450,
    user_face: "450-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 03:00:55 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 451,
    user_face: "451-user-face.png",
    user_id: "Thistles⚡︎⚡︎",
    is_op: false,
    create_at: "2022-12-29 03:10:42 荷兰",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 452,
    user_face: "452-user-face.png",
    user_id: "aespa刘青松",
    is_op: false,
    create_at: "2022-12-29 03:19:08 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我蹲磕死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 453,
    user_face: "453-user-face.png",
    user_id: "略略略",
    is_op: false,
    create_at: "2022-12-29 03:30:29 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 454,
    user_face: "454-user-face.png",
    user_id: "爆炒五花肉",
    is_op: false,
    create_at: "2022-12-29 03:43:05 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑晕😱😱😱",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 455,
    user_face: "455-user-face.png",
    user_id: "pinnnnn",
    is_op: false,
    create_at: "2022-12-29 03:45:06 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 456,
    user_face: "456-user-face.png",
    user_id: "盏",
    is_op: false,
    create_at: "2022-12-29 03:50:15 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "正精彩呢就没了，gkdgkd，希望明天还能继续看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 457,
    user_face: "457-user-face.png",
    user_id: "啊呀",
    is_op: false,
    create_at: "2022-12-29 04:39:07 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 458,
    user_face: "458-user-face.png",
    user_id: "🗣",
    is_op: false,
    create_at: "2022-12-29 05:04:17 日本",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好吓人",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 459,
    user_face: "459-user-face.png",
    user_id: "👀",
    is_op: false,
    create_at: "2022-12-29 06:46:40 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 460,
    user_face: "460-user-face.png",
    user_id: "🚬",
    is_op: false,
    create_at: "2022-12-29 07:38:35 德国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "希望我一觉醒来帖子还在 拜托拜托",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 461,
    user_face: "461-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 07:46:00 福建",
    quote: {
      quote_status: true,
      quote_content:
        "其实一直不太明白有什么好举报的。。。当年一半的i3站姐都偷偷多开一个岛站。。。还都是大站子。。。换号嗑药。。。xpx姐姐们。。。手下留情吧。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我有听说i3站姐知道很多。。。而且当时那个脱粉组没炸的时候 一个i2还是i3脱粉帖被狙 楼主气亖 说不如问问站姐手里都有什么图藏着 然后甩出一个三字看微信的图 三字微信背景是他和二字一个背影图。。。但是开岛站是真的震撼我妈。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "295",
  },
  {
    id: 462,
    user_face: "462-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 08:05:39 重庆",
    quote: {
      quote_status: true,
      quote_content: "怎么唯粉掐架也像在磕💊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 463,
    user_face: "463-user-face.png",
    user_id: "想不出名字",
    is_op: false,
    create_at: "2022-12-29 08:16:25 四川",
    quote: {
      quote_status: true,
      quote_content:
        "我有听说i3站姐知道很多。。。而且当时那个脱粉组没炸的时候 一个i2还是i3脱粉帖被狙 楼主气亖 说不如问问站姐手里都有什么图藏着 然后甩出一个三字看微信的图 三字微信背景是他和二字一个背影图。。。但是开岛站是真的震撼我妈。。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "催更 还有吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 464,
    user_face: "464-user-face.png",
    user_id: "念辞",
    is_op: false,
    create_at: "2022-12-29 08:40:40 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 465,
    user_face: "465-user-face.png",
    user_id: "嘎嘣脆",
    is_op: false,
    create_at: "2022-12-29 08:46:26 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 466,
    user_face: "466-user-face.png",
    user_id: "我是宋居盆",
    is_op: false,
    create_at: "2022-12-29 08:46:53 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死了，🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 467,
    user_face: "467-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 08:51:10 四川",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "确实。。。这也是我对绿料有所疑惑的原因，绿料里他们17年都在一起了，但是我补物料却感觉很明显17的尴尬。。。。时好时尴尬那种。。。。最明显的就是以前所有时候都是23 4这样坐着或者站着，17年开始出现了好多次2 34这种中间空位的情况。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "52",
  },
  {
    id: 468,
    user_face: "468-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-29 08:53:28 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥第二天了…",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 469,
    user_face: "469-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 08:55:13 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "美滋滋跟着哥哥复盘。。。。早期磕过不知道后来的事情。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 470,
    user_face: "470-user-face.png",
    user_id: "R18-蕾哈娜",
    is_op: false,
    create_at: "2022-12-29 08:55:37 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "有一只追连载的感觉😏",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 471,
    user_face: "471-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 09:08:38 福建",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好痛。。。。。哥哥好会说。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 472,
    user_face: "472-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 09:13:18 福建",
    quote: {
      quote_status: true,
      quote_content:
        "其实也不是很彻底。。表面收回而已。。当时23表面发糖骤减。。但是帝国当时少年时代的采访。。主持人问4 3给他私下说高考什么相关的事情没有。。4说就是学习之类的。。但是2说。。3给他说高考完了很多人以后就再也见不到了。。那也是2第一次公开喊3俊凯。。。那段时间2也在开始纠结未来了。。他一开始并没有坚定出国的。。参加湖南台一个采访的时候还说以后可能会选影视。。那段说辞和3之前很像。。应该23私下是做过交流的。。后面开始改变是在青春旅社的时候。。在青春旅社2提过很多次3。。我为什么说表面3收回偏爱。。因为这个时候3已经没有小时候那么直来直去了。。很多情绪都掩埋的比较好。。包括2在青春旅社有一次3正好也去那边录演员的那个综艺。。2当时住山上。。有天晚上骑着自行车就不知道哪去了。。当时我记得是有人说3给他送厚衣服去了（说错了就是我记错了。。好像说是去的时候拿了行李箱回来就没了啥的忘记了）然后后面18年。。岛上很多事情都是18年发生的。。2那个时候还在纠结要不要出国。。当时发了首歌叫我不知道。。然后发微博。。3就在下面说出发去找答案。。从2纠结到真的决定期间2发的每次微博3当时回复的都很郑重。。也就是说3其实一直是支持的。。我也偏向这两个人私下肯定说了什么。。包括著名的机场未知事件和传说中的璀璨夺目善良天真都是这段时间发生的事情。。怎么越回顾事儿越多。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "出发去找答案。。。。妈呀。。。。。好深情一对。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "21",
  },
  {
    id: 473,
    user_face: "473-user-face.png",
    user_id: "一粒沙白",
    is_op: false,
    create_at: "2022-12-29 09:26:06 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我睡醒了一觉，哥哥还没更新么",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 474,
    user_face: "474-user-face.png",
    user_id: "1只竹饱",
    is_op: false,
    create_at: "2022-12-29 09:33:17 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 475,
    user_face: "475-user-face.png",
    user_id: "Kitty(背书中",
    is_op: false,
    create_at: "2022-12-29 10:16:44 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥醒了吗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 476,
    user_face: "476-user-face.png",
    user_id: "TFBOYS-管国林",
    is_op: false,
    create_at: "2022-12-29 10:27:25 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "楼主更新了吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 477,
    user_face: "477-user-face.png",
    user_id: "非著名judge家",
    is_op: false,
    create_at: "2022-12-29 10:47:11 内蒙古",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥们。。。写了一半的来了。。。。\n\n3⃣️ 发疯成年人\n\n说到成年阶段了，这个阶段的开始所有人都不陌生，就是22留学。很多哥哥也分析过wjk的那条微博了，文案是：出发去找答案\n\n这个事情是下一个阶段的开启，但还没有开始发疯。\n\n这个时候其实ky是刚刚结束试探和折磨，至于他们试探出什么结果来了吗？其实我本身不是很确定，但是确实是因为出国留学而关系缓和了，wjk那段时间对wy对态度柔和了很多。\n\n因为那时候是i3，所以其实我对wjk发微博到底是什么语气等等的都很敏锐。\n\n众所周知，几年前开始明星的微博就像死人一样了，商务广告博就不涛了，他们彼此之间每年送生日祝福其实都有点套话，有点无聊。但是那一次那首歌的转发，大家都知道wy决定去伯克利了，所以那次的文案很特别，用头担保，这是wjk走心走脑子走情写的，很特别很好品。\n\n没错，于理他是队长，他应该要祝福弟弟，他是公众人物，要维护好tfb在外界面前的感情和形象。他怎么样都应该发条微博的，但是他说一切顺利也可以，说继续加油也可以，但他说的是：出发去找答案。这个文案绝对不是工作室给他写的，讲理的东西只要求他做到说“一切顺利未来加油”这种程度，但他做到了更多。\n\n这是wjk近几年为数不多在wb流露他对wy的真心的时刻，或者也只有这种时刻是被工作室允许的，被世俗允许的，被清理允许的。更多的东西，于团队，于粉丝，于世俗都是出格，因为他们已经不再是15岁了。\n\n2019年是22和33关系有些许缓和的时候，22对wjk的反应是连i3都会注意到的程度。\n\n\n先说深圳六周年吧。。。对，我又在现场。。。\n\nlove和123wjk两个大糖不用我多说了，不知道的哥哥可以去看其他哥哥的整理，图文并茂，说的都非常好嗑。\n\n我这里还是做分析，不做回顾了，另外我这里来分析的一些糖点都是作为辅助，唯饭看这些东西的视角和cp粉肯定不太一样的。因为心路历程不一样，我们都是实在接受不了才相信是真的。哥哥们如果认为我说的不对，就当是喂饭本身下意识就想为他找借口骗自己吧哈哈，毕竟人和人对不同的事情肯定有不同的看法，但是换个思路想想，连我都觉得骗不了自己的🍬我都被迫按着头嗑的🍬才是真的甜嘛哈哈哈\n\n言归正传，love这个点其实我觉得甜也甜的，但你说唱嗨了也能理解。真的好玩的是123王俊凯。\n\n那天22喊出来的时候，我在台下的心情是？？？你小子挺敢的，这么多人，不避嫌了吗，笑得跟多花一样。至于wjk的反应，我复看自己拍的图是，心情是🚬\n\n\nwjk比起wy的大方磊落，反应更像问心有愧的那一位。他是没想到22那么大胆的（废话谁想到了我也被吓死了好吧，全场尖叫声达到顶峰，岛鸡真有这么多人吗？i4是不是也偷偷嗑呢）wjk眼神有点慌乱，但是嘴是忍不住勾起来在笑的，他就是又害怕又欣喜又慌乱但是对于wy的大胆，千万人中呐喊你姓名的勇气，wjk的心口是火热的，心动的。\n\n对，连我都看得出来，他开心，妈的。\n\n不过不算破大防，这些天长日久的细碎事情其实只是让我明白的心理历程进化到下一步，💙💚关系就是真的很好。\n\n真破大防怀疑他们是不是真的有一🦵的是19年底。\n\n\n\n\n这个part未完。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 478,
    user_face: "478-user-face.png",
    user_id: "不要再吵啦",
    is_op: false,
    create_at: "2022-12-29 10:55:27 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥，，，醒了吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 479,
    user_face: "479-user-face.png",
    user_id: "摘星星的小狐狸",
    is_op: false,
    create_at: "2022-12-29 11:01:51 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 480,
    user_face: "480-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 11:05:00 北京",
    quote: {
      quote_status: true,
      quote_content:
        "我有听说i3站姐知道很多。。。而且当时那个脱粉组没炸的时候 一个i2还是i3脱粉帖被狙 楼主气亖 说不如问问站姐手里都有什么图藏着 然后甩出一个三字看微信的图 三字微信背景是他和二字一个背影图。。。但是开岛站是真的震撼我妈。。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "渴死。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 481,
    user_face: "481-user-face.png",
    user_id: "不止是粒米",
    is_op: false,
    create_at: "2022-12-29 11:05:11 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。我等不及了。。。能不能快点更新。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 482,
    user_face: "482-user-face.png",
    user_id: "减肥达人",
    is_op: false,
    create_at: "2022-12-29 11:13:04 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。醒了吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 483,
    user_face: "483-user-face.png",
    user_id: "雪王宝贝",
    is_op: false,
    create_at: "2022-12-29 11:16:10 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。来更了吗。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 484,
    user_face: "484-user-face.png",
    user_id: "和光",
    is_op: false,
    create_at: "2022-12-29 11:33:56 黑龙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "原来ky还有微信背景图的🍬 震撼…",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "42",
  },
  {
    id: 485,
    user_face: "485-user-face.png",
    user_id: "INTO1-叶舒华",
    is_op: false,
    create_at: "2022-12-29 11:36:29 天津",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "非常赞同楼主朋友的大框架，但是17年18年真的发生了太多事情，我总感觉💙高考、成立个人工作室和成年都是非常重要的阶段，这三个阶段过后，例如💚17岁生日，准备生日会场、发微博有🤟🏻这个手势、卡点两个人生日、黑天鹅挚爱蛋糕……都太不对劲了……可能还在纠结阶段，但是一定和恋爱时代的时候不一样了。也是17年底拍天坑的时候，北京大连往返总是改签。例如冬至那天22会考完突然买票回北京，33突然就改签这样的情况经常发生。然后18年开年33一直在拍戏嘛，每一次回北京都特地打扮，也不是说平时不打扮，但是33身上很少会出现配饰，放肆一下那次他戴了金丝眼镜还戴了毛线帽（Jesus我再感叹一下），接着就出现了卡地亚。时间线拉后一点，7月33在机场故意撸袖子露出来一块表（22是品牌大使33有其他表的代言），接着有了为爱改签的八月，然后再往后33进了新的组，有假就回北京，发生了很多次换口罩，也包括拎过22给粉丝送蛋糕的那家品牌的包装袋……包括22生日当天33没能回去，但是剧组有假之后马上就回北京了，就待了一天又回去拍戏。然后基本上没有穿过supreme的33在回北京那天穿了（早上发生的事情就不带第三人出场了），然后很少发生活视频的33自己在微博发了乐高的一地狼藉，同时22在柏林电影节接受采访的时候说对乐高感兴趣。那段时间真的很微妙啊啊啊啊啊！就是很浓的情侣感有没有人懂我！紧接着就到了最精彩的19年……所以我的总结是17年是非常拉扯戳窗户纸的一年，18年可以说是很热恋疯狂开屏的一年，也正是这两年的积累才会有决定出国之后的拉扯。19年不用说了大家都知道很痛，但是18年的精彩比较少有人讲啊啊啊啊有没有人写写18年",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "251",
  },
  {
    id: 486,
    user_face: "486-user-face.png",
    user_id: "睡觉时候别吵我",
    is_op: false,
    create_at: "2022-12-29 11:38:02 黑龙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "再来点。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 487,
    user_face: "487-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 11:39:13 福建",
    quote: {
      quote_status: true,
      quote_content:
        "非常赞同楼主朋友的大框架，但是17年18年真的发生了太多事情，我总感觉💙高考、成立个人工作室和成年都是非常重要的阶段，这三个阶段过后，例如💚17岁生日，准备生日会场、发微博有🤟🏻这个手势、卡点两个人生日、黑天鹅挚爱蛋糕……都太不对劲了……可能还在纠结阶段，但是一定和恋爱时代的时候不一样了。也是17年底拍天坑的时候，北京大连往返总是改签。例如冬至那天22会考完突然买票回北京，33突然就改签这样的情况经常发生。然后18年开年33一直在拍戏嘛，每一次回北京都特地打扮，也不是说平时不打扮，但是33身上很少会出现配饰，放肆一下那次他戴了金丝眼镜还戴了毛线帽（Jesus我再感叹一下），接着就出现了卡地亚。时间线拉后一点，7月33在机场故意撸袖子露出来一块表（22是品牌大使33有其他表的代言），接着有了为爱改签的八月，然后再往后33进了新的组，有假就回北京，发生了很多次换口罩，也包括拎过22给粉丝送蛋糕的那家品牌的包装袋……包括22生日当天33没能回去，但是剧组有假之后马上就回北京了，就待了一天又回去拍戏。然后基本上没有穿过supreme的33在回北京那天穿了（早上发生的事情就不带第三人出场了），然后很少发生活视频的33自己在微博发了乐高的一地狼藉，同时22在柏林电影节接受采访的时候说对乐高感兴趣。那段时间真的很微妙啊啊啊啊啊！就是很浓的情侣感有没有人懂我！紧接着就到了最精彩的19年……所以我的总结是17年是非常拉扯戳窗户纸的一年，18年可以说是很热恋疯狂开屏的一年，也正是这两年的积累才会有决定出国之后的拉扯。19年不用说了大家都知道很痛，但是18年的精彩比较少有人讲啊啊啊啊有没有人写写18年",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。嗑得晚的在你这狠狠补课了。。。阿里嘎多。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "61",
  },
  {
    id: 488,
    user_face: "488-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-29 11:40:05 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥快回来",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 489,
    user_face: "489-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 11:43:59 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "i2哥哥视角（1）\n\n因为我在💚粉圈一直呆着。。对💚了解多于💙。。💚的爱都是有迹可循的。。\n\n他一开始进入sdfj的时候还是偏于自己真实的性格。。有点调皮但总体上说内向的。。当时他对💙就是崇拜。。对同龄师兄的那种崇拜。。后来公司决定要两个人一起发展之后。。给💙的定位就是队长。。责任心强照顾队友之类的。。💚人设是活跃气氛的小天使。。\n\n但💚本身是内向的人（infp）。。所以他小时候在节目上总容易“表现过度”。。看起来咋咋唬唬的。。但是就是这么一直戴着面具的小孩。。总是会在镜头没有扫到他的时候。。用很安静很温柔的眼神看💙。。这个才是他最真实的一面。。他根本就不是什么二货吃货人设。。相反。。他是非常包容到有点疯的性格。。很多时候并不在乎自己得到还是失去。。他自己说过“不要因为你爱我所以我快乐，而要因为我爱你所以我快乐”\n\n\n而他这种包容。。给💙给的是最多的。。比起💙其实💚才是真正缺失童年的人。。💙性格比较直接。。看着不好惹但其实内心很软。。他进sdfj目的很明确。。💚一开始只当个免费兴趣班。。13年的时候还想过要退出。。你猜他为什么留下来了。。💚对💙几乎是无条件纵容。。在他面前逗乐。。满足他的好胜心。。💙手指一指💚在舞台另一边也要跑老远过去。。永远接💙的梗。。永远给💙回应。。哪怕在冷战。。\n如果真像i2说的每个人都在💚这有一次机会的话，那💙大概永远有机会。。\n\n\n而且小朋友。。对自己崇拜但不亲近不爱的人。。一般会用敬称。。但当崇拜转化成了喜欢。。想要靠近的时候。。就开始故意掩盖自己曾经崇拜过的事实。。敬称往往会转变成。。带着点调戏但更多是小朋友在悄悄释放信号“我想和你更贴近的”的称呼：小凯、王俊凯🥺这点从💚对别人的称呼可以看出来。。💚很擅长social。。叫哥哥姐姐都是信手拈来。。所以他为什么不叫💙哥哥呢。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "374",
  },
  {
    id: 490,
    user_face: "490-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 11:44:40 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "i2哥哥视角（2）\n\n还有💚决定出国留学的过程。。💙考了北电之后。。记者有问他们唱歌还是表演。。几乎同一时间。。💚脱口而出唱歌。。💙说的表演。。然后💚气笑了。。毕竟曾经说一起考央音。。后来💚在杂志采访说想出国读流行音乐和作曲。。17岁生日会。。💙送他八音盒说希望他把自己的声音唱给全世界听。。17.12.15💙又说了音乐是最喜欢的。。表演只是现阶段最想突破的事。。这里感觉是两个人在互相交流你来我往地纠结挣扎了。。💙像是舍不得💚出国。。他会不安吧。。💚一直是他的安全感。。同时💚也在纠结。。12.24💚回答高考方向时说要选影视。。因为演戏需要系统学。。但是最后还是选了音乐。。是不是因为从小他就对你说“好好唱歌”啊。。😭\n\n18.12.4。。网传💚伯克利面试。。💚发歌《我不知道》“我不知道怎么让你不受伤，越心向远方越渴望流浪”。。💙转发微博说“出发去找答案”。。这里感觉💙💚暂时达成和解。。\n然而和解只是表面。。暗里两人依旧在拉扯。。8.23💙说自己夜深了喜欢听知足“为了你而祈祷而祝福而感动”，当天在五月天演唱会唱了当年合唱洋葱时💚的part。。831告别演唱会💚临时加唱我怀念的“我怀念的是一起做梦”。。11.1💙《词不达意》“你不会知道我有多着急”“我无法传达我自己 从何说起”回应💚《我怀念的》。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "239",
  },
  {
    id: 491,
    user_face: "491-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 11:45:30 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "i2哥哥视角（3）\n\n💚是很有想法的。。他在爱里长大所以毫不吝啬地给周围人爱。。他完全相信真爱的存在。。但这也导致他的真爱阈值很高。。所以会显得很疯。。会不断试探。。\n💙心态更像小孩子。。他的偏爱和不懂都很明显。。从小就偏爱💚。。但是他不太懂💚在试探什么。。💚要出国他当然不爽。。所以拉扯纠结。。但是最后还是妥协“有些人用一辈子去学习，化解沟通的难题，为你我也可以”\n\n还有个就是，💚不知道帮💙捡过多少次耳返。。感觉💚比💙本人还在意。。四周年的加油阿米狗现场。。💚注意到之后就一直试图捡。。蹲下去之后那个往后探的手😇我都想说宝宝你别太爱了😅\n\n💙备战高考时期。。主持人问💚有没有什么话要对高考学子说。。他说要注意身体多吃饭多休息不要忘记照顾好自己。。“全世界在等我飞更高，你却心疼我小小翅膀”。。我真的仙木wjk\n\n20、21年💚上了好几个综艺。。当时良缘、勋源B站也有剪辑。。我看下来就感觉。。对于💚来说，因为小时候sdfj给的定位和人设，这种撒娇式相处可能已经成为他的交友习惯了，他对wdx还有以前的四字的某些瞬间是惊人的一致 。。但是💚这几对为什么冲击不到我呢。。因为我觉得💚一直都是这几段关系的掌控者。。就是我可以主动撩但是你给我回应的话我不一定接受。。奇异剧本鲨他带蓝色发带那一集。。他嘟嘴亲亲时，wdx也嘟了。。他自己当时都惊了然后插科打诨混过去了。。包括组内的kaio给我的感觉也是。。💚看上去非常游刃有余。。他自己说的梦寐以求是真爱和自由。。真爱对他来说不会这么浅。。反观他和💙的关系。。有一个镜头我印象深刻。。主持人拥着💚往前走。。中途碰到了他的胳膊。。他一脸惊慌失措地往后看。。他以为是💙要牵他吧。。那个表情我都无语了。。我想说宝宝你的social呢你的游刃有余呢怎么对象换成💙就都没了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "393",
  },
  {
    id: 492,
    user_face: "492-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-29 11:56:29 湖北",
    quote: {
      quote_status: true,
      quote_content:
        "非常赞同楼主朋友的大框架，但是17年18年真的发生了太多事情，我总感觉💙高考、成立个人工作室和成年都是非常重要的阶段，这三个阶段过后，例如💚17岁生日，准备生日会场、发微博有🤟🏻这个手势、卡点两个人生日、黑天鹅挚爱蛋糕……都太不对劲了……可能还在纠结阶段，但是一定和恋爱时代的时候不一样了。也是17年底拍天坑的时候，北京大连往返总是改签。例如冬至那天22会考完突然买票回北京，33突然就改签这样的情况经常发生。然后18年开年33一直在拍戏嘛，每一次回北京都特地打扮，也不是说平时不打扮，但是33身上很少会出现配饰，放肆一下那次他戴了金丝眼镜还戴了毛线帽（Jesus我再感叹一下），接着就出现了卡地亚。时间线拉后一点，7月33在机场故意撸袖子露出来一块表（22是品牌大使33有其他表的代言），接着有了为爱改签的八月，然后再往后33进了新的组，有假就回北京，发生了很多次换口罩，也包括拎过22给粉丝送蛋糕的那家品牌的包装袋……包括22生日当天33没能回去，但是剧组有假之后马上就回北京了，就待了一天又回去拍戏。然后基本上没有穿过supreme的33在回北京那天穿了（早上发生的事情就不带第三人出场了），然后很少发生活视频的33自己在微博发了乐高的一地狼藉，同时22在柏林电影节接受采访的时候说对乐高感兴趣。那段时间真的很微妙啊啊啊啊啊！就是很浓的情侣感有没有人懂我！紧接着就到了最精彩的19年……所以我的总结是17年是非常拉扯戳窗户纸的一年，18年可以说是很热恋疯狂开屏的一年，也正是这两年的积累才会有决定出国之后的拉扯。19年不用说了大家都知道很痛，但是18年的精彩比较少有人讲啊啊啊啊有没有人写写18年",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "窝趣。。。居然有这么多我没磕过的。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 493,
    user_face: "493-user-face.png",
    user_id: "宋昕冉",
    is_op: false,
    create_at: "2022-12-29 11:58:46 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "狠狠🐴，kswl。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 494,
    user_face: "494-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 12:01:58 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 495,
    user_face: "495-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 12:05:42 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我来了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 496,
    user_face: "496-user-face.png",
    user_id: "雪橙苏打",
    is_op: false,
    create_at: "2022-12-29 12:06:10 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 497,
    user_face: "497-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 12:08:08 广东",
    quote: {
      quote_status: true,
      quote_content:
        "非常赞同楼主朋友的大框架，但是17年18年真的发生了太多事情，我总感觉💙高考、成立个人工作室和成年都是非常重要的阶段，这三个阶段过后，例如💚17岁生日，准备生日会场、发微博有🤟🏻这个手势、卡点两个人生日、黑天鹅挚爱蛋糕……都太不对劲了……可能还在纠结阶段，但是一定和恋爱时代的时候不一样了。也是17年底拍天坑的时候，北京大连往返总是改签。例如冬至那天22会考完突然买票回北京，33突然就改签这样的情况经常发生。然后18年开年33一直在拍戏嘛，每一次回北京都特地打扮，也不是说平时不打扮，但是33身上很少会出现配饰，放肆一下那次他戴了金丝眼镜还戴了毛线帽（Jesus我再感叹一下），接着就出现了卡地亚。时间线拉后一点，7月33在机场故意撸袖子露出来一块表（22是品牌大使33有其他表的代言），接着有了为爱改签的八月，然后再往后33进了新的组，有假就回北京，发生了很多次换口罩，也包括拎过22给粉丝送蛋糕的那家品牌的包装袋……包括22生日当天33没能回去，但是剧组有假之后马上就回北京了，就待了一天又回去拍戏。然后基本上没有穿过supreme的33在回北京那天穿了（早上发生的事情就不带第三人出场了），然后很少发生活视频的33自己在微博发了乐高的一地狼藉，同时22在柏林电影节接受采访的时候说对乐高感兴趣。那段时间真的很微妙啊啊啊啊啊！就是很浓的情侣感有没有人懂我！紧接着就到了最精彩的19年……所以我的总结是17年是非常拉扯戳窗户纸的一年，18年可以说是很热恋疯狂开屏的一年，也正是这两年的积累才会有决定出国之后的拉扯。19年不用说了大家都知道很痛，但是18年的精彩比较少有人讲啊啊啊啊有没有人写写18年",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "虽然tfb成立之后ky几乎没有机会再合唱或者双人资源。。。但是暗戳戳（或者说是明目张胆的埋伏一直是有的。。。他们好嗑的地方就是埋伏是黄锐的引导所以总吸引着人去探究他们对彼此到底有多少真心。。。成年之后他们就不再是草台班子组合（当年虽然🔥但是和现在成熟的男女团比起来就是草台班子。。。他们变成了成熟体面的艺人。。。一切都专业了起来。。。这之后再流露出的真心。。。弥足珍贵。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "191",
  },
  {
    id: 498,
    user_face: "498-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 12:11:15 北京",
    quote: {
      quote_status: true,
      quote_content:
        "i2哥哥视角（3）\n\n💚是很有想法的。。他在爱里长大所以毫不吝啬地给周围人爱。。他完全相信真爱的存在。。但这也导致他的真爱阈值很高。。所以会显得很疯。。会不断试探。。\n💙心态更像小孩子。。他的偏爱和不懂都很明显。。从小就偏爱💚。。但是他不太懂💚在试探什么。。💚要出国他当然不爽。。所以拉扯纠结。。但是最后还是妥协“有些人用一辈子去学习，化解沟通的难题，为你我也可以”\n\n还有个就是，💚不知道帮💙捡过多少次耳返。。感觉💚比💙本人还在意。。四周年的加油阿米狗现场。。💚注意到之后就一直试图捡。。蹲下去之后那个往后探的手😇我都想说宝宝你别太爱了😅\n\n💙备战高考时期。。主持人问💚有没有什么话要对高考学子说。。他说要注意身体多吃饭多休息不要忘记照顾好自己。。“全世界在等我飞更高，你却心疼我小小翅膀”。。我真的仙木wjk\n\n20、21年💚上了好几个综艺。。当时良缘、勋源B站也有剪辑。。我看下来就感觉。。对于💚来说，因为小时候sdfj给的定位和人设，这种撒娇式相处可能已经成为他的交友习惯了，他对wdx还有以前的四字的某些瞬间是惊人的一致 。。但是💚这几对为什么冲击不到我呢。。因为我觉得💚一直都是这几段关系的掌控者。。就是我可以主动撩但是你给我回应的话我不一定接受。。奇异剧本鲨他带蓝色发带那一集。。他嘟嘴亲亲时，wdx也嘟了。。他自己当时都惊了然后插科打诨混过去了。。包括组内的kaio给我的感觉也是。。💚看上去非常游刃有余。。他自己说的梦寐以求是真爱和自由。。真爱对他来说不会这么浅。。反观他和💙的关系。。有一个镜头我印象深刻。。主持人拥着💚往前走。。中途碰到了他的胳膊。。他一脸惊慌失措地往后看。。他以为是💙要牵他吧。。那个表情我都无语了。。我想说宝宝你的social呢你的游刃有余呢怎么对象换成💙就都没了。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "最后一段配上这个图更好磕了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "273",
  },
  {
    id: 499,
    user_face: "499-user-face.png",
    user_id: "我美式",
    is_op: false,
    create_at: "2022-12-29 12:14:12 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴亖。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 500,
    user_face: "500-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 12:15:56 天津",
    quote: {
      quote_status: true,
      quote_content:
        "i2哥哥视角（1）\n\n因为我在💚粉圈一直呆着。。对💚了解多于💙。。💚的爱都是有迹可循的。。\n\n他一开始进入sdfj的时候还是偏于自己真实的性格。。有点调皮但总体上说内向的。。当时他对💙就是崇拜。。对同龄师兄的那种崇拜。。后来公司决定要两个人一起发展之后。。给💙的定位就是队长。。责任心强照顾队友之类的。。💚人设是活跃气氛的小天使。。\n\n但💚本身是内向的人（infp）。。所以他小时候在节目上总容易“表现过度”。。看起来咋咋唬唬的。。但是就是这么一直戴着面具的小孩。。总是会在镜头没有扫到他的时候。。用很安静很温柔的眼神看💙。。这个才是他最真实的一面。。他根本就不是什么二货吃货人设。。相反。。他是非常包容到有点疯的性格。。很多时候并不在乎自己得到还是失去。。他自己说过“不要因为你爱我所以我快乐，而要因为我爱你所以我快乐”\n\n\n而他这种包容。。给💙给的是最多的。。比起💙其实💚才是真正缺失童年的人。。💙性格比较直接。。看着不好惹但其实内心很软。。他进sdfj目的很明确。。💚一开始只当个免费兴趣班。。13年的时候还想过要退出。。你猜他为什么留下来了。。💚对💙几乎是无条件纵容。。在他面前逗乐。。满足他的好胜心。。💙手指一指💚在舞台另一边也要跑老远过去。。永远接💙的梗。。永远给💙回应。。哪怕在冷战。。\n如果真像i2说的每个人都在💚这有一次机会的话，那💙大概永远有机会。。\n\n\n而且小朋友。。对自己崇拜但不亲近不爱的人。。一般会用敬称。。但当崇拜转化成了喜欢。。想要靠近的时候。。就开始故意掩盖自己曾经崇拜过的事实。。敬称往往会转变成。。带着点调戏但更多是小朋友在悄悄释放信号“我想和你更贴近的”的称呼：小凯、王俊凯🥺这点从💚对别人的称呼可以看出来。。💚很擅长social。。叫哥哥姐姐都是信手拈来。。所以他为什么不叫💙哥哥呢。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "年下不叫哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "76",
  },
  {
    id: 501,
    user_face: "501-user-face.png",
    user_id: "芝士菠萝",
    is_op: false,
    create_at: "2022-12-29 12:18:31 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "窝趣。。。。好好嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 502,
    user_face: "502-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 12:20:07 天津",
    quote: {
      quote_status: true,
      quote_content: "最后一段配上这个图更好磕了",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "502-quote.png",
      },
    },
    cmt: {
      cmt_content: "这个表情真的。。。🚬",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "145",
  },
  {
    id: 503,
    user_face: "503-user-face.png",
    user_id: "陈玘（已退役）",
    is_op: false,
    create_at: "2022-12-29 12:21:04 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑亖了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 504,
    user_face: "504-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 12:26:22 四川",
    quote: {
      quote_status: true,
      quote_content: "最后一段配上这个图更好磕了",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "504-quote.png",
      },
    },
    cmt: {
      cmt_content: "这个真的。。。。。。。太虐了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "109",
  },
  {
    id: 505,
    user_face: "505-user-face.png",
    user_id: "朴正洙(已养狗)",
    is_op: false,
    create_at: "2022-12-29 12:39:25 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "捏妈 嗑亖",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 506,
    user_face: "506-user-face.png",
    user_id: "一寸灰",
    is_op: false,
    create_at: "2022-12-29 12:40:10 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "go on。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 507,
    user_face: "507-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 12:41:41 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哎呀他喵的 渴死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 508,
    user_face: "508-user-face.png",
    user_id: "隔水观花",
    is_op: false,
    create_at: "2022-12-29 12:42:33 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哇好东西马了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 509,
    user_face: "509-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 12:47:18 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "我朋友说的。。。她正在快速码字。。。哥哥们等等。。。有些故事。。。太细节了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "509-quote.png",
      },
    },
    cmt: {
      cmt_content: "磕晕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 510,
    user_face: "510-user-face.png",
    user_id: "INTO1-叶舒华",
    is_op: false,
    create_at: "2022-12-29 12:51:13 天津",
    quote: {
      quote_status: true,
      quote_content:
        "虽然tfb成立之后ky几乎没有机会再合唱或者双人资源。。。但是暗戳戳（或者说是明目张胆的埋伏一直是有的。。。他们好嗑的地方就是埋伏是黄锐的引导所以总吸引着人去探究他们对彼此到底有多少真心。。。成年之后他们就不再是草台班子组合（当年虽然🔥但是和现在成熟的男女团比起来就是草台班子。。。他们变成了成熟体面的艺人。。。一切都专业了起来。。。这之后再流露出的真心。。。弥足珍贵。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是的🥺特别是成立工作室之后，搬出宿舍不再光明正大同吃同住，再加上33大一在学校课程还是蛮多的，开始聚少离多。然后17年下半年开始的青春旅社，22总是提起来33，一会儿说第一次去录节目最开心，一会儿又说被认错成33。那时候的22有一种特别想要全世界都知道他们依然很好的那种宣示主权的感觉。也能感受到有一点点缺少安全感吧🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "253",
  },
  {
    id: 511,
    user_face: "511-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 12:52:44 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我懂。。。哥哥。。。这也是凯源最戳我一点，控制狂控制住了自己。。。想自由的风筝又重新飞回放风筝的人手里。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "248",
  },
  {
    id: 512,
    user_face: "512-user-face.png",
    user_id: "小林不是李昀锐",
    is_op: false,
    create_at: "2022-12-29 13:02:08 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 513,
    user_face: "513-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 13:02:57 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "我懂。。。哥哥。。。这也是凯源最戳我一点，控制狂控制住了自己。。。想自由的风筝又重新飞回放风筝的人手里。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "爱是互相臣服。。。是彼此驯养。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "100",
  },
  {
    id: 514,
    user_face: "514-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 13:03:01 广西",
    quote: {
      quote_status: true,
      quote_content: "最后一段配上这个图更好磕了",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "514-quote.png",
      },
    },
    cmt: {
      cmt_content: "我超。。。。。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 515,
    user_face: "515-user-face.png",
    user_id: "张婧怡（期末版",
    is_op: false,
    create_at: "2022-12-29 13:05:23 江苏",
    quote: {
      quote_status: true,
      quote_content: "接楼上。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "515-quote.png",
      },
    },
    cmt: {
      cmt_content: "啊啊啊啊！kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 516,
    user_face: "516-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 13:07:42 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "果然wf视角就是不一样啊，再复嗑一遍",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 517,
    user_face: "517-user-face.png",
    user_id: "一只盒",
    is_op: false,
    create_at: "2022-12-29 13:16:04 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑死我了，唯粉视角我真的就是，真的嗑死我了啊啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 518,
    user_face: "518-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-29 13:18:27 河南",
    quote: {
      quote_status: true,
      quote_content: "最后一段配上这个图更好磕了",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "518-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "😭。。。。谁帮帮这对璧人。。。。见不得别人爱的这么辛苦。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "218",
  },
  {
    id: 519,
    user_face: "519-user-face.png",
    user_id: "旺仔秋秋糖",
    is_op: false,
    create_at: "2022-12-29 13:22:49 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "再来点。。再让我磕点。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 520,
    user_face: "520-user-face.png",
    user_id: "吃一整个窑鸡",
    is_op: false,
    create_at: "2022-12-29 13:33:24 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "薅。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 521,
    user_face: "521-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 13:35:04 云南",
    quote: {
      quote_status: true,
      quote_content:
        "i2哥哥视角（3）\n\n💚是很有想法的。。他在爱里长大所以毫不吝啬地给周围人爱。。他完全相信真爱的存在。。但这也导致他的真爱阈值很高。。所以会显得很疯。。会不断试探。。\n💙心态更像小孩子。。他的偏爱和不懂都很明显。。从小就偏爱💚。。但是他不太懂💚在试探什么。。💚要出国他当然不爽。。所以拉扯纠结。。但是最后还是妥协“有些人用一辈子去学习，化解沟通的难题，为你我也可以”\n\n还有个就是，💚不知道帮💙捡过多少次耳返。。感觉💚比💙本人还在意。。四周年的加油阿米狗现场。。💚注意到之后就一直试图捡。。蹲下去之后那个往后探的手😇我都想说宝宝你别太爱了😅\n\n💙备战高考时期。。主持人问💚有没有什么话要对高考学子说。。他说要注意身体多吃饭多休息不要忘记照顾好自己。。“全世界在等我飞更高，你却心疼我小小翅膀”。。我真的仙木wjk\n\n20、21年💚上了好几个综艺。。当时良缘、勋源B站也有剪辑。。我看下来就感觉。。对于💚来说，因为小时候sdfj给的定位和人设，这种撒娇式相处可能已经成为他的交友习惯了，他对wdx还有以前的四字的某些瞬间是惊人的一致 。。但是💚这几对为什么冲击不到我呢。。因为我觉得💚一直都是这几段关系的掌控者。。就是我可以主动撩但是你给我回应的话我不一定接受。。奇异剧本鲨他带蓝色发带那一集。。他嘟嘴亲亲时，wdx也嘟了。。他自己当时都惊了然后插科打诨混过去了。。包括组内的kaio给我的感觉也是。。💚看上去非常游刃有余。。他自己说的梦寐以求是真爱和自由。。真爱对他来说不会这么浅。。反观他和💙的关系。。有一个镜头我印象深刻。。主持人拥着💚往前走。。中途碰到了他的胳膊。。他一脸惊慌失措地往后看。。他以为是💙要牵他吧。。那个表情我都无语了。。我想说宝宝你的social呢你的游刃有余呢怎么对象换成💙就都没了。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "看到第四段。。。。。。突然想到有一次采访他两坐一起挨得有点近。。。。。💙其实是伸手碰了一下自己膝盖。。。💚以为💙要碰他。。。。吓得💚一激灵地缩了一下手。。。。。有没有哥哥上动图啊妈的。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "173",
  },
  {
    id: 522,
    user_face: "522-user-face.png",
    user_id: "玫瑰色眼镜",
    is_op: false,
    create_at: "2022-12-29 13:41:59 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑得想哭。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 523,
    user_face: "523-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 13:43:03 北京",
    quote: {
      quote_status: true,
      quote_content:
        "看到第四段。。。。。。突然想到有一次采访他两坐一起挨得有点近。。。。。💙其实是伸手碰了一下自己膝盖。。。💚以为💙要碰他。。。。吓得💚一激灵地缩了一下手。。。。。有没有哥哥上动图啊妈的。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "210",
  },
  {
    id: 524,
    user_face: "524-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 13:46:06 云南",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "524-quote.png",
      },
    },
    cmt: {
      cmt_content: "就是这个！！！哥哥。。。。😭😭爱你。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "81",
  },
  {
    id: 525,
    user_face: "525-user-face.png",
    user_id: "AKB48-张元英",
    is_op: false,
    create_at: "2022-12-29 13:47:01 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "先🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 526,
    user_face: "526-user-face.png",
    user_id: "MBWS*",
    is_op: false,
    create_at: "2022-12-29 13:48:51 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "i2哥哥也写得好好。。。wf视角真的精彩。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "46",
  },
  {
    id: 527,
    user_face: "527-user-face.png",
    user_id: "钮祜禄甄嬛",
    is_op: false,
    create_at: "2022-12-29 13:49:27 福建",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "527-quote.png",
      },
    },
    cmt: {
      cmt_content: "妈呀。。。。。。ks",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "28",
  },
  {
    id: 528,
    user_face: "528-user-face.png",
    user_id: "波波蜜瓜",
    is_op: false,
    create_at: "2022-12-29 13:50:15 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "要🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 529,
    user_face: "529-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-29 13:52:28 广东",
    quote: {
      quote_status: true,
      quote_content:
        "i2哥哥视角（3）\n\n💚是很有想法的。。他在爱里长大所以毫不吝啬地给周围人爱。。他完全相信真爱的存在。。但这也导致他的真爱阈值很高。。所以会显得很疯。。会不断试探。。\n💙心态更像小孩子。。他的偏爱和不懂都很明显。。从小就偏爱💚。。但是他不太懂💚在试探什么。。💚要出国他当然不爽。。所以拉扯纠结。。但是最后还是妥协“有些人用一辈子去学习，化解沟通的难题，为你我也可以”\n\n还有个就是，💚不知道帮💙捡过多少次耳返。。感觉💚比💙本人还在意。。四周年的加油阿米狗现场。。💚注意到之后就一直试图捡。。蹲下去之后那个往后探的手😇我都想说宝宝你别太爱了😅\n\n💙备战高考时期。。主持人问💚有没有什么话要对高考学子说。。他说要注意身体多吃饭多休息不要忘记照顾好自己。。“全世界在等我飞更高，你却心疼我小小翅膀”。。我真的仙木wjk\n\n20、21年💚上了好几个综艺。。当时良缘、勋源B站也有剪辑。。我看下来就感觉。。对于💚来说，因为小时候sdfj给的定位和人设，这种撒娇式相处可能已经成为他的交友习惯了，他对wdx还有以前的四字的某些瞬间是惊人的一致 。。但是💚这几对为什么冲击不到我呢。。因为我觉得💚一直都是这几段关系的掌控者。。就是我可以主动撩但是你给我回应的话我不一定接受。。奇异剧本鲨他带蓝色发带那一集。。他嘟嘴亲亲时，wdx也嘟了。。他自己当时都惊了然后插科打诨混过去了。。包括组内的kaio给我的感觉也是。。💚看上去非常游刃有余。。他自己说的梦寐以求是真爱和自由。。真爱对他来说不会这么浅。。反观他和💙的关系。。有一个镜头我印象深刻。。主持人拥着💚往前走。。中途碰到了他的胳膊。。他一脸惊慌失措地往后看。。他以为是💙要牵他吧。。那个表情我都无语了。。我想说宝宝你的social呢你的游刃有余呢怎么对象换成💙就都没了。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "为什么那么矛盾，又说💚缺失童年又说他在爱里长大。。。我没看懂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "41",
  },
  {
    id: 530,
    user_face: "530-user-face.png",
    user_id: "宋亚轩(毛绒版)",
    is_op: false,
    create_at: "2022-12-29 14:03:11 四川",
    quote: {
      quote_status: true,
      quote_content:
        "我懂。。。哥哥。。。这也是凯源最戳我一点，控制狂控制住了自己。。。想自由的风筝又重新飞回放风筝的人手里。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "嗑死。。。。昨晚上和一个追了七八年的i2哥哥聊了好久。。。wf嘴还是很硬 虽然字里行间都是渴到了。。。可能wfj也对爱得这么疯的女婿有一点子满意吧。。。。😑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "186",
  },
  {
    id: 531,
    user_face: "531-user-face.png",
    user_id: "☾.˖٭🌠",
    is_op: false,
    create_at: "2022-12-29 14:06:41 广西",
    quote: {
      quote_status: true,
      quote_content:
        "为什么那么矛盾，又说💚缺失童年又说他在爱里长大。。。我没看懂",
      quote_user_id: "富贵仙人掌🌵",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。我的理解。。。缺失童年不一定就缺爱。。。稿主的意思应该是指2一开始不一定想当明星。。。年少成名会让2失去一些普通人的快乐之类的。。。但闯荡娱乐圈是3的目标事业。。。3和2对此感受可能不一样。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "258",
  },
  {
    id: 532,
    user_face: "532-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 14:07:22 天津",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "关于三字没轻重的开玩笑。。两个人冷战。。从Roy6设定和故事中可以看出二字的态度。。。劳迪是云，莱阳是小太阳。。。莱阳发光的时候有时候会把劳迪蒸发掉。。。劳迪会打闹把莱阳淋湿成落汤小狮子。。。主持人：那劳迪下雨不会让莱阳的火熄灭吗。。。二字：不会不会是朋友开玩笑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "283",
  },
  {
    id: 533,
    user_face: "533-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 14:08:48 天津",
    quote: {
      quote_status: true,
      quote_content:
        "看到第四段。。。。。。突然想到有一次采访他两坐一起挨得有点近。。。。。💙其实是伸手碰了一下自己膝盖。。。💚以为💙要碰他。。。。吓得💚一激灵地缩了一下手。。。。。有没有哥哥上动图啊妈的。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "还有wy以为wjk喝了他的水。。。左右来回看确认。。。。wjk偷笑。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "198",
  },
  {
    id: 534,
    user_face: "534-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 14:14:22 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "楼上说的蜜汁避嫌。。。其实做的真的很 不知道怎么说 很假 17年到今年春晚 每次躲避都好像怕被人发现似的 楼上那个惊讶回头 采访时手碰一下惊吓躲开 到春晚镜头一转手都不知道放哪 一个出道十年镜头里长大的人永远在和三字同框被发现距离可能过近时像个新人一样不知所措 但其实作为那么多年队友 就算同框肩并肩站一块 除了西皮粉谁还会嗑亖 只有他这样不知所措弹开才让人觉得不对劲吧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "314",
  },
  {
    id: 535,
    user_face: "535-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-29 14:14:25 湖北",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "535-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "2字你到底为什么这么问心有愧的样子。。。。你说啊你说啊你说啊。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "207",
  },
  {
    id: 536,
    user_face: "536-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 14:19:02 云南",
    quote: {
      quote_status: true,
      quote_content:
        "还有wy以为wjk喝了他的水。。。左右来回看确认。。。。wjk偷笑。。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我记得有分析贴💙喝的确实是💚的水。。。kswl。。。。。。讨厌没有边界感的xql😫。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "145",
  },
  {
    id: 537,
    user_face: "537-user-face.png",
    user_id: "mxghj",
    is_op: false,
    create_at: "2022-12-29 14:34:08 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "还有吗哥哥。。。。。蹲蹲。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 538,
    user_face: "538-user-face.png",
    user_id: "茉莉",
    is_op: false,
    create_at: "2022-12-29 14:34:21 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 539,
    user_face: "539-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 14:39:21 河南",
    quote: {
      quote_status: true,
      quote_content: "谢谢哥哥。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 540,
    user_face: "540-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 15:01:21 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。快回来更。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 541,
    user_face: "541-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 15:01:53 山东",
    quote: {
      quote_status: true,
      quote_content:
        "关于三字没轻重的开玩笑。。两个人冷战。。从Roy6设定和故事中可以看出二字的态度。。。劳迪是云，莱阳是小太阳。。。莱阳发光的时候有时候会把劳迪蒸发掉。。。劳迪会打闹把莱阳淋湿成落汤小狮子。。。主持人：那劳迪下雨不会让莱阳的火熄灭吗。。。二字：不会不会是朋友开玩笑",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "渴死我了。。。啊啊啊啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "22",
  },
  {
    id: 542,
    user_face: "542-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 15:03:19 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "说实话这个艾尔艾三视角自述真的很艾尔艾三。。。出发点都是我儿子怎么样怎么样。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "247",
  },
  {
    id: 543,
    user_face: "543-user-face.png",
    user_id: "把月亮摔碎",
    is_op: false,
    create_at: "2022-12-29 15:04:20 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@牧场 跪下来求你爬完每一楼。。。想亖了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 544,
    user_face: "544-user-face.png",
    user_id: "魔术杯",
    is_op: false,
    create_at: "2022-12-29 15:17:48 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "今天也是嗑生嗑死的一天",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 545,
    user_face: "545-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 15:18:27 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "被i2哥哥的视角感动得。。。😭。。。如果其他人在22这里只有一次机会。。wjk大概就是永远有机会。。。太对了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "296",
  },
  {
    id: 546,
    user_face: "546-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-29 15:44:07 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 547,
    user_face: "547-user-face.png",
    user_id: "乐旎",
    is_op: false,
    create_at: "2022-12-29 15:45:39 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死我了。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 548,
    user_face: "548-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-29 16:04:37 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@Q.in ",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 549,
    user_face: "549-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 16:15:44 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "又有一位i2哥哥投稿了。。。等我朋友的i3成年阶段今天完结就把这位哥哥的整理好发出来。。。非常感谢i2哥哥们。。。替我的贴子完善了另一个视角。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "195",
  },
  {
    id: 550,
    user_face: "550-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 16:21:37 山东",
    quote: {
      quote_status: true,
      quote_content:
        "又有一位i2哥哥投稿了。。。等我朋友的i3成年阶段今天完结就把这位哥哥的整理好发出来。。。非常感谢i2哥哥们。。。替我的贴子完善了另一个视角。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "等你。。。哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 551,
    user_face: "551-user-face.png",
    user_id: "阿豆",
    is_op: false,
    create_at: "2022-12-29 16:28:32 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "又有一位i2哥哥投稿了。。。等我朋友的i3成年阶段今天完结就把这位哥哥的整理好发出来。。。非常感谢i2哥哥们。。。替我的贴子完善了另一个视角。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。我知道我不该急。。但是很急。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "101",
  },
  {
    id: 552,
    user_face: "552-user-face.png",
    user_id: "道北",
    is_op: false,
    create_at: "2022-12-29 16:41:26 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死了。。。。我信他们是真的了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "13",
  },
  {
    id: 553,
    user_face: "553-user-face.png",
    user_id: "禁止生气",
    is_op: false,
    create_at: "2022-12-29 16:42:21 北京",
    quote: {
      quote_status: true,
      quote_content:
        "又有一位i2哥哥投稿了。。。等我朋友的i3成年阶段今天完结就把这位哥哥的整理好发出来。。。非常感谢i2哥哥们。。。替我的贴子完善了另一个视角。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "蹲蹲(不催)",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 554,
    user_face: "554-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 16:43:33 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "唯粉姐姐多多投稿。。。摩多摩多。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 555,
    user_face: "555-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 16:44:44 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "wfj都出来说几句吧。。。好想看。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 556,
    user_face: "556-user-face.png",
    user_id: "别失眠了",
    is_op: false,
    create_at: "2022-12-29 16:49:49 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "天呐我还没看完。。。wf姐姐手下留情撑到我回家。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "10",
  },
  {
    id: 557,
    user_face: "557-user-face.png",
    user_id: "樱桃肉丸丸-",
    is_op: false,
    create_at: "2022-12-29 16:54:49 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "ky真的是我唯一不追但是会一直磕下去的 越嗑越好嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "89",
  },
  {
    id: 558,
    user_face: "558-user-face.png",
    user_id: "把月亮摔碎",
    is_op: false,
    create_at: "2022-12-29 16:56:37 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "这个帖能不能备份。。。真的很害怕😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "32",
  },
  {
    id: 559,
    user_face: "559-user-face.png",
    user_id: "再说吧",
    is_op: false,
    create_at: "2022-12-29 17:00:47 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。快来",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 560,
    user_face: "560-user-face.png",
    user_id: "乐旎",
    is_op: false,
    create_at: "2022-12-29 17:01:06 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@披星戴月_鹤 来看 渴死我了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 561,
    user_face: "561-user-face.png",
    user_id: "TFBOYS-管国林",
    is_op: false,
    create_at: "2022-12-29 17:08:48 贵州",
    quote: {
      quote_status: true,
      quote_content: "最后一段配上这个图更好磕了",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "561-quote.png",
      },
    },
    cmt: {
      cmt_content: "太虐了老天爷啊让他俩结婚又能怎样！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "160",
  },
  {
    id: 562,
    user_face: "562-user-face.png",
    user_id: "我蚁谋了",
    is_op: false,
    create_at: "2022-12-29 17:19:22 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "那个321wjk 当时在现场别给我磕升天",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "44",
  },
  {
    id: 563,
    user_face: "563-user-face.png",
    user_id: "胡乱说话",
    is_op: false,
    create_at: "2022-12-29 17:20:33 广东",
    quote: {
      quote_status: true,
      quote_content:
        "又有一位i2哥哥投稿了。。。等我朋友的i3成年阶段今天完结就把这位哥哥的整理好发出来。。。非常感谢i2哥哥们。。。替我的贴子完善了另一个视角。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。gkd。。。。等不及了🥹",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 564,
    user_face: "564-user-face.png",
    user_id: "如花美眷",
    is_op: false,
    create_at: "2022-12-29 17:22:34 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥。。。我上班都在看你的贴。。。快点继续。。。不要停。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "32",
  },
  {
    id: 565,
    user_face: "565-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 17:23:37 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑死了。。。。急。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 566,
    user_face: "566-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-29 17:35:37 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这个时期前段时间和朋友考古二字第一部个人团综王牌，帝国去的那一期，二字是主持人，其实现在看二字的表现有点用力过猛的尴尬，第一次独当一面当主持人也是有点紧张，帝国来的那期真的太好磕了。。。二字不管怎么耍宝或者有意在炫耀他和三字的关系，比如“有一次我和王俊凯睡觉”还有后面的游戏环节，但是三字就是非常宠他，说什么都顺着他，他不在游戏中还会絮絮叨叨二字的小事，说他老爱藏柜子里让人找啊，没人找一会自己又出来了，就整个感觉是去给二字撑场子的，甚至还领着台下的i3打趣二字小时候唱的儿歌。。。。就是好磕疯了。。。但是我记得那会俩人已经开始“兄弟化”，以前不觉得多好嗑现在嗑那时候的三字比小时候凯源里打直球又虎逼的三字更像长大了也知道他和二字关系中的暧昧和小尴尬但是还是会宠二字给二字撑场子。。。。\n没嗑过的哥哥记得嗑这个【【凯源】浪漫爱+冤家路窄（王牌对王牌糖点CUT）-哔哩哔哩】 https://b23.tv/21a32oG",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "啊啊啊啊啊啊二字老是跟三字躲猫猫那点好好磕啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "53",
  },
  {
    id: 567,
    user_face: "567-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-29 17:40:48 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "一天点进这个帖子。。。800次。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "53",
  },
  {
    id: 568,
    user_face: "568-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 17:42:13 福建",
    quote: {
      quote_status: true,
      quote_content: "一天点进这个帖子。。。800次。。。。",
      quote_user_id: "把糖塞我嘴里",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥我也。。。结果都是蹲。。。嗑亖。。。我哭了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 569,
    user_face: "569-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 17:42:43 福建",
    quote: {
      quote_status: true,
      quote_content: "哥哥我也。。。结果都是蹲。。。嗑亖。。。我哭了。。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "没有说蹲和嗑亖的哥哥们不好的意思。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 570,
    user_face: "570-user-face.png",
    user_id: "走走停停",
    is_op: false,
    create_at: "2022-12-29 17:43:26 山西",
    quote: {
      quote_status: true,
      quote_content:
        "i2哥哥视角（2）\n\n还有💚决定出国留学的过程。。💙考了北电之后。。记者有问他们唱歌还是表演。。几乎同一时间。。💚脱口而出唱歌。。💙说的表演。。然后💚气笑了。。毕竟曾经说一起考央音。。后来💚在杂志采访说想出国读流行音乐和作曲。。17岁生日会。。💙送他八音盒说希望他把自己的声音唱给全世界听。。17.12.15💙又说了音乐是最喜欢的。。表演只是现阶段最想突破的事。。这里感觉是两个人在互相交流你来我往地纠结挣扎了。。💙像是舍不得💚出国。。他会不安吧。。💚一直是他的安全感。。同时💚也在纠结。。12.24💚回答高考方向时说要选影视。。因为演戏需要系统学。。但是最后还是选了音乐。。是不是因为从小他就对你说“好好唱歌”啊。。😭\n\n18.12.4。。网传💚伯克利面试。。💚发歌《我不知道》“我不知道怎么让你不受伤，越心向远方越渴望流浪”。。💙转发微博说“出发去找答案”。。这里感觉💙💚暂时达成和解。。\n然而和解只是表面。。暗里两人依旧在拉扯。。8.23💙说自己夜深了喜欢听知足“为了你而祈祷而祝福而感动”，当天在五月天演唱会唱了当年合唱洋葱时💚的part。。831告别演唱会💚临时加唱我怀念的“我怀念的是一起做梦”。。11.1💙《词不达意》“你不会知道我有多着急”“我无法传达我自己 从何说起”回应💚《我怀念的》。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "当时。。。我也是i2。。。。真的。。太拉扯了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "31",
  },
  {
    id: 571,
    user_face: "571-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-29 17:44:51 河南",
    quote: {
      quote_status: true,
      quote_content: "啊啊啊啊啊啊二字老是跟三字躲猫猫那点好好磕啊",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是的啊啊啊 开头他讲二字躲猫猫那段 虽然嘴里说很无聊 但是描述的又很详细 什么一会在桌子下一会在柜子里 其他人在谈事情只有二字跑去躲起来等别人来找 就像把二字当小孩一样😭真的要看看这个视频 三字讲二字那段莫名很温柔",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "131",
  },
  {
    id: 572,
    user_face: "572-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 17:46:57 云南",
    quote: {
      quote_status: true,
      quote_content:
        "又有一位i2哥哥投稿了。。。等我朋友的i3成年阶段今天完结就把这位哥哥的整理好发出来。。。非常感谢i2哥哥们。。。替我的贴子完善了另一个视角。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。。你说没有你。。。我该怎么活啊😭😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 573,
    user_face: "573-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 17:47:51 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "急死我了 我是急急国王。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "52",
  },
  {
    id: 574,
    user_face: "574-user-face.png",
    user_id: "到八点半",
    is_op: false,
    create_at: "2022-12-29 17:49:30 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 575,
    user_face: "575-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 17:53:57 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。搞快点。。。（来自点进800遍的momo）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "14",
  },
  {
    id: 576,
    user_face: "576-user-face.png",
    user_id: "宫脇咲良（solo",
    is_op: false,
    create_at: "2022-12-29 17:54:26 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "感谢wfjj喂饭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 577,
    user_face: "577-user-face.png",
    user_id: "是爱要久久📢",
    is_op: false,
    create_at: "2022-12-29 17:56:06 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "妈的还是唯粉会嗑。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 578,
    user_face: "578-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 17:56:35 北京",
    quote: {
      quote_status: true,
      quote_content: "当时。。。我也是i2。。。。真的。。太拉扯了。。",
      quote_user_id: "走走停停",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这段都有视频吗。。。能上哪复盘一下。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 579,
    user_face: "579-user-face.png",
    user_id: "走走停停",
    is_op: false,
    create_at: "2022-12-29 17:57:34 山西",
    quote: {
      quote_status: true,
      quote_content: "这段都有视频吗。。。能上哪复盘一下。。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥等我找下 我记得我看过 我想想这是哪个来着 时间太久了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 580,
    user_face: "580-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 18:04:29 北京",
    quote: {
      quote_status: true,
      quote_content: "哥哥等我找下 我记得我看过 我想想这是哪个来着 时间太久了",
      quote_user_id: "走走停停",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "谢谢哥哥。。。我想磕死。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 581,
    user_face: "581-user-face.png",
    user_id: "糕贵流心包",
    is_op: false,
    create_at: "2022-12-29 18:18:04 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "😭😭😭这个贴一定要活下来。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 582,
    user_face: "582-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-29 18:31:43 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥还没来吗。。。。😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 583,
    user_face: "583-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 18:33:26 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 584,
    user_face: "584-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 18:36:42 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 585,
    user_face: "585-user-face.png",
    user_id: "管⁢⁢理⁢员",
    is_op: false,
    create_at: "2022-12-29 18:46:21 浙江",
    quote: {
      quote_status: true,
      quote_content: "有哥哥私信投稿的。。。非我原创。。。大家可以先嗑着。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "585-quote.png",
      },
    },
    cmt: {
      cmt_content: "1111",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 586,
    user_face: "586-user-face.png",
    user_id: "苏到咯",
    is_op: false,
    create_at: "2022-12-29 18:49:21 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 587,
    user_face: "587-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-29 19:07:11 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥后续想看后续",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 588,
    user_face: "588-user-face.png",
    user_id: "糖窝窝",
    is_op: false,
    create_at: "2022-12-29 19:14:07 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "追平了 嗑亖。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 589,
    user_face: "589-user-face.png",
    user_id: "小梨真央",
    is_op: false,
    create_at: "2022-12-29 19:19:17 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@发财的小狗 快看这个",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 590,
    user_face: "590-user-face.png",
    user_id: "赏花大王",
    is_op: false,
    create_at: "2022-12-29 19:21:20 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "住下了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 591,
    user_face: "591-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 19:26:17 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "i2哥哥视角（1）\n\n因为我在💚粉圈一直呆着。。对💚了解多于💙。。💚的爱都是有迹可循的。。\n\n他一开始进入sdfj的时候还是偏于自己真实的性格。。有点调皮但总体上说内向的。。当时他对💙就是崇拜。。对同龄师兄的那种崇拜。。后来公司决定要两个人一起发展之后。。给💙的定位就是队长。。责任心强照顾队友之类的。。💚人设是活跃气氛的小天使。。\n\n但💚本身是内向的人（infp）。。所以他小时候在节目上总容易“表现过度”。。看起来咋咋唬唬的。。但是就是这么一直戴着面具的小孩。。总是会在镜头没有扫到他的时候。。用很安静很温柔的眼神看💙。。这个才是他最真实的一面。。他根本就不是什么二货吃货人设。。相反。。他是非常包容到有点疯的性格。。很多时候并不在乎自己得到还是失去。。他自己说过“不要因为你爱我所以我快乐，而要因为我爱你所以我快乐”\n\n\n而他这种包容。。给💙给的是最多的。。比起💙其实💚才是真正缺失童年的人。。💙性格比较直接。。看着不好惹但其实内心很软。。他进sdfj目的很明确。。💚一开始只当个免费兴趣班。。13年的时候还想过要退出。。你猜他为什么留下来了。。💚对💙几乎是无条件纵容。。在他面前逗乐。。满足他的好胜心。。💙手指一指💚在舞台另一边也要跑老远过去。。永远接💙的梗。。永远给💙回应。。哪怕在冷战。。\n如果真像i2说的每个人都在💚这有一次机会的话，那💙大概永远有机会。。\n\n\n而且小朋友。。对自己崇拜但不亲近不爱的人。。一般会用敬称。。但当崇拜转化成了喜欢。。想要靠近的时候。。就开始故意掩盖自己曾经崇拜过的事实。。敬称往往会转变成。。带着点调戏但更多是小朋友在悄悄释放信号“我想和你更贴近的”的称呼：小凯、王俊凯🥺这点从💚对别人的称呼可以看出来。。💚很擅长social。。叫哥哥姐姐都是信手拈来。。所以他为什么不叫💙哥哥呢。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "“如果真像i2说的每个人都在💚这有一次机会的话，那💙大概永远有机会。。”这句话好戳人哦。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "151",
  },
  {
    id: 592,
    user_face: "592-user-face.png",
    user_id: "sqysa",
    is_op: false,
    create_at: "2022-12-29 19:32:53 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "2023年了 评论区怎么还有这么多我没见过的🍬🥰",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 593,
    user_face: "593-user-face.png",
    user_id: "醉梅子酒",
    is_op: false,
    create_at: "2022-12-29 19:36:02 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 594,
    user_face: "594-user-face.png",
    user_id: "冷漠代表",
    is_op: false,
    create_at: "2022-12-29 19:58:59 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "每年总会有几天磕💙💚疯狂上头",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "52",
  },
  {
    id: 595,
    user_face: "595-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 20:10:22 四川",
    quote: {
      quote_status: true,
      quote_content:
        "被i2哥哥的视角感动得。。。😭。。。如果其他人在22这里只有一次机会。。wjk大概就是永远有机会。。。太对了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "确实是这样。。。。。嗑23久了很自然的就能发现，3在2这里的特别是独一无二的。。。。。永远和别的人不一样",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "134",
  },
  {
    id: 596,
    user_face: "596-user-face.png",
    user_id: "子所不语",
    is_op: false,
    create_at: "2022-12-29 20:12:59 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲。。。在这里。。住下了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 597,
    user_face: "597-user-face.png",
    user_id: "逃离冬季",
    is_op: false,
    create_at: "2022-12-29 20:20:13 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "楼上哥哥说的是真的。。真的很多料。。。虽然假的也很多就是了。。。我印象最深是三字生日会彩排二字陪着去的 当着粉丝的面下车跑掉 三字在后面慢慢走 那是他俩被说be最凶的17年。。。我以为是滤料 直到前段时间看到视频。。。四五年。。。这帮人是真会藏啊。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。有视频吗？这对我真的很重要。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 598,
    user_face: "598-user-face.png",
    user_id: "伤心凉皮",
    is_op: false,
    create_at: "2022-12-29 20:21:56 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "妈呀先买个房子。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 599,
    user_face: "599-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 20:25:15 天津",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥们小心。。。。唯粉来了。。。。唯粉来组团聚宝了。。。且嗑且珍惜。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "81",
  },
  {
    id: 600,
    user_face: "600-user-face.png",
    user_id: "小心超人",
    is_op: false,
    create_at: "2022-12-29 20:29:12 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "先🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 601,
    user_face: "601-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 20:39:36 福建",
    quote: {
      quote_status: true,
      quote_content: "哥哥。。。有视频吗？这对我真的很重要。。。",
      quote_user_id: "逃离冬季",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "在b站我记得。。。但是没有保存我也找不到 等一个热心道济给。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 602,
    user_face: "602-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 20:40:16 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。快发。。。唯粉组团来狙了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 603,
    user_face: "603-user-face.png",
    user_id: "1987哇哈哈AD钙",
    is_op: false,
    create_at: "2022-12-29 20:41:11 江苏",
    quote: {
      quote_status: true,
      quote_content: "哥哥。。。有视频吗？这对我真的很重要。。。",
      quote_user_id: "逃离冬季",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "我只能找到一张很糊很糊的动图。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "156",
  },
  {
    id: 604,
    user_face: "604-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 20:44:57 山东",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "604-quote.png",
      },
    },
    cmt: {
      cmt_content: "kswl。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 605,
    user_face: "605-user-face.png",
    user_id: "吃口蛋挞🧁",
    is_op: false,
    create_at: "2022-12-29 20:53:02 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "关于三字没轻重的开玩笑。。两个人冷战。。从Roy6设定和故事中可以看出二字的态度。。。劳迪是云，莱阳是小太阳。。。莱阳发光的时候有时候会把劳迪蒸发掉。。。劳迪会打闹把莱阳淋湿成落汤小狮子。。。主持人：那劳迪下雨不会让莱阳的火熄灭吗。。。二字：不会不会是朋友开玩笑",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "又来磕了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "10",
  },
  {
    id: 606,
    user_face: "606-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 21:05:44 北京",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "606-quote.png",
      },
    },
    cmt: {
      cmt_content: "跑这么快。。。。。磕死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "99",
  },
  {
    id: 607,
    user_face: "607-user-face.png",
    user_id: "Joyder",
    is_op: false,
    create_at: "2022-12-29 21:08:40 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "是22更早开始有意识地试探拉扯这个观点，想起一篇同人文潮汐锁定…",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "40",
  },
  {
    id: 608,
    user_face: "608-user-face.png",
    user_id: "幼儿园园长",
    is_op: false,
    create_at: "2022-12-29 21:16:58 四川",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "血腥爱情故事，2是不是后悔了哇",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 609,
    user_face: "609-user-face.png",
    user_id: "泥头车驾驶司机",
    is_op: false,
    create_at: "2022-12-29 21:19:53 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "好的哥哥。。。我朋友只是个屏幕饭。。。绝对底层。。。以上都是我朋友臆想编的小故事的。。。哥哥别往心里去啊。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "来了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 610,
    user_face: "610-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 21:23:02 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。还有吗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 611,
    user_face: "611-user-face.png",
    user_id: "逃离冬季",
    is_op: false,
    create_at: "2022-12-29 21:26:32 安徽",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "611-quote.png",
      },
    },
    cmt: {
      cmt_content: "哥哥。。。kswl！！！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 612,
    user_face: "612-user-face.png",
    user_id: "芝士奶盖抹茶杯",
    is_op: false,
    create_at: "2022-12-29 21:30:58 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 613,
    user_face: "613-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-29 21:34:50 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 614,
    user_face: "614-user-face.png",
    user_id: "🚬",
    is_op: false,
    create_at: "2022-12-29 21:39:42 德国",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "614-quote.png",
      },
    },
    cmt: {
      cmt_content: "awsl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 615,
    user_face: "615-user-face.png",
    user_id: "陈浩南（已坐牢",
    is_op: false,
    create_at: "2022-12-29 21:39:57 四川",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "615-quote.png",
      },
    },
    cmt: {
      cmt_content: "好有嫂德。。。。。🥰🥰🥰🥰",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "164",
  },
  {
    id: 616,
    user_face: "616-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 21:53:41 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "532",
  },
  {
    id: 617,
    user_face: "617-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 21:54:29 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "这个大帽子外套是💙的。。。3在客舱里还穿着。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "323",
  },
  {
    id: 618,
    user_face: "618-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 21:55:06 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "。。。。啊啊啊终于更新了！！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 619,
    user_face: "619-user-face.png",
    user_id: "冲浪美女👌",
    is_op: false,
    create_at: "2022-12-29 21:55:13 山东",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "终于等到你🥹🥹",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 620,
    user_face: "620-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-29 21:58:20 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哦莫。。这个没嗑过🤩",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "38",
  },
  {
    id: 621,
    user_face: "621-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:00:53 广东",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "那天不管i2还是i3看到wjk带着22已经在头等舱坐好的时候。。。真的气si又狼狈。。。\n\n说起来。。。之前看组里有哥哥说。。。wjk跨年去🇲🇴这操作是单刀赴会丈母娘很勇。。。当时就心想。。。这算啥呀（没有说那个哥哥说不好的意思。。。\n\n更疯的他又不是没干过。。。正好也在🇲🇴呢呵呵。。。当时我真怕i2在机舱里同亖他。。。带着人家生病的女儿提前上飞机不给看。。。😅",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "427",
  },
  {
    id: 622,
    user_face: "622-user-face.png",
    user_id: "嘻嘻",
    is_op: false,
    create_at: "2022-12-29 22:01:24 河南",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我草没嗑过的。。。渴死了。。。。啊啊啊啊啊。。。。💙果然是爹系男友。。。有这么爱吗。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "25",
  },
  {
    id: 623,
    user_face: "623-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:01:56 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "33当时在这个衣服外面再穿着那个大帽子外套。。。但是到达之后。。。在22身上😅我朋友说她当时真的一口气回不过来。。。想撅过去。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "90",
  },
  {
    id: 624,
    user_face: "624-user-face.png",
    user_id: "恋爱日记",
    is_op: false,
    create_at: "2022-12-29 22:04:16 江苏",
    quote: {
      quote_status: true,
      quote_content: "这个大帽子外套是💙的。。。3在客舱里还穿着。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "624-quote.png",
      },
    },
    cmt: {
      cmt_content: "🆘🆘🆘",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "62",
  },
  {
    id: 625,
    user_face: "625-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:04:47 江西",
    quote: {
      quote_status: true,
      quote_content: "这个大帽子外套是💙的。。。3在客舱里还穿着。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "625-quote.png",
      },
    },
    cmt: {
      cmt_content: "真的kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "46",
  },
  {
    id: 626,
    user_face: "626-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:04:59 四川",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "卧槽卧槽。。。kswl。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "28",
  },
  {
    id: 627,
    user_face: "627-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 22:06:04 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "卧槽 哥哥你来了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 628,
    user_face: "628-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:06:24 北京",
    quote: {
      quote_status: true,
      quote_content:
        "那天不管i2还是i3看到wjk带着22已经在头等舱坐好的时候。。。真的气si又狼狈。。。\n\n说起来。。。之前看组里有哥哥说。。。wjk跨年去🇲🇴这操作是单刀赴会丈母娘很勇。。。当时就心想。。。这算啥呀（没有说那个哥哥说不好的意思。。。\n\n更疯的他又不是没干过。。。正好也在🇲🇴呢呵呵。。。当时我真怕i2在机舱里同亖他。。。带着人家生病的女儿提前上飞机不给看。。。😅",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。让你朋友再多说点。。。。好爱看。。。。🤤🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "41",
  },
  {
    id: 629,
    user_face: "629-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 22:07:25 山东",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "他好爱他。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "40",
  },
  {
    id: 630,
    user_face: "630-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:07:50 上海",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "。。。。🆘",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 631,
    user_face: "631-user-face.png",
    user_id: "高太太",
    is_op: false,
    create_at: "2022-12-29 22:08:00 江苏",
    quote: {
      quote_status: true,
      quote_content: "这个大帽子外套是💙的。。。3在客舱里还穿着。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "631-quote.png",
      },
    },
    cmt: {
      cmt_content: "好。。。。好老公。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "79",
  },
  {
    id: 632,
    user_face: "632-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:09:05 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "139",
  },
  {
    id: 633,
    user_face: "633-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 22:11:11 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "澳门。。。我命中注定的澳门。。。这次还能不能再给点嗑的，。。，",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "237",
  },
  {
    id: 634,
    user_face: "634-user-face.png",
    user_id: "Joyder",
    is_op: false,
    create_at: "2022-12-29 22:11:50 上海",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "突然意识到，cpf和wf的视角确实很不一样，cpf就快乐当糖磕了，因为视角的前提就是他俩相爱，给外套只是他确实好爱他；wf视角是你怎么能不管你自己，把对方放得比自己重，艹居然是真给子",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "360",
  },
  {
    id: 635,
    user_face: "635-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:11:55 广东",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "635-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "wjk出发的时候这倒霉格子外面就穿着大帽子。。。但是到达之后。。。却在22身上😅我朋友说她当时真的一口气回不过来。。。想撅过去。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "363",
  },
  {
    id: 636,
    user_face: "636-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:13:26 美国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕死我了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 637,
    user_face: "637-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 22:14:53 云南",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "妈的。。。。。。这个真没磕过啊🤤🤤🤤🤤🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "48",
  },
  {
    id: 638,
    user_face: "638-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:17:06 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "接到一位哥哥的投稿补充。。。关于22本身的穿搭原来也有问题。。。诡计多端的给子啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "143",
  },
  {
    id: 639,
    user_face: "639-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:17:26 广东",
    quote: {
      quote_status: true,
      quote_content:
        "接到一位哥哥的投稿补充。。。关于22本身的穿搭原来也有问题。。。诡计多端的给子啊。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "639-quote.png",
      },
    },
    cmt: {
      cmt_content: "这是这位哥哥的瑞评。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "639-cmt.png",
      },
    },
    like_cnt: "254",
  },
  {
    id: 640,
    user_face: "640-user-face.png",
    user_id: "十七一",
    is_op: false,
    create_at: "2022-12-29 22:18:25 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "竟然有我没磕过的！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 641,
    user_face: "641-user-face.png",
    user_id: "不止是粒米",
    is_op: false,
    create_at: "2022-12-29 22:19:06 福建",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "永远在一起好吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "65",
  },
  {
    id: 642,
    user_face: "642-user-face.png",
    user_id: "美貌营业ing",
    is_op: false,
    create_at: "2022-12-29 22:20:03 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑的想亖",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 643,
    user_face: "643-user-face.png",
    user_id: "момо",
    is_op: false,
    create_at: "2022-12-29 22:20:06 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好高的楼omg",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 644,
    user_face: "644-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 22:20:15 山东",
    quote: {
      quote_status: true,
      quote_content: "这是这位哥哥的瑞评。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "644-quote.png",
      },
    },
    cmt: {
      cmt_content: "kswl。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 645,
    user_face: "645-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:20:53 北京",
    quote: {
      quote_status: true,
      quote_content:
        "接到一位哥哥的投稿补充。。。关于22本身的穿搭原来也有问题。。。诡计多端的给子啊。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "645-quote.png",
      },
    },
    cmt: {
      cmt_content: "没想到能磕到新的。。。。🆘他好爱他。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "80",
  },
  {
    id: 646,
    user_face: "646-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 22:21:18 云南",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "道济只顾着双人机场。。。。。好像真没磕过起飞前这一出。。。。。。😭😭。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "190",
  },
  {
    id: 647,
    user_face: "647-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 22:23:59 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "找到了。。2在上飞机之前根本不是羽绒服外套。。是这个大衣",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "212",
  },
  {
    id: 648,
    user_face: "648-user-face.png",
    user_id: "失忆蝴蝶",
    is_op: false,
    create_at: "2022-12-29 22:24:17 福建",
    quote: {
      quote_status: true,
      quote_content:
        "wjk出发的时候这倒霉格子外面就穿着大帽子。。。但是到达之后。。。却在22身上😅我朋友说她当时真的一口气回不过来。。。想撅过去。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "妈呀。。ky。。越渴越有",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "45",
  },
  {
    id: 649,
    user_face: "649-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-29 22:24:42 山东",
    quote: {
      quote_status: true,
      quote_content: "找到了。。2在上飞机之前根本不是羽绒服外套。。是这个大衣",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "649-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "也印证了，他那个搭配一开始就是要穿大衣的。。。最后穿了羽绒服",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "161",
  },
  {
    id: 650,
    user_face: "650-user-face.png",
    user_id: "R1NG-Ming",
    is_op: false,
    create_at: "2022-12-29 22:25:16 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊啊啊啊啊啊啊kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 651,
    user_face: "651-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-29 22:25:27 浙江",
    quote: {
      quote_status: true,
      quote_content: "找到了。。2在上飞机之前根本不是羽绒服外套。。是这个大衣",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "651-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "omg。。。。。好多说道济的🍭大同小异。。。这次是真的不一样了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "176",
  },
  {
    id: 652,
    user_face: "652-user-face.png",
    user_id: "yyyyyi",
    is_op: false,
    create_at: "2022-12-29 22:25:47 广东",
    quote: {
      quote_status: true,
      quote_content: "这是这位哥哥的瑞评。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "652-quote.png",
      },
    },
    cmt: {
      cmt_content: "kswl  💙好爱他。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "35",
  },
  {
    id: 653,
    user_face: "653-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:26:19 广东",
    quote: {
      quote_status: true,
      quote_content:
        "突然意识到，cpf和wf的视角确实很不一样，cpf就快乐当糖磕了，因为视角的前提就是他俩相爱，给外套只是他确实好爱他；wf视角是你怎么能不管你自己，把对方放得比自己重，艹居然是真给子",
      quote_user_id: "Joyder",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是。。。cpf的前提就是一切建立在他们很相爱的基础上。。。本贴带大家看看两个给子（主要是看wjk。。。到底是干了些什么丧心病狂的事情逼迫唯饭去相信他们是相爱的😡😡。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "314",
  },
  {
    id: 654,
    user_face: "654-user-face.png",
    user_id: "MBWS*",
    is_op: false,
    create_at: "2022-12-29 22:26:27 江苏",
    quote: {
      quote_status: true,
      quote_content: "这是这位哥哥的瑞评。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "654-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。。听我说谢谢你。。。双人机场。。。从来没有从这个角度嗑过。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "79",
  },
  {
    id: 655,
    user_face: "655-user-face.png",
    user_id: "失忆蝴蝶",
    is_op: false,
    create_at: "2022-12-29 22:26:36 福建",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "655-quote.png",
      },
    },
    cmt: {
      cmt_content: "妈呀。。跑得真快。。笑死我了。。怕被婆婆打是吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "170",
  },
  {
    id: 656,
    user_face: "656-user-face.png",
    user_id: "抱抱豹豹",
    is_op: false,
    create_at: "2022-12-29 22:26:49 山西",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "妈妈呀凯源怎么还有我没克过的呢。。。😍😍😍",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "61",
  },
  {
    id: 657,
    user_face: "657-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:27:40 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哦莫哦莫哦莫多来点",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 658,
    user_face: "658-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 22:28:17 云南",
    quote: {
      quote_status: true,
      quote_content:
        "那天不管i2还是i3看到wjk带着22已经在头等舱坐好的时候。。。真的气si又狼狈。。。\n\n说起来。。。之前看组里有哥哥说。。。wjk跨年去🇲🇴这操作是单刀赴会丈母娘很勇。。。当时就心想。。。这算啥呀（没有说那个哥哥说不好的意思。。。\n\n更疯的他又不是没干过。。。正好也在🇲🇴呢呵呵。。。当时我真怕i2在机舱里同亖他。。。带着人家生病的女儿提前上飞机不给看。。。😅",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "《亲妈担心自己的虎儿子被丈母娘同亖》。。。。。我要笑死了。。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "59",
  },
  {
    id: 659,
    user_face: "659-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 22:28:33 北京",
    quote: {
      quote_status: true,
      quote_content: "这个大帽子外套是💙的。。。3在客舱里还穿着。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "659-quote.png",
      },
    },
    cmt: {
      cmt_content: "哇趣 磕的好想死 能不能在一起一辈子啊啊啊啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "80",
  },
  {
    id: 660,
    user_face: "660-user-face.png",
    user_id: "Reykjavik",
    is_op: false,
    create_at: "2022-12-29 22:29:12 广东",
    quote: {
      quote_status: true,
      quote_content: "找到了。。2在上飞机之前根本不是羽绒服外套。。是这个大衣",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "660-quote.png",
      },
    },
    cmt: {
      cmt_content: "玛雅。。。玛雅。。。玛雅。。真的是真的啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "47",
  },
  {
    id: 661,
    user_face: "661-user-face.png",
    user_id: "地瓜是地瓜",
    is_op: false,
    create_at: "2022-12-29 22:30:00 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 662,
    user_face: "662-user-face.png",
    user_id: "雾凛",
    is_op: false,
    create_at: "2022-12-29 22:30:59 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "尊重爱情🙏",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 663,
    user_face: "663-user-face.png",
    user_id: "Rr.",
    is_op: false,
    create_at: "2022-12-29 22:33:12 河北",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "663-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "什么。。。这件事竟然真的有图。。。我一直抱着文字描述信一半的心态看来着。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "146",
  },
  {
    id: 664,
    user_face: "664-user-face.png",
    user_id: "你好贱哦",
    is_op: false,
    create_at: "2022-12-29 22:33:50 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "你们💙💚。。。怎么越磕越有啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "130",
  },
  {
    id: 665,
    user_face: "665-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-29 22:35:26 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥今晚会更完吗。。。困了但又怕一晚上过去帖子没了😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "33",
  },
  {
    id: 666,
    user_face: "666-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 22:37:05 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕的有点昏厥了。。。。这么好在一起一辈子行不行",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "68",
  },
  {
    id: 667,
    user_face: "667-user-face.png",
    user_id: "mxghj",
    is_op: false,
    create_at: "2022-12-29 22:37:10 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "271",
  },
  {
    id: 668,
    user_face: "668-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:37:21 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "有哥哥说。。。这个大帽子很像22自己那件。。。不是特别确定。。。但有点像。。。但是在澳门出发的时候。。。他是被33穿着身上的。。。落地之后在22身上。。。不过应该不影响ke💊。。。科学严谨客观嗑药的前提下再补一下这个。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "210",
  },
  {
    id: 669,
    user_face: "669-user-face.png",
    user_id: "啦啦卡啦卡",
    is_op: false,
    create_at: "2022-12-29 22:37:24 陕西",
    quote: {
      quote_status: true,
      quote_content:
        "那天不管i2还是i3看到wjk带着22已经在头等舱坐好的时候。。。真的气si又狼狈。。。\n\n说起来。。。之前看组里有哥哥说。。。wjk跨年去🇲🇴这操作是单刀赴会丈母娘很勇。。。当时就心想。。。这算啥呀（没有说那个哥哥说不好的意思。。。\n\n更疯的他又不是没干过。。。正好也在🇲🇴呢呵呵。。。当时我真怕i2在机舱里同亖他。。。带着人家生病的女儿提前上飞机不给看。。。😅",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这不是对上了吗，之前有小踩哥哥爆料过",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "261",
  },
  {
    id: 670,
    user_face: "670-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:37:31 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "本贴说的细节料都对真实度负责。。。如果有哥哥觉得哪里记错了或者是错的。。。可以私我锤。。。确定的情况下删或改都可以。。。虽然这是一个cp贴。。。但每不想糊弄编💊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "211",
  },
  {
    id: 671,
    user_face: "671-user-face.png",
    user_id: "不吃甜的🐷",
    is_op: false,
    create_at: "2022-12-29 22:37:49 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我去。。。完全不知道这一茬 也太能藏了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 672,
    user_face: "672-user-face.png",
    user_id: "葡萄芋圆",
    is_op: false,
    create_at: "2022-12-29 22:37:53 河北",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这个竟然没嗑过",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 673,
    user_face: "673-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-29 22:38:50 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "本贴说的细节料都对真实度负责。。。如果有哥哥觉得哪里记错了或者是错的。。。可以私我锤。。。确定的情况下删或改都可以。。。虽然这是一个cp贴。。。但每不想糊弄编💊。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。。摩多。。。摩多。。。实不相瞒。。。我已经一觉睡醒了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "14",
  },
  {
    id: 674,
    user_face: "674-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-29 22:39:26 福建",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。我有个朋友。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "45",
  },
  {
    id: 675,
    user_face: "675-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 22:39:30 广东",
    quote: {
      quote_status: true,
      quote_content: "哥哥今晚会更完吗。。。困了但又怕一晚上过去帖子没了😭",
      quote_user_id: "不喝冰阔落了",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "后面都是一些自己的分析了。。。应该没有大家没见过的药。。。就是简单总结他们这两年的状态。。。哥哥当心睡。。。寄了一定会再发的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "88",
  },
  {
    id: 676,
    user_face: "676-user-face.png",
    user_id: "洁白无瑕伍嘉成",
    is_op: false,
    create_at: "2022-12-29 22:41:05 福建",
    quote: {
      quote_status: true,
      quote_content:
        "wjk出发的时候这倒霉格子外面就穿着大帽子。。。但是到达之后。。。却在22身上😅我朋友说她当时真的一口气回不过来。。。想撅过去。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这个尊的没磕过 谢谢你哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 677,
    user_face: "677-user-face.png",
    user_id: "蜜桃乌龙茶",
    is_op: false,
    create_at: "2022-12-29 22:42:11 山西",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。这是什么好东西。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "30",
  },
  {
    id: 678,
    user_face: "678-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:43:18 山东",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥我今天听不到真的睡不着。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "95",
  },
  {
    id: 679,
    user_face: "679-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 22:44:14 云南",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。。我感觉我此生听不到会亖不瞑目。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "98",
  },
  {
    id: 680,
    user_face: "680-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 22:46:22 北京",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "属于这辈子听不到不想死的程度。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "140",
  },
  {
    id: 681,
    user_face: "681-user-face.png",
    user_id: "AKB48-三冘月駦",
    is_op: false,
    create_at: "2022-12-29 22:46:28 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哦莫帝国前线jj们瞒得我好苦啊这么大颗糖硬是藏了三年。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "189",
  },
  {
    id: 682,
    user_face: "682-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:47:10 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "阳迪 你今晚不把语音放出来 我晚上把你扛到吴彤床上去信不信",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "153",
  },
  {
    id: 683,
    user_face: "683-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:48:57 山东",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "杨迪哥哥。。。你说句话啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "45",
  },
  {
    id: 684,
    user_face: "684-user-face.png",
    user_id: "Wisdom",
    is_op: false,
    create_at: "2022-12-29 22:49:25 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "妈呀。。。怎么。。越磕越有。。。震to the撼",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "29",
  },
  {
    id: 685,
    user_face: "685-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 22:51:17 云南",
    quote: {
      quote_status: true,
      quote_content: "阳迪 你今晚不把语音放出来 我晚上把你扛到吴彤床上去信不信",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "我抗上半身你抗下半身。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 686,
    user_face: "686-user-face.png",
    user_id: "AKB48-三冘月駦",
    is_op: false,
    create_at: "2022-12-29 22:51:46 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "wjk出发的时候这倒霉格子外面就穿着大帽子。。。但是到达之后。。。却在22身上😅我朋友说她当时真的一口气回不过来。。。想撅过去。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "妈耶这哪个wf看了不心梗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 687,
    user_face: "687-user-face.png",
    user_id: "心碎洋葱圈",
    is_op: false,
    create_at: "2022-12-29 22:54:13 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "吉。。。瑟。。斯。。。💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "13",
  },
  {
    id: 688,
    user_face: "688-user-face.png",
    user_id: "啦啦卡啦卡",
    is_op: false,
    create_at: "2022-12-29 22:55:06 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "呵呵呵，19年他们参加活动在台下坐着，有个视频是2问3冷不冷。他应该是冷了，3在干嘛忘了，好像在装逼摇头。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "177",
  },
  {
    id: 689,
    user_face: "689-user-face.png",
    user_id: "AKB48-三冘月駦",
    is_op: false,
    create_at: "2022-12-29 22:55:40 浙江",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "689-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "这套衣服我记得，到达北京的时候一群站姐跟着他们下楼，wjk还在等电梯，wy就自己走楼梯下去了，完了还跟嘚瑟地抱着手臂在门边等wjk过来。wjk知道wy自己走楼梯下去了，那个表情也是很精彩，虽然戴着口罩也能看到他眼里的震惊和不解。我只记得这个场景很好笑，当时有图和视频，有哪个哥哥还能找到吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "234",
  },
  {
    id: 690,
    user_face: "690-user-face.png",
    user_id: "mxghj",
    is_op: false,
    create_at: "2022-12-29 22:55:43 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "杨迪也没录音啊哥哥们。。。。是我朋友当面给我放的。。。。好像是重庆话。。。当时就差把🔪架在我脖子上让我上岛了。。。结果18年那会儿窝还在i🇰🇷人。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "176",
  },
  {
    id: 691,
    user_face: "691-user-face.png",
    user_id: "顿顿火锅🍲",
    is_op: false,
    create_at: "2022-12-29 22:55:51 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "居然还有没嗑过的。。。。。i3i2速速放饭。。。。我要坐下美美恰饭了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "28",
  },
  {
    id: 692,
    user_face: "692-user-face.png",
    user_id: "。",
    is_op: false,
    create_at: "2022-12-29 22:56:07 湖南",
    quote: {
      quote_status: true,
      quote_content: "找到了。。2在上飞机之前根本不是羽绒服外套。。是这个大衣",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "692-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "长款风衣搭短款羽绒有够难看的 不过这是老公的关心那就另说了😍😍",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "165",
  },
  {
    id: 693,
    user_face: "693-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 22:56:42 云南",
    quote: {
      quote_status: true,
      quote_content:
        "杨迪也没录音啊哥哥们。。。。是我朋友当面给我放的。。。。好像是重庆话。。。当时就差把🔪架在我脖子上让我上岛了。。。结果18年那会儿窝还在i🇰🇷人。。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "我嫉妒亖你了哥哥。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "52",
  },
  {
    id: 694,
    user_face: "694-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:58:26 山东",
    quote: {
      quote_status: true,
      quote_content:
        "杨迪也没录音啊哥哥们。。。。是我朋友当面给我放的。。。。好像是重庆话。。。当时就差把🔪架在我脖子上让我上岛了。。。结果18年那会儿窝还在i🇰🇷人。。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。能不能再问朋友要一下。。。我真的哭亖。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "72",
  },
  {
    id: 695,
    user_face: "695-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 22:59:10 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "杨迪也没录音啊哥哥们。。。。是我朋友当面给我放的。。。。好像是重庆话。。。当时就差把🔪架在我脖子上让我上岛了。。。结果18年那会儿窝还在i🇰🇷人。。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥啊哥哥。。。你怎么错过了好时机！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 696,
    user_face: "696-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-29 23:01:47 云南",
    quote: {
      quote_status: true,
      quote_content:
        "这套衣服我记得，到达北京的时候一群站姐跟着他们下楼，wjk还在等电梯，wy就自己走楼梯下去了，完了还跟嘚瑟地抱着手臂在门边等wjk过来。wjk知道wy自己走楼梯下去了，那个表情也是很精彩，虽然戴着口罩也能看到他眼里的震惊和不解。我只记得这个场景很好笑，当时有图和视频，有哪个哥哥还能找到吗",
      quote_user_id: "AKB48-三冘月駦",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥是不是记混了。。。。。我听你的描述好像是另一次双人机场hhhh。。。。https://m.weibo.cn/3003803804/4331038576710858",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "92",
  },
  {
    id: 697,
    user_face: "697-user-face.png",
    user_id: "AKB48-三冘月駦",
    is_op: false,
    create_at: "2022-12-29 23:04:01 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "这套衣服我记得，到达北京的时候一群站姐跟着他们下楼，wjk还在等电梯，wy就自己走楼梯下去了，完了还跟嘚瑟地抱着手臂在门边等wjk过来。wjk知道wy自己走楼梯下去了，那个表情也是很精彩，虽然戴着口罩也能看到他眼里的震惊和不解。我只记得这个场景很好笑，当时有图和视频，有哪个哥哥还能找到吗",
      quote_user_id: "AKB48-三冘月駦",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "啊是我搞错了！不是同一次，是另一次！ 有组外哥哥找到了视频https://m.bilibili.com/video/BV1Ft411h7Vs/\n",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "42",
  },
  {
    id: 698,
    user_face: "698-user-face.png",
    user_id: "AKB48-三冘月駦",
    is_op: false,
    create_at: "2022-12-29 23:04:17 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥是不是记混了。。。。。我听你的描述好像是另一次双人机场hhhh。。。。https://m.weibo.cn/3003803804/4331038576710858",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "对对对！记混了！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 699,
    user_face: "699-user-face.png",
    user_id: "joji",
    is_op: false,
    create_at: "2022-12-29 23:06:03 河北",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我听过！！好像是打游戏还是在酒店来着我忘了（如果没记错的话。。。）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "74",
  },
  {
    id: 700,
    user_face: "700-user-face.png",
    user_id: "西兰开花",
    is_op: false,
    create_at: "2022-12-29 23:06:22 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊啊啊啊啊啊啊啊啊啊还得是💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 701,
    user_face: "701-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:06:24 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑亖。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 702,
    user_face: "702-user-face.png",
    user_id: "天童觉人觉世",
    is_op: false,
    create_at: "2022-12-29 23:07:37 北京",
    quote: {
      quote_status: true,
      quote_content: "这是这位哥哥的瑞评。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "702-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "谢谢哥哥。。当时我记得嗑的是。。三在边上就管着二穿衣服了。。没想到是直接把自己衣服给硬裹上去了。。怎么着自己觉得纽约巨冷北京还好是吧。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "144",
  },
  {
    id: 703,
    user_face: "703-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:09:40 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@momo",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 704,
    user_face: "704-user-face.png",
    user_id: "是爱要久久📢",
    is_op: false,
    create_at: "2022-12-29 23:12:21 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "震撼我全家。。。💙💚还有多少是我们不知道的。。。i2i3再多漏点。。。🙏🥺🙏",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "50",
  },
  {
    id: 705,
    user_face: "705-user-face.png",
    user_id: "正宗盐水鸭",
    is_op: false,
    create_at: "2022-12-29 23:13:02 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 706,
    user_face: "706-user-face.png",
    user_id: "明天睡到自然醒",
    is_op: false,
    create_at: "2022-12-29 23:13:06 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "srds 去澳门的时候是24一起走的 他俩还点外卖吃 过廊桥的时候4还把自己助理给2用了 就是胖虎一眼就能瞅见那个",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "67",
  },
  {
    id: 707,
    user_face: "707-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-29 23:13:19 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "好磕就好磕在。。。每一段文字都有动图视频印证。。。。。还得是你啊💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "131",
  },
  {
    id: 708,
    user_face: "708-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:13:47 山东",
    quote: {
      quote_status: true,
      quote_content:
        "我听过！！好像是打游戏还是在酒店来着我忘了（如果没记错的话。。。）",
      quote_user_id: "joji",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。别逼跪。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 709,
    user_face: "709-user-face.png",
    user_id: "氧气邮递员",
    is_op: false,
    create_at: "2022-12-29 23:17:52 甘肃",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕死我了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 710,
    user_face: "710-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:19:31 北京",
    quote: {
      quote_status: true,
      quote_content:
        "啊是我搞错了！不是同一次，是另一次！ 有组外哥哥找到了视频https://m.bilibili.com/video/BV1Ft411h7Vs/\n",
      quote_user_id: "AKB48-三冘月駦",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "😭等一等jk。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "27",
  },
  {
    id: 711,
    user_face: "711-user-face.png",
    user_id: "明天睡到自然醒",
    is_op: false,
    create_at: "2022-12-29 23:20:51 北京",
    quote: {
      quote_status: true,
      quote_content:
        "srds 去澳门的时候是24一起走的 他俩还点外卖吃 过廊桥的时候4还把自己助理给2用了 就是胖虎一眼就能瞅见那个",
      quote_user_id: "明天睡到自然醒",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "去的时候24比以前提早好久到  去的时候24回来23应该是因为当时2刚回国 助理啥的都不在     身边 那时候我们TFB还能说上话",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "124",
  },
  {
    id: 712,
    user_face: "712-user-face.png",
    user_id: "清唱",
    is_op: false,
    create_at: "2022-12-29 23:21:03 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死我了……",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 713,
    user_face: "713-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:22:10 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我去",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 714,
    user_face: "714-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 23:24:29 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "后面就是因为口罩wy回国，22回国之后很长一段时间住wjk家养猫这些细节就不用我给各位哥哥复习了。。。\n\n他们在这个阶段一定是有一个质变的，wy回国后和出国前的状态更是大相径庭，等一个i2哥哥补补吧我对22的感情视角没那么清晰。。。\n\n在这个阶段，我更偏向于他们愿意放过自己也放过彼此（放过不是放弃。。。他们会去学着接受他们这种特殊的关系。\n\n去珍惜他们关系中的独一无二和特性，毕竟从一开始他们只有彼此，真的是没繁华红毯的少年时代里，陪彼此走过籍籍无名啊，是回头看，不管是因为什么缘故你没有走，但原来只有你是没有和我走散的，你也不愿意和我走散，那我要好好珍惜。\n\n去忘记曾经别扭时的互相伤害，曾经他们就是太在意“缘故”，是外界的声音吗？是为了埋腐吗？你拿我当成什么？我不想被定义为你的睡，我是我自己，尤其是wy，他应该是有一段时间非常介意被粉丝称作wjk女朋友的。。。wjk也看不懂wy曾经很多的心事，各种别扭闹个不停，彼此伤害，应该也有很多彼此刺痛，但是这个时间段他们都选择忘记和接受这些过往，而不是纠缠不放。\n\n所以这两年他们的关系一直是在正向循环的。。。\n\n其实跨年是很甜，我真的对踩组的嗑法没有任何意见，只是我是唯饭的思维吧（也可能是我自己的原因。。。缺德归缺德，乐子归乐子，说归说。。。真的要说wjk去江苏跨年肯定是因为和两个台协商之下，哪边的曝光酬劳待遇更合适就去哪边，不会是因为wy去他就屁颠屁颠跟着去。\n\n但是他就是去了。\n\n他和他的团队肯定知道他这么去，i3就是来不及应援的，但他也不是很在乎的样子，他也肯定知道22也在（废话不可能不知道。。。但他不想避嫌。。。或者说他是觉得他和22的关系不需要特意避嫌。。。我们就是关系不错，怎么了？有什么问题？\n\ni3也别骗自己。。。wjk就是不觉得和wy同台是禁忌。。。他就是不觉得他要和wy老死不相往来。。。他们就是很好。。。不能确定是给子的话（毕竟我不能爬他们床底确认。。。他们也就是很好。。。真的很好。。。唯饭再怎么辩驳也骗不了自己。。。你哥哥就是和wy关系不差。。。\n\ni3视角完结",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "459",
  },
  {
    id: 715,
    user_face: "715-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:28:13 内蒙古",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "好像…直和直一起长大，一个弯了开始别扭，直恋弯不懂在别扭什么也变弯了，要我说结婚吧，我太奶奶都会祝福的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "281",
  },
  {
    id: 716,
    user_face: "716-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 23:32:11 广东",
    quote: {
      quote_status: true,
      quote_content:
        "srds 去澳门的时候是24一起走的 他俩还点外卖吃 过廊桥的时候4还把自己助理给2用了 就是胖虎一眼就能瞅见那个",
      quote_user_id: "明天睡到自然醒",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "第一哥哥。。。这是💙💚贴不嗑24。。。后面的内容就不太合适了。。。\n第二。。。哥哥有当年是行程图吗。。。因为出发和嗑药没太大关系。。。我朋友写的时候懒得求证靠记忆写的。。。所以特地标了好像是这样。。。如果确实是有出入就私密马赛。。。鞠躬。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "178",
  },
  {
    id: 717,
    user_face: "717-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:37:23 四川",
    quote: {
      quote_status: true,
      quote_content:
        "我听过！！好像是打游戏还是在酒店来着我忘了（如果没记错的话。。。）",
      quote_user_id: "joji",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "有点印象 。。。道济手上这种东西不少吧 。。还有ss打电话给2结果是3接的录音啥的。。。还有2还是3大早上7点过赶飞机另一个没行程但是起来陪着打游戏啥的 。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "185",
  },
  {
    id: 718,
    user_face: "718-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 23:38:04 广东",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "查了行程。。。加上一些哥哥的纠错。。。24是一起出发去澳门。。。是记错了。。。给大家道歉。。私密马赛。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "112",
  },
  {
    id: 719,
    user_face: "719-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:40:06 四川",
    quote: {
      quote_status: true,
      quote_content:
        "什么。。。这件事竟然真的有图。。。我一直抱着文字描述信一半的心态看来着。。。",
      quote_user_id: "Rr.",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "是视频。。。真的很好笑。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "25",
  },
  {
    id: 720,
    user_face: "720-user-face.png",
    user_id: "宋昕冉",
    is_op: false,
    create_at: "2022-12-29 23:40:27 广东",
    quote: {
      quote_status: true,
      quote_content:
        "有点印象 。。。道济手上这种东西不少吧 。。还有ss打电话给2结果是3接的录音啥的。。。还有2还是3大早上7点过赶飞机另一个没行程但是起来陪着打游戏啥的 。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "omg。。。这两个给子真的。。。道济速速把这些都给我放出来",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "77",
  },
  {
    id: 721,
    user_face: "721-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:40:44 北京",
    quote: {
      quote_status: true,
      quote_content:
        "后面就是因为口罩wy回国，22回国之后很长一段时间住wjk家养猫这些细节就不用我给各位哥哥复习了。。。\n\n他们在这个阶段一定是有一个质变的，wy回国后和出国前的状态更是大相径庭，等一个i2哥哥补补吧我对22的感情视角没那么清晰。。。\n\n在这个阶段，我更偏向于他们愿意放过自己也放过彼此（放过不是放弃。。。他们会去学着接受他们这种特殊的关系。\n\n去珍惜他们关系中的独一无二和特性，毕竟从一开始他们只有彼此，真的是没繁华红毯的少年时代里，陪彼此走过籍籍无名啊，是回头看，不管是因为什么缘故你没有走，但原来只有你是没有和我走散的，你也不愿意和我走散，那我要好好珍惜。\n\n去忘记曾经别扭时的互相伤害，曾经他们就是太在意“缘故”，是外界的声音吗？是为了埋腐吗？你拿我当成什么？我不想被定义为你的睡，我是我自己，尤其是wy，他应该是有一段时间非常介意被粉丝称作wjk女朋友的。。。wjk也看不懂wy曾经很多的心事，各种别扭闹个不停，彼此伤害，应该也有很多彼此刺痛，但是这个时间段他们都选择忘记和接受这些过往，而不是纠缠不放。\n\n所以这两年他们的关系一直是在正向循环的。。。\n\n其实跨年是很甜，我真的对踩组的嗑法没有任何意见，只是我是唯饭的思维吧（也可能是我自己的原因。。。缺德归缺德，乐子归乐子，说归说。。。真的要说wjk去江苏跨年肯定是因为和两个台协商之下，哪边的曝光酬劳待遇更合适就去哪边，不会是因为wy去他就屁颠屁颠跟着去。\n\n但是他就是去了。\n\n他和他的团队肯定知道他这么去，i3就是来不及应援的，但他也不是很在乎的样子，他也肯定知道22也在（废话不可能不知道。。。但他不想避嫌。。。或者说他是觉得他和22的关系不需要特意避嫌。。。我们就是关系不错，怎么了？有什么问题？\n\ni3也别骗自己。。。wjk就是不觉得和wy同台是禁忌。。。他就是不觉得他要和wy老死不相往来。。。他们就是很好。。。不能确定是给子的话（毕竟我不能爬他们床底确认。。。他们也就是很好。。。真的很好。。。唯饭再怎么辩驳也骗不了自己。。。你哥哥就是和wy关系不差。。。\n\ni3视角完结",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我也觉得💙💚最好磕的就是。。。人设是公司定的。。关系是公司推动着炒的。。。但他们最开始是真的好。。。后来是想摆脱。。。把真实的情感关系隐藏在人们都看不到的地方。。。因为太珍惜了不想失去。。。（一直游走到被忽悠瘸的边缘。。但怎么都否认不了的是。。他们对彼此很重要。。他们的关系是真的好。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "245",
  },
  {
    id: 722,
    user_face: "722-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:42:51 北京",
    quote: {
      quote_status: true,
      quote_content:
        "我也觉得💙💚最好磕的就是。。。人设是公司定的。。关系是公司推动着炒的。。。但他们最开始是真的好。。。后来是想摆脱。。。把真实的情感关系隐藏在人们都看不到的地方。。。因为太珍惜了不想失去。。。（一直游走到被忽悠瘸的边缘。。但怎么都否认不了的是。。他们对彼此很重要。。他们的关系是真的好。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "现在他们又不想否定和掩饰了。。。慢慢和解自洽了。。你们。。。。能不能一辈子在一起🥺🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "171",
  },
  {
    id: 723,
    user_face: "723-user-face.png",
    user_id: "stand by river",
    is_op: false,
    create_at: "2022-12-29 23:43:24 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "睡前一口好🍬。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 724,
    user_face: "724-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:45:22 北京",
    quote: {
      quote_status: true,
      quote_content:
        "又有一位i2哥哥投稿了。。。等我朋友的i3成年阶段今天完结就把这位哥哥的整理好发出来。。。非常感谢i2哥哥们。。。替我的贴子完善了另一个视角。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "蹲。。。。i2哥哥再多说点。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 725,
    user_face: "725-user-face.png",
    user_id: "糕贵流心包",
    is_op: false,
    create_at: "2022-12-29 23:47:07 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑崩溃了。。。😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 726,
    user_face: "726-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 23:48:31 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "明天给发另一位i2哥哥的视角。。。也是投稿。。。还有一位哥哥发的yb小垃圾的一些补充和嗑点。。今晚应该就这样了。。。大家睡吧。。。让我们谢谢i2哥哥。。。非常感谢每一位i2哥哥的投稿。。完善了贴子的另一个视角。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "129",
  },
  {
    id: 727,
    user_face: "727-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:48:36 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "感恩哥哥如此勤劳。。。嗑药🐔好幸福。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "13",
  },
  {
    id: 728,
    user_face: "728-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:50:37 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好嗑的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 729,
    user_face: "729-user-face.png",
    user_id: "be bad",
    is_op: false,
    create_at: "2022-12-29 23:51:04 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑得我满地拉😭哦莫真的好好嗑😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 730,
    user_face: "730-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 23:51:35 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "楼里别说24了。。。谢谢🙏。。。毕竟是32贴。。。提到4是避免不了的。。。哪怕他们闹别扭的时期和4走得近被理解为发糖这都可以说。。。但434和24的cp向是没必要提的。。。哥哥们想嗑可以另开。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "237",
  },
  {
    id: 731,
    user_face: "731-user-face.png",
    user_id: "āáǎà",
    is_op: false,
    create_at: "2022-12-29 23:51:57 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕到流泪",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 732,
    user_face: "732-user-face.png",
    user_id: "聚光灯",
    is_op: false,
    create_at: "2022-12-29 23:52:41 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "是这样的。。上面说的澳门这次是2因为一些原因没有贴身助理。。他来回都和队友一起才有人照看。。去的时候是24一起休息室吃饭。。回来是3给衣服穿。。也不是不能嗑一嘴3觉得只有自己照顾得好。。提前上飞机什么的。。3怕不是把自己当2助理呢。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "191",
  },
  {
    id: 733,
    user_face: "733-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-29 23:53:16 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "好像…直和直一起长大，一个弯了开始别扭，直恋弯不懂在别扭什么也变弯了，要我说结婚吧，我太奶奶都会祝福的",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。你这个角度感觉也很好磕。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "29",
  },
  {
    id: 734,
    user_face: "734-user-face.png",
    user_id: "林黛玉（剪香囊",
    is_op: false,
    create_at: "2022-12-29 23:56:33 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑亖。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 735,
    user_face: "735-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-29 23:57:27 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "srds 是不是没办法证明这件外套是3的 都是侧面佐证带毛外套是3 🍬（我太认真了。。。不求原谅",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "30",
  },
  {
    id: 736,
    user_face: "736-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-29 23:58:17 广东",
    quote: {
      quote_status: true,
      quote_content:
        "好像…直和直一起长大，一个弯了开始别扭，直恋弯不懂在别扭什么也变弯了，要我说结婚吧，我太奶奶都会祝福的",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "很不唯美哈哈哈哈。。。但是简单粗暴来总结就是这样。。。哥哥你是懂做中心思想提炼的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "124",
  },
  {
    id: 737,
    user_face: "737-user-face.png",
    user_id: "MBWS*",
    is_op: false,
    create_at: "2022-12-30 00:00:56 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "后面就是因为口罩wy回国，22回国之后很长一段时间住wjk家养猫这些细节就不用我给各位哥哥复习了。。。\n\n他们在这个阶段一定是有一个质变的，wy回国后和出国前的状态更是大相径庭，等一个i2哥哥补补吧我对22的感情视角没那么清晰。。。\n\n在这个阶段，我更偏向于他们愿意放过自己也放过彼此（放过不是放弃。。。他们会去学着接受他们这种特殊的关系。\n\n去珍惜他们关系中的独一无二和特性，毕竟从一开始他们只有彼此，真的是没繁华红毯的少年时代里，陪彼此走过籍籍无名啊，是回头看，不管是因为什么缘故你没有走，但原来只有你是没有和我走散的，你也不愿意和我走散，那我要好好珍惜。\n\n去忘记曾经别扭时的互相伤害，曾经他们就是太在意“缘故”，是外界的声音吗？是为了埋腐吗？你拿我当成什么？我不想被定义为你的睡，我是我自己，尤其是wy，他应该是有一段时间非常介意被粉丝称作wjk女朋友的。。。wjk也看不懂wy曾经很多的心事，各种别扭闹个不停，彼此伤害，应该也有很多彼此刺痛，但是这个时间段他们都选择忘记和接受这些过往，而不是纠缠不放。\n\n所以这两年他们的关系一直是在正向循环的。。。\n\n其实跨年是很甜，我真的对踩组的嗑法没有任何意见，只是我是唯饭的思维吧（也可能是我自己的原因。。。缺德归缺德，乐子归乐子，说归说。。。真的要说wjk去江苏跨年肯定是因为和两个台协商之下，哪边的曝光酬劳待遇更合适就去哪边，不会是因为wy去他就屁颠屁颠跟着去。\n\n但是他就是去了。\n\n他和他的团队肯定知道他这么去，i3就是来不及应援的，但他也不是很在乎的样子，他也肯定知道22也在（废话不可能不知道。。。但他不想避嫌。。。或者说他是觉得他和22的关系不需要特意避嫌。。。我们就是关系不错，怎么了？有什么问题？\n\ni3也别骗自己。。。wjk就是不觉得和wy同台是禁忌。。。他就是不觉得他要和wy老死不相往来。。。他们就是很好。。。不能确定是给子的话（毕竟我不能爬他们床底确认。。。他们也就是很好。。。真的很好。。。唯饭再怎么辩驳也骗不了自己。。。你哥哥就是和wy关系不差。。。\n\ni3视角完结",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "他俩从W&W到TFB再到各自工作。。。时间流逝。。。多少人说走散。。。也不怪别人说。。。因为我们大多数人有多少要好朋友随着时间变得陌生。。。多少情侣随着分离变得陌生。。。时间与空间会使人们距离拉开。。。更何况纸醉金迷的ylq。。。\n哥哥最后说的他俩感情就是好。。。让我感慨。。。人生路上很难有真挚的感情。。。亲情友情爱情我们不可缺少。。。但当得到后同样很难自己意识到珍惜以至于失去后才发出感慨说着“当时只道是寻常”。。。\n他俩意识到了珍惜了。。。对他俩而言就足够了。。。\n人生路漫漫幼时玩伴还在身边。。。很可贵。。。也很让人羡慕。。。\n最后感谢哥哥、哥哥朋友以及i2哥哥的陈述啦。。。让我开心地重温了他俩的许多糖点。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "273",
  },
  {
    id: 738,
    user_face: "738-user-face.png",
    user_id: "喝水都胖",
    is_op: false,
    create_at: "2022-12-30 00:03:42 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl i2 i3多说点",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 739,
    user_face: "739-user-face.png",
    user_id: "酷妹（养儿中）",
    is_op: false,
    create_at: "2022-12-30 00:07:42 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@钢蛙养殖户 求你爬楼看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 740,
    user_face: "740-user-face.png",
    user_id: "IVE-蔡亨源",
    is_op: false,
    create_at: "2022-12-30 00:08:37 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "嗑死我了。。i2 i3能不能别举这条。。。就放过他们也放过我们吧🥺😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "148",
  },
  {
    id: 741,
    user_face: "741-user-face.png",
    user_id: "R18-蕾哈娜",
    is_op: false,
    create_at: "2022-12-30 00:09:52 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "心满意足的去睡觉",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 742,
    user_face: "742-user-face.png",
    user_id: "美味花生包",
    is_op: false,
    create_at: "2022-12-30 00:14:19 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "希望醒来就能看到更新😄",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 743,
    user_face: "743-user-face.png",
    user_id: "张婧怡（期末版",
    is_op: false,
    create_at: "2022-12-30 00:18:07 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "里面哥哥提到的糖点我也有看过！！！可惜当初没存！！😭😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 744,
    user_face: "744-user-face.png",
    user_id: "🆕鸭翅",
    is_op: false,
    create_at: "2022-12-30 00:20:36 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "狠狠🐎了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 745,
    user_face: "745-user-face.png",
    user_id: "葳蕤",
    is_op: false,
    create_at: "2022-12-30 00:24:38 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 746,
    user_face: "746-user-face.png",
    user_id: "☃️",
    is_op: false,
    create_at: "2022-12-30 00:27:38 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "💙💚比较戳中我的还是一些小细节，比如团一起去🇰🇷拍摄mv那阵，空闲时间四字单独行动跑去追星，他们两个就一起去逛商场给💚妈妈买生日礼物了。同一天还在微博晒了互拍的商场🐧玩偶合影，购物回酒店后两人对着镜头试穿新鞋时💚的毛线帽戴在了💙头上，比拼谁的新鞋更好看(同品牌同色看不出啥差别……)但这种很日常的相处能感觉到关系不一般。\n还有某年fc年刊里面一人晒一张手机照片，💙晒的是💚在餐桌前和椅子一起摔倒的瞬间，配文好像是“某人吃饭不小心抓拍的”暗戳戳秀恩爱的feel……",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "248",
  },
  {
    id: 747,
    user_face: "747-user-face.png",
    user_id: "少管我的事",
    is_op: false,
    create_at: "2022-12-30 00:31:34 广东",
    quote: {
      quote_status: true,
      quote_content:
        "我觉得是33可能没安全感，33\n不会开窍那么晚，17年开始发现22\n有时候走路一拐一拐还扶腰，也明显干了啥，如果说还在纠结不可能就直接做了，这么冲动?\n\n",
      quote_user_id: "大象大象",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。求你给我看看。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "22",
  },
  {
    id: 748,
    user_face: "748-user-face.png",
    user_id: "有时托明月",
    is_op: false,
    create_at: "2022-12-30 00:38:24 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊啊啊啊给我看清醒了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 749,
    user_face: "749-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2022-12-30 00:49:27 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊抽个哥哥教我复制链接。。。我要给我朋友看。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 750,
    user_face: "750-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-30 00:53:23 云南",
    quote: {
      quote_status: true,
      quote_content: "啊啊啊抽个哥哥教我复制链接。。。我要给我朋友看。。。",
      quote_user_id: "已注销",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥复制不了吗。。。https://www.douban.com/group/topic/279199969/?_i=723321451261723",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 751,
    user_face: "751-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2022-12-30 00:54:54 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥复制不了吗。。。https://www.douban.com/group/topic/279199969/?_i=723321451261723",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "自从分享殉了之后就变成了一个人的狂欢。。谢谢哥哥🔗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 752,
    user_face: "752-user-face.png",
    user_id: "一棵仙人掌",
    is_op: false,
    create_at: "2022-12-30 00:59:20 北京",
    quote: {
      quote_status: true,
      quote_content:
        "什么。。。这件事竟然真的有图。。。我一直抱着文字描述信一半的心态看来着。。。",
      quote_user_id: "Rr.",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "是视频，2字还对婆婆说了句“拍什么拍”，也是勇…",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "55",
  },
  {
    id: 753,
    user_face: "753-user-face.png",
    user_id: "momo（已上岸）",
    is_op: false,
    create_at: "2022-12-30 01:00:56 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "19年底澳门事件\n\n19年底有一件事情其实在我心里是大🍬，但不知道为什么没多少道济舞这个。。。\n\n就是那次tfb澳门活动，应该是倒数的几次组合活动，他们三个都是北京飞澳门，澳门飞北京，出发地是一样的，我没记错的话飞过去他们三个发病，三个人，三趟航班，就是不一起走。。。🍀那时候好像狠狠心碎来着。。。\n\n回来的航班最精彩，4单独一班，ky是一起走的，这也没什么，毕竟澳门飞北京合适的航班就那么几趟，买到一起了也很正常对吧。。。\n\n但是没有站姐拍到33和22上飞机。\n\n先和大家说一下，现在很多人涛dp，但是dp这个概念源起于帝国，一开始只是某些站姐走不开，又不想错过某次活动的产出，所以买其他前线的图，很多人自己有属性，但是自担的图，队友的图，cp图都会卖，反正拍得有多就卖掉回血，叫买图卖图，但是这时候的代拍本质还是粉丝。后面很多人发现代拍真赚钱，才有很多无心无情贴脸的赚钱代拍。\n\n很多糊豆走机场是不走v所以代拍可以拍他们出发和落地，帝国这三个都是走v的，除非跟机否则是看不见他们的，和代拍的流程不太一样。\n\n站姐拍他们三个的机场look，在口罩之前基本都是从帝国起家就约定俗成的默契，登机他们会在比较正常的时间来，让站姐有充分的时间拍到他们。\n\n而wjk在澳门飞回北京的那一天，带着wy一大早就上了飞机😅😅😅站姐在廊桥（或者摆渡车）不太记得了，等不到wjk，才发现他已经上飞机了。。。没有任何“意外”情况。。。这是几乎从没有出现过的情况。。。\n\n我现在都记得那种无语的心情，那天我倒是不在（逃过一劫。。。但是我认识的在那天跟机的i3在朋友圈直接骂wjk：你敢提前带着wy上飞机担不敢给我们拍是吧😅\n\n那天是没有出发的照片的。。。但是有机舱偷拍的照片，wjk在客舱穿着外套。。。但是下飞机的时候。。。那个外套穿在wy身上。。。\n\n是没错。。。那几天wy是感冒了，但一个男的，感冒了，把外套给另一个男的穿上😅😅😅再补充一点，那个时候是北京冬天，机场落地是很冷的，wjk脱了那个外套里面是不够厚的，北方的哥哥都知道，外面肯定要有外套（大衣或者羽绒才能在外面走动的）所以这件外套对wjk来说不是可有可无的。。。如果不是wy。。。他没有理由不穿外套落地北京，如果不是wy自己感冒。。。还不穿衣服（澳门冬天暖和wy可能出发的时候觉得不穿也行忘了北京冷。。。wjk也不至于把外套给他。\n\n好兄弟之间，我有多一件当然可以给你，但我也只有一件，我却脱给你，这就不止是好兄弟了，反正我也破大防，我也觉得wjk踏爹的失心feng了哈哈。。。那是我第一次怀疑wjk真给子。。。真正意义的通讯录的那种给子。。。哪怕不用给子来解释。。这个时候他们已经成年了。。。不是小时候那个时期。。。他仍然保留着对wy那种过度照顾和特殊到像女朋友一样的疼爱。。。那不是兄弟之间该有的化学反应。。。男孩子正常不是这样的。。。i3也没办法自欺欺人了。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "嗑晕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 754,
    user_face: "754-user-face.png",
    user_id: "-请您努力-",
    is_op: false,
    create_at: "2022-12-30 01:23:11 吉林",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 755,
    user_face: "755-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 01:46:00 四川",
    quote: {
      quote_status: true,
      quote_content: "是视频，2字还对婆婆说了句“拍什么拍”，也是勇…",
      quote_user_id: "一棵仙人掌",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "。。。。。说的是拜拜。。。。不是拍什么拍。。。。。。。。我记忆里这个视频是二字的生日会三字陪二字彩排，可是楼里都说是三字生日会，我现在也疑惑了。。。。但是视频确实说的是拜拜",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "153",
  },
  {
    id: 756,
    user_face: "756-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 01:47:56 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "岛的料很多。。。。。但是假料也多。。。倒不是凯源是假的，主要是转述中出现了很多偏差。。。。所以没图没视频的料，哥哥们最好听听就算了。。。因为其实真实情况可能是A，大家传着传着就变成B了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "238",
  },
  {
    id: 757,
    user_face: "757-user-face.png",
    user_id: "akb-羽生结弦",
    is_op: false,
    create_at: "2022-12-30 01:51:10 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 758,
    user_face: "758-user-face.png",
    user_id: "限定四月",
    is_op: false,
    create_at: "2022-12-30 01:51:12 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "岛的料很多。。。。。但是假料也多。。。倒不是凯源是假的，主要是转述中出现了很多偏差。。。。所以没图没视频的料，哥哥们最好听听就算了。。。因为其实真实情况可能是A，大家传着传着就变成B了",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这话很对。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "46",
  },
  {
    id: 759,
    user_face: "759-user-face.png",
    user_id: "TFBOYS-管国林",
    is_op: false,
    create_at: "2022-12-30 02:02:19 贵州",
    quote: {
      quote_status: true,
      quote_content: "找到了。。2在上飞机之前根本不是羽绒服外套。。是这个大衣",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "759-quote.png",
      },
    },
    cmt: {
      cmt_content: "原来如此",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 760,
    user_face: "760-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 02:54:31 北京",
    quote: {
      quote_status: true,
      quote_content:
        "后面就是因为口罩wy回国，22回国之后很长一段时间住wjk家养猫这些细节就不用我给各位哥哥复习了。。。\n\n他们在这个阶段一定是有一个质变的，wy回国后和出国前的状态更是大相径庭，等一个i2哥哥补补吧我对22的感情视角没那么清晰。。。\n\n在这个阶段，我更偏向于他们愿意放过自己也放过彼此（放过不是放弃。。。他们会去学着接受他们这种特殊的关系。\n\n去珍惜他们关系中的独一无二和特性，毕竟从一开始他们只有彼此，真的是没繁华红毯的少年时代里，陪彼此走过籍籍无名啊，是回头看，不管是因为什么缘故你没有走，但原来只有你是没有和我走散的，你也不愿意和我走散，那我要好好珍惜。\n\n去忘记曾经别扭时的互相伤害，曾经他们就是太在意“缘故”，是外界的声音吗？是为了埋腐吗？你拿我当成什么？我不想被定义为你的睡，我是我自己，尤其是wy，他应该是有一段时间非常介意被粉丝称作wjk女朋友的。。。wjk也看不懂wy曾经很多的心事，各种别扭闹个不停，彼此伤害，应该也有很多彼此刺痛，但是这个时间段他们都选择忘记和接受这些过往，而不是纠缠不放。\n\n所以这两年他们的关系一直是在正向循环的。。。\n\n其实跨年是很甜，我真的对踩组的嗑法没有任何意见，只是我是唯饭的思维吧（也可能是我自己的原因。。。缺德归缺德，乐子归乐子，说归说。。。真的要说wjk去江苏跨年肯定是因为和两个台协商之下，哪边的曝光酬劳待遇更合适就去哪边，不会是因为wy去他就屁颠屁颠跟着去。\n\n但是他就是去了。\n\n他和他的团队肯定知道他这么去，i3就是来不及应援的，但他也不是很在乎的样子，他也肯定知道22也在（废话不可能不知道。。。但他不想避嫌。。。或者说他是觉得他和22的关系不需要特意避嫌。。。我们就是关系不错，怎么了？有什么问题？\n\ni3也别骗自己。。。wjk就是不觉得和wy同台是禁忌。。。他就是不觉得他要和wy老死不相往来。。。他们就是很好。。。不能确定是给子的话（毕竟我不能爬他们床底确认。。。他们也就是很好。。。真的很好。。。唯饭再怎么辩驳也骗不了自己。。。你哥哥就是和wy关系不差。。。\n\ni3视角完结",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "三字对二字的情感转变是什么样呢。。。他太难捉摸了。。。经常看到大家分析22的心里转变。。。几乎每个阶段不是i2也能看出来。。。。但是33只能通过实际行动看出来他的态度。。。。至于他的想法谜一样。。。（以前还行，没有组合活动以后更难看出。。。。。）最外露的表达就是词不达意了吧。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "139",
  },
  {
    id: 761,
    user_face: "761-user-face.png",
    user_id: "唯爱ESG♻️",
    is_op: false,
    create_at: "2022-12-30 02:56:31 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚💙💚💙💚💙💚💙💚💙💚💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "21",
  },
  {
    id: 762,
    user_face: "762-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 07:47:42 山东",
    quote: {
      quote_status: true,
      quote_content:
        "三字对二字的情感转变是什么样呢。。。他太难捉摸了。。。经常看到大家分析22的心里转变。。。几乎每个阶段不是i2也能看出来。。。。但是33只能通过实际行动看出来他的态度。。。。至于他的想法谜一样。。。（以前还行，没有组合活动以后更难看出。。。。。）最外露的表达就是词不达意了吧。。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "是的！词不达意真的很好磕😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "42",
  },
  {
    id: 763,
    user_face: "763-user-face.png",
    user_id: "Rr.",
    is_op: false,
    create_at: "2022-12-30 08:04:55 河北",
    quote: {
      quote_status: true,
      quote_content: "是视频，2字还对婆婆说了句“拍什么拍”，也是勇…",
      quote_user_id: "一棵仙人掌",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥哪里能看到这个视频。。。求求指路",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 764,
    user_face: "764-user-face.png",
    user_id: "最迷人班长",
    is_op: false,
    create_at: "2022-12-30 08:19:41 上海",
    quote: {
      quote_status: true,
      quote_content:
        "是这样的。。上面说的澳门这次是2因为一些原因没有贴身助理。。他来回都和队友一起才有人照看。。去的时候是24一起休息室吃饭。。回来是3给衣服穿。。也不是不能嗑一嘴3觉得只有自己照顾得好。。提前上飞机什么的。。3怕不是把自己当2助理呢。。",
      quote_user_id: "聚光灯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "你吗磕死我了。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 765,
    user_face: "765-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 08:25:19 山东",
    quote: {
      quote_status: true,
      quote_content:
        "💙💚比较戳中我的还是一些小细节，比如团一起去🇰🇷拍摄mv那阵，空闲时间四字单独行动跑去追星，他们两个就一起去逛商场给💚妈妈买生日礼物了。同一天还在微博晒了互拍的商场🐧玩偶合影，购物回酒店后两人对着镜头试穿新鞋时💚的毛线帽戴在了💙头上，比拼谁的新鞋更好看(同品牌同色看不出啥差别……)但这种很日常的相处能感觉到关系不一般。\n还有某年fc年刊里面一人晒一张手机照片，💙晒的是💚在餐桌前和椅子一起摔倒的瞬间，配文好像是“某人吃饭不小心抓拍的”暗戳戳秀恩爱的feel……",
      quote_user_id: "☃️",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 766,
    user_face: "766-user-face.png",
    user_id: "☃️",
    is_op: false,
    create_at: "2022-12-30 08:25:59 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "说到控制欲，这个视频里三正在帮二整理一个耳返，另一个耳返四想伸手去弄时被三匆忙打断了…… https://b23.tv/5Ipoyb2",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "124",
  },
  {
    id: 767,
    user_face: "767-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 08:29:00 北京",
    quote: {
      quote_status: true,
      quote_content:
        "说到控制欲，这个视频里三正在帮二整理一个耳返，另一个耳返四想伸手去弄时被三匆忙打断了…… https://b23.tv/5Ipoyb2",
      quote_user_id: "☃️",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "磕昏了。。。。。。啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 768,
    user_face: "768-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 09:09:01 福建",
    quote: {
      quote_status: true,
      quote_content:
        "他俩从W&amp;W到TFB再到各自工作。。。时间流逝。。。多少人说走散。。。也不怪别人说。。。因为我们大多数人有多少要好朋友随着时间变得陌生。。。多少情侣随着分离变得陌生。。。时间与空间会使人们距离拉开。。。更何况纸醉金迷的ylq。。。\n哥哥最后说的他俩感情就是好。。。让我感慨。。。人生路上很难有真挚的感情。。。亲情友情爱情我们不可缺少。。。但当得到后同样很难自己意识到珍惜以至于失去后才发出感慨说着“当时只道是寻常”。。。\n他俩意识到了珍惜了。。。对他俩而言就足够了。。。\n人生路漫漫幼时玩伴还在身边。。。很可贵。。。也很让人羡慕。。。\n最后感谢哥哥、哥哥朋友以及i2哥哥的陈述啦。。。让我开心地重温了他俩的许多糖点。。。",
      quote_user_id: "MBWS*",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是这样的。。。我重庆的朋友(非道济)是真的见过三字去接二字放学。。。那时候重庆的人都说出了明星所以特别好奇 但朋友看完只觉得就是最普通的小孩儿放学 打打闹闹很开心。。。。没有摄像机没有剧本还是小土豆的他们依旧是那样相处的 凯源让我动容是世界乱七八糟帝国丝都进化出108种属性 而他俩好像还是那年放学的两个小土豆 14年他们第一次上台领奖 三字说唱撇了我陪你 后来走红了上过很多舞台 19年再上台 三字依旧问二字 开心吗。。。每次想到这 做了社畜久了心都硬了的我还是哈特软软 感慨这样的感情不论爱情友情 都很难得。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "341",
  },
  {
    id: 769,
    user_face: "769-user-face.png",
    user_id: "邢鹿男",
    is_op: false,
    create_at: "2022-12-30 09:11:05 北京",
    quote: {
      quote_status: true,
      quote_content:
        "是这样的。。。我重庆的朋友(非道济)是真的见过三字去接二字放学。。。那时候重庆的人都说出了明星所以特别好奇 但朋友看完只觉得就是最普通的小孩儿放学 打打闹闹很开心。。。。没有摄像机没有剧本还是小土豆的他们依旧是那样相处的 凯源让我动容是世界乱七八糟帝国丝都进化出108种属性 而他俩好像还是那年放学的两个小土豆 14年他们第一次上台领奖 三字说唱撇了我陪你 后来走红了上过很多舞台 19年再上台 三字依旧问二字 开心吗。。。每次想到这 做了社畜久了心都硬了的我还是哈特软软 感慨这样的感情不论爱情友情 都很难得。。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "上放学图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "180",
  },
  {
    id: 770,
    user_face: "770-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 09:11:10 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "三字小时候真的端不好水直球很搞笑。。。别人说你人真好英文名这么简单都接受的了。。。。三字扭头就巴拉巴拉二字的英文名是怎么起的还记得一清二楚。。。。。前面不忘提一嘴的洗涤都不知道是不是后期为了团魂加上的哈哈哈哈哈哈哈哈哈哈 他以前真的不管什么话题都能七扭八扭扯到二字身上 然后巴拉巴拉说一堆",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "240",
  },
  {
    id: 771,
    user_face: "771-user-face.png",
    user_id: "xttc（潜水版）",
    is_op: false,
    create_at: "2022-12-30 09:25:27 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 772,
    user_face: "772-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 09:31:11 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl。。。💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 773,
    user_face: "773-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 09:33:38 山东",
    quote: {
      quote_status: true,
      quote_content: "上放学图",
      quote_user_id: "邢鹿男",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "773-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "带这么多东西仿佛是去提亲的。。。可惜提亲的袋子上全都是路飞。。。可能丈母娘没同意就是因为这些袋子。。。🥲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "219",
  },
  {
    id: 774,
    user_face: "774-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-30 09:41:47 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥复制不了吗。。。https://www.douban.com/group/topic/279199969/?_i=723321451261723",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "啊啊啊看完全部真的哈特软软",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 775,
    user_face: "775-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-30 09:41:48 陕西",
    quote: {
      quote_status: true,
      quote_content:
        "说到控制欲，这个视频里三正在帮二整理一个耳返，另一个耳返四想伸手去弄时被三匆忙打断了…… https://b23.tv/5Ipoyb2",
      quote_user_id: "☃️",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "3真的是一些老妈子行为。。。2也是乖乖配合他。。。很难不磕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "94",
  },
  {
    id: 776,
    user_face: "776-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 09:46:20 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "带这么多东西仿佛是去提亲的。。。可惜提亲的袋子上全都是路飞。。。可能丈母娘没同意就是因为这些袋子。。。🥲",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "啊啊啊啊啊。。笑。得。。想鼠。。哥哥好幽默。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "47",
  },
  {
    id: 777,
    user_face: "777-user-face.png",
    user_id: "момо",
    is_op: false,
    create_at: "2022-12-30 09:56:17 天津",
    quote: {
      quote_status: true,
      quote_content:
        "三字小时候真的端不好水直球很搞笑。。。别人说你人真好英文名这么简单都接受的了。。。。三字扭头就巴拉巴拉二字的英文名是怎么起的还记得一清二楚。。。。。前面不忘提一嘴的洗涤都不知道是不是后期为了团魂加上的哈哈哈哈哈哈哈哈哈哈 他以前真的不管什么话题都能七扭八扭扯到二字身上 然后巴拉巴拉说一堆",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "777-quote.png",
      },
    },
    cmt: {
      cmt_content: "。。。又被我磕到了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "29",
  },
  {
    id: 778,
    user_face: "778-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 09:58:50 河南",
    quote: {
      quote_status: true,
      quote_content: "。。。又被我磕到了",
      quote_user_id: "момо",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "他说的这些真的和黄锐写的y白里凯源的相处模式一模一样😭黄锐这辈子做过为数不多的好事就是写了y白",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "242",
  },
  {
    id: 779,
    user_face: "779-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 10:07:25 四川",
    quote: {
      quote_status: true,
      quote_content:
        "。。。。。说的是拜拜。。。。不是拍什么拍。。。。。。。。我记忆里这个视频是二字的生日会三字陪二字彩排，可是楼里都说是三字生日会，我现在也疑惑了。。。。但是视频确实说的是拜拜",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是的。。没有说拍什么拍。。就是说的拜拜。。不过这应该就是3生日会。。3陪2彩排是另一次。。狗仔不是拍到3插个兜站在外面等2。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "122",
  },
  {
    id: 780,
    user_face: "780-user-face.png",
    user_id: "妖怪退散",
    is_op: false,
    create_at: "2022-12-30 10:08:27 辽宁",
    quote: {
      quote_status: true,
      quote_content:
        "那天不管i2还是i3看到wjk带着22已经在头等舱坐好的时候。。。真的气si又狼狈。。。\n\n说起来。。。之前看组里有哥哥说。。。wjk跨年去🇲🇴这操作是单刀赴会丈母娘很勇。。。当时就心想。。。这算啥呀（没有说那个哥哥说不好的意思。。。\n\n更疯的他又不是没干过。。。正好也在🇲🇴呢呵呵。。。当时我真怕i2在机舱里同亖他。。。带着人家生病的女儿提前上飞机不给看。。。😅",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "笑死，想必这就是i2天天骂三字控制狂的原因吧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "112",
  },
  {
    id: 781,
    user_face: "781-user-face.png",
    user_id: "冷冰凝爱语梦霜",
    is_op: false,
    create_at: "2022-12-30 10:27:01 天津",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl kswl  等一个i2哥哥的回应",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 782,
    user_face: "782-user-face.png",
    user_id: "樱桃肉丸丸-",
    is_op: false,
    create_at: "2022-12-30 10:28:05 北京",
    quote: {
      quote_status: true,
      quote_content:
        "非常赞同楼主朋友的大框架，但是17年18年真的发生了太多事情，我总感觉💙高考、成立个人工作室和成年都是非常重要的阶段，这三个阶段过后，例如💚17岁生日，准备生日会场、发微博有🤟🏻这个手势、卡点两个人生日、黑天鹅挚爱蛋糕……都太不对劲了……可能还在纠结阶段，但是一定和恋爱时代的时候不一样了。也是17年底拍天坑的时候，北京大连往返总是改签。例如冬至那天22会考完突然买票回北京，33突然就改签这样的情况经常发生。然后18年开年33一直在拍戏嘛，每一次回北京都特地打扮，也不是说平时不打扮，但是33身上很少会出现配饰，放肆一下那次他戴了金丝眼镜还戴了毛线帽（Jesus我再感叹一下），接着就出现了卡地亚。时间线拉后一点，7月33在机场故意撸袖子露出来一块表（22是品牌大使33有其他表的代言），接着有了为爱改签的八月，然后再往后33进了新的组，有假就回北京，发生了很多次换口罩，也包括拎过22给粉丝送蛋糕的那家品牌的包装袋……包括22生日当天33没能回去，但是剧组有假之后马上就回北京了，就待了一天又回去拍戏。然后基本上没有穿过supreme的33在回北京那天穿了（早上发生的事情就不带第三人出场了），然后很少发生活视频的33自己在微博发了乐高的一地狼藉，同时22在柏林电影节接受采访的时候说对乐高感兴趣。那段时间真的很微妙啊啊啊啊啊！就是很浓的情侣感有没有人懂我！紧接着就到了最精彩的19年……所以我的总结是17年是非常拉扯戳窗户纸的一年，18年可以说是很热恋疯狂开屏的一年，也正是这两年的积累才会有决定出国之后的拉扯。19年不用说了大家都知道很痛，但是18年的精彩比较少有人讲啊啊啊啊有没有人写写18年",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "没想到每年还能磕到新的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 783,
    user_face: "783-user-face.png",
    user_id: "李莓铃天下第一",
    is_op: false,
    create_at: "2022-12-30 10:45:10 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕死我了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 784,
    user_face: "784-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:52:15 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "第二位i2哥哥的投稿\n\n（非常戳她的一些🍬点汇总\n\n1⃣️关于22 smoking\n\n“楼主我要给你激情投稿！！！我从前，19年22抽烟的那个事我还是个吃瓜路人，我亲眼见证了33秒撤了“wjk举报老师抽烟”的rs，一刷新词条就掉下去了……当初给本路人的观感就是23感情是真的好，这个时候竟然没有“趁你病要你命”，对比一下44的“禁烟大使”rs，真的不要太鲜明了。而且我也比较奇葩，因为这个事我竟然成了2的路好，理由是觉得抽个烟怎么被黑成这样，那是真的没啥可黑了。。。再后来成了i2，然后开始疯狂扒塌房对象。。。扒出来的人居然是3。。。我整个人都恍惚了。。。后来再回忆起撤热搜那个事。。。我更恍惚了。。。谁知道这背后是一段情呢🚬”\n\n\n\n。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "367",
  },
  {
    id: 785,
    user_face: "785-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:52:46 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "并且他5.25的活动脸色很差",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "196",
  },
  {
    id: 786,
    user_face: "786-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:53:52 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "19年520💚被爆🚬当天💙某场戏ng了6次",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "186",
  },
  {
    id: 787,
    user_face: "787-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:54:29 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "以及5.25～5.26两天三地极限压缩行程",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "211",
  },
  {
    id: 788,
    user_face: "788-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:57:24 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "2⃣️连名带姓+跨年夜\n\n这是💚19年初wb放出来的歌单，全是分手情歌 而且我之前也是唯粉 就是因为这个歌单让我觉得太咯噔了，隐隐发现自己房子塌了。。。都不是隐隐了。。就是tm塌得妈都不认识。。。然后开始疯狂扒塌房对pin象。。。扒出来的人是wjk。。。看他的编辑记录，还非要强调是“最近”听的歌，题眼《连名带姓》然后我就开始一首歌一首歌地扒\n\n\n图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "130",
  },
  {
    id: 789,
    user_face: "789-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:57:35 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "《连名带姓》里有一句歌词：“算不清多少个跨年夜”。。。他每一个跨年夜都是跟队友一起过的，我看到歌词就开始怀疑，他不会是在跟队友谈吧？？？\n\n\n图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "160",
  },
  {
    id: 790,
    user_face: "790-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:58:10 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "这是张动图。。。何炅在零点说“拥抱身边最爱的人”，然后3悄悄用膝盖顶了我儿大腿一下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "280",
  },
  {
    id: 791,
    user_face: "791-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 10:58:30 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "然后我看到那个歌单里有戳爷的《youth》“my  youth is yours”是队友没跑了。。。。他还戴过那个帽子\n\n\n\n图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "176",
  },
  {
    id: 792,
    user_face: "792-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:05:09 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "3⃣️ 唱作人\n\n“哥哥。。。我继续给你投稿。。我想说说💚在19年四月的唱作人上唱哭的事，时间线麻烦你按顺序整理了，我也有强迫症。。。这样看起来故事更连贯。。。大概是19年2月💚wb放出分手情歌歌单→4月唱作人台上唱哭→5月💚抽烟被爆，同时期💙撤热搜，直播上脸色很差以及两天三地极限压缩行程→8月💚唱哭我怀念的→11月💙唱词不达意”\n\n他19年真的状态肉眼可见地非常非常不好，唱《世界上没有真正的感同身受》没忍住唱哭了，在唱之前还说“大家看舞台上亮吗” “亮” “但我看你们其实很黑”，说实话我看到他那么说的时候真的蛮心疼的。。。\n\n图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "192",
  },
  {
    id: 793,
    user_face: "793-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:05:32 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "“给哥哥们放一张快唱哭的时候的图吧，哭我就不放了，截不出来，我本人也很心梗，感兴趣的哥哥们可以自己去看看。。。”\n\n图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "122",
  },
  {
    id: 794,
    user_face: "794-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:05:51 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "然后我不是怀疑他和队友嘛，我就开始看被奉为岛经的《y白》，本来就是当编料看着玩。。。结果没想着越看越真。。。很锤我的一个点是这段话，这里小白是💚，可能是取自于他名字里的“源”，y是💙，应该是取自于英文名karry\n\n16年的y白原贴在19年的唱作人里得到印证，“小白就讲，很不喜欢散场的感觉，但有时候灯照的太亮也容易没什么安全感”他三年后在台上说“但我看你们其实很黑”。。。这也是y白让我觉得很锤的点之一，好多细节都是在之后的好几年里陆续得到印证，而且16年同年黄锐（疑似y白作者）从sdfj离职，就显得这个东西更真了🚬有没有人能告诉我为什么这么真啊。。。我现在打下这段文字的时候。。。都还有点恍惚。。只是一点点。。。毕竟我最开始扒的时候。。恍惚了好几个月。。那种心理大概是，虽然我现在确信💙💚是真的。。。但我每每想到ky竟然szd。。都会感叹。。。这世上还有什么是不可能的🚬\n\n\n图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "203",
  },
  {
    id: 795,
    user_face: "795-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:07:06 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "232",
  },
  {
    id: 796,
    user_face: "796-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-30 11:16:36 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "点开看了。。痛死我了。。。。痛死我。。。好磕。。虽然很多说17 18be得彻底。。。但是那个时候他俩也不过十八九岁。。是最复杂变化最多最纠结的年纪。。。感觉两个人就像很想挣扎脱离身份上的束缚。。但是又没有正确的方法。。。只能互相伤害。。。用不成熟的方式表达自己。。。然后经历风风雨雨沉淀到二十出头。。。开始和解。。。用更温柔同时也更坚定的方法做自己了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "177",
  },
  {
    id: 797,
    user_face: "797-user-face.png",
    user_id: "早日退休",
    is_op: false,
    create_at: "2022-12-30 11:18:42 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我又住下了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 798,
    user_face: "798-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:23:20 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "💙个人演唱会\n“然后我又去8了一下3的无边界个人演唱会了。。。唱了一首《词不达意》🚬   间奏全场绿光。。。不仅绿了i3一脸也绿了i2一脸吧。。。为你们的爱情鼓鼓掌好吧。。。说实话。。。大家结构33都知道他在镜头前很少表达浓烈的情绪（和22相比。。。所以很多i2觉得💙对💚不如2对3深情。。。但词不达意这首歌。。。我第一次体会到💙确实很爱💚的，噢噢对他唱这首歌之前还说：“这首歌呢，在我身上会形容得比较准确。”说完还蛮不好意思地笑了一下。。。唱得。。很苦情的亚子。。。\n\n最好笑的是，我去b站看《词不达意》剪辑，蟹姐们7个机位愣是把绿光一点都没透出来全给剪没了，而且最前面说的那句“这首歌呢 可能在我身上形容的比较准确”也剪掉了了。。。\n\n这个绿光。。。不说蟹姐。。。我都被绿傻了”\n\n\n（我的i3朋友看到这一条被亖去的记忆攻击。。。没错。。。词不达意就是绿色的灯光和舞美。。。这个绿光和17岁那年的绿光好k程度可真是不相上下。。。\n\n\n图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "295",
  },
  {
    id: 799,
    user_face: "799-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:24:31 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "这位哥哥的理解。。。（分析向\n\n我自己的i3朋友觉得💙某种意义上是特别双标的人，他对于不需要分配感情的人和群体表现得非常淡漠甚至抗拒，💙这个人是对不起全世界都不会对不起💚的人。但其实我并不觉得他真的不在乎粉丝，我解构了一下💙这个人，其实他非常不擅长表达自己的情感，有十分爱大概就流露出五分，还是在这两口子的分手期被逼得没办法了才表现出来让我们看到。但💚就不是，💚是那种有十分爱就表露出十分的性格，我觉得这和原生家庭的关系也很大。i3之所以对真嫂子那么破防，无非是因为女友粉比例高而💙又不做男友向营业，其实蛮死心眼的。💙今年整整一个月没有营业，把💚的生日博相当于置顶了一个月，当初搜他工作室的实时广场都可以看到好多蟹姐在激情开麦，怎么说呢，我作为一个前i2，看着还是蛮触动的。💙这个人确实就蛮搭《词不达意》这首歌的，我有时候也会觉得💙这种不善于表达只会闷声做事的性格，其实是有点吃亏的。不管怎么说，希望💚可以多多治愈他吧。这两口子就好好过吧。献上我最诚挚的祝福～\n\n而且我甚至觉得💙不做男友向营业这个行为，怎么说呢，有点傻气又很真诚。他不知道自己该怎样对待粉丝的那份爱，因为他给不出对等的爱来，而且因为有了💚，他可能会觉得，如果媚粉的话，显得很不真诚，他没有办法去违心地做出媚粉的举动，当然这些只是我个人的想法。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "328",
  },
  {
    id: 800,
    user_face: "800-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-30 11:26:12 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这是张动图。。。何炅在零点说“拥抱身边最爱的人”，然后3悄悄用膝盖顶了我儿大腿一下。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "800-quote.png",
      },
    },
    cmt: {
      cmt_content: "我去。。渴死",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "37",
  },
  {
    id: 801,
    user_face: "801-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-30 11:26:31 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "楼主保重。。。我看到。。。i3号召要聚宝了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "135",
  },
  {
    id: 802,
    user_face: "802-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:26:50 广东",
    quote: {
      quote_status: true,
      quote_content:
        "这位哥哥的理解。。。（分析向\n\n我自己的i3朋友觉得💙某种意义上是特别双标的人，他对于不需要分配感情的人和群体表现得非常淡漠甚至抗拒，💙这个人是对不起全世界都不会对不起💚的人。但其实我并不觉得他真的不在乎粉丝，我解构了一下💙这个人，其实他非常不擅长表达自己的情感，有十分爱大概就流露出五分，还是在这两口子的分手期被逼得没办法了才表现出来让我们看到。但💚就不是，💚是那种有十分爱就表露出十分的性格，我觉得这和原生家庭的关系也很大。i3之所以对真嫂子那么破防，无非是因为女友粉比例高而💙又不做男友向营业，其实蛮死心眼的。💙今年整整一个月没有营业，把💚的生日博相当于置顶了一个月，当初搜他工作室的实时广场都可以看到好多蟹姐在激情开麦，怎么说呢，我作为一个前i2，看着还是蛮触动的。💙这个人确实就蛮搭《词不达意》这首歌的，我有时候也会觉得💙这种不善于表达只会闷声做事的性格，其实是有点吃亏的。不管怎么说，希望💚可以多多治愈他吧。这两口子就好好过吧。献上我最诚挚的祝福～\n\n而且我甚至觉得💙不做男友向营业这个行为，怎么说呢，有点傻气又很真诚。他不知道自己该怎样对待粉丝的那份爱，因为他给不出对等的爱来，而且因为有了💚，他可能会觉得，如果媚粉的话，显得很不真诚，他没有办法去违心地做出媚粉的举动，当然这些只是我个人的想法。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我朋友这位i3非常肯定这位i2哥哥说的。。。33确实不是不在乎粉丝。。。他也知道他女友粉的比例多。。。但他就是不做男友向的营业。。。很神奇。。。这种感觉被这位哥哥描述的很好。。。所以他对22的感情是非常特别的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "280",
  },
  {
    id: 803,
    user_face: "803-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-30 11:29:25 北京",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "他好爱他。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "33",
  },
  {
    id: 804,
    user_face: "804-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 11:32:56 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "顺风车大姐。。。我可没造谣。。。干嘛挂我呀😢😢😢。。。我朋友每一件事情。。。可都有照片。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "347",
  },
  {
    id: 805,
    user_face: "805-user-face.png",
    user_id: "陈玘（已退役）",
    is_op: false,
    create_at: "2022-12-30 11:36:49 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "唯粉姐你们真的好狠的心。。。。。这么好嗑的帖子也要聚啊😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "205",
  },
  {
    id: 806,
    user_face: "806-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 11:38:02 山东",
    quote: {
      quote_status: true,
      quote_content:
        "顺风车大姐。。。我可没造谣。。。干嘛挂我呀😢😢😢。。。我朋友每一件事情。。。可都有照片。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。。记得存档。。。。再发。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "93",
  },
  {
    id: 807,
    user_face: "807-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 11:43:10 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "唯粉大姐。。请放过kyj。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "78",
  },
  {
    id: 808,
    user_face: "808-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 11:45:47 福建",
    quote: {
      quote_status: true,
      quote_content:
        "2⃣️连名带姓+跨年夜\n\n这是💚19年初wb放出来的歌单，全是分手情歌 而且我之前也是唯粉 就是因为这个歌单让我觉得太咯噔了，隐隐发现自己房子塌了。。。都不是隐隐了。。就是tm塌得妈都不认识。。。然后开始疯狂扒塌房对pin象。。。扒出来的人是wjk。。。看他的编辑记录，还非要强调是“最近”听的歌，题眼《连名带姓》然后我就开始一首歌一首歌地扒\n\n\n图",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "808-quote.png",
      },
    },
    cmt: {
      cmt_content: "我才嗑到这个编辑记录。。。还得强调是最近。。。嗑亖。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "64",
  },
  {
    id: 809,
    user_face: "809-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 11:46:19 福建",
    quote: {
      quote_status: true,
      quote_content:
        "2⃣️连名带姓+跨年夜\n\n这是💚19年初wb放出来的歌单，全是分手情歌 而且我之前也是唯粉 就是因为这个歌单让我觉得太咯噔了，隐隐发现自己房子塌了。。。都不是隐隐了。。就是tm塌得妈都不认识。。。然后开始疯狂扒塌房对pin象。。。扒出来的人是wjk。。。看他的编辑记录，还非要强调是“最近”听的歌，题眼《连名带姓》然后我就开始一首歌一首歌地扒\n\n\n图",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "809-quote.png",
      },
    },
    cmt: {
      cmt_content: "而且连名带姓代进凯源真的严丝合缝。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "64",
  },
  {
    id: 810,
    user_face: "810-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 11:48:31 福建",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "这段我还看了。。。他跑回去说再唱一首 希望大家记得今晚 我以为唱什么欢乐的歌 结果是我怀念的。。。大哥 难忘今宵都比这合适吧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "165",
  },
  {
    id: 811,
    user_face: "811-user-face.png",
    user_id: "陈浩南（已坐牢",
    is_op: false,
    create_at: "2022-12-30 11:48:35 四川",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "说到这个我私心想说一个。。。👉🏻👈🏻也可能是窝cp脑不过看提的哥哥不是很多，纯属个人感觉啦。除了大家经常提到的💙唱词不达意和lucky，其实我觉得19年拉扯期他在个人演唱会唱《玫瑰少年》也很好品。主演是那会儿这首歌还没被用烂🚬他应该是内底艺人最早那波翻唱的吧？歌词更不用多说大家都懂，主要是💙唱的时候那种状态怎么说呢，真的能感觉到很认真在唱，在反抗这样，算是少见地感觉到了攻击性？我不知道怎么表达，总之就和他平时唱歌不太一样，很像感同身受地表达这样。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "158",
  },
  {
    id: 812,
    user_face: "812-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 11:50:21 福建",
    quote: {
      quote_status: true,
      quote_content:
        "顺风车大姐。。。我可没造谣。。。干嘛挂我呀😢😢😢。。。我朋友每一件事情。。。可都有照片。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "熟悉的id。。。危险危险危险。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "98",
  },
  {
    id: 813,
    user_face: "813-user-face.png",
    user_id: "韩素希",
    is_op: false,
    create_at: "2022-12-30 11:51:05 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 814,
    user_face: "814-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 11:53:50 上海",
    quote: {
      quote_status: true,
      quote_content:
        "顺风车大姐。。。我可没造谣。。。干嘛挂我呀😢😢😢。。。我朋友每一件事情。。。可都有照片。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "保护。。哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 815,
    user_face: "815-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 11:56:52 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "但是老实说 三字触动我的是知足 他和五月天合作那天 是二字去办签证那天 他们周年请五月天做嘉宾的时候 三字兴冲冲说二字是五月天粉丝 二字还说有机会要去演唱会 结果真的去给人家做嘉宾 却只有三字 三字和阿信合唱洋葱 这是当年他和二字街头唱歌最初红的几首 很有纪念意义对吧 但是他和阿信合唱却是唱的当年二字唱的部分 后来唱知足 他的表情真的 我不能说一定哭了 但是真的很难过 频繁望天不直视镜头 他唱洋葱的时候没这样的 “午夜徘徊时就会听知足” 这也是他自己说过的……那时候我嗑凯源还是随便蹭两口 看完知足觉得 哇不会真的是真的吧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "260",
  },
  {
    id: 816,
    user_face: "816-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 11:57:30 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "建议危机搜索吴京国ji调理一下👎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 817,
    user_face: "817-user-face.png",
    user_id: "午夜高速没有车",
    is_op: false,
    create_at: "2022-12-30 11:58:40 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "我有听说i3站姐知道很多。。。而且当时那个脱粉组没炸的时候 一个i2还是i3脱粉帖被狙 楼主气亖 说不如问问站姐手里都有什么图藏着 然后甩出一个三字看微信的图 三字微信背景是他和二字一个背影图。。。但是开岛站是真的震撼我妈。。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "我去。。站姐东西真多。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "37",
  },
  {
    id: 818,
    user_face: "818-user-face.png",
    user_id: "啦啦卡啦卡",
    is_op: false,
    create_at: "2022-12-30 12:01:38 陕西",
    quote: {
      quote_status: true,
      quote_content:
        "然后我看到那个歌单里有戳爷的《youth》“my  youth is yours”是队友没跑了。。。。他还戴过那个帽子\n\n\n\n图",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "818-quote.png",
      },
    },
    cmt: {
      cmt_content: "这个好像给cp站子给过to签",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "70",
  },
  {
    id: 819,
    user_face: "819-user-face.png",
    user_id: "ssssalty",
    is_op: false,
    create_at: "2022-12-30 12:02:08 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "蹲蹲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 820,
    user_face: "820-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-30 12:05:44 湖北",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "窝趣。。。第一次听。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 821,
    user_face: "821-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 12:08:37 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "三字对二字的情感转变是什么样呢。。。他太难捉摸了。。。经常看到大家分析22的心里转变。。。几乎每个阶段不是i2也能看出来。。。。但是33只能通过实际行动看出来他的态度。。。。至于他的想法谜一样。。。（以前还行，没有组合活动以后更难看出。。。。。）最外露的表达就是词不达意了吧。。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "三字给人的感觉就是明晃晃告诉你：我们怎么样关你屁事。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "154",
  },
  {
    id: 822,
    user_face: "822-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-30 12:11:38 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哥哥。。。还有吗。。再发点感觉可以凑个复活卡了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "19",
  },
  {
    id: 823,
    user_face: "823-user-face.png",
    user_id: "小乖乖",
    is_op: false,
    create_at: "2022-12-30 12:11:59 四川",
    quote: {
      quote_status: true,
      quote_content:
        "后面就是因为口罩wy回国，22回国之后很长一段时间住wjk家养猫这些细节就不用我给各位哥哥复习了。。。\n\n他们在这个阶段一定是有一个质变的，wy回国后和出国前的状态更是大相径庭，等一个i2哥哥补补吧我对22的感情视角没那么清晰。。。\n\n在这个阶段，我更偏向于他们愿意放过自己也放过彼此（放过不是放弃。。。他们会去学着接受他们这种特殊的关系。\n\n去珍惜他们关系中的独一无二和特性，毕竟从一开始他们只有彼此，真的是没繁华红毯的少年时代里，陪彼此走过籍籍无名啊，是回头看，不管是因为什么缘故你没有走，但原来只有你是没有和我走散的，你也不愿意和我走散，那我要好好珍惜。\n\n去忘记曾经别扭时的互相伤害，曾经他们就是太在意“缘故”，是外界的声音吗？是为了埋腐吗？你拿我当成什么？我不想被定义为你的睡，我是我自己，尤其是wy，他应该是有一段时间非常介意被粉丝称作wjk女朋友的。。。wjk也看不懂wy曾经很多的心事，各种别扭闹个不停，彼此伤害，应该也有很多彼此刺痛，但是这个时间段他们都选择忘记和接受这些过往，而不是纠缠不放。\n\n所以这两年他们的关系一直是在正向循环的。。。\n\n其实跨年是很甜，我真的对踩组的嗑法没有任何意见，只是我是唯饭的思维吧（也可能是我自己的原因。。。缺德归缺德，乐子归乐子，说归说。。。真的要说wjk去江苏跨年肯定是因为和两个台协商之下，哪边的曝光酬劳待遇更合适就去哪边，不会是因为wy去他就屁颠屁颠跟着去。\n\n但是他就是去了。\n\n他和他的团队肯定知道他这么去，i3就是来不及应援的，但他也不是很在乎的样子，他也肯定知道22也在（废话不可能不知道。。。但他不想避嫌。。。或者说他是觉得他和22的关系不需要特意避嫌。。。我们就是关系不错，怎么了？有什么问题？\n\ni3也别骗自己。。。wjk就是不觉得和wy同台是禁忌。。。他就是不觉得他要和wy老死不相往来。。。他们就是很好。。。不能确定是给子的话（毕竟我不能爬他们床底确认。。。他们也就是很好。。。真的很好。。。唯饭再怎么辩驳也骗不了自己。。。你哥哥就是和wy关系不差。。。\n\ni3视角完结",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "感觉是给自己真情实感磕了几年的一个感情交代了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "32",
  },
  {
    id: 824,
    user_face: "824-user-face.png",
    user_id: "花生米",
    is_op: false,
    create_at: "2022-12-30 12:14:41 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "差点找不到这个帖子了吓死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 825,
    user_face: "825-user-face.png",
    user_id: "Joyder",
    is_op: false,
    create_at: "2022-12-30 12:15:17 上海",
    quote: {
      quote_status: true,
      quote_content:
        "💙个人演唱会\n“然后我又去8了一下3的无边界个人演唱会了。。。唱了一首《词不达意》🚬   间奏全场绿光。。。不仅绿了i3一脸也绿了i2一脸吧。。。为你们的爱情鼓鼓掌好吧。。。说实话。。。大家结构33都知道他在镜头前很少表达浓烈的情绪（和22相比。。。所以很多i2觉得💙对💚不如2对3深情。。。但词不达意这首歌。。。我第一次体会到💙确实很爱💚的，噢噢对他唱这首歌之前还说：“这首歌呢，在我身上会形容得比较准确。”说完还蛮不好意思地笑了一下。。。唱得。。很苦情的亚子。。。\n\n最好笑的是，我去b站看《词不达意》剪辑，蟹姐们7个机位愣是把绿光一点都没透出来全给剪没了，而且最前面说的那句“这首歌呢 可能在我身上形容的比较准确”也剪掉了了。。。\n\n这个绿光。。。不说蟹姐。。。我都被绿傻了”\n\n\n（我的i3朋友看到这一条被亖去的记忆攻击。。。没错。。。词不达意就是绿色的灯光和舞美。。。这个绿光和17岁那年的绿光好k程度可真是不相上下。。。\n\n\n图",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "825-quote.png",
      },
    },
    cmt: {
      cmt_content: "第一次看到词不达意原来这么绿….",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "135",
  },
  {
    id: 826,
    user_face: "826-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:20:22 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "这位哥哥说：“以上就是本前i2的上岛心路历程，哥哥可以帮我在评论区纠正一下。。我现在已经不算i2了，我是已经上了岛的前i2。。。是那种会被i2毒唯姐们人人喊打的纯血道济。。。”",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "201",
  },
  {
    id: 827,
    user_face: "827-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:25:09 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "这也是一位i2哥哥的投稿。。。一共有三位i2哥哥投稿了。。。对22的情绪有不一样的见解。。。我的i3朋友对22的视角也是缺失的。。。所以也放上来哥哥们。。。自行理解品味。。。说得也非常好。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "236",
  },
  {
    id: 828,
    user_face: "828-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 12:25:27 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "但是老实说 三字触动我的是知足 他和五月天合作那天 是二字去办签证那天 他们周年请五月天做嘉宾的时候 三字兴冲冲说二字是五月天粉丝 二字还说有机会要去演唱会 结果真的去给人家做嘉宾 却只有三字 三字和阿信合唱洋葱 这是当年他和二字街头唱歌最初红的几首 很有纪念意义对吧 但是他和阿信合唱却是唱的当年二字唱的部分 后来唱知足 他的表情真的 我不能说一定哭了 但是真的很难过 频繁望天不直视镜头 他唱洋葱的时候没这样的 “午夜徘徊时就会听知足” 这也是他自己说过的……那时候我嗑凯源还是随便蹭两口 看完知足觉得 哇不会真的是真的吧",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "啊，这个戳到我了，知足的歌词就是自己劝自己曾经拥有就该满足了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "97",
  },
  {
    id: 829,
    user_face: "829-user-face.png",
    user_id: "Sherry",
    is_op: false,
    create_at: "2022-12-30 12:27:50 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "天啊这个心路历程简直是死去的记忆在攻击我 我是看的y白 直接一个垂直入坑 现在想来磕ky那段时间 真的是三观重塑的一段时间 真实又不真实 主要是剧情太drama了 年少成名一路跌跌撞撞 成长 名利 同性 爱情这些因素集合到一起 电视剧都写不出的精彩",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "175",
  },
  {
    id: 830,
    user_face: "830-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:29:17 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "一位哥哥看到我说的澳门事件。。联想到了yb小垃圾和生病相关的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "81",
  },
  {
    id: 831,
    user_face: "831-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 12:29:28 北京",
    quote: {
      quote_status: true,
      quote_content:
        "说到控制欲，这个视频里三正在帮二整理一个耳返，另一个耳返四想伸手去弄时被三匆忙打断了…… https://b23.tv/5Ipoyb2",
      quote_user_id: "☃️",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "评论里说 整理领带。。。好像没看过诶。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 832,
    user_face: "832-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:29:37 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "“我想补两个和生病有关的事儿，是当时他们身边工作人员写的y白，大约是他们2015-2016年期间。下面是原记录，y是wjk，小白是wy。\n\n有一次y身体不舒服，有点发烧，整个人都有点蔫。  然后小白挺自觉说照顾他，y挺意外地说你真要照顾我啊？小白说是啊。 结果那一天y开始变着法地喊自己身体不舒服，怎么怎么没力气。动不动就说我可是病人，你得好好对我。\n\n小白没好气的说，你别等到我生病的那一天。 然后y听了就特别严肃的跟他说 “所以你最好别给我生病。”\n\n⬇️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "300",
  },
  {
    id: 833,
    user_face: "833-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:29:52 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "“还有一个事是：之前他们上声乐课，y到的时候，小白正在练习，y问他上的怎么样，小白说老师让他练发声的位置，这个东西可以用手摸来感受，y就跟着他一起练，然后小白说你唱响一点，我摸摸看。\n\n然后小白的手刚摸上去，y的声音就停了，他几乎是很严肃地质问，什么情况，都这个天了，你手怎么还是这么冷。\n\n就是这两件小事吧，但是一是能看出来wjk一直都很在意wy身体健不健康，虽然wjk自己有时候也不太知道照顾自己。。。训练或者工作起来很拼的。。。二是wy确实从小身体偏凉，又偏瘦，wjk会盯着他好好吃饭。。。”\n\n⬇️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "245",
  },
  {
    id: 834,
    user_face: "834-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:30:25 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "“说起来，去年七一集训的时候，有料说wjk在盯着wy吃饭。。。。咱就是说去年他俩已经一个22岁一个21岁了。。。。一个男人还能这么在意另一个男人的饮食健康。。。。。这种照顾，有时候我也想不通，或者说没法解释这到底是种什么样的感情。。。。。。”\n\n。。。他俩难以解释的事情真的很多。。。。我也想知道wf姐姐是怎么看待这事儿的。。。。我真的觉得这种关系好微妙啊。。。。。\n\n\n🔚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "274",
  },
  {
    id: 835,
    user_face: "835-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 12:31:07 河南",
    quote: {
      quote_status: true,
      quote_content:
        "这也是一位i2哥哥的投稿。。。一共有三位i2哥哥投稿了。。。对22的情绪有不一样的见解。。。我的i3朋友对22的视角也是缺失的。。。所以也放上来哥哥们。。。自行理解品味。。。说得也非常好。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "835-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "错误的。。。凯源有青梅竹马的默契 同甘共苦的羁绊 恍神时刻的心动 越陷越深的推拉 还有最纯的初恋感。。。除了爱情让人发疯以外他们的感情是非常复杂的。。。。。。二字不只是在三字机会。。。。也是在给自己机会。。。。。如果三字放手二字也会发疯。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "322",
  },
  {
    id: 836,
    user_face: "836-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:31:18 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "⬆️是yb小垃圾相关的投稿。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "17",
  },
  {
    id: 837,
    user_face: "837-user-face.png",
    user_id: "蜡笔小丸子",
    is_op: false,
    create_at: "2022-12-30 12:31:45 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "把楼追平了。。。我发现嗑这对的嗑药寄的记忆力都好好。。。这对的💊都超过十年了。。。嗑药鸡对时间线脱口而出。。。还能具体到某年某月某日。。。服了。。。嗑药有真的有助于人进步吧。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "265",
  },
  {
    id: 838,
    user_face: "838-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 12:32:41 山东",
    quote: {
      quote_status: true,
      quote_content:
        "错误的。。。凯源有青梅竹马的默契 同甘共苦的羁绊 恍神时刻的心动 越陷越深的推拉 还有最纯的初恋感。。。除了爱情让人发疯以外他们的感情是非常复杂的。。。。。。二字不只是在三字机会。。。。也是在给自己机会。。。。。如果三字放手二字也会发疯。。。。",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "顶了哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "47",
  },
  {
    id: 839,
    user_face: "839-user-face.png",
    user_id: "午夜高速没有车",
    is_op: false,
    create_at: "2022-12-30 12:34:22 湖南",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "839-quote.png",
      },
    },
    cmt: {
      cmt_content: "我去。。你在，害怕，什么？。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "76",
  },
  {
    id: 840,
    user_face: "840-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 12:35:41 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 841,
    user_face: "841-user-face.png",
    user_id: "喝水都胖",
    is_op: false,
    create_at: "2022-12-30 12:35:48 山西",
    quote: {
      quote_status: true,
      quote_content:
        "这段我还看了。。。他跑回去说再唱一首 希望大家记得今晚 我以为唱什么欢乐的歌 结果是我怀念的。。。大哥 难忘今宵都比这合适吧",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "凯源 真的总有没磕过的 道济别太幸福了就是说🥲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "101",
  },
  {
    id: 842,
    user_face: "842-user-face.png",
    user_id: "午夜高速没有车",
    is_op: false,
    create_at: "2022-12-30 12:36:25 陕西",
    quote: {
      quote_status: true,
      quote_content: "我只能找到一张很糊很糊的动图。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "842-quote.png",
      },
    },
    cmt: {
      cmt_content: "卧槽。。震大惊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "54",
  },
  {
    id: 843,
    user_face: "843-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:39:26 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "说起来。。。也经常会看很多哥哥求推💙💚的同人文。。。\n\n但是他们的关系总是随着时间变化而改变，很多文虽然非常非常好，但是从他们现在来看又显得有一点片面（不是说厨子不好的意思。。。而是他们在彼此生命中的时间太长了。。。那个时间段有一些文完美的诠释了他们的关系。。。可是有些东西又在不断改变。。。\n\n很多同人文对未来有一些设定。。。但现实到这一刻时其实不太一样\n\n不过非常非常幸运的是。。。或许因为世事变迁很多东西不得不低头，不得不改变。。。但他们至少没有变成很糟糕的大人。。。而是去审视、接受、以及珍惜他们之间的独一无二的感情。\n\nfromi3朋友。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "220",
  },
  {
    id: 844,
    user_face: "844-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 12:42:47 广东",
    quote: {
      quote_status: true,
      quote_content:
        "把楼追平了。。。我发现嗑这对的嗑药寄的记忆力都好好。。。这对的💊都超过十年了。。。嗑药鸡对时间线脱口而出。。。还能具体到某年某月某日。。。服了。。。嗑药有真的有助于人进步吧。。。",
      quote_user_id: "蜡笔小丸子",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "以前帝国下半年三个生日都会打架哈哈哈。。。每一次关于生日会的地址都能打架大半天。。。比如33的17岁生日会地址和2244的16岁生日会地址不同。。。从礼堂规格打到座位席豪华与否。。。伴随而来的是彼此才是真皇族的洗脑包。。。p图辱骂队友和常规流程lifei亖了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "180",
  },
  {
    id: 845,
    user_face: "845-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 12:47:40 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "天呢，我看完了我怀念的，第一次在208身上感觉到了歌曲以外的情绪",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "183",
  },
  {
    id: 846,
    user_face: "846-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:00:54 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "“说起来，去年七一集训的时候，有料说wjk在盯着wy吃饭。。。。咱就是说去年他俩已经一个22岁一个21岁了。。。。一个男人还能这么在意另一个男人的饮食健康。。。。。这种照顾，有时候我也想不通，或者说没法解释这到底是种什么样的感情。。。。。。”\n\n。。。他俩难以解释的事情真的很多。。。。我也想知道wf姐姐是怎么看待这事儿的。。。。我真的觉得这种关系好微妙啊。。。。。\n\n\n🔚",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "其实挺好理解的 粉丝云养成都陷这么深 更何况💙某种程度上真养成（但好像这么说有点奇奇怪怪的有点bt",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "279",
  },
  {
    id: 847,
    user_face: "847-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:01:02 北京",
    quote: {
      quote_status: true,
      quote_content:
        "“说起来，去年七一集训的时候，有料说wjk在盯着wy吃饭。。。。咱就是说去年他俩已经一个22岁一个21岁了。。。。一个男人还能这么在意另一个男人的饮食健康。。。。。这种照顾，有时候我也想不通，或者说没法解释这到底是种什么样的感情。。。。。。”\n\n。。。他俩难以解释的事情真的很多。。。。我也想知道wf姐姐是怎么看待这事儿的。。。。我真的觉得这种关系好微妙啊。。。。。\n\n\n🔚",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "想起那个。。。给师弟团的建议。。。wjk：变声期保护嗓子不要过多练歌 wy：还是要练的 wjk顶腮。。。。三字一辈子都改变不了老妈子的心",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "229",
  },
  {
    id: 848,
    user_face: "848-user-face.png",
    user_id: "向日葵鲔海",
    is_op: false,
    create_at: "2022-12-30 13:01:26 山东",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "他俩关系明显不好是从17年下半年， 18年那时候，22不是还经常在综艺里提33，但是33在小黑屋等等团综，包括五周年演唱会后台他们三个把手放一起加油，三三都有意避开22。。。我感觉是22长大一点之后有点反骨不太喜欢33全方位的管他，但是他在明面上看不太出来啥。后来他俩关系有点僵硬之后，33表现的特别明显，就那种一下子就让人知道他俩之间现在特尴尬那种感觉。后来的事我就不知道了。鉴于17年18年发生的事，后面都没怎么关注他们了。15.16年的时候，我觉得他俩起码是真的暧昧，懵懂纯粹真心的暧昧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "128",
  },
  {
    id: 849,
    user_face: "849-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 13:03:38 福建",
    quote: {
      quote_status: true,
      quote_content:
        "把楼追平了。。。我发现嗑这对的嗑药寄的记忆力都好好。。。这对的💊都超过十年了。。。嗑药鸡对时间线脱口而出。。。还能具体到某年某月某日。。。服了。。。嗑药有真的有助于人进步吧。。。",
      quote_user_id: "蜡笔小丸子",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "其实是需要触发点的。。。楼里很多💊我都是嗑过。。。但是忘了。。。但你一提我又记忆浮现。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "81",
  },
  {
    id: 850,
    user_face: "850-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 13:05:16 福建",
    quote: {
      quote_status: true,
      quote_content:
        "天呢，我看完了我怀念的，第一次在208身上感觉到了歌曲以外的情绪",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是的哥哥。。。知足和我怀念的是我第一次在208w舞台真的感受到了唱歌的人的难过。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "117",
  },
  {
    id: 851,
    user_face: "851-user-face.png",
    user_id: "蒂特洛伊木马",
    is_op: false,
    create_at: "2022-12-30 13:10:07 中国香港",
    quote: {
      quote_status: true,
      quote_content:
        "说起来。。。也经常会看很多哥哥求推💙💚的同人文。。。\n\n但是他们的关系总是随着时间变化而改变，很多文虽然非常非常好，但是从他们现在来看又显得有一点片面（不是说厨子不好的意思。。。而是他们在彼此生命中的时间太长了。。。那个时间段有一些文完美的诠释了他们的关系。。。可是有些东西又在不断改变。。。\n\n很多同人文对未来有一些设定。。。但现实到这一刻时其实不太一样\n\n不过非常非常幸运的是。。。或许因为世事变迁很多东西不得不低头，不得不改变。。。但他们至少没有变成很糟糕的大人。。。而是去审视、接受、以及珍惜他们之间的独一无二的感情。\n\nfromi3朋友。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是。。虽然吧唧那段金句已被道济刻烟吸肺。。但我对长大的凯源的评价是。。。一起变成无聊的大人也没什么不好。。。。重要的是“一起”。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "210",
  },
  {
    id: 852,
    user_face: "852-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 13:10:26 山东",
    quote: {
      quote_status: true,
      quote_content:
        "天呢，我看完了我怀念的，第一次在208身上感觉到了歌曲以外的情绪",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "我怀念的，对应同年十一月份三字在演唱会上唱的词不达意。。。。彼此陷地太深了才会一直这么耿耿于怀，于是20年回来，二字给三字的歌又在破镜重圆。。。花瓣里的“我记得你不太喜欢苦涩味。。。”、“能否把我们的路再走一遍。。”，年末又有用重庆话写的一段rap。。。“你要我楞个办嘛”那种带着微微撒娇的语气。。。都在告诉我们。。。这对死给子已经在复合了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "211",
  },
  {
    id: 853,
    user_face: "853-user-face.png",
    user_id: "向日葵鲔海",
    is_op: false,
    create_at: "2022-12-30 13:10:36 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "很奇妙的关系",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "183",
  },
  {
    id: 854,
    user_face: "854-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 13:10:52 河南",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "唱到那句也记得那一首歌时。。。。二字突然跑到舞台边坐下。。。没唱两句又起来。。。。想起来他和三字第一次上快乐大本营时就是安排他们坐在舞台边背对背唱蒲公英的约定。。。。。二字当时紧张三字还安慰他让粉丝安静点二字听不到音乐了。。。。。。二字唱到这没想起来这一幕打死我也不信",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "166",
  },
  {
    id: 855,
    user_face: "855-user-face.png",
    user_id: "向日葵鲔海",
    is_op: false,
    create_at: "2022-12-30 13:11:34 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "很难说的氛围。手机里现在还能找到几张16年的动图",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "143",
  },
  {
    id: 856,
    user_face: "856-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:13:11 四川",
    quote: {
      quote_status: true,
      quote_content:
        "顺风车大姐。。。我可没造谣。。。干嘛挂我呀😢😢😢。。。我朋友每一件事情。。。可都有照片。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "没事哥哥。。。她给你举了。。你再发就行。。。窝们嗑药鸡给你顶 贴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "107",
  },
  {
    id: 857,
    user_face: "857-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 13:13:39 河南",
    quote: {
      quote_status: true,
      quote_content:
        "唱到那句也记得那一首歌时。。。。二字突然跑到舞台边坐下。。。没唱两句又起来。。。。想起来他和三字第一次上快乐大本营时就是安排他们坐在舞台边背对背唱蒲公英的约定。。。。。二字当时紧张三字还安慰他让粉丝安静点二字听不到音乐了。。。。。。二字唱到这没想起来这一幕打死我也不信",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "857-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "和三字坐在舞台边。。。。还是第一次进入主流媒体视线参加活动。。。。。印象一定很深吧。。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "857-cmt.png",
      },
    },
    like_cnt: "143",
  },
  {
    id: 858,
    user_face: "858-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:14:14 四川",
    quote: {
      quote_status: true,
      quote_content:
        "啊，这个戳到我了，知足的歌词就是自己劝自己曾经拥有就该满足了",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "午夜徘徊会听知足 。。五月天还问3是不是有谈恋爱 唱知足的时候也能感受到那种巨大的悲伤 。。那天也是2去拿签证的日子\n歌词真的很应景。。。当一阵风吹来风筝飞向天空。。。会不会放手其实才是拥有。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "213",
  },
  {
    id: 859,
    user_face: "859-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-30 13:17:19 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "想问一下，你们说的小说y白的原型ky这个是真的吗🥺✌️想去看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "17",
  },
  {
    id: 860,
    user_face: "860-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 13:19:35 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "wjk还买了个以前上过的不重要的热搜 好像登了一会儿第一 但是还是被刷下来了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "77",
  },
  {
    id: 861,
    user_face: "861-user-face.png",
    user_id: "樱桃肉丸丸-",
    is_op: false,
    create_at: "2022-12-30 13:21:40 北京",
    quote: {
      quote_status: true,
      quote_content:
        "然后我不是怀疑他和队友嘛，我就开始看被奉为岛经的《y白》，本来就是当编料看着玩。。。结果没想着越看越真。。。很锤我的一个点是这段话，这里小白是💚，可能是取自于他名字里的“源”，y是💙，应该是取自于英文名karry\n\n16年的y白原贴在19年的唱作人里得到印证，“小白就讲，很不喜欢散场的感觉，但有时候灯照的太亮也容易没什么安全感”他三年后在台上说“但我看你们其实很黑”。。。这也是y白让我觉得很锤的点之一，好多细节都是在之后的好几年里陆续得到印证，而且16年同年黄锐（疑似y白作者）从sdfj离职，就显得这个东西更真了🚬有没有人能告诉我为什么这么真啊。。。我现在打下这段文字的时候。。。都还有点恍惚。。只是一点点。。。毕竟我最开始扒的时候。。恍惚了好几个月。。那种心理大概是，虽然我现在确信💙💚是真的。。。但我每每想到ky竟然szd。。都会感叹。。。这世上还有什么是不可能的🚬\n\n\n图",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "861-quote.png",
      },
    },
    cmt: {
      cmt_content: "再说一遍 kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "25",
  },
  {
    id: 862,
    user_face: "862-user-face.png",
    user_id: "宋亚轩(毛绒版)",
    is_op: false,
    create_at: "2022-12-30 13:22:02 四川",
    quote: {
      quote_status: true,
      quote_content: "想问一下，你们说的小说y白的原型ky这个是真的吗🥺✌️想去看",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是真的 豆瓣上就能看原帖。。不过不一定是小说 也可能是黄锐写的纪实文学🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "143",
  },
  {
    id: 863,
    user_face: "863-user-face.png",
    user_id: "一口红茶",
    is_op: false,
    create_at: "2022-12-30 13:22:38 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "ky真的越嗑越有。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "13",
  },
  {
    id: 864,
    user_face: "864-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:24:31 四川",
    quote: {
      quote_status: true,
      quote_content:
        "“说起来，去年七一集训的时候，有料说wjk在盯着wy吃饭。。。。咱就是说去年他俩已经一个22岁一个21岁了。。。。一个男人还能这么在意另一个男人的饮食健康。。。。。这种照顾，有时候我也想不通，或者说没法解释这到底是种什么样的感情。。。。。。”\n\n。。。他俩难以解释的事情真的很多。。。。我也想知道wf姐姐是怎么看待这事儿的。。。。我真的觉得这种关系好微妙啊。。。。。\n\n\n🔚",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "童养媳是这样的。。。。大家不懂。。。。养成媳。。。。蒽",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "134",
  },
  {
    id: 865,
    user_face: "865-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 13:28:18 广东",
    quote: {
      quote_status: true,
      quote_content: "想问一下，你们说的小说y白的原型ky这个是真的吗🥺✌️想去看",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "九成是真的。。。扣掉是因为没有办法拿出黄锐在打字的照片。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "269",
  },
  {
    id: 866,
    user_face: "866-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:28:18 浙江",
    quote: {
      quote_status: true,
      quote_content: "想问一下，你们说的小说y白的原型ky这个是真的吗🥺✌️想去看",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "@在之为上 黄锐问你话呢 礼貌点赶紧回答",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "106",
  },
  {
    id: 867,
    user_face: "867-user-face.png",
    user_id: "向日葵鲔海",
    is_op: false,
    create_at: "2022-12-30 13:29:37 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "有个uu私信想让我代发一下~ 💚会在生日会。。看着💙送的天气瓶落泪。。。16年就已不只是年少无知的暧昧了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "166",
  },
  {
    id: 868,
    user_face: "868-user-face.png",
    user_id: "向日葵鲔海",
    is_op: false,
    create_at: "2022-12-30 13:29:46 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "105",
  },
  {
    id: 869,
    user_face: "869-user-face.png",
    user_id: "向日葵鲔海",
    is_op: false,
    create_at: "2022-12-30 13:31:54 山东",
    quote: {
      quote_status: true,
      quote_content: "想问一下，你们说的小说y白的原型ky这个是真的吗🥺✌️想去看",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "感觉就是他们的工作人员写的，像真的记录生活，性格也对的上",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "82",
  },
  {
    id: 870,
    user_face: "870-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 13:32:04 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这是张动图。。。何炅在零点说“拥抱身边最爱的人”，然后3悄悄用膝盖顶了我儿大腿一下。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "870-quote.png",
      },
    },
    cmt: {
      cmt_content: "磕的好想哭。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "63",
  },
  {
    id: 871,
    user_face: "871-user-face.png",
    user_id: "一棵仙人掌",
    is_op: false,
    create_at: "2022-12-30 13:32:10 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这也是一位i2哥哥的投稿。。。一共有三位i2哥哥投稿了。。。对22的情绪有不一样的见解。。。我的i3朋友对22的视角也是缺失的。。。所以也放上来哥哥们。。。自行理解品味。。。说得也非常好。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "871-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "二字说因为我爱你所以我快乐而不是你爱我所以我快乐，在我看来，人非圣贤，在没有得到对方的爱时肯定还是他爱我所以我快乐，能做到因为我爱你所以我快乐的，一定是因为对方给了自己足够的爱和安全感，二字已经得到自己想要的了，所以他的爱情观才能升华到下一个高度。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "201",
  },
  {
    id: 872,
    user_face: "872-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 13:32:12 河南",
    quote: {
      quote_status: true,
      quote_content:
        "“还有一个事是：之前他们上声乐课，y到的时候，小白正在练习，y问他上的怎么样，小白说老师让他练发声的位置，这个东西可以用手摸来感受，y就跟着他一起练，然后小白说你唱响一点，我摸摸看。\n\n然后小白的手刚摸上去，y的声音就停了，他几乎是很严肃地质问，什么情况，都这个天了，你手怎么还是这么冷。\n\n就是这两件小事吧，但是一是能看出来wjk一直都很在意wy身体健不健康，虽然wjk自己有时候也不太知道照顾自己。。。训练或者工作起来很拼的。。。二是wy确实从小身体偏凉，又偏瘦，wjk会盯着他好好吃饭。。。”\n\n⬇️",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "想起来这个 在我们三老只单飞后。。。最后一次线上录播的周年演唱会。。。。这个演唱会纪录片出来除了有两次三字看二字以外基本三个人没有其他互动。。。。可以说像陌生人拼盘。。。。。但是有工作人员在朋友圈发了二字彩排身体不舒服把三字吓了一跳。。。结果i2发截图在微博虐粉还把这句话码掉了。。。。。。。好嗑程度加倍。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "188",
  },
  {
    id: 873,
    user_face: "873-user-face.png",
    user_id: "午夜高速没有车",
    is_op: false,
    create_at: "2022-12-30 13:32:25 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "这也是一位i2哥哥的投稿。。。一共有三位i2哥哥投稿了。。。对22的情绪有不一样的见解。。。我的i3朋友对22的视角也是缺失的。。。所以也放上来哥哥们。。。自行理解品味。。。说得也非常好。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "873-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "我觉得这个感觉好贴。。我觉得2应该对待感情醒的更早，看得更清楚，也更果断的。。。3就像是凭着爱与直觉这么多年。。终于在2的拉扯下开始醒悟的感觉。。。所以先心动的人。。也先醒悟。。要是2决定离开了感觉真的不意外。。可惜他们彼此的成长轨迹完全交融。。在互相脱轨之前就已经意识到彼此的重要性了。。要我说。。都现在了。。与其狠心与彼此脱轨。。不如出柜得了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "156",
  },
  {
    id: 874,
    user_face: "874-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 13:32:48 河南",
    quote: {
      quote_status: true,
      quote_content:
        "想起来这个 在我们三老只单飞后。。。最后一次线上录播的周年演唱会。。。。这个演唱会纪录片出来除了有两次三字看二字以外基本三个人没有其他互动。。。。可以说像陌生人拼盘。。。。。但是有工作人员在朋友圈发了二字彩排身体不舒服把三字吓了一跳。。。结果i2发截图在微博虐粉还把这句话码掉了。。。。。。。好嗑程度加倍。。。。",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "874-quote.png",
      },
    },
    cmt: {
      cmt_content: "怎么吓一跳了吓一跳以后干什么了多说点啊😭😭😭跌的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "139",
  },
  {
    id: 875,
    user_face: "875-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 13:36:06 北京",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "磕死。。。昨天听了一晚上。。。“谁自顾自地有，谁忘了看着我，谁让爱变沉重，谁忘了要给你温柔”那里撕心裂肺。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "132",
  },
  {
    id: 876,
    user_face: "876-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 13:36:52 山东",
    quote: {
      quote_status: true,
      quote_content:
        "有个uu私信想让我代发一下~ 💚会在生日会。。看着💙送的天气瓶落泪。。。16年就已不只是年少无知的暧昧了。。",
      quote_user_id: "向日葵鲔海",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "876-quote.png",
      },
    },
    cmt: {
      cmt_content: "。。。。kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "57",
  },
  {
    id: 877,
    user_face: "877-user-face.png",
    user_id: "蒂特洛伊木马",
    is_op: false,
    create_at: "2022-12-30 13:37:12 广东",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "呃哥哥。。。。你开心就好。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 878,
    user_face: "878-user-face.png",
    user_id: "午夜高速没有车",
    is_op: false,
    create_at: "2022-12-30 13:44:10 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "之前的23贴里跟着看了我怀念的，玫瑰少年和词不达意的舞台。。真的是我为数不多觉得爱豆真心的感觉。。这就去品品春心荡漾的lucky。。。kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "196",
  },
  {
    id: 879,
    user_face: "879-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:45:00 吉林",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "又嗑到。。原来中间发生这么多故事。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "25",
  },
  {
    id: 880,
    user_face: "880-user-face.png",
    user_id: "抱抱豹豹",
    is_op: false,
    create_at: "2022-12-30 13:47:09 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "这个楼没有了我会很伤心。。。楼主一定要存档。。。。拜托。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "92",
  },
  {
    id: 881,
    user_face: "881-user-face.png",
    user_id: "Plutoooooy",
    is_op: false,
    create_at: "2022-12-30 13:48:31 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "真的是kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 882,
    user_face: "882-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 13:48:54 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚 这辈子磕到你们是我的福气。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "68",
  },
  {
    id: 883,
    user_face: "883-user-face.png",
    user_id: "限定四月",
    is_op: false,
    create_at: "2022-12-30 13:49:09 江苏",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "向日葵鲔海",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "883-quote.png",
      },
    },
    cmt: {
      cmt_content: "瓶底还是哪里好像有love的标识来着😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "97",
  },
  {
    id: 884,
    user_face: "884-user-face.png",
    user_id: "浪我随便",
    is_op: false,
    create_at: "2022-12-30 13:52:20 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "楼楼一定要记得存档😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 885,
    user_face: "885-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:52:27 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "我觉得这个感觉好贴。。我觉得2应该对待感情醒的更早，看得更清楚，也更果断的。。。3就像是凭着爱与直觉这么多年。。终于在2的拉扯下开始醒悟的感觉。。。所以先心动的人。。也先醒悟。。要是2决定离开了感觉真的不意外。。可惜他们彼此的成长轨迹完全交融。。在互相脱轨之前就已经意识到彼此的重要性了。。要我说。。都现在了。。与其狠心与彼此脱轨。。不如出柜得了",
      quote_user_id: "午夜高速没有车",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥最后一句话笑死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 886,
    user_face: "886-user-face.png",
    user_id: "流畅水写笔",
    is_op: false,
    create_at: "2022-12-30 13:52:55 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "kswl。。。。大家。。。。等跨年33的歌吧。。。绝对好磕。。。。。对着丈母娘唱这歌。。。。。。真有你小子的。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "173",
  },
  {
    id: 887,
    user_face: "887-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 13:56:31 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "真的感谢。。。。跨年前极速上岛。。。。明天就跨年了。。。。过年都没这么高兴。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "166",
  },
  {
    id: 888,
    user_face: "888-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 13:57:09 美国",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "富贵仙人掌🌵",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "啊啊啊啊这个名字。。。有种挑衅丈母娘的感觉。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "31",
  },
  {
    id: 889,
    user_face: "889-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 14:00:16 美国",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "富贵仙人掌🌵",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "窝趣。。。台下的艾二艾三真的不咯噔吗。。。这和直接绿光打脸上有什么区别。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "63",
  },
  {
    id: 890,
    user_face: "890-user-face.png",
    user_id: "雪王宝贝",
    is_op: false,
    create_at: "2022-12-30 14:00:28 广东",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "向日葵鲔海",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "890-quote.png",
      },
    },
    cmt: {
      cmt_content: "💙也眼睛红红。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "54",
  },
  {
    id: 891,
    user_face: "891-user-face.png",
    user_id: "呼哧呼哧胖胖球",
    is_op: false,
    create_at: "2022-12-30 14:01:19 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 892,
    user_face: "892-user-face.png",
    user_id: "不要再吵啦",
    is_op: false,
    create_at: "2022-12-30 14:03:26 广东",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "富贵仙人掌🌵",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "还有合唱啊。。。道济都不敢dream",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "36",
  },
  {
    id: 893,
    user_face: "893-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 14:04:43 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "kswl。。。。大家。。。。等跨年33的歌吧。。。绝对好磕。。。。。对着丈母娘唱这歌。。。。。。真有你小子的。。。。",
      quote_user_id: "流畅水写笔",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥是不是有点人脉啊👂🏻👂🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "70",
  },
  {
    id: 894,
    user_face: "894-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-30 14:05:02 广东",
    quote: {
      quote_status: true,
      quote_content: "还有合唱啊。。。道济都不敢dream",
      quote_user_id: "不要再吵啦",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "不是 是这首歌年代比较久远 xpx推测可能是别的前辈合唱",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "37",
  },
  {
    id: 895,
    user_face: "895-user-face.png",
    user_id: "极光辐能聚集",
    is_op: false,
    create_at: "2022-12-30 14:07:34 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕死我了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 896,
    user_face: "896-user-face.png",
    user_id: "一口好牙稀碎",
    is_op: false,
    create_at: "2022-12-30 14:07:49 河南",
    quote: {
      quote_status: true,
      quote_content:
        "kswl。。。。大家。。。。等跨年33的歌吧。。。绝对好磕。。。。。对着丈母娘唱这歌。。。。。。真有你小子的。。。。",
      quote_user_id: "流畅水写笔",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "期待了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "21",
  },
  {
    id: 897,
    user_face: "897-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-30 14:08:12 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "不暴露歌名啦 害怕打架 楼就没了 也有哥哥私信说担心暴露歌名帖子没+不唱了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "98",
  },
  {
    id: 898,
    user_face: "898-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 14:17:22 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "后排先提醒。。。有道济私我说可能只是三字宣传新电影啥的唱的插曲。。。但是只嗑名字也可以了 因为真的很好笑很应景 i2也不知道插曲啥的 当场可能就气的汤圆爆浆。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "207",
  },
  {
    id: 899,
    user_face: "899-user-face.png",
    user_id: "sowhat",
    is_op: false,
    create_at: "2022-12-30 14:18:10 广西",
    quote: {
      quote_status: true,
      quote_content:
        "💙个人演唱会\n“然后我又去8了一下3的无边界个人演唱会了。。。唱了一首《词不达意》🚬   间奏全场绿光。。。不仅绿了i3一脸也绿了i2一脸吧。。。为你们的爱情鼓鼓掌好吧。。。说实话。。。大家结构33都知道他在镜头前很少表达浓烈的情绪（和22相比。。。所以很多i2觉得💙对💚不如2对3深情。。。但词不达意这首歌。。。我第一次体会到💙确实很爱💚的，噢噢对他唱这首歌之前还说：“这首歌呢，在我身上会形容得比较准确。”说完还蛮不好意思地笑了一下。。。唱得。。很苦情的亚子。。。\n\n最好笑的是，我去b站看《词不达意》剪辑，蟹姐们7个机位愣是把绿光一点都没透出来全给剪没了，而且最前面说的那句“这首歌呢 可能在我身上形容的比较准确”也剪掉了了。。。\n\n这个绿光。。。不说蟹姐。。。我都被绿傻了”\n\n\n（我的i3朋友看到这一条被亖去的记忆攻击。。。没错。。。词不达意就是绿色的灯光和舞美。。。这个绿光和17岁那年的绿光好k程度可真是不相上下。。。\n\n\n图",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "899-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "这点好少人提，也没有录像佐证，i3真的觉得塌房了吧才剪掉了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "153",
  },
  {
    id: 900,
    user_face: "900-user-face.png",
    user_id: "布吉岛",
    is_op: false,
    create_at: "2022-12-30 14:19:07 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "看过y白就知道什么是“这世界还有谁，比我们更绝配”",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "173",
  },
  {
    id: 901,
    user_face: "901-user-face.png",
    user_id: "423",
    is_op: false,
    create_at: "2022-12-30 14:22:06 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "从14年嗑到17年。。。凯源也算是我嗑的第一对rps了。。。那会每天在贴吧嗑。真的很单纯快乐。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "107",
  },
  {
    id: 902,
    user_face: "902-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 14:22:07 广西",
    quote: {
      quote_status: true,
      quote_content:
        "真的感谢。。。。跨年前极速上岛。。。。明天就跨年了。。。。过年都没这么高兴。。",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "+1。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "22",
  },
  {
    id: 903,
    user_face: "903-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 14:24:34 黑龙江",
    quote: {
      quote_status: true,
      quote_content: "期待了。。。",
      quote_user_id: "一口好牙稀碎",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "唱什么呀 卖汤圆啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "136",
  },
  {
    id: 904,
    user_face: "904-user-face.png",
    user_id: "sowhat",
    is_op: false,
    create_at: "2022-12-30 14:24:36 广西",
    quote: {
      quote_status: true,
      quote_content:
        "kswl。。。。大家。。。。等跨年33的歌吧。。。绝对好磕。。。。。对着丈母娘唱这歌。。。。。。真有你小子的。。。。",
      quote_user_id: "流畅水写笔",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "天呀。。。。🐏康仔靠嗑药恢复健康。。。。谢谢哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "49",
  },
  {
    id: 905,
    user_face: "905-user-face.png",
    user_id: "大花🌸",
    is_op: false,
    create_at: "2022-12-30 14:25:10 安徽",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "向日葵鲔海",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "905-quote.png",
      },
    },
    cmt: {
      cmt_content: "这张凯子真的好男友。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "125",
  },
  {
    id: 906,
    user_face: "906-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-30 14:26:57 浙江",
    quote: {
      quote_status: true,
      quote_content: "💙也眼睛红红。。",
      quote_user_id: "雪王宝贝",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "他俩每次在对方生日上都会眼睛红红。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "137",
  },
  {
    id: 907,
    user_face: "907-user-face.png",
    user_id: "Vingilótë",
    is_op: false,
    create_at: "2022-12-30 14:28:33 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "留个爪",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 908,
    user_face: "908-user-face.png",
    user_id: "不要再吵啦",
    is_op: false,
    create_at: "2022-12-30 14:30:34 广东",
    quote: {
      quote_status: true,
      quote_content: "唱什么呀 卖汤圆啊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈哈哈哈哈哈哈哥哥你是懂幽默的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "67",
  },
  {
    id: 909,
    user_face: "909-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 14:30:35 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这点好少人提，也没有录像佐证，i3真的觉得塌房了吧才剪掉了。。。",
      quote_user_id: "sowhat",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "真的放了一整个间奏。。。以帝国对颜色的敏感。。没点什么含义我不信。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "138",
  },
  {
    id: 910,
    user_face: "910-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-30 14:30:58 湖北",
    quote: {
      quote_status: true,
      quote_content:
        "后排先提醒。。。有道济私我说可能只是三字宣传新电影啥的唱的插曲。。。但是只嗑名字也可以了 因为真的很好笑很应景 i2也不知道插曲啥的 当场可能就气的汤圆爆浆。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "想一键快进到明晚了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "52",
  },
  {
    id: 911,
    user_face: "911-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 14:31:46 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "大家都说22给33写歌。。。33唱给22的歌真的蛮吓人的。。。。绿光。。lucky。。知足。。词不达意。。。每一首都很爆炸。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "203",
  },
  {
    id: 912,
    user_face: "912-user-face.png",
    user_id: "一口好牙稀碎",
    is_op: false,
    create_at: "2022-12-30 14:36:41 河南",
    quote: {
      quote_status: true,
      quote_content: "唱什么呀 卖汤圆啊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "笑得疯了啊啊啊啊啊啊啊啊啊啊啊啊啊啊汤圆汤圆卖汤圆",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "97",
  },
  {
    id: 913,
    user_face: "913-user-face.png",
    user_id: "The9-魔仙小兰",
    is_op: false,
    create_at: "2022-12-30 14:43:54 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑的。。。。好想发疯。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 914,
    user_face: "914-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-30 14:44:53 陕西",
    quote: {
      quote_status: true,
      quote_content: "唱什么呀 卖汤圆啊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈。。。不像假的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "25",
  },
  {
    id: 915,
    user_face: "915-user-face.png",
    user_id: "爱恨难收",
    is_op: false,
    create_at: "2022-12-30 14:45:40 甘肃",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "唯粉好会磕。。。比cp粉还会。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "26",
  },
  {
    id: 916,
    user_face: "916-user-face.png",
    user_id: "嘻嘻",
    is_op: false,
    create_at: "2022-12-30 14:46:34 河南",
    quote: {
      quote_status: true,
      quote_content: "唱什么呀 卖汤圆啊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "卖汤圆。。卖汤圆好呀。。。。哈哈哈哈哈哈哈姐夫亲自卖。。。哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "43",
  },
  {
    id: 917,
    user_face: "917-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-30 14:55:46 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "词不达意。。间奏绿光来了。。。。https://video.weibo.com/show?fid=1034:4617318551191612",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "94",
  },
  {
    id: 918,
    user_face: "918-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-30 15:01:51 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "每个没看lucky舞台的人我都会伤心。。。ok？？？。。。太娇了。。和好朋友谈恋爱就这么开心是吧。。。。【【DARKSTAR王俊凯】180922 《lucky》focus-哔哩哔哩】 https://b23.tv/y0RzCzH",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "116",
  },
  {
    id: 919,
    user_face: "919-user-face.png",
    user_id: "SalaDeFruits",
    is_op: false,
    create_at: "2022-12-30 15:08:07 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "薅磕。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 920,
    user_face: "920-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-30 15:09:58 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "都说y白写的东西过几年都对上了。。所以有没有y白和凯源的对应贴给我磕磕啊🥺🥺我已经看完岛经了，我同意确实就是凯源",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "99",
  },
  {
    id: 921,
    user_face: "921-user-face.png",
    user_id: "豆友",
    is_op: false,
    create_at: "2022-12-30 15:11:12 北京",
    quote: {
      quote_status: true,
      quote_content: "唱什么呀 卖汤圆啊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "他还真唱过。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "67",
  },
  {
    id: 922,
    user_face: "922-user-face.png",
    user_id: "吃口蛋挞🧁",
    is_op: false,
    create_at: "2022-12-30 15:13:43 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "笑死。。。。边笑边磕。。。。。kswl💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 923,
    user_face: "923-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 15:16:18 上海",
    quote: {
      quote_status: true,
      quote_content: "唱什么呀 卖汤圆啊",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "111111111不像假的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 924,
    user_face: "924-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2022-12-30 15:25:18 河南",
    quote: {
      quote_status: true,
      quote_content:
        "谢谢哥哥喜欢。。。我朋友也是想了很久才出来聊的。。。毕竟是初恋追星。。。虽然跑路了。。。但她真的见证了这对给子很多高甜时刻。。。就是wjk按着她的头让她知道凯源关系就是好（甚至是真的，给子的那种真的）",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好好看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 925,
    user_face: "925-user-face.png",
    user_id: "抹茶巧克力",
    is_op: false,
    create_at: "2022-12-30 15:27:25 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "都说y白写的东西过几年都对上了。。所以有没有y白和凯源的对应贴给我磕磕啊🥺🥺我已经看完岛经了，我同意确实就是凯源",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "https://www.douban.com/group/topic/82841594/?_i=723579089b6860e",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "19",
  },
  {
    id: 926,
    user_face: "926-user-face.png",
    user_id: "墨白公子",
    is_op: false,
    create_at: "2022-12-30 15:39:51 内蒙古",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "呜呜呜呜，永远被ky粉表述的ky打动",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 927,
    user_face: "927-user-face.png",
    user_id: "国际男高刘耀文",
    is_op: false,
    create_at: "2022-12-30 15:47:14 江苏",
    quote: {
      quote_status: true,
      quote_content: "最后一段配上这个图更好磕了",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "927-quote.png",
      },
    },
    cmt: {
      cmt_content: "卧槽这个。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "43",
  },
  {
    id: 928,
    user_face: "928-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2022-12-30 15:53:59 河南",
    quote: {
      quote_status: true,
      quote_content: "这个大帽子外套是💙的。。。3在客舱里还穿着。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "928-quote.png",
      },
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 929,
    user_face: "929-user-face.png",
    user_id: "仙人掌味橡皮糖",
    is_op: false,
    create_at: "2022-12-30 16:08:10 海南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕的我嗷嗷哭。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 930,
    user_face: "930-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 16:14:24 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "😭这个高楼wfj那边开始jb了，呜呜呜还想之后慢慢爬楼磕，只能现在赶紧看了,wfj好狠的心",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "76",
  },
  {
    id: 931,
    user_face: "931-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2022-12-30 16:24:42 河南",
    quote: {
      quote_status: true,
      quote_content:
        "这位哥哥的理解。。。（分析向\n\n我自己的i3朋友觉得💙某种意义上是特别双标的人，他对于不需要分配感情的人和群体表现得非常淡漠甚至抗拒，💙这个人是对不起全世界都不会对不起💚的人。但其实我并不觉得他真的不在乎粉丝，我解构了一下💙这个人，其实他非常不擅长表达自己的情感，有十分爱大概就流露出五分，还是在这两口子的分手期被逼得没办法了才表现出来让我们看到。但💚就不是，💚是那种有十分爱就表露出十分的性格，我觉得这和原生家庭的关系也很大。i3之所以对真嫂子那么破防，无非是因为女友粉比例高而💙又不做男友向营业，其实蛮死心眼的。💙今年整整一个月没有营业，把💚的生日博相当于置顶了一个月，当初搜他工作室的实时广场都可以看到好多蟹姐在激情开麦，怎么说呢，我作为一个前i2，看着还是蛮触动的。💙这个人确实就蛮搭《词不达意》这首歌的，我有时候也会觉得💙这种不善于表达只会闷声做事的性格，其实是有点吃亏的。不管怎么说，希望💚可以多多治愈他吧。这两口子就好好过吧。献上我最诚挚的祝福～\n\n而且我甚至觉得💙不做男友向营业这个行为，怎么说呢，有点傻气又很真诚。他不知道自己该怎样对待粉丝的那份爱，因为他给不出对等的爱来，而且因为有了💚，他可能会觉得，如果媚粉的话，显得很不真诚，他没有办法去违心地做出媚粉的举动，当然这些只是我个人的想法。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好真诚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 932,
    user_face: "932-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 16:32:18 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "关于罚款的。。。投稿。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "91",
  },
  {
    id: 933,
    user_face: "933-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 16:35:51 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "同一家馆子的投稿。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "250",
  },
  {
    id: 934,
    user_face: "934-user-face.png",
    user_id: "国际男高刘耀文",
    is_op: false,
    create_at: "2022-12-30 16:42:24 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "真的感谢。。。。跨年前极速上岛。。。。明天就跨年了。。。。过年都没这么高兴。。",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。我也是。。好幸福",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "35",
  },
  {
    id: 935,
    user_face: "935-user-face.png",
    user_id: "如花美眷",
    is_op: false,
    create_at: "2022-12-30 16:43:26 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好磕。。。一天刷新800遍这帖子。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "44",
  },
  {
    id: 936,
    user_face: "936-user-face.png",
    user_id: "洁白无瑕伍嘉成",
    is_op: false,
    create_at: "2022-12-30 16:44:53 福建",
    quote: {
      quote_status: true,
      quote_content: "同一家馆子的投稿。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "936-quote.png",
      },
    },
    cmt: {
      cmt_content: "omg",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "27",
  },
  {
    id: 937,
    user_face: "937-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2022-12-30 16:45:58 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "家人们，怎么复制链接🥲🥲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 938,
    user_face: "938-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 16:46:44 山东",
    quote: {
      quote_status: true,
      quote_content: "同一家馆子的投稿。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "938-quote.png",
      },
    },
    cmt: {
      cmt_content: "kswl。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 939,
    user_face: "939-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 16:46:54 山东",
    quote: {
      quote_status: true,
      quote_content: "家人们，怎么复制链接🥲🥲",
      quote_user_id: "一颗桑葚",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "https://www.douban.com/group/topic/279199969/?_i=723890078d2eb94&amp;dt_dapp=1",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 940,
    user_face: "940-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 16:47:35 山东",
    quote: {
      quote_status: true,
      quote_content: "同一家馆子的投稿。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "940-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "这个真的好好嗑。。。有没有道济告诉我时间线。。。二字去的时候三字还在那里拍戏吗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 941,
    user_face: "941-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 16:52:43 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "补一个🍬。。。也很吓死唯饭的。。。4的成年岁生日会在天津开的（以前生日会队友都会去的。。。北京和天津很近。。。所以是开车的。。。大家审判自行22吧。。。反正当时这条wb一出来。。。和格格嫂子唇妆九宫格对唯粉打击👊的威力。。。差不多",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "200",
  },
  {
    id: 942,
    user_face: "942-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 16:53:34 广东",
    quote: {
      quote_status: true,
      quote_content: "同一家馆子的投稿。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "942-quote.png",
      },
    },
    cmt: {
      cmt_content: "配套的。。。i2瑞萍。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "942-cmt.png",
      },
    },
    like_cnt: "321",
  },
  {
    id: 943,
    user_face: "943-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 17:07:46 四川",
    quote: {
      quote_status: true,
      quote_content:
        "补一个🍬。。。也很吓死唯饭的。。。4的成年岁生日会在天津开的（以前生日会队友都会去的。。。北京和天津很近。。。所以是开车的。。。大家审判自行22吧。。。反正当时这条wb一出来。。。和格格嫂子唇妆九宫格对唯粉打击👊的威力。。。差不多",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "943-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "2在3车上副驾驶拍照。。。后座衣服疑似3外套。。当年差点把道济吓死。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "209",
  },
  {
    id: 944,
    user_face: "944-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-30 17:10:25 云南",
    quote: {
      quote_status: true,
      quote_content: "家人们，怎么复制链接🥲🥲",
      quote_user_id: "一颗桑葚",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "https://www.douban.com/group/topic/279199969/?_i=72390634626c7a3",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 945,
    user_face: "945-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 17:10:55 河南",
    quote: {
      quote_status: true,
      quote_content:
        "都说y白写的东西过几年都对上了。。所以有没有y白和凯源的对应贴给我磕磕啊🥺🥺我已经看完岛经了，我同意确实就是凯源",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "https://m.weibo.cn/7511211160/4734944490031316 哥哥可以看看",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 946,
    user_face: "946-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 17:12:57 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "这个真的好好嗑。。。有没有道济告诉我时间线。。。二字去的时候三字还在那里拍戏吗。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "我也想知道。。。所以有人可以解惑吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 947,
    user_face: "947-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 17:16:16 河南",
    quote: {
      quote_status: true,
      quote_content: "我也想知道。。。所以有人可以解惑吗",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "已经杀青了 如果没杀青二字过去岂不是会被i3堵上。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "137",
  },
  {
    id: 948,
    user_face: "948-user-face.png",
    user_id: "三九五六",
    is_op: false,
    create_at: "2022-12-30 17:17:58 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "补一个🍬。。。也很吓死唯饭的。。。4的成年岁生日会在天津开的（以前生日会队友都会去的。。。北京和天津很近。。。所以是开车的。。。大家审判自行22吧。。。反正当时这条wb一出来。。。和格格嫂子唇妆九宫格对唯粉打击👊的威力。。。差不多",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "948-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "当这么多年大明星少化妆了吗。。。。。怎么偏偏。。。这天化妆就要秀。。。。。好怪噢。。。像发嫂子瘾。。。不确定再看一眼。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "254",
  },
  {
    id: 949,
    user_face: "949-user-face.png",
    user_id: "大卫•科波菲尔",
    is_op: false,
    create_at: "2022-12-30 17:20:12 四川",
    quote: {
      quote_status: true,
      quote_content: "很难说的氛围。手机里现在还能找到几张16年的动图",
      quote_user_id: "向日葵鲔海",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "949-quote.png",
      },
    },
    cmt: {
      cmt_content: "这个勾手 真是有点东西。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "100",
  },
  {
    id: 950,
    user_face: "950-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-30 17:20:34 云南",
    quote: {
      quote_status: true,
      quote_content:
        "补一个🍬。。。也很吓死唯饭的。。。4的成年岁生日会在天津开的（以前生日会队友都会去的。。。北京和天津很近。。。所以是开车的。。。大家审判自行22吧。。。反正当时这条wb一出来。。。和格格嫂子唇妆九宫格对唯粉打击👊的威力。。。差不多",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "950-quote.png",
      },
    },
    cmt: {
      cmt_content: "老公车上拍自拍——嫂子瘾犯了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "189",
  },
  {
    id: 951,
    user_face: "951-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 17:25:49 海南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "微分手下留情😭😭😭😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "30",
  },
  {
    id: 952,
    user_face: "952-user-face.png",
    user_id: "大花🌸",
    is_op: false,
    create_at: "2022-12-30 17:28:17 安徽",
    quote: {
      quote_status: true,
      quote_content: "配套的。。。i2瑞萍。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "952-quote.png",
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈，笑死。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "46",
  },
  {
    id: 953,
    user_face: "953-user-face.png",
    user_id: "洁白无瑕伍嘉成",
    is_op: false,
    create_at: "2022-12-30 17:29:00 福建",
    quote: {
      quote_status: true,
      quote_content: "配套的。。。i2瑞萍。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "953-quote.png",
      },
    },
    cmt: {
      cmt_content: "i2 谢谢你们",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "76",
  },
  {
    id: 954,
    user_face: "954-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 17:30:17 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "刚才抖音搜索凯源，就在搜索下面几个视频后面看到二字（不知道什么综艺评论也没看见）说：\n\n“可能相处十年，突然发现你要跟他在一起”\n\n😭是谁跟谁已经十年了啊，莫名磕到（but,没看过原片不知道名字，所以不知道具体什么场景说的，单纯觉得磕到）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "160",
  },
  {
    id: 955,
    user_face: "955-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 17:35:25 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "【【凯源/y白】所以那些可能的都会是真的-哔哩哔哩】 https://b23.tv/z4fpZaY  组外哥哥投稿的。。。感兴趣y白的哥哥们可以看下",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "32",
  },
  {
    id: 956,
    user_face: "956-user-face.png",
    user_id: "大花🌸",
    is_op: false,
    create_at: "2022-12-30 17:40:05 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "后面就是因为口罩wy回国，22回国之后很长一段时间住wjk家养猫这些细节就不用我给各位哥哥复习了。。。\n\n他们在这个阶段一定是有一个质变的，wy回国后和出国前的状态更是大相径庭，等一个i2哥哥补补吧我对22的感情视角没那么清晰。。。\n\n在这个阶段，我更偏向于他们愿意放过自己也放过彼此（放过不是放弃。。。他们会去学着接受他们这种特殊的关系。\n\n去珍惜他们关系中的独一无二和特性，毕竟从一开始他们只有彼此，真的是没繁华红毯的少年时代里，陪彼此走过籍籍无名啊，是回头看，不管是因为什么缘故你没有走，但原来只有你是没有和我走散的，你也不愿意和我走散，那我要好好珍惜。\n\n去忘记曾经别扭时的互相伤害，曾经他们就是太在意“缘故”，是外界的声音吗？是为了埋腐吗？你拿我当成什么？我不想被定义为你的睡，我是我自己，尤其是wy，他应该是有一段时间非常介意被粉丝称作wjk女朋友的。。。wjk也看不懂wy曾经很多的心事，各种别扭闹个不停，彼此伤害，应该也有很多彼此刺痛，但是这个时间段他们都选择忘记和接受这些过往，而不是纠缠不放。\n\n所以这两年他们的关系一直是在正向循环的。。。\n\n其实跨年是很甜，我真的对踩组的嗑法没有任何意见，只是我是唯饭的思维吧（也可能是我自己的原因。。。缺德归缺德，乐子归乐子，说归说。。。真的要说wjk去江苏跨年肯定是因为和两个台协商之下，哪边的曝光酬劳待遇更合适就去哪边，不会是因为wy去他就屁颠屁颠跟着去。\n\n但是他就是去了。\n\n他和他的团队肯定知道他这么去，i3就是来不及应援的，但他也不是很在乎的样子，他也肯定知道22也在（废话不可能不知道。。。但他不想避嫌。。。或者说他是觉得他和22的关系不需要特意避嫌。。。我们就是关系不错，怎么了？有什么问题？\n\ni3也别骗自己。。。wjk就是不觉得和wy同台是禁忌。。。他就是不觉得他要和wy老死不相往来。。。他们就是很好。。。不能确定是给子的话（毕竟我不能爬他们床底确认。。。他们也就是很好。。。真的很好。。。唯饭再怎么辩驳也骗不了自己。。。你哥哥就是和wy关系不差。。。\n\ni3视角完结",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这个👆🏻有印象，后来wjk不是还被拍到大衣上有猫毛嘛",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "62",
  },
  {
    id: 957,
    user_face: "957-user-face.png",
    user_id: "大花🌸",
    is_op: false,
    create_at: "2022-12-30 17:43:19 安徽",
    quote: {
      quote_status: true,
      quote_content: "很难说的氛围。手机里现在还能找到几张16年的动图",
      quote_user_id: "向日葵鲔海",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "957-quote.png",
      },
    },
    cmt: {
      cmt_content: "emmmm，怪不得i3骂小小年纪一股子狐媚，把她儿子迷得五迷三道",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "182",
  },
  {
    id: 958,
    user_face: "958-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 17:45:23 重庆",
    quote: {
      quote_status: true,
      quote_content: "已经杀青了 如果没杀青二字过去岂不是会被i3堵上。。。。",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "有道理哥哥。。。kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "27",
  },
  {
    id: 959,
    user_face: "959-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 17:47:28 山东",
    quote: {
      quote_status: true,
      quote_content:
        "刚才抖音搜索凯源，就在搜索下面几个视频后面看到二字（不知道什么综艺评论也没看见）说：\n\n“可能相处十年，突然发现你要跟他在一起”\n\n😭是谁跟谁已经十年了啊，莫名磕到（but,没看过原片不知道名字，所以不知道具体什么场景说的，单纯觉得磕到）",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "959-quote.png",
      },
    },
    cmt: {
      cmt_content: "啊啊啊啊啊啊啊啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 960,
    user_face: "960-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 17:57:39 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "来自一位i2哥哥的投稿。。。让我们谢谢i2哥哥们。。。\n\n\n我其实也是i2，从14年就因为小源喜欢整个团，但粉丝老吵架我不吵学着习惯最后发现实在不喜欢吵架，19年就solo追小源了。\n我今年大概8月看了同居贴，整个震惊然后补了两周凯源的贴心里感叹“小源果然还是喜欢他，还好小凯也喜欢他”\n从我角度小源其实很小大概15年就隐隐约约喜欢小凯了……岛姐觉得wjk演唱会的小天使在说wy，因为wy的确小天使，小时候接电话面对别人的自己的粉丝态度都很好，做小主持人也很照顾其他小孩，但他对wjk真的不一样。。。。初恋之枪眼神很经典，暗暗帮wjk弄破气球，希望他比自己高，无条件偏向wjk等等，我当时和朋友说好担心小源求而不得玉玉，他喜欢wjk蛮明显，但wjk应该身体比心理先开窍，摔跤喂饭太多亲密动作了，说出口的话又是把小源看成小孩子和弟弟在照顾……\n\n\n⬇️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "223",
  },
  {
    id: 961,
    user_face: "961-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 17:58:01 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "我现在95%相信凯源是真的，剩下5%是没有官宣，这么多年唯粉的倔强和他们太小就生活在一起了，说不定是真兄弟😂😅\n不过我已经把wjk看成我女婿了，而且越看越满意！断桥我请客朋友去看了，万里归途请了不同的朋友二刷。贴一个10月我发给朋友的话\n“由于对小源无限溺爱型，我现在对王俊凯看顺眼了，觉得他长得帅，之前印象是【王源从小暗恋的人】【队长】【脾气比较急】【很喜欢对王源管东管西】，现在觉得他很不错，丈母娘看女婿越看越满意………”\n\n“如果凯源是真的，我其实有微妙的自豪感，类似王俊凯那么多人喜欢，但是他喜欢王源”\n\n“我心态已经转变了，之前接受不了小源同性恋，现在想想是真的我也爽了，王俊凯那么多梦女，但又怎么样，他一心一意只喜欢我儿子诶！！！！！！！王俊凯越好说明我儿子越赚！”\n\n\n⬇️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "324",
  },
  {
    id: 962,
    user_face: "962-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 17:58:38 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "其实wjk很好的，踏实不乱来不喜欢娱乐圈乱七八糟的社交，虽然有点嘴笨爱管东管西，但不能否认把小源交给他的确放心。小源应该喜欢他很久了，我觉得是小源先动心的，他喜欢就好，如果对象一定要是男的，那我只接受王俊凯。。凯源是真的就祝福他们永远相爱，永远幸福。\n\n\n\n🔚\n\n\n这位哥哥是。。。和善的丈母娘一枚呀。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "431",
  },
  {
    id: 963,
    user_face: "963-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 17:58:55 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我i3朋友说。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "281",
  },
  {
    id: 964,
    user_face: "964-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 17:59:39 四川",
    quote: {
      quote_status: true,
      quote_content:
        "或许楼主不知道。。。不光造型师否认了。。。这个鞋前一天就穿了。。。第二天💙又特地换了🌈鞋带。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "而且这个鞋不是有人偶遇他们七夕节去实体店买的吗（貌似没有图。。。主要他们俩那种私下被路人偶遇的图挺多的。。。有些记混了。。。而且这个算是没有锤的料吧。。。）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "79",
  },
  {
    id: 965,
    user_face: "965-user-face.png",
    user_id: "洁白无瑕伍嘉成",
    is_op: false,
    create_at: "2022-12-30 17:59:39 福建",
    quote: {
      quote_status: true,
      quote_content:
        "来自一位i2哥哥的投稿。。。让我们谢谢i2哥哥们。。。\n\n\n我其实也是i2，从14年就因为小源喜欢整个团，但粉丝老吵架我不吵学着习惯最后发现实在不喜欢吵架，19年就solo追小源了。\n我今年大概8月看了同居贴，整个震惊然后补了两周凯源的贴心里感叹“小源果然还是喜欢他，还好小凯也喜欢他”\n从我角度小源其实很小大概15年就隐隐约约喜欢小凯了……岛姐觉得wjk演唱会的小天使在说wy，因为wy的确小天使，小时候接电话面对别人的自己的粉丝态度都很好，做小主持人也很照顾其他小孩，但他对wjk真的不一样。。。。初恋之枪眼神很经典，暗暗帮wjk弄破气球，希望他比自己高，无条件偏向wjk等等，我当时和朋友说好担心小源求而不得玉玉，他喜欢wjk蛮明显，但wjk应该身体比心理先开窍，摔跤喂饭太多亲密动作了，说出口的话又是把小源看成小孩子和弟弟在照顾……\n\n\n⬇️",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "果然粉丝是最懂的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "20",
  },
  {
    id: 966,
    user_face: "966-user-face.png",
    user_id: "洁白无瑕伍嘉成",
    is_op: false,
    create_at: "2022-12-30 18:01:16 福建",
    quote: {
      quote_status: true,
      quote_content: "我i3朋友说。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "966-quote.png",
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "29",
  },
  {
    id: 967,
    user_face: "967-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-30 18:01:51 陕西",
    quote: {
      quote_status: true,
      quote_content: "我i3朋友说。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "967-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "哈哈哈哈哈哈。。。。和善的丈母娘和。。。。心碎的女友粉。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "143",
  },
  {
    id: 968,
    user_face: "968-user-face.png",
    user_id: "他即海中鸟",
    is_op: false,
    create_at: "2022-12-30 18:05:17 山东",
    quote: {
      quote_status: true,
      quote_content:
        "带这么多东西仿佛是去提亲的。。。可惜提亲的袋子上全都是路飞。。。可能丈母娘没同意就是因为这些袋子。。。🥲",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "笑死我了哥哥。。。。热爱海贼王和老婆的给子一枚呀。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "124",
  },
  {
    id: 969,
    user_face: "969-user-face.png",
    user_id: "贫尼甘露寺静白",
    is_op: false,
    create_at: "2022-12-30 18:08:19 河南",
    quote: {
      quote_status: true,
      quote_content:
        "每个没看lucky舞台的人我都会伤心。。。ok？？？。。。太娇了。。和好朋友谈恋爱就这么开心是吧。。。。【【DARKSTAR王俊凯】180922 《lucky》focus-哔哩哔哩】 https://b23.tv/y0RzCzH",
      quote_user_id: "兔兔与猫猫",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "969-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "王俊凯荡漾不亖你。。每个i3都要感谢王源 你们天天发春做梦王俊凯的好几张图 背后都是他对着王源 每个鲜活的王俊凯少不了王源在身边助力",
      cmt_img: {
        cmt_img_status: true,
        is_gif: true,
        cmt_img_src: "969-cmt.png",
      },
    },
    like_cnt: "232",
  },
  {
    id: 970,
    user_face: "970-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 18:11:19 山东",
    quote: {
      quote_status: true,
      quote_content:
        "王俊凯荡漾不亖你。。每个i3都要感谢王源 你们天天发春做梦王俊凯的好几张图 背后都是他对着王源 每个鲜活的王俊凯少不了王源在身边助力",
      quote_user_id: "贫尼甘露寺静白",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "970-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "小时候绿光。。。长大点儿lucky。。。从开始到未来都是恋爱脑小哥哥一枚呀。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: true,
        cmt_img_src: "970-cmt.png",
      },
    },
    like_cnt: "192",
  },
  {
    id: 971,
    user_face: "971-user-face.png",
    user_id: "练习生（已在读",
    is_op: false,
    create_at: "2022-12-30 18:12:53 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "被楼上最近的那个i2哥哥写得很想哭不知道为什么。。。。就。。。这么多年了。。。如果非要是一个的话。。。就他俩吧。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "197",
  },
  {
    id: 972,
    user_face: "972-user-face.png",
    user_id: "纾之实",
    is_op: false,
    create_at: "2022-12-30 18:18:16 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "而且这个鞋不是有人偶遇他们七夕节去实体店买的吗（貌似没有图。。。主要他们俩那种私下被路人偶遇的图挺多的。。。有些记混了。。。而且这个算是没有锤的料吧。。。）",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "其实有的。。。偶遇图。。。只不过是在大街上。。。不是店里。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "116",
  },
  {
    id: 973,
    user_face: "973-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 18:18:55 四川",
    quote: {
      quote_status: true,
      quote_content:
        "其实有的。。。偶遇图。。。只不过是在大街上。。。不是店里。。。",
      quote_user_id: "纾之实",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "973-quote.png",
      },
    },
    cmt: {
      cmt_content: "对。。。这个我知道。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "25",
  },
  {
    id: 974,
    user_face: "974-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 18:19:06 北京",
    quote: {
      quote_status: true,
      quote_content:
        "其实wjk很好的，踏实不乱来不喜欢娱乐圈乱七八糟的社交，虽然有点嘴笨爱管东管西，但不能否认把小源交给他的确放心。小源应该喜欢他很久了，我觉得是小源先动心的，他喜欢就好，如果对象一定要是男的，那我只接受王俊凯。。凯源是真的就祝福他们永远相爱，永远幸福。\n\n\n\n🔚\n\n\n这位哥哥是。。。和善的丈母娘一枚呀。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "被全世界祝福的小情侣。。。。很多人都说希望这对结婚。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "128",
  },
  {
    id: 975,
    user_face: "975-user-face.png",
    user_id: "贫尼甘露寺静白",
    is_op: false,
    create_at: "2022-12-30 18:19:12 河南",
    quote: {
      quote_status: true,
      quote_content:
        "王俊凯荡漾不亖你。。每个i3都要感谢王源 你们天天发春做梦王俊凯的好几张图 背后都是他对着王源 每个鲜活的王俊凯少不了王源在身边助力",
      quote_user_id: "贫尼甘露寺静白",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "975-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "i3你帮着磕糖的那30s你是不是在想成全他们呢 还是成全他们呢 还是成全他们呢。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "975-cmt.png",
      },
    },
    like_cnt: "185",
  },
  {
    id: 976,
    user_face: "976-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 18:22:03 广东",
    quote: {
      quote_status: true,
      quote_content:
        "小时候绿光。。。长大点儿lucky。。。从开始到未来都是恋爱脑小哥哥一枚呀。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "976-quote.png",
      },
    },
    cmt: {
      cmt_content: "i2哥哥的投稿。。。是都很会扭的小情侣一对呀。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: true,
        cmt_img_src: "976-cmt.png",
      },
    },
    like_cnt: "160",
  },
  {
    id: 977,
    user_face: "977-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 18:23:17 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我去 第一次嗑那个毛领衣服的🍭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "18",
  },
  {
    id: 978,
    user_face: "978-user-face.png",
    user_id: "草莓味",
    is_op: false,
    create_at: "2022-12-30 18:24:09 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好热闹。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 979,
    user_face: "979-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 18:32:37 重庆",
    quote: {
      quote_status: true,
      quote_content: "配套的。。。i2瑞萍。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "979-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "可是。。。王俊凯做饭很好吃。。。🥺（不是裸奔 观中餐厅等一系列综艺有感）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "188",
  },
  {
    id: 980,
    user_face: "980-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 18:35:43 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "来自组外哥哥的投稿",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "216",
  },
  {
    id: 981,
    user_face: "981-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 18:36:19 山东",
    quote: {
      quote_status: true,
      quote_content:
        "可是。。。王俊凯做饭很好吃。。。🥺（不是裸奔 观中餐厅等一系列综艺有感）",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。二字也认证过。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "154",
  },
  {
    id: 982,
    user_face: "982-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 18:36:25 重庆",
    quote: {
      quote_status: true,
      quote_content: "想问一下，你们说的小说y白的原型ky这个是真的吗🥺✌️想去看",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "黄锐写的，90%是真的，还有10%是因为现实更甜黄锐不敢写上来啦🥰",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "160",
  },
  {
    id: 983,
    user_face: "983-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 18:39:15 四川",
    quote: {
      quote_status: true,
      quote_content: "补321wjk的图一张",
      quote_user_id: "邢鹿男",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "983-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "一直觉得这张图超有氛围感\n“千万人欢呼什么我不在意，我只看向你眼底”",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "189",
  },
  {
    id: 984,
    user_face: "984-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 18:42:46 福建",
    quote: {
      quote_status: true,
      quote_content: "哥哥。。。二字也认证过。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "二字是不是自己觉得三字做的好吃。。。他去的店也一定好吃。。。结果去了大踩雷。。。还要哄“哥哥推荐的真的好吃”。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "237",
  },
  {
    id: 985,
    user_face: "985-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 18:53:41 四川",
    quote: {
      quote_status: true,
      quote_content:
        "非常赞同楼主朋友的大框架，但是17年18年真的发生了太多事情，我总感觉💙高考、成立个人工作室和成年都是非常重要的阶段，这三个阶段过后，例如💚17岁生日，准备生日会场、发微博有🤟🏻这个手势、卡点两个人生日、黑天鹅挚爱蛋糕……都太不对劲了……可能还在纠结阶段，但是一定和恋爱时代的时候不一样了。也是17年底拍天坑的时候，北京大连往返总是改签。例如冬至那天22会考完突然买票回北京，33突然就改签这样的情况经常发生。然后18年开年33一直在拍戏嘛，每一次回北京都特地打扮，也不是说平时不打扮，但是33身上很少会出现配饰，放肆一下那次他戴了金丝眼镜还戴了毛线帽（Jesus我再感叹一下），接着就出现了卡地亚。时间线拉后一点，7月33在机场故意撸袖子露出来一块表（22是品牌大使33有其他表的代言），接着有了为爱改签的八月，然后再往后33进了新的组，有假就回北京，发生了很多次换口罩，也包括拎过22给粉丝送蛋糕的那家品牌的包装袋……包括22生日当天33没能回去，但是剧组有假之后马上就回北京了，就待了一天又回去拍戏。然后基本上没有穿过supreme的33在回北京那天穿了（早上发生的事情就不带第三人出场了），然后很少发生活视频的33自己在微博发了乐高的一地狼藉，同时22在柏林电影节接受采访的时候说对乐高感兴趣。那段时间真的很微妙啊啊啊啊啊！就是很浓的情侣感有没有人懂我！紧接着就到了最精彩的19年……所以我的总结是17年是非常拉扯戳窗户纸的一年，18年可以说是很热恋疯狂开屏的一年，也正是这两年的积累才会有决定出国之后的拉扯。19年不用说了大家都知道很痛，但是18年的精彩比较少有人讲啊啊啊啊有没有人写写18年",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "而且他发乐高散落一地的那天晚上wy在和魏大勋约饭。。。一些吃醋小心思哟。。。是帮对象收拾残局的爹系男友一枚吖。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "210",
  },
  {
    id: 986,
    user_face: "986-user-face.png",
    user_id: "sowhat",
    is_op: false,
    create_at: "2022-12-30 18:55:44 广西",
    quote: {
      quote_status: true,
      quote_content: "来自组外哥哥的投稿",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "986-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "讲真。。两个都能赚钱，且赚的💰相当，不存在一般明星女强男弱，男强女弱的财产分配问题。。。这种搭配最优配了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "230",
  },
  {
    id: 987,
    user_face: "987-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 18:57:59 重庆",
    quote: {
      quote_status: true,
      quote_content: "接楼上。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "987-quote.png",
      },
    },
    cmt: {
      cmt_content: "突然不知道i2i3谁更惨，反正道济稳稳的幸福",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "134",
  },
  {
    id: 988,
    user_face: "988-user-face.png",
    user_id: "甜到掉牙啦",
    is_op: false,
    create_at: "2022-12-30 18:58:04 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "喜欢，多来一点",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 989,
    user_face: "989-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2022-12-30 19:02:54 河南",
    quote: {
      quote_status: true,
      quote_content:
        "而且他发乐高散落一地的那天晚上wy在和魏大勋约饭。。。一些吃醋小心思哟。。。是帮对象收拾残局的爹系男友一枚吖。。。",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "想上岛了，真是按头磕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "61",
  },
  {
    id: 990,
    user_face: "990-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 19:03:16 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "我有点子印象！。。。。当时这句321wjk一出来，整个豆瓣全是蓝绿贴。。。大家都get到了那种微妙情绪。。。。而且他喊4只喊了321qx，感觉就是，他喊了wjk之后现场炸了，他才在那儿有点慌的找补。。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "是的他没有喊4字全名，咋了满4-2吗？而且在一些重大场合，比如颁奖典礼，大家都是全名的呀对叭。这是我一直都觉得他是只想喊33的点。再者我复盘看这时候的33，他是一开始很懵很震惊的一个表情，不知道22在干嘛，反应过来之后（这时候已经喊完qx准备喊TFBOYS）他其实眸含泪光...是真的，各位哥哥都可以去看，他当时真的被感动到眼睛发亮了🥺",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "196",
  },
  {
    id: 991,
    user_face: "991-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 19:06:42 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "二字是不是自己觉得三字做的好吃。。。他去的店也一定好吃。。。结果去了大踩雷。。。还要哄“哥哥推荐的真的好吃”。。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥你是懂怎么拱火的哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "86",
  },
  {
    id: 992,
    user_face: "992-user-face.png",
    user_id: "大花🌸",
    is_op: false,
    create_at: "2022-12-30 19:09:04 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "i3你帮着磕糖的那30s你是不是在想成全他们呢 还是成全他们呢 还是成全他们呢。。",
      quote_user_id: "贫尼甘露寺静白",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "992-quote.png",
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈，笑死，不孝子",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "78",
  },
  {
    id: 993,
    user_face: "993-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 19:10:39 四川",
    quote: {
      quote_status: true,
      quote_content:
        "关于三字没轻重的开玩笑。。两个人冷战。。从Roy6设定和故事中可以看出二字的态度。。。劳迪是云，莱阳是小太阳。。。莱阳发光的时候有时候会把劳迪蒸发掉。。。劳迪会打闹把莱阳淋湿成落汤小狮子。。。主持人：那劳迪下雨不会让莱阳的火熄灭吗。。。二字：不会不会是朋友开玩笑",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "王源真的尽可能把他们的故事用歌也好漫画也好甚至是动画也好 讲述了一些些 虽然只是冰山一角 但是已经是他可以做到的最大限度了。。。劳迪是你 彩虹云朵是你 也只有王俊凯是这个你。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "183",
  },
  {
    id: 994,
    user_face: "994-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-30 19:12:36 云南",
    quote: {
      quote_status: true,
      quote_content:
        "i3你帮着磕糖的那30s你是不是在想成全他们呢 还是成全他们呢 还是成全他们呢。。",
      quote_user_id: "贫尼甘露寺静白",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "994-quote.png",
      },
    },
    cmt: {
      cmt_content: "笑死我了。。。。暴躁婆婆。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "45",
  },
  {
    id: 995,
    user_face: "995-user-face.png",
    user_id: "暹罗神偷高卿尘",
    is_op: false,
    create_at: "2022-12-30 19:13:42 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑多少次都想流泪。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "38",
  },
  {
    id: 996,
    user_face: "996-user-face.png",
    user_id: "满杯百香果",
    is_op: false,
    create_at: "2022-12-30 19:16:08 贵州",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哇 看帖子的时候不知道为什么脑子里面一直是这句歌词“所以那些可能都会是真的”",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "133",
  },
  {
    id: 997,
    user_face: "997-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 19:17:37 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "接明天跨年夜俩人发疯。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "180",
  },
  {
    id: 998,
    user_face: "998-user-face.png",
    user_id: "INTO1-叶舒华",
    is_op: false,
    create_at: "2022-12-30 19:22:45 天津",
    quote: {
      quote_status: true,
      quote_content:
        "而且他发乐高散落一地的那天晚上wy在和魏大勋约饭。。。一些吃醋小心思哟。。。是帮对象收拾残局的爹系男友一枚吖。。。",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "而且白天那个事件之后……22发了一个和灭火器的自拍……灭火……接着就是那个在33车上自拍……就很妙……说18年很be感的都是错误的！！！！18年恋爱感真的超级无敌重",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "176",
  },
  {
    id: 999,
    user_face: "999-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 19:30:20 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "哥哥们。。。复活卡是截个图就行吗。。。还是需要去哪里认领啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "45",
  },
  {
    id: 1000,
    user_face: "1000-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 19:31:39 美国",
    quote: {
      quote_status: true,
      quote_content: "想上岛了，真是按头磕",
      quote_user_id: "一颗桑葚",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "欢迎哥哥。。。岛史三天三夜也看不完。。。稳稳的幸福。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "78",
  },
  {
    id: 1001,
    user_face: "1001-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 19:32:54 山东",
    quote: {
      quote_status: true,
      quote_content:
        "而且白天那个事件之后……22发了一个和灭火器的自拍……灭火……接着就是那个在33车上自拍……就很妙……说18年很be感的都是错误的！！！！18年恋爱感真的超级无敌重",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。白天什么事件。。。让我嗑嗑🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 1002,
    user_face: "1002-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 19:34:54 美国",
    quote: {
      quote_status: true,
      quote_content:
        "王俊凯荡漾不亖你。。每个i3都要感谢王源 你们天天发春做梦王俊凯的好几张图 背后都是他对着王源 每个鲜活的王俊凯少不了王源在身边助力",
      quote_user_id: "贫尼甘露寺静白",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1002-quote.png",
      },
    },
    cmt: {
      cmt_content: "说到荡漾那就不得不提这张图。。。33你不要太明显咯。。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1002-cmt.png",
      },
    },
    like_cnt: "144",
  },
  {
    id: 1003,
    user_face: "1003-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 19:36:50 北京",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥们。。。复活卡是截个图就行吗。。。还是需要去哪里认领啊。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "截图保存就行。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 1004,
    user_face: "1004-user-face.png",
    user_id: "INTO1-叶舒华",
    is_op: false,
    create_at: "2022-12-30 19:37:12 天津",
    quote: {
      quote_status: true,
      quote_content: "哥哥。。。白天什么事件。。。让我嗑嗑🤤",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "呜呜呜不想提别人，其实就是22那时候很喜欢supreme嘛，有个人微博艾特22看supreme的啥视频，当然22也没有回复。22灭火瓶自拍发了之后晚上33回北京就穿了supreme的衣服，他在那之前几乎没有穿过捏。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "140",
  },
  {
    id: 1005,
    user_face: "1005-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 19:38:12 山东",
    quote: {
      quote_status: true,
      quote_content:
        "呜呜呜不想提别人，其实就是22那时候很喜欢supreme嘛，有个人微博艾特22看supreme的啥视频，当然22也没有回复。22灭火瓶自拍发了之后晚上33回北京就穿了supreme的衣服，他在那之前几乎没有穿过捏。",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "谢谢哥哥。。。瞬间有get到。。。嗑亖。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "34",
  },
  {
    id: 1006,
    user_face: "1006-user-face.png",
    user_id: "极光辐能聚集",
    is_op: false,
    create_at: "2022-12-30 19:44:36 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "i3你帮着磕糖的那30s你是不是在想成全他们呢 还是成全他们呢 还是成全他们呢。。",
      quote_user_id: "贫尼甘露寺静白",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1006-quote.png",
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 1007,
    user_face: "1007-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 19:46:19 广东",
    quote: {
      quote_status: true,
      quote_content: "截图保存就行。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "谢谢哥哥。。。是1k条对吗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 1008,
    user_face: "1008-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 19:46:53 山东",
    quote: {
      quote_status: true,
      quote_content: "谢谢哥哥。。。是1k条对吗。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。点赞1000也算。。。建议录屏保存。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 1009,
    user_face: "1009-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 19:49:19 广东",
    quote: {
      quote_status: true,
      quote_content: "哥哥。。。点赞1000也算。。。建议录屏保存。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "那我这算两张卡吗。。。惊呆。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "41",
  },
  {
    id: 1010,
    user_face: "1010-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 19:52:14 福建",
    quote: {
      quote_status: true,
      quote_content:
        "呜呜呜不想提别人，其实就是22那时候很喜欢supreme嘛，有个人微博艾特22看supreme的啥视频，当然22也没有回复。22灭火瓶自拍发了之后晚上33回北京就穿了supreme的衣服，他在那之前几乎没有穿过捏。",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "嗯。。。想到一些唯粉拉瓜。。。掐头去尾地假装有得嗑。。。无所谓。。。三字会出手。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "133",
  },
  {
    id: 1011,
    user_face: "1011-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 19:53:59 四川",
    quote: {
      quote_status: true,
      quote_content:
        "其实有的。。。偶遇图。。。只不过是在大街上。。。不是店里。。。",
      quote_user_id: "纾之实",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1011-quote.png",
      },
    },
    cmt: {
      cmt_content: "终于找到了",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1011-cmt.png",
      },
    },
    like_cnt: "77",
  },
  {
    id: 1012,
    user_face: "1012-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 19:56:09 四川",
    quote: {
      quote_status: true,
      quote_content:
        "突然想到一个。。。。。当时不嗑。。道济给我放了一个语音。。。是💚撒娇说。。凯凯你怎么还不回来。。。我两只耳朵都听到了。。。具体时间地点情况都忘记了但是这句话记忆深刻。。。",
      quote_user_id: "mxghj",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "还有“你哥对你弟说了情人节快乐”\n有爆料截图。。。但是找半天没找到。。。是拍少年时代的时候。。。这个语音我听不到也死不瞑目。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "132",
  },
  {
    id: 1013,
    user_face: "1013-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 19:58:35 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "那一天王俊凯听的歌也很好品。。。有兴趣的哥哥可以去听一下。。。开心得嘞。。。“他表现出来的开心那就是真的超开心了”。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "125",
  },
  {
    id: 1014,
    user_face: "1014-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 20:06:40 四川",
    quote: {
      quote_status: true,
      quote_content:
        "我听过！！好像是打游戏还是在酒店来着我忘了（如果没记错的话。。。）",
      quote_user_id: "joji",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "说到酒店打游戏我就想起来了！我也知道这个！但是没听过录音😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "31",
  },
  {
    id: 1015,
    user_face: "1015-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-30 20:11:41 湖北",
    quote: {
      quote_status: true,
      quote_content:
        "那一天王俊凯听的歌也很好品。。。有兴趣的哥哥可以去听一下。。。开心得嘞。。。“他表现出来的开心那就是真的超开心了”。。。",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1015-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "这首歌我前几年单曲循环好久。。。甜得发腻。。。看来确实开心得勒。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "70",
  },
  {
    id: 1016,
    user_face: "1016-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 20:12:09 四川",
    quote: {
      quote_status: true,
      quote_content:
        "有点印象 。。。道济手上这种东西不少吧 。。还有ss打电话给2结果是3接的录音啥的。。。还有2还是3大早上7点过赶飞机另一个没行程但是起来陪着打游戏啥的 。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "这种料全听过。。。就是不见锤。。。无所谓。。。最终的结局怎么样。。。这些过期🍬的锤我也还是会等。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "75",
  },
  {
    id: 1017,
    user_face: "1017-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 20:14:33 四川",
    quote: {
      quote_status: true,
      quote_content:
        "还有“你哥对你弟说了情人节快乐”\n有爆料截图。。。但是找半天没找到。。。是拍少年时代的时候。。。这个语音我听不到也死不瞑目。。。",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "有好心哥哥私信的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "129",
  },
  {
    id: 1018,
    user_face: "1018-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 20:18:38 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "接投稿：我看到有uu发的33很荡漾那场，除了我们都看过的那个回头撩22的动图，还有一张这个。。💙这小子那天可夸张。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "219",
  },
  {
    id: 1019,
    user_face: "1019-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 20:18:54 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "是上面的一位i2哥哥的续投稿。。。感谢哥哥。。。\n\n投稿\n“提到劳迪莱阳，真的是按头嗑啊，道济到今年才后知后觉，这两个名字是不是出自于劳斯莱斯那首歌”\n\n\n图\n\n⬇️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "124",
  },
  {
    id: 1020,
    user_face: "1020-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 20:19:43 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "“友情”和“友情”\n\n图\n\n⬇️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "99",
  },
  {
    id: 1021,
    user_face: "1021-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 20:20:33 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "这是劳斯莱斯的歌词，讲同性的，“能成为密友大概总带着爱” 放上《彩虹云朵》歌词，这首歌出了没多久💙就唱了《夏天》：在这片天空，云朵就是我。。。\n\n图\n\n⬇️",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "120",
  },
  {
    id: 1022,
    user_face: "1022-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 20:21:00 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "“来看看💙怎么认领劳迪的。。。”\n\n🔚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "158",
  },
  {
    id: 1023,
    user_face: "1023-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-30 20:21:37 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "👆是i2哥哥对于。。。22的歌和公仔的。。。解读。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "85",
  },
  {
    id: 1024,
    user_face: "1024-user-face.png",
    user_id: "贫尼甘露寺静白",
    is_op: false,
    create_at: "2022-12-30 20:26:26 河南",
    quote: {
      quote_status: true,
      quote_content: "同一家馆子的投稿。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1024-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "配平。。咱就是说i2i3没事不要随便去打卡。。以免碰见情敌。。哈哈哈",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1024-cmt.png",
      },
    },
    like_cnt: "246",
  },
  {
    id: 1025,
    user_face: "1025-user-face.png",
    user_id: "1987哇哈哈AD钙",
    is_op: false,
    create_at: "2022-12-30 20:32:58 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "是上面的一位i2哥哥的续投稿。。。感谢哥哥。。。\n\n投稿\n“提到劳迪莱阳，真的是按头嗑啊，道济到今年才后知后觉，这两个名字是不是出自于劳斯莱斯那首歌”\n\n\n图\n\n⬇️",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1025-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "说到此，今天莱阳（生日：9月21日）出了兔年联名。。。。是谁属兔我不说。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "236",
  },
  {
    id: 1026,
    user_face: "1026-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 20:35:36 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "而且22自己说过的有对象会为TA在七夕节发歌。结果他真的在七夕节发歌了。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "236",
  },
  {
    id: 1027,
    user_face: "1027-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 20:39:36 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好嗑。。谁还没嗑。。。希望这个帖子能活久一点 这对我很重要🥹",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "73",
  },
  {
    id: 1028,
    user_face: "1028-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 21:02:45 福建",
    quote: {
      quote_status: true,
      quote_content:
        "说到此，今天莱阳（生日：9月21日）出了兔年联名。。。。是谁属兔我不说。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥应该补充。。。大头煎饼没有生肖限定过还是几年没限定。。。忘了。。。但是一到兔年就限定。。。是谁属兔我不说。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "164",
  },
  {
    id: 1029,
    user_face: "1029-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 21:08:50 四川",
    quote: {
      quote_status: true,
      quote_content:
        "带这么多东西仿佛是去提亲的。。。可惜提亲的袋子上全都是路飞。。。可能丈母娘没同意就是因为这些袋子。。。🥲",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "长大后送的就高大上了哈哈哈哈。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 1030,
    user_face: "1030-user-face.png",
    user_id: "Never",
    is_op: false,
    create_at: "2022-12-30 21:10:15 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕亖。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 1031,
    user_face: "1031-user-face.png",
    user_id: "大花🌸",
    is_op: false,
    create_at: "2022-12-30 21:20:09 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "接投稿：我看到有uu发的33很荡漾那场，除了我们都看过的那个回头撩22的动图，还有一张这个。。💙这小子那天可夸张。。。。",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1031-quote.png",
      },
    },
    cmt: {
      cmt_content: "这里两人的表现都很好品。。。尤其是3，好荡漾。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "127",
  },
  {
    id: 1032,
    user_face: "1032-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 21:26:44 四川",
    quote: {
      quote_status: true,
      quote_content:
        "第二位i2哥哥的投稿\n\n（非常戳她的一些🍬点汇总\n\n1⃣️关于22 smoking\n\n“楼主我要给你激情投稿！！！我从前，19年22抽烟的那个事我还是个吃瓜路人，我亲眼见证了33秒撤了“wjk举报老师抽烟”的rs，一刷新词条就掉下去了……当初给本路人的观感就是23感情是真的好，这个时候竟然没有“趁你病要你命”，对比一下44的“禁烟大使”rs，真的不要太鲜明了。而且我也比较奇葩，因为这个事我竟然成了2的路好，理由是觉得抽个烟怎么被黑成这样，那是真的没啥可黑了。。。再后来成了i2，然后开始疯狂扒塌房对象。。。扒出来的人居然是3。。。我整个人都恍惚了。。。后来再回忆起撤热搜那个事。。。我更恍惚了。。。谁知道这背后是一段情呢🚬”\n\n\n\n。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "值得划重点的是这个不重要的热搜以前上过。。。第二次上还直奔着热搜第一去的。。。懂得都懂😂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "87",
  },
  {
    id: 1033,
    user_face: "1033-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2022-12-30 21:29:44 河南",
    quote: {
      quote_status: true,
      quote_content: "有好心哥哥私信的",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1033-quote.png",
      },
    },
    cmt: {
      cmt_content: "斯哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 1034,
    user_face: "1034-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2022-12-30 21:32:58 河南",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥应该补充。。。大头煎饼没有生肖限定过还是几年没限定。。。忘了。。。但是一到兔年就限定。。。是谁属兔我不说。。。",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "呜呜呜",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 1035,
    user_face: "1035-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 21:34:02 四川",
    quote: {
      quote_status: true,
      quote_content: "这个好像给cp站子给过to签",
      quote_user_id: "啦啦卡啦卡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "92",
  },
  {
    id: 1036,
    user_face: "1036-user-face.png",
    user_id: "糖窝窝",
    is_op: false,
    create_at: "2022-12-30 21:46:36 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑死我了。。。逼着我上岛。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "25",
  },
  {
    id: 1037,
    user_face: "1037-user-face.png",
    user_id: "钮祜禄•安宥真",
    is_op: false,
    create_at: "2022-12-30 21:49:02 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕。。。越磕越有。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 1038,
    user_face: "1038-user-face.png",
    user_id: "顽皮炸鸡",
    is_op: false,
    create_at: "2022-12-30 21:52:38 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "存一个。。。慢慢看 不知道别的 反正道济稳稳的幸福🈶😇😇😇",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "31",
  },
  {
    id: 1039,
    user_face: "1039-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 21:56:40 四川",
    quote: {
      quote_status: true,
      quote_content:
        "都说y白写的东西过几年都对上了。。所以有没有y白和凯源的对应贴给我磕磕啊🥺🥺我已经看完岛经了，我同意确实就是凯源",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "https://www.douban.com/group/topic/247328124/?_i=724081887a38aa3",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 1040,
    user_face: "1040-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 21:57:29 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕一个",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1041,
    user_face: "1041-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 22:01:27 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "莱斯莱斯。。。我第一次磕。。。好家伙太真了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "21",
  },
  {
    id: 1042,
    user_face: "1042-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 22:01:30 重庆",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1042-quote.png",
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1042-cmt.png",
      },
    },
    like_cnt: "67",
  },
  {
    id: 1043,
    user_face: "1043-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 22:04:02 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1044,
    user_face: "1044-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 22:05:01 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "还有一个很戳我的糖，但是没多少人提😭就是六周年小黑屋，当时33转头对着22唱了一句“I'm in love with you”，22当时回了一句“I love you, too”，但是这个字幕没打出来，而且当时说话的人挺多的，33唱完那句在笑，别的人也在笑，需要很认真听才听得见，不过真的是可以听得到的😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "183",
  },
  {
    id: 1045,
    user_face: "1045-user-face.png",
    user_id: "磕下这颗糖",
    is_op: false,
    create_at: "2022-12-30 22:05:38 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1046,
    user_face: "1046-user-face.png",
    user_id: "芝士多肉桃桃",
    is_op: false,
    create_at: "2022-12-30 22:07:04 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1047,
    user_face: "1047-user-face.png",
    user_id: "没人替你上班",
    is_op: false,
    create_at: "2022-12-30 22:07:11 广东",
    quote: {
      quote_status: true,
      quote_content: "配套的。。。i2瑞萍。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1047-quote.png",
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈哈哈哈哈哈哈哈哈笑疯了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "28",
  },
  {
    id: 1048,
    user_face: "1048-user-face.png",
    user_id: "甜糖山无耳兔",
    is_op: false,
    create_at: "2022-12-30 22:07:55 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马一下",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1049,
    user_face: "1049-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 22:09:01 四川",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1049-quote.png",
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1049-cmt.png",
      },
    },
    like_cnt: "75",
  },
  {
    id: 1050,
    user_face: "1050-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-30 22:12:27 四川",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1050-quote.png",
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1050-cmt.png",
      },
    },
    like_cnt: "68",
  },
  {
    id: 1051,
    user_face: "1051-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 22:15:48 重庆",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1051-quote.png",
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1051-cmt.png",
      },
    },
    like_cnt: "83",
  },
  {
    id: 1052,
    user_face: "1052-user-face.png",
    user_id: "螃蟹壳子",
    is_op: false,
    create_at: "2022-12-30 22:21:46 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "wjk真被wy吃的死死的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "92",
  },
  {
    id: 1053,
    user_face: "1053-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 22:21:52 重庆",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1053-quote.png",
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1053-cmt.png",
      },
    },
    like_cnt: "48",
  },
  {
    id: 1054,
    user_face: "1054-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-30 22:21:57 重庆",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1054-quote.png",
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1054-cmt.png",
      },
    },
    like_cnt: "58",
  },
  {
    id: 1055,
    user_face: "1055-user-face.png",
    user_id: "蓝牙无杂音",
    is_op: false,
    create_at: "2022-12-30 22:27:58 黑龙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑亖。。。真越嗑越有。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "11",
  },
  {
    id: 1056,
    user_face: "1056-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 22:29:18 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "抖人瑞平一下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "179",
  },
  {
    id: 1057,
    user_face: "1057-user-face.png",
    user_id: "甜到掉牙啦",
    is_op: false,
    create_at: "2022-12-30 22:31:15 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "美美嗑药",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1058,
    user_face: "1058-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 22:37:02 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1059,
    user_face: "1059-user-face.png",
    user_id: "无余屋宇",
    is_op: false,
    create_at: "2022-12-30 22:44:53 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "😳😳😳。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1060,
    user_face: "1060-user-face.png",
    user_id: "学会挖金矿",
    is_op: false,
    create_at: "2022-12-30 22:45:50 河南",
    quote: {
      quote_status: true,
      quote_content:
        "一直觉得这张图超有氛围感\n“千万人欢呼什么我不在意，我只看向你眼底”",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "磕。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1061,
    user_face: "1061-user-face.png",
    user_id: "INTO1-叶舒华",
    is_op: false,
    create_at: "2022-12-30 22:46:29 天津",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "如图 有组外宝宝投稿 发出来给大家看看😋😋😋",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "113",
  },
  {
    id: 1062,
    user_face: "1062-user-face.png",
    user_id: "极光辐能聚集",
    is_op: false,
    create_at: "2022-12-30 22:48:02 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "还有一个很戳我的糖，但是没多少人提😭就是六周年小黑屋，当时33转头对着22唱了一句“I'm in love with you”，22当时回了一句“I love you, too”，但是这个字幕没打出来，而且当时说话的人挺多的，33唱完那句在笑，别的人也在笑，需要很认真听才听得见，不过真的是可以听得到的😭",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1062-quote.png",
      },
    },
    cmt: {
      cmt_content: "😭😭😭😭热恋吧热恋吧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "67",
  },
  {
    id: 1063,
    user_face: "1063-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 22:56:11 北京",
    quote: {
      quote_status: true,
      quote_content:
        "还有一个很戳我的糖，但是没多少人提😭就是六周年小黑屋，当时33转头对着22唱了一句“I'm in love with you”，22当时回了一句“I love you, too”，但是这个字幕没打出来，而且当时说话的人挺多的，33唱完那句在笑，别的人也在笑，需要很认真听才听得见，不过真的是可以听得到的😭",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1063-quote.png",
      },
    },
    cmt: {
      cmt_content: "能不能立刻官宣给我看啊啊啊啊啊啊啊啊。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "55",
  },
  {
    id: 1064,
    user_face: "1064-user-face.png",
    user_id: "装温柔会糊",
    is_op: false,
    create_at: "2022-12-30 22:59:59 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊马上官宣",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 1065,
    user_face: "1065-user-face.png",
    user_id: "我在长头发",
    is_op: false,
    create_at: "2022-12-30 23:06:38 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "明晚跨年倒计时 我能梦一个拥抱吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "40",
  },
  {
    id: 1066,
    user_face: "1066-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-30 23:08:16 福建",
    quote: {
      quote_status: true,
      quote_content: "如图 有组外宝宝投稿 发出来给大家看看😋😋😋",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1066-quote.png",
      },
    },
    cmt: {
      cmt_content: "呃呃呃啊啊啊没嗑过 谢谢哥哥！！！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 1067,
    user_face: "1067-user-face.png",
    user_id: "omom",
    is_op: false,
    create_at: "2022-12-30 23:09:40 河南",
    quote: {
      quote_status: true,
      quote_content: "如图 有组外宝宝投稿 发出来给大家看看😋😋😋",
      quote_user_id: "INTO1-叶舒华",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1067-quote.png",
      },
    },
    cmt: {
      cmt_content: "这都能看到。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1068,
    user_face: "1068-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 23:12:03 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "投稿：三演唱会吐舌头动图：",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "66",
  },
  {
    id: 1069,
    user_face: "1069-user-face.png",
    user_id: "很成工力",
    is_op: false,
    create_at: "2022-12-30 23:12:27 山东",
    quote: {
      quote_status: true,
      quote_content:
        "但是老实说 三字触动我的是知足 他和五月天合作那天 是二字去办签证那天 他们周年请五月天做嘉宾的时候 三字兴冲冲说二字是五月天粉丝 二字还说有机会要去演唱会 结果真的去给人家做嘉宾 却只有三字 三字和阿信合唱洋葱 这是当年他和二字街头唱歌最初红的几首 很有纪念意义对吧 但是他和阿信合唱却是唱的当年二字唱的部分 后来唱知足 他的表情真的 我不能说一定哭了 但是真的很难过 频繁望天不直视镜头 他唱洋葱的时候没这样的 “午夜徘徊时就会听知足” 这也是他自己说过的……那时候我嗑凯源还是随便蹭两口 看完知足觉得 哇不会真的是真的吧",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "投稿动图：",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "91",
  },
  {
    id: 1070,
    user_face: "1070-user-face.png",
    user_id: "练习生（已在读",
    is_op: false,
    create_at: "2022-12-30 23:17:07 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "22迫不及待分享跨年排练照片。。。怎么。。跟老公一起跨年这么开心。。知道你在澳门了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "228",
  },
  {
    id: 1071,
    user_face: "1071-user-face.png",
    user_id: "♡",
    is_op: false,
    create_at: "2022-12-30 23:18:50 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1072,
    user_face: "1072-user-face.png",
    user_id: "你可真是棒棒哟",
    is_op: false,
    create_at: "2022-12-30 23:20:29 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "大磕一口",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1073,
    user_face: "1073-user-face.png",
    user_id: "籁也滴嘛",
    is_op: false,
    create_at: "2022-12-30 23:32:01 广东",
    quote: {
      quote_status: true,
      quote_content: "投稿动图：",
      quote_user_id: "很成工力",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1073-quote.png",
      },
    },
    cmt: {
      cmt_content: "呜呜太心疼33怎么能那么心痛",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "57",
  },
  {
    id: 1074,
    user_face: "1074-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 23:39:32 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl哥哥 23kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 1075,
    user_face: "1075-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 23:39:50 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "讲真。。两个都能赚钱，且赚的💰相当，不存在一般明星女强男弱，男强女弱的财产分配问题。。。这种搭配最优配了。。。。",
      quote_user_id: "sowhat",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "从这个角度来说。。。财产收入相当确实是有利于一段关系的稳定。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "146",
  },
  {
    id: 1076,
    user_face: "1076-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-30 23:40:27 重庆",
    quote: {
      quote_status: true,
      quote_content:
        "是的他没有喊4字全名，咋了满4-2吗？而且在一些重大场合，比如颁奖典礼，大家都是全名的呀对叭。这是我一直都觉得他是只想喊33的点。再者我复盘看这时候的33，他是一开始很懵很震惊的一个表情，不知道22在干嘛，反应过来之后（这时候已经喊完qx准备喊TFBOYS）他其实眸含泪光...是真的，各位哥哥都可以去看，他当时真的被感动到眼睛发亮了🥺",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "满4-2哈哈哈哈哈哈哈哈哈，哥哥你笑到我了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "59",
  },
  {
    id: 1077,
    user_face: "1077-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-30 23:42:42 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好糖不嫌多。。。。多来点多来点。。。我要晕过去了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 1078,
    user_face: "1078-user-face.png",
    user_id: "不止是粒米",
    is_op: false,
    create_at: "2022-12-30 23:46:39 福建",
    quote: {
      quote_status: true,
      quote_content:
        "还有一个很戳我的糖，但是没多少人提😭就是六周年小黑屋，当时33转头对着22唱了一句“I'm in love with you”，22当时回了一句“I love you, too”，但是这个字幕没打出来，而且当时说话的人挺多的，33唱完那句在笑，别的人也在笑，需要很认真听才听得见，不过真的是可以听得到的😭",
      quote_user_id: "小梨哥哥抱抱",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1078-quote.png",
      },
    },
    cmt: {
      cmt_content: "嗑疯了我",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "17",
  },
  {
    id: 1079,
    user_face: "1079-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-31 00:02:48 广东",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "宋亚轩(毛绒版)",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哥哥。。。这个。。。。是不是有点。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1080,
    user_face: "1080-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 00:17:49 河南",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1080-quote.png",
      },
    },
    cmt: {
      cmt_content: "玛雅感觉💙冷到搓手了也要把外套让给老婆",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "72",
  },
  {
    id: 1081,
    user_face: "1081-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 00:19:59 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "查过组规了。。。涛这个的哥哥全删了。。。大家发言要谨慎。。。虽然小踩是。。。发疯的地方。。。但小踩是最大的娱乐组之一。。。不要说没证据还容易引战造成很大影响的东西。。。辛苦哥哥们。。。我真的很想维护好这个贴。。。毕竟虽然说寄了再发。。。但是建设很辛苦。。。\n鞠躬。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "87",
  },
  {
    id: 1082,
    user_face: "1082-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 00:34:44 河南",
    quote: {
      quote_status: true,
      quote_content:
        "💙个人演唱会\n“然后我又去8了一下3的无边界个人演唱会了。。。唱了一首《词不达意》🚬   间奏全场绿光。。。不仅绿了i3一脸也绿了i2一脸吧。。。为你们的爱情鼓鼓掌好吧。。。说实话。。。大家结构33都知道他在镜头前很少表达浓烈的情绪（和22相比。。。所以很多i2觉得💙对💚不如2对3深情。。。但词不达意这首歌。。。我第一次体会到💙确实很爱💚的，噢噢对他唱这首歌之前还说：“这首歌呢，在我身上会形容得比较准确。”说完还蛮不好意思地笑了一下。。。唱得。。很苦情的亚子。。。\n\n最好笑的是，我去b站看《词不达意》剪辑，蟹姐们7个机位愣是把绿光一点都没透出来全给剪没了，而且最前面说的那句“这首歌呢 可能在我身上形容的比较准确”也剪掉了了。。。\n\n这个绿光。。。不说蟹姐。。。我都被绿傻了”\n\n\n（我的i3朋友看到这一条被亖去的记忆攻击。。。没错。。。词不达意就是绿色的灯光和舞美。。。这个绿光和17岁那年的绿光好k程度可真是不相上下。。。\n\n\n图",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1082-quote.png",
      },
    },
    cmt: {
      cmt_content: "虽然很缺德但窝笑的想丝。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "50",
  },
  {
    id: 1083,
    user_face: "1083-user-face.png",
    user_id: "周宝璐",
    is_op: false,
    create_at: "2022-12-31 00:41:42 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑到了。。真心祝福。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 1084,
    user_face: "1084-user-face.png",
    user_id: "易烊千玺（独美",
    is_op: false,
    create_at: "2022-12-31 00:55:16 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "补一张💙动图。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "114",
  },
  {
    id: 1085,
    user_face: "1085-user-face.png",
    user_id: "飞飞_flyfly",
    is_op: false,
    create_at: "2022-12-31 00:57:15 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "别太好渴。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 1086,
    user_face: "1086-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-31 01:01:09 广东",
    quote: {
      quote_status: true,
      quote_content:
        "查过组规了。。。涛这个的哥哥全删了。。。大家发言要谨慎。。。虽然小踩是。。。发疯的地方。。。但小踩是最大的娱乐组之一。。。不要说没证据还容易引战造成很大影响的东西。。。辛苦哥哥们。。。我真的很想维护好这个贴。。。毕竟虽然说寄了再发。。。但是建设很辛苦。。。\n鞠躬。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1086-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "是的。。。我看到说三个的时候就开始瑟瑟发抖害怕楼不见了。。。感谢哥哥。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "21",
  },
  {
    id: 1087,
    user_face: "1087-user-face.png",
    user_id: "AKA初恋达人",
    is_op: false,
    create_at: "2022-12-31 01:16:25 河南",
    quote: {
      quote_status: true,
      quote_content:
        "说到此，今天莱阳（生日：9月21日）出了兔年联名。。。。是谁属兔我不说。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥，生日9月21日是什么情况。。。这不是💚出的玩偶吗？921不是💙的生日吗🥹是💚设定玩偶生日是921吗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "57",
  },
  {
    id: 1088,
    user_face: "1088-user-face.png",
    user_id: "momo（磕药机版",
    is_op: false,
    create_at: "2022-12-31 01:19:49 四川",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "“我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。”磕到想亖。。22真的敏感早慧（防安利公共场所抽华子🚬）。。他其实更先知道到底是兄弟还是恋人而且知道自己动了心。。但他了解33。。知道他其实还没有意识到这是什么所以害怕。。。\n",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "116",
  },
  {
    id: 1089,
    user_face: "1089-user-face.png",
    user_id: "泽一今天吃什么",
    is_op: false,
    create_at: "2022-12-31 01:19:52 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1090,
    user_face: "1090-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 01:27:16 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "刚刚有另一个艾二哥哥投稿。。我给放上来。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 1091,
    user_face: "1091-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 01:28:45 重庆",
    quote: {
      quote_status: true,
      quote_content: "刚刚有另一个艾二哥哥投稿。。我给放上来。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1091-quote.png",
      },
    },
    cmt: {
      cmt_content: "补图。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1091-cmt.png",
      },
    },
    like_cnt: "16",
  },
  {
    id: 1092,
    user_face: "1092-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 01:29:31 重庆",
    quote: {
      quote_status: true,
      quote_content: "刚刚有另一个艾二哥哥投稿。。我给放上来。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1092-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "再补。。。不知道这图啥意思。。。有了解的哥哥可以解答一下。。。",
      cmt_img: {
        cmt_img_status: true,
        is_gif: true,
        cmt_img_src: "1092-cmt.png",
      },
    },
    like_cnt: "30",
  },
  {
    id: 1093,
    user_face: "1093-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 01:30:20 重庆",
    quote: {
      quote_status: true,
      quote_content: "刚刚有另一个艾二哥哥投稿。。我给放上来。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1093-quote.png",
      },
    },
    cmt: {
      cmt_content: "然后这位艾二哥哥说自己去打分的时候很无语。。并发出疑问",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1093-cmt.png",
      },
    },
    like_cnt: "46",
  },
  {
    id: 1094,
    user_face: "1094-user-face.png",
    user_id: ".",
    is_op: false,
    create_at: "2022-12-31 01:32:16 澳大利亚",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "哪位道济给我讲讲他们拉扯的过程。。。我好喜欢虐虐的。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 1095,
    user_face: "1095-user-face.png",
    user_id: "momo（磕药机版",
    is_op: false,
    create_at: "2022-12-31 01:36:07 四川",
    quote: {
      quote_status: true,
      quote_content: "嗑疯了我",
      quote_user_id: "不止是粒米",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "这里我记得很清楚的是22还慌张到咬手指",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 1096,
    user_face: "1096-user-face.png",
    user_id: "限定四月",
    is_op: false,
    create_at: "2022-12-31 01:38:54 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "再补。。。不知道这图啥意思。。。有了解的哥哥可以解答一下。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1096-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "听说是吵架了俩人 然后💙拉💚进小房间 然后关门的那瞬间 里面的灯黑了(应该是看发光手表⌚哈哈哈哈哈哈哈哈哈)",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "142",
  },
  {
    id: 1097,
    user_face: "1097-user-face.png",
    user_id: "限定四月",
    is_op: false,
    create_at: "2022-12-31 01:39:09 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "听说是吵架了俩人 然后💙拉💚进小房间 然后关门的那瞬间 里面的灯黑了(应该是看发光手表⌚哈哈哈哈哈哈哈哈哈)",
      quote_user_id: "限定四月",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "出来了之后貌似就和好了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "40",
  },
  {
    id: 1098,
    user_face: "1098-user-face.png",
    user_id: "纾之实",
    is_op: false,
    create_at: "2022-12-31 01:41:08 湖南",
    quote: {
      quote_status: true,
      quote_content:
        "再补。。。不知道这图啥意思。。。有了解的哥哥可以解答一下。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1098-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "是他俩在机场，外面全是粉丝，。。。这个小房间只有他们两个人，哥哥你注意看工作人员关门的时候，有个手伸过去把房间的灯关了。。。这个房间一直到要走了，他俩才开门出来。。。反正就是到现在也不知道他俩当时在里面干嘛，还需要关灯",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "159",
  },
  {
    id: 1099,
    user_face: "1099-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 02:13:53 北京",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥，生日9月21日是什么情况。。。这不是💚出的玩偶吗？921不是💙的生日吗🥹是💚设定玩偶生日是921吗。。。",
      quote_user_id: "AKA初恋达人",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "76",
  },
  {
    id: 1100,
    user_face: "1100-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2022-12-31 02:31:06 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "我说一个，当年他们🔥，每年团演唱会和生日会我都看（纯跟风狗），三字唱词不达意那年是刚高考完吧？他一唱我就咯噔了，比他们大十多年，当时我就觉得三字肯定谈恋爱了，要么暧昧阶段，然后我八卦去贴吧翻私生贴（超话不能发私物料，老粉应该都知道我在说哪几个贴吧）由于当年都觉得他们直男，我只想到是高中女同学还是大学女同学。。。但是连爆料贴，知乎爆料也翻了，找不到瓜。。\n然后二字唱我怀念的，我也咯噔了，好家伙你也谈恋爱？同样，二字也翻不来瓜，所以后来有段时间我都等着他们哪天爆女朋友塌房。。。（i2i3别骂我\n直到二字唱血腥爱情故事（这是这首吗？）就是重庆话rap那首，rap应该是他写的吧？很离谱，“你凭啥子拽嘛”这不就是在说三字吗。。。\n就，逻辑通了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "187",
  },
  {
    id: 1101,
    user_face: "1101-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-31 02:37:46 福建",
    quote: {
      quote_status: true,
      quote_content:
        "我说一个，当年他们🔥，每年团演唱会和生日会我都看（纯跟风狗），三字唱词不达意那年是刚高考完吧？他一唱我就咯噔了，比他们大十多年，当时我就觉得三字肯定谈恋爱了，要么暧昧阶段，然后我八卦去贴吧翻私生贴（超话不能发私物料，老粉应该都知道我在说哪几个贴吧）由于当年都觉得他们直男，我只想到是高中女同学还是大学女同学。。。但是连爆料贴，知乎爆料也翻了，找不到瓜。。\n然后二字唱我怀念的，我也咯噔了，好家伙你也谈恋爱？同样，二字也翻不来瓜，所以后来有段时间我都等着他们哪天爆女朋友塌房。。。（i2i3别骂我\n直到二字唱血腥爱情故事（这是这首吗？）就是重庆话rap那首，rap应该是他写的吧？很离谱，“你凭啥子拽嘛”这不就是在说三字吗。。。\n就，逻辑通了",
      quote_user_id: "已注销",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "笑死。。。。哥哥。。。你这属于灯下黑了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "86",
  },
  {
    id: 1102,
    user_face: "1102-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-31 02:38:23 福建",
    quote: {
      quote_status: true,
      quote_content:
        "再补。。。不知道这图啥意思。。。有了解的哥哥可以解答一下。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1102-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "我今天才发现关灯了。。。我还寻思俩人找个小房间沟通和解有啥子。。。。是我嗑得不仔细了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "67",
  },
  {
    id: 1103,
    user_face: "1103-user-face.png",
    user_id: "TFBOYS-管国林",
    is_op: false,
    create_at: "2022-12-31 02:45:02 贵州",
    quote: {
      quote_status: true,
      quote_content: "抖人瑞平一下。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1103-quote.png",
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈救！！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "27",
  },
  {
    id: 1104,
    user_face: "1104-user-face.png",
    user_id: "i恋爱禁区",
    is_op: false,
    create_at: "2022-12-31 03:14:06 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "😷回国那段时间真的太好嗑。。。。。连staff都在嗑。。。。。。。太爱了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "93",
  },
  {
    id: 1105,
    user_face: "1105-user-face.png",
    user_id: "i恋爱禁区",
    is_op: false,
    create_at: "2022-12-31 03:15:10 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "而且。。。。劳迪也算roy6里面销量最差的一个。。。。。感觉买了的都是家人们。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "150",
  },
  {
    id: 1106,
    user_face: "1106-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 03:33:06 北京",
    quote: {
      quote_status: true,
      quote_content: "抖人瑞平一下。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1106-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "哈哈哈哈哈哈哈哈哈哈哈哈哈哈。。。。这个视频我看过。。。很双标。。。。（33一直说22吃的干净。。。i2别总是说33pua22。。。。夸他的偏爱他的。。。你们怎么就视而不见。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "113",
  },
  {
    id: 1107,
    user_face: "1107-user-face.png",
    user_id: "佚名",
    is_op: false,
    create_at: "2022-12-31 03:36:06 海南",
    quote: {
      quote_status: true,
      quote_content: "玛雅感觉💙冷到搓手了也要把外套让给老婆",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: " 我超 真破防了 到底是多爱啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "44",
  },
  {
    id: 1108,
    user_face: "1108-user-face.png",
    user_id: "管⁢⁢理⁢员",
    is_op: false,
    create_at: "2022-12-31 04:58:27 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊啊啊啊啊啊怎么就看到早上啦",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "10",
  },
  {
    id: 1109,
    user_face: "1109-user-face.png",
    user_id: "花匠（上学版）",
    is_op: false,
    create_at: "2022-12-31 05:13:50 美国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑ky到现在也是觉得像走过一条时光隧道。。。感慨",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "89",
  },
  {
    id: 1110,
    user_face: "1110-user-face.png",
    user_id: "危险扳机",
    is_op: false,
    create_at: "2022-12-31 07:00:34 英国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🚬🚬🚬🚬🚬",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1111,
    user_face: "1111-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 07:27:23 广东",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥。。。我同意你的想法但是我觉得开窍时间没有那么晚诶。。。。哥哥磕过卡地亚吗。。。。天坑那会他一直戴着卡地亚拍戏没拿下来我觉得也挺好磕。。。。。然后我感觉22出国。。。他两之间更多是跨越半个地球追求梦想和四年异地的纠结🤔🤔。。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "说实话。。。cp粉可能觉得这是大糖。。。但是唯粉心里只会给他找借口belike这是大火的款式。。。or巧合而已。。。这才是唯粉下意识的第一反应和真实心态。。。曾经很长一段时间我朋友也是这样给33找借口的。。。而且他们住一起（口罩前应该也是经常去wjk家住的。。。有些东西拿串了不是很正常吗（嘴硬。。。但次数多了。。。一次是巧合这种咯噔事儿次次还能是巧合吗。。。他们不是真给子就是关系太好了。。。自己选吧🙂反正骗不了自己。。。💙你太知道害一个唯粉怎样害一生。。。这是逼着人相信啊。。。所以我的贴子里的观点。。。可能是前i3嘴硬也可能太理智所以不敢肯定他们是一对真给子（真没办法绝对客观。。。但是可以肯定。。。他们关系是真好啊。。。就是很好。。。很好很好。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "123",
  },
  {
    id: 1112,
    user_face: "1112-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 07:30:26 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "https://m.weibo.cn/6514786758/4248385495529369\n氮气事件。。。那种感觉。。。哥哥们审判审判我朋友的。。。儿媳妇吧。。。真的很会勾引nan人哦💙💚。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "114",
  },
  {
    id: 1113,
    user_face: "1113-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 07:40:06 广东",
    quote: {
      quote_status: true,
      quote_content:
        "说实话。。。cp粉可能觉得这是大糖。。。但是唯粉心里只会给他找借口belike这是大火的款式。。。or巧合而已。。。这才是唯粉下意识的第一反应和真实心态。。。曾经很长一段时间我朋友也是这样给33找借口的。。。而且他们住一起（口罩前应该也是经常去wjk家住的。。。有些东西拿串了不是很正常吗（嘴硬。。。但次数多了。。。一次是巧合这种咯噔事儿次次还能是巧合吗。。。他们不是真给子就是关系太好了。。。自己选吧🙂反正骗不了自己。。。💙你太知道害一个唯粉怎样害一生。。。这是逼着人相信啊。。。所以我的贴子里的观点。。。可能是前i3嘴硬也可能太理智所以不敢肯定他们是一对真给子（真没办法绝对客观。。。但是可以肯定。。。他们关系是真好啊。。。就是很好。。。很好很好。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "i3就是真的i3。。。不是道济批皮的。。。我朋友当年。。。也是zqsg嘴过22的。。。曾经骂得也蛮难听。。。至今她也只是被迫对22。。。爱屋及乌。。。甚至因为22还会骂wjk。。。\n\n我朋友原话“他唱的歌是爱江山更爱美人。。。但他自己看着可真不怎么爱江山。。。倒是爱惨了旁边那个美人。。。现在还长残了算个毛美人（原话骂得比较难听恶婆婆暴言类。。。wjk他🐎是瞎子吗。。。不过是wy也好。。。也不好。。。其实在i3心里到底是草粉好还是草wy好真说不清。。”\n\n现在她也是两个给子一起骂。。。两个疯魔给子。。。我朋友说她就希望他们锁死。。。这样这么多年也不算她白骂了22。。。22都是你活该。。。（端水33被丈母娘骂也是同理。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "181",
  },
  {
    id: 1114,
    user_face: "1114-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 07:58:34 吉林",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "祝福💙💚。。嗑亖。。我狂炫三大碗。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "37",
  },
  {
    id: 1115,
    user_face: "1115-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 08:03:49 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "and💙💚这对cp很多人都在强调一个点就是特别。\n\n为什么特别呢？\n\n他们小的时候其实炒作感和卖腐感是很重的，比如说他们做的同样的事情如果发生在内娱其他男明星身上踩组哥哥一定会毫不犹豫审判他们卖腐的程度，而且很多blcp简直把老子想🔥写在眼睛里了（没有审判别的cp的意思不过欢迎对号入座\n\nky不是这样，第一，那个时候年龄太小了，就像本贴题眼说得一样，他们甚至都不懂卖腐这个词，很多东西是黄锐有意无意引导的，他们那个时候最多知道：粉丝很喜欢看我和jk/wy有互动，那个时候这些东西不能明码标价变现为资源/片酬/商务。\n\n第二，他们的演技不好，他俩的演技演戏都演不明白，我骂了无数次。。。为什么不能继续唱歌要去演戏，虽然现在在内娱演戏才是最好的赛道，但这个赛道真的不适合他俩。。。如果他们唱歌🎤or做男团的天赋是内娱天花板（tfb应该是公认的养成系偶像何内娱男团top吧不算粉丝裸奔吹逼吧。。。just陈述公众眼中的外界事实，小虎队不是一个年代不做比较。。。求生欲很强别举报我。。。这么比的话那演戏真的同批有不少都比他们天赋强的，非要这么搞粉丝也只能尊重，被迫含泪吹逼做数据了。。。所以他们其实是不太懂得怎么去装去演的，客观主观那些青涩懵懂。。。稚嫩的在意都是演不出来的。。。\n\n其实如果是这样，这对cp的风味也没有到无可取代的地步，而是像个青涩美好的标本，只像一封美丽的情书，找个校园向的bg也能代餐代到差不多，但💙💚在成年后的生长痛，伤害彼此，撕裂自己，和解，自洽却让他们一下生动立体了起来，像是活生生的两个活人。就像我说得一样，这两年wjk少有的明显的情绪波动，都是因为wy\n\n这就是特性，无可取代，忽悠瘸了多少人。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "230",
  },
  {
    id: 1116,
    user_face: "1116-user-face.png",
    user_id: "美味花生包",
    is_op: false,
    create_at: "2022-12-31 08:04:24 河南",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1116-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "这个我知道，我问我的i2朋友是怎么回事，为啥roy6和wjk一天生日，我的i2朋友说因为wy想当wjk的爹😀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "346",
  },
  {
    id: 1117,
    user_face: "1117-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 08:12:41 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "https://www.douban.com/group/topic/242768025/?_i=72443918be696d9&amp;dt_dapp=1\n这个贴子对他们拉扯的这段时间诠释的超级超级好，文笔也好好。。。\n这段真的好认可。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "111",
  },
  {
    id: 1118,
    user_face: "1118-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2022-12-31 08:22:20 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这个我知道，我问我的i2朋友是怎么回事，为啥roy6和wjk一天生日，我的i2朋友说因为wy想当wjk的爹😀",
      quote_user_id: "美味花生包",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "笑死哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "59",
  },
  {
    id: 1119,
    user_face: "1119-user-face.png",
    user_id: "不喝冰阔落了",
    is_op: false,
    create_at: "2022-12-31 08:50:06 湖北",
    quote: {
      quote_status: true,
      quote_content:
        "这个我知道，我问我的i2朋友是怎么回事，为啥roy6和wjk一天生日，我的i2朋友说因为wy想当wjk的爹😀",
      quote_user_id: "美味花生包",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "笑亖。。。一生嘴硬的wf。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "136",
  },
  {
    id: 1120,
    user_face: "1120-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 09:15:30 云南",
    quote: {
      quote_status: true,
      quote_content:
        "https://m.weibo.cn/6514786758/4248385495529369\n氮气事件。。。那种感觉。。。哥哥们审判审判我朋友的。。。儿媳妇吧。。。真的很会勾引nan人哦💙💚。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "很会夸男人的小狐狸精一枚呀。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "84",
  },
  {
    id: 1121,
    user_face: "1121-user-face.png",
    user_id: "虽说且说但",
    is_op: false,
    create_at: "2022-12-31 09:33:08 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕死。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1122,
    user_face: "1122-user-face.png",
    user_id: "1987哇哈哈AD钙",
    is_op: false,
    create_at: "2022-12-31 09:37:40 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "https://m.weibo.cn/6514786758/4248385495529369\n氮气事件。。。那种感觉。。。哥哥们审判审判我朋友的。。。儿媳妇吧。。。真的很会勾引nan人哦💙💚。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "配合食用风味绝佳。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "108",
  },
  {
    id: 1123,
    user_face: "1123-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 09:54:48 山东",
    quote: {
      quote_status: true,
      quote_content: "配合食用风味绝佳。。。",
      quote_user_id: "1987哇哈哈AD钙",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1123-quote.png",
      },
    },
    cmt: {
      cmt_content: "什么救兄弟。。。。明明是救老婆。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "95",
  },
  {
    id: 1124,
    user_face: "1124-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 10:02:21 北京",
    quote: {
      quote_status: true,
      quote_content:
        "这个我知道，我问我的i2朋友是怎么回事，为啥roy6和wjk一天生日，我的i2朋友说因为wy想当wjk的爹😀",
      quote_user_id: "美味花生包",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "怎么我。。。磕到了。。。也不是不行。。。。22还泥塑33呢。。。劳迪是女孩。。。。22想逆cp。。。。看到源凯灯牌暗爽得不行。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "128",
  },
  {
    id: 1125,
    user_face: "1125-user-face.png",
    user_id: "金秋天作之和",
    is_op: false,
    create_at: "2022-12-31 10:12:30 江西",
    quote: {
      quote_status: true,
      quote_content: "并且他5.25的活动脸色很差",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1125-quote.png",
      },
    },
    cmt: {
      cmt_content: "嗑晕。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 1126,
    user_face: "1126-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 10:33:02 云南",
    quote: {
      quote_status: true,
      quote_content:
        "说实话。。。cp粉可能觉得这是大糖。。。但是唯粉心里只会给他找借口belike这是大火的款式。。。or巧合而已。。。这才是唯粉下意识的第一反应和真实心态。。。曾经很长一段时间我朋友也是这样给33找借口的。。。而且他们住一起（口罩前应该也是经常去wjk家住的。。。有些东西拿串了不是很正常吗（嘴硬。。。但次数多了。。。一次是巧合这种咯噔事儿次次还能是巧合吗。。。他们不是真给子就是关系太好了。。。自己选吧🙂反正骗不了自己。。。💙你太知道害一个唯粉怎样害一生。。。这是逼着人相信啊。。。所以我的贴子里的观点。。。可能是前i3嘴硬也可能太理智所以不敢肯定他们是一对真给子（真没办法绝对客观。。。但是可以肯定。。。他们关系是真好啊。。。就是很好。。。很好很好。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。。。能不能问问i3朋友。。。。。。在i3眼里💙露卡地亚他们不觉得很刻意吗。。。。。不管这个镯子有啥寓意。。。。。有没有觉得💙在很刻意地想让站姐拍到捏。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "89",
  },
  {
    id: 1127,
    user_face: "1127-user-face.png",
    user_id: "怀瑾瑜兮",
    is_op: false,
    create_at: "2022-12-31 10:37:34 江苏",
    quote: {
      quote_status: true,
      quote_content: "配套的。。。i2瑞萍。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1127-quote.png",
      },
    },
    cmt: {
      cmt_content: "笑得崩潰。。唯粉姐好會說。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "51",
  },
  {
    id: 1128,
    user_face: "1128-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-31 10:39:00 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "卡地亚到底什么梗。。。有没有哥哥给我补课。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 1129,
    user_face: "1129-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 10:40:54 黑龙江",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥。。。。能不能问问i3朋友。。。。。。在i3眼里💙露卡地亚他们不觉得很刻意吗。。。。。不管这个镯子有啥寓意。。。。。有没有觉得💙在很刻意地想让站姐拍到捏。。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "前i3来回答你 太太太刻意了 当天我看到站姐拍的那张图的时候心里就咯噔一下 什么意思这是 这姿势也太明显了吧 当时就觉得那个手镯很有点东西 但是没往给子方面想：）年轻了还是",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "134",
  },
  {
    id: 1130,
    user_face: "1130-user-face.png",
    user_id: "喝水都胖",
    is_op: false,
    create_at: "2022-12-31 10:43:19 山西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "天真是什么糖.......有哥哥知道吗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 1131,
    user_face: "1131-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-31 10:44:30 浙江",
    quote: {
      quote_status: true,
      quote_content: "天真是什么糖.......有哥哥知道吗",
      quote_user_id: "喝水都胖",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "天真我知道的是。。💙对💚的评价都是最小最萌最天真，可爱之类的",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "73",
  },
  {
    id: 1132,
    user_face: "1132-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 10:51:04 北京",
    quote: {
      quote_status: true,
      quote_content: "天真是什么糖.......有哥哥知道吗",
      quote_user_id: "喝水都胖",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "好像是wjk在朋友圈发wy的歌。。。配字：璀璨夺目，天真善良。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "182",
  },
  {
    id: 1133,
    user_face: "1133-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 10:51:42 云南",
    quote: {
      quote_status: true,
      quote_content: "卡地亚到底什么梗。。。有没有哥哥给我补课。。。",
      quote_user_id: "把糖塞我嘴里",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "💙之前有一次机场戴了一只卡地亚的镯子。。。。。走机场的时候很刻意的把袖子翻起来。。。还一直抬手挠头。。。。就差问所有站姐有没有看到我的新镯子的水平。。。。。如图。。。然后那个镯子很有寓意。。。官网的解释是这个镯子配有一个钥匙。。。只有钥匙才能打开。。。。💙很多次拍戏啥的都戴着镯子没拿下来只能往袖子里藏。。。。所以🔑肯定不在他自己手上吧。。。。不知道是不是在💚手里（瞎磕磕。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "125",
  },
  {
    id: 1134,
    user_face: "1134-user-face.png",
    user_id: "把糖塞我嘴里",
    is_op: false,
    create_at: "2022-12-31 10:52:48 浙江",
    quote: {
      quote_status: true,
      quote_content:
        "💙之前有一次机场戴了一只卡地亚的镯子。。。。。走机场的时候很刻意的把袖子翻起来。。。还一直抬手挠头。。。。就差问所有站姐有没有看到我的新镯子的水平。。。。。如图。。。然后那个镯子很有寓意。。。官网的解释是这个镯子配有一个钥匙。。。只有钥匙才能打开。。。。💙很多次拍戏啥的都戴着镯子没拿下来只能往袖子里藏。。。。所以🔑肯定不在他自己手上吧。。。。不知道是不是在💚手里（瞎磕磕。。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1134-quote.png",
      },
    },
    cmt: {
      cmt_content: "谢谢哥哥。。。。磕亖。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "31",
  },
  {
    id: 1135,
    user_face: "1135-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 10:54:34 云南",
    quote: {
      quote_status: true,
      quote_content:
        "💙之前有一次机场戴了一只卡地亚的镯子。。。。。走机场的时候很刻意的把袖子翻起来。。。还一直抬手挠头。。。。就差问所有站姐有没有看到我的新镯子的水平。。。。。如图。。。然后那个镯子很有寓意。。。官网的解释是这个镯子配有一个钥匙。。。只有钥匙才能打开。。。。💙很多次拍戏啥的都戴着镯子没拿下来只能往袖子里藏。。。。所以🔑肯定不在他自己手上吧。。。。不知道是不是在💚手里（瞎磕磕。。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1135-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "妈的。。。纠正一下。。不是🔑。。。是螺丝刀😂😂😂。。。。。。然后手镯是love系列。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "116",
  },
  {
    id: 1136,
    user_face: "1136-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 10:55:21 云南",
    quote: {
      quote_status: true,
      quote_content:
        "前i3来回答你 太太太刻意了 当天我看到站姐拍的那张图的时候心里就咯噔一下 什么意思这是 这姿势也太明显了吧 当时就觉得那个手镯很有点东西 但是没往给子方面想：）年轻了还是",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好的哥哥。。。。。🤤🤤🤤嘿嘿",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "17",
  },
  {
    id: 1137,
    user_face: "1137-user-face.png",
    user_id: "18:12",
    is_op: false,
    create_at: "2022-12-31 10:58:23 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好高的楼。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "6",
  },
  {
    id: 1138,
    user_face: "1138-user-face.png",
    user_id: "秋叶胡同第一美",
    is_op: false,
    create_at: "2022-12-31 11:06:09 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我在这栋楼住下了。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 1139,
    user_face: "1139-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-31 11:13:31 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "同居是什么。。一直看到你们提同居但有没有领磕(⑉꒦ິ^꒦ິ⑉)",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "34",
  },
  {
    id: 1140,
    user_face: "1140-user-face.png",
    user_id: "阿豆",
    is_op: false,
    create_at: "2022-12-31 11:30:21 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "怎么我。。。磕到了。。。也不是不行。。。。22还泥塑33呢。。。劳迪是女孩。。。。22想逆cp。。。。看到源凯灯牌暗爽得不行。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "他看源凯灯牌一个人暗爽那段真的好好笑。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "96",
  },
  {
    id: 1141,
    user_face: "1141-user-face.png",
    user_id: "拉手老爷",
    is_op: false,
    create_at: "2022-12-31 11:30:24 上海",
    quote: {
      quote_status: true,
      quote_content:
        "妈的。。。纠正一下。。不是🔑。。。是螺丝刀😂😂😂。。。。。。然后手镯是love系列。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好有创意的镯子",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 1142,
    user_face: "1142-user-face.png",
    user_id: "龙丹妮（闭关中",
    is_op: false,
    create_at: "2022-12-31 12:06:12 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕到了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1143,
    user_face: "1143-user-face.png",
    user_id: "恋爱日记",
    is_op: false,
    create_at: "2022-12-31 12:11:33 安徽",
    quote: {
      quote_status: true,
      quote_content: "他看源凯灯牌一个人暗爽那段真的好好笑。。。。",
      quote_user_id: "阿豆",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "是想做1。。。的小哥哥一枚呀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "48",
  },
  {
    id: 1144,
    user_face: "1144-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-31 12:12:07 福建",
    quote: {
      quote_status: true,
      quote_content:
        "💙之前有一次机场戴了一只卡地亚的镯子。。。。。走机场的时候很刻意的把袖子翻起来。。。还一直抬手挠头。。。。就差问所有站姐有没有看到我的新镯子的水平。。。。。如图。。。然后那个镯子很有寓意。。。官网的解释是这个镯子配有一个钥匙。。。只有钥匙才能打开。。。。💙很多次拍戏啥的都戴着镯子没拿下来只能往袖子里藏。。。。所以🔑肯定不在他自己手上吧。。。。不知道是不是在💚手里（瞎磕磕。。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1144-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "这个我知道。。。甚至去上学有活动手腕绑丝带藏着这个镯子 后来二字也戴了镯子 但是看不清什么牌子 i2否认卡地亚说是gucci的blind for love 那不是更好嗑 一个是爱 另一个是为爱眼瞎呀",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "164",
  },
  {
    id: 1145,
    user_face: "1145-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 12:13:07 云南",
    quote: {
      quote_status: true,
      quote_content:
        "这个我知道。。。甚至去上学有活动手腕绑丝带藏着这个镯子 后来二字也戴了镯子 但是看不清什么牌子 i2否认卡地亚说是gucci的blind for love 那不是更好嗑 一个是爱 另一个是为爱眼瞎呀",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "为爱眼瞎。。。。。。。笑死我了。。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "40",
  },
  {
    id: 1146,
    user_face: "1146-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 12:14:10 云南",
    quote: {
      quote_status: true,
      quote_content:
        "这个我知道。。。甚至去上学有活动手腕绑丝带藏着这个镯子 后来二字也戴了镯子 但是看不清什么牌子 i2否认卡地亚说是gucci的blind for love 那不是更好嗑 一个是爱 另一个是为爱眼瞎呀",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "我现在才知道Gucci的是这个系列。。。。。。哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "28",
  },
  {
    id: 1147,
    user_face: "1147-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 12:16:33 广东",
    quote: {
      quote_status: true,
      quote_content: "同居是什么。。一直看到你们提同居但有没有领磕(⑉꒦ິ^꒦ິ⑉)",
      quote_user_id: "如何科学发疯",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥同居的领嗑那可太多了。。。组里好多哥哥都会送过。。。什么窗帘什么做菜什么猫笼猫毛。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "72",
  },
  {
    id: 1148,
    user_face: "1148-user-face.png",
    user_id: "如何科学发疯",
    is_op: false,
    create_at: "2022-12-31 12:19:04 北京",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥同居的领嗑那可太多了。。。组里好多哥哥都会送过。。。什么窗帘什么做菜什么猫笼猫毛。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "主要是搜不到💔💔豆瓣大家磕凯源都只会打💙💚。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "55",
  },
  {
    id: 1149,
    user_face: "1149-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-31 12:29:33 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "同居让我想起来道济怀疑二字的猫是三字养着的 衣服还有猫毛啥的 被i3嘲都是🐢 结果恰少里三字突然被董子健爆出来真的养了两只猫 i3根本不知道这事。。。说起来这个综艺 也是很精彩 恰学帖都歹了很遗憾",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "198",
  },
  {
    id: 1150,
    user_face: "1150-user-face.png",
    user_id: "珍妮玛士多",
    is_op: false,
    create_at: "2022-12-31 12:30:44 江西",
    quote: {
      quote_status: true,
      quote_content:
        "这阶段再补一点。。。\n\n他们之间是22先表达出，他想离开wjk的禁锢。\n\n但那个时候的22也没有太聪明，许多手段做法都是伤人又伤己的，他觉得他确实像是被33囚禁的鸟，33锦衣玉食精心照料他，但可怕的是33根本意识不到他圈禁了22，而且还是以爱为名。爱是彼此臣服的事情，我感觉22其实不太介意被wjk套牢掌控，但他害怕的是wjk根本就不是爱他。\n\n而就像刚刚说的，他的很多手段不太漂亮，不能击溃敌人一泻千里，反而经常杀敌一千自损八百。wjk也在成长中有很多压力，就像说的考北电的事情，他是先行者，要去探成人世界的路，本身就喘不过气来了，他那个时候理解不了22的很多情绪，只是觉得弟弟的很多做法真是伤人。赌气也好，长大了应该要改变也好，凯源cp确实应该避嫌也罢，wjk在这个时期的确收回这份偏爱非常彻底。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "kswl。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1151,
    user_face: "1151-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-31 12:37:00 四川",
    quote: {
      quote_status: true,
      quote_content:
        "同居让我想起来道济怀疑二字的猫是三字养着的 衣服还有猫毛啥的 被i3嘲都是🐢 结果恰少里三字突然被董子健爆出来真的养了两只猫 i3根本不知道这事。。。说起来这个综艺 也是很精彩 恰学帖都歹了很遗憾",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "https://www.douban.com/group/topic/263087419/?_i=724613598169a43\n（恰学还有点残🍬。。。）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "27",
  },
  {
    id: 1152,
    user_face: "1152-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 12:51:49 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@momo 嗑死我了还是凯源",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1153,
    user_face: "1153-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-31 12:55:39 福建",
    quote: {
      quote_status: true,
      quote_content:
        "https://www.douban.com/group/topic/263087419/?_i=724613598169a43\n（恰学还有点残🍬。。。）",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "炫过了。。。再炫一遍。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 1154,
    user_face: "1154-user-face.png",
    user_id: "弦上看月-",
    is_op: false,
    create_at: "2022-12-31 13:00:09 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑死我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1155,
    user_face: "1155-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-31 13:02:01 四川",
    quote: {
      quote_status: true,
      quote_content:
        "同居让我想起来道济怀疑二字的猫是三字养着的 衣服还有猫毛啥的 被i3嘲都是🐢 结果恰少里三字突然被董子健爆出来真的养了两只猫 i3根本不知道这事。。。说起来这个综艺 也是很精彩 恰学帖都歹了很遗憾",
      quote_user_id: "山姆冰柜搬运工",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "31",
  },
  {
    id: 1156,
    user_face: "1156-user-face.png",
    user_id: "珍妮玛士多",
    is_op: false,
    create_at: "2022-12-31 13:06:22 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "组外投稿 。。。。i2姐提问箱料",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "121",
  },
  {
    id: 1157,
    user_face: "1157-user-face.png",
    user_id: "珍妮玛士多",
    is_op: false,
    create_at: "2022-12-31 13:06:41 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "58",
  },
  {
    id: 1158,
    user_face: "1158-user-face.png",
    user_id: "张家族长(已婚",
    is_op: false,
    create_at: "2022-12-31 13:09:07 江西",
    quote: {
      quote_status: true,
      quote_content: "组外投稿 。。。。i2姐提问箱料",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1158-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "一个月也见不到几天。。。所以更要抓紧时间就住一起啊。。。更好嗑了。。。丈母娘放弃挣扎吧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "102",
  },
  {
    id: 1159,
    user_face: "1159-user-face.png",
    user_id: "泽泽",
    is_op: false,
    create_at: "2022-12-31 13:19:32 吉林",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "爱情来了！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "116",
  },
  {
    id: 1160,
    user_face: "1160-user-face.png",
    user_id: "弦上看月-",
    is_op: false,
    create_at: "2022-12-31 13:30:46 江苏",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1160-quote.png",
      },
    },
    cmt: {
      cmt_content: "没嗑过的 嗑。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "23",
  },
  {
    id: 1161,
    user_face: "1161-user-face.png",
    user_id: "泡",
    is_op: false,
    create_at: "2022-12-31 13:33:44 云南",
    quote: {
      quote_status: true,
      quote_content: "组外投稿 。。。。i2姐提问箱料",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1161-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "没有这种可能。。。放弃幻想吧。。。。。i2姐姐威武。。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "75",
  },
  {
    id: 1162,
    user_face: "1162-user-face.png",
    user_id: "陈浩南（已坐牢",
    is_op: false,
    create_at: "2022-12-31 13:43:57 四川",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1162-quote.png",
      },
    },
    cmt: {
      cmt_content: "可以具体说说吗哥哥。。。。我是弱智我有点看不懂😭😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "26",
  },
  {
    id: 1163,
    user_face: "1163-user-face.png",
    user_id: "陈浩南（已坐牢",
    is_op: false,
    create_at: "2022-12-31 13:48:51 四川",
    quote: {
      quote_status: true,
      quote_content: "[该条回应已被删除]",
      quote_user_id: "兔兔与猫猫",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "🤤🤤🤤哇噢。。。懂了懂了。。2字疯子。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1164,
    user_face: "1164-user-face.png",
    user_id: "山姆冰柜搬运工",
    is_op: false,
    create_at: "2022-12-31 13:51:34 福建",
    quote: {
      quote_status: true,
      quote_content: "组外投稿 。。。。i2姐提问箱料",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1164-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "“一个月也见不到几天 住不住在一起有什么重要的”好狠心又嘴好硬的丈母娘。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "108",
  },
  {
    id: 1165,
    user_face: "1165-user-face.png",
    user_id: "看过疾风劲草",
    is_op: false,
    create_at: "2022-12-31 13:53:18 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊马一下",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1166,
    user_face: "1166-user-face.png",
    user_id: "R1SE赫敏格兰杰",
    is_op: false,
    create_at: "2022-12-31 13:54:42 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "啊啊啊马",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1167,
    user_face: "1167-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 13:54:56 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1168,
    user_face: "1168-user-face.png",
    user_id: "Grapefruit",
    is_op: false,
    create_at: "2022-12-31 13:56:09 海南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嘿嘿。。🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1169,
    user_face: "1169-user-face.png",
    user_id: "弦上看月-",
    is_op: false,
    create_at: "2022-12-31 13:58:20 江苏",
    quote: {
      quote_status: true,
      quote_content: "“来看看💙怎么认领劳迪的。。。”\n\n🔚",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1169-quote.png",
      },
    },
    cmt: {
      cmt_content: "我说为什么当时这个字幕标出了这几个字。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "67",
  },
  {
    id: 1170,
    user_face: "1170-user-face.png",
    user_id: "兔兔与猫猫",
    is_op: false,
    create_at: "2022-12-31 13:59:37 陕西",
    quote: {
      quote_status: true,
      quote_content: "🤤🤤🤤哇噢。。。懂了懂了。。2字疯子。。。",
      quote_user_id: "陈浩南（已坐牢",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。。我记错了。。。这个才是真正的名字。。。别人给我发的。。。哥哥。。我是看了句组高楼来的。。那个miss you day and night是《披星戴月的想你》的舞台。。《流星也为你落下来了》的英文名是fall for you。。但很难不怀疑是来自Troye Sivan的only fools fall for you。。毕竟这对给子某种程度上可能是。。戳爷的信徒。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "86",
  },
  {
    id: 1171,
    user_face: "1171-user-face.png",
    user_id: "贝壳儿（备考版",
    is_op: false,
    create_at: "2022-12-31 14:00:16 广东",
    quote: {
      quote_status: true,
      quote_content:
        "说实话。。。cp粉可能觉得这是大糖。。。但是唯粉心里只会给他找借口belike这是大火的款式。。。or巧合而已。。。这才是唯粉下意识的第一反应和真实心态。。。曾经很长一段时间我朋友也是这样给33找借口的。。。而且他们住一起（口罩前应该也是经常去wjk家住的。。。有些东西拿串了不是很正常吗（嘴硬。。。但次数多了。。。一次是巧合这种咯噔事儿次次还能是巧合吗。。。他们不是真给子就是关系太好了。。。自己选吧🙂反正骗不了自己。。。💙你太知道害一个唯粉怎样害一生。。。这是逼着人相信啊。。。所以我的贴子里的观点。。。可能是前i3嘴硬也可能太理智所以不敢肯定他们是一对真给子（真没办法绝对客观。。。但是可以肯定。。。他们关系是真好啊。。。就是很好。。。很好很好。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "🤤🤤🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1172,
    user_face: "1172-user-face.png",
    user_id: "珍妮玛士多",
    is_op: false,
    create_at: "2022-12-31 14:02:46 江西",
    quote: {
      quote_status: true,
      quote_content: "可以具体说说吗哥哥。。。。我是弱智我有点看不懂😭😭",
      quote_user_id: "陈浩南（已坐牢",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "就是这个样子。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "61",
  },
  {
    id: 1173,
    user_face: "1173-user-face.png",
    user_id: "陈浩南（已坐牢",
    is_op: false,
    create_at: "2022-12-31 14:04:59 四川",
    quote: {
      quote_status: true,
      quote_content: "就是这个样子。。",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1173-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "。。好浓的塌房味儿。。。。。我好像懂i2破防的点是什么，，。。要我说如果非要塌那还不如就，。。选💙吧。。。🤗",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "102",
  },
  {
    id: 1174,
    user_face: "1174-user-face.png",
    user_id: "陈浩南（已坐牢",
    is_op: false,
    create_at: "2022-12-31 14:06:31 四川",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥。。。我记错了。。。这个才是真正的名字。。。别人给我发的。。。哥哥。。我是看了句组高楼来的。。那个miss you day and night是《披星戴月的想你》的舞台。。《流星也为你落下来了》的英文名是fall for you。。但很难不怀疑是来自Troye Sivan的only fools fall for you。。毕竟这对给子某种程度上可能是。。戳爷的信徒。。",
      quote_user_id: "兔兔与猫猫",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "好精辟的。。。戳爷信徒。。。。笑尿了哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "38",
  },
  {
    id: 1175,
    user_face: "1175-user-face.png",
    user_id: "吃不吃早餐",
    is_op: false,
    create_at: "2022-12-31 14:08:39 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1176,
    user_face: "1176-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-31 14:15:40 四川",
    quote: {
      quote_status: true,
      quote_content: "组外投稿 。。。。i2姐提问箱料",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1176-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "srds很多i2都这样。。。口嗨罢了。。。她还说过434都比凯源真之类的话呢。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "63",
  },
  {
    id: 1177,
    user_face: "1177-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2022-12-31 14:21:01 云南",
    quote: {
      quote_status: true,
      quote_content: "i2哥哥的投稿。。。是都很会扭的小情侣一对呀。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1177-quote.png",
      },
    },
    cmt: {
      cmt_content: "好嗑。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "14",
  },
  {
    id: 1178,
    user_face: "1178-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2022-12-31 14:26:01 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕亖。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1179,
    user_face: "1179-user-face.png",
    user_id: "mоmо",
    is_op: false,
    create_at: "2022-12-31 14:27:40 河南",
    quote: {
      quote_status: true,
      quote_content:
        "4⃣️ 演唱会\n\n💚个人演唱会\n再然后就是19年0831💚的告别演唱会，本来升降台都下去了，最后返场唱了一首《我怀念的》，还因为超时被场馆罚了几十万还是一百多万来着。。。问题是他真的唱得声嘶力竭唱红了眼啊。。。我tm心都听碎了。。。我说我的前同担们别太傻乎乎的老是他好爱窝他好爱窝的。。。我承认他确实很爱粉丝。。但他真的最爱💙🚬我从来都不觉得那首歌他是唱给粉丝的，我当初心里只有一个疑惑：他被哪个搞得这么伤情。。。我放个链接。。各位哥哥们请审判。。指路3分20秒。。。真的痛亖窝了。。\n\n🔗\n\n【【王源•星源】20190831南京 我怀念的-哔哩哔哩】 https://b23.tv/FS5uZHc",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "@郭德纲",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 1180,
    user_face: "1180-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-31 14:28:22 四川",
    quote: {
      quote_status: true,
      quote_content:
        "哥哥。。。我记错了。。。这个才是真正的名字。。。别人给我发的。。。哥哥。。我是看了句组高楼来的。。那个miss you day and night是《披星戴月的想你》的舞台。。《流星也为你落下来了》的英文名是fall for you。。但很难不怀疑是来自Troye Sivan的only fools fall for you。。毕竟这对给子某种程度上可能是。。戳爷的信徒。。",
      quote_user_id: "兔兔与猫猫",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "来自组外哥哥的投稿：\n",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "28",
  },
  {
    id: 1181,
    user_face: "1181-user-face.png",
    user_id: "小梨哥哥抱抱",
    is_op: false,
    create_at: "2022-12-31 14:34:36 重庆",
    quote: {
      quote_status: true,
      quote_content: "就是这个样子。。",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1181-quote.png",
      },
    },
    cmt: {
      cmt_content: "经典秒删",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "22",
  },
  {
    id: 1182,
    user_face: "1182-user-face.png",
    user_id: "我没瘦",
    is_op: false,
    create_at: "2022-12-31 14:35:23 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好高。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1183,
    user_face: "1183-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 14:36:21 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "组外的有点人脉哥哥。。。确认过投稿哥哥的真实性了。。。保护哥哥隐私不能发出来。。。\n\n诡计多端的小情侣两枚。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "95",
  },
  {
    id: 1184,
    user_face: "1184-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-31 15:07:14 广东",
    quote: {
      quote_status: true,
      quote_content:
        "组外的有点人脉哥哥。。。确认过投稿哥哥的真实性了。。。保护哥哥隐私不能发出来。。。\n\n诡计多端的小情侣两枚。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1184-quote.png",
      },
    },
    cmt: {
      cmt_content: "但是这个发布时间估计是活动方有安排吧。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "30",
  },
  {
    id: 1185,
    user_face: "1185-user-face.png",
    user_id: "名品小水饺",
    is_op: false,
    create_at: "2022-12-31 15:15:21 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死啦。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1186,
    user_face: "1186-user-face.png",
    user_id: "再也不吃了",
    is_op: false,
    create_at: "2022-12-31 15:24:03 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕死我了😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1187,
    user_face: "1187-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-31 15:24:06 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "由组外哥哥投稿的封面致敬。。。我就想到以前wy一首歌里面的同性元素。。。还有曾轶可想为他写首歌的歌名也很那啥（zyk肯定知道这个同性梗的。。。毕竟她写歌蛮多都是。。。）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "69",
  },
  {
    id: 1188,
    user_face: "1188-user-face.png",
    user_id: "逃离冬季",
    is_op: false,
    create_at: "2022-12-31 15:26:33 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "这个我知道，我问我的i2朋友是怎么回事，为啥roy6和wjk一天生日，我的i2朋友说因为wy想当wjk的爹😀",
      quote_user_id: "美味花生包",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "13",
  },
  {
    id: 1189,
    user_face: "1189-user-face.png",
    user_id: "比你可爱陈书竞",
    is_op: false,
    create_at: "2022-12-31 15:27:33 四川",
    quote: {
      quote_status: true,
      quote_content:
        "由组外哥哥投稿的封面致敬。。。我就想到以前wy一首歌里面的同性元素。。。还有曾轶可想为他写首歌的歌名也很那啥（zyk肯定知道这个同性梗的。。。毕竟她写歌蛮多都是。。。）",
      quote_user_id: "比你可爱陈书竞",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1189-quote.png",
      },
    },
    cmt: {
      cmt_content: "“你会找到同类，会有人替你保管你的秘密 ，然后 男孩别哭”",
      cmt_img: {
        cmt_img_status: true,
        is_gif: false,
        cmt_img_src: "1189-cmt.png",
      },
    },
    like_cnt: "105",
  },
  {
    id: 1190,
    user_face: "1190-user-face.png",
    user_id: "z洋葱w",
    is_op: false,
    create_at: "2022-12-31 15:28:50 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "码",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1191,
    user_face: "1191-user-face.png",
    user_id: "INTO1-叶舒华",
    is_op: false,
    create_at: "2022-12-31 15:34:36 天津",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1191-quote.png",
      },
    },
    cmt: {
      cmt_content: "而且发的那天…是不是就是💙进组拍戏去了🥹",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "75",
  },
  {
    id: 1192,
    user_face: "1192-user-face.png",
    user_id: "小熊菠萝啤",
    is_op: false,
    create_at: "2022-12-31 16:23:25 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1193,
    user_face: "1193-user-face.png",
    user_id: "仙人掌味橡皮糖",
    is_op: false,
    create_at: "2022-12-31 16:52:48 海南",
    quote: {
      quote_status: true,
      quote_content: "i2哥哥的投稿。。。是都很会扭的小情侣一对呀。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1193-quote.png",
      },
    },
    cmt: {
      cmt_content:
        "哎呦我晕死了。。。。。。。谈过恋爱的哥哥肯定懂。。。。。这不是索吻撒娇是什么啊我老天。。。。。。。。。。。。。。。。。。。晕死了。。。。。。。。。。。。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "85",
  },
  {
    id: 1194,
    user_face: "1194-user-face.png",
    user_id: "归海一刀🥷",
    is_op: false,
    create_at: "2022-12-31 16:58:26 广东",
    quote: {
      quote_status: true,
      quote_content:
        "这个我知道，我问我的i2朋友是怎么回事，为啥roy6和wjk一天生日，我的i2朋友说因为wy想当wjk的爹😀",
      quote_user_id: "美味花生包",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "哈哈哈哈哈哈哈哈哈哈哈哈哈哈",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "16",
  },
  {
    id: 1195,
    user_face: "1195-user-face.png",
    user_id: "归海一刀🥷",
    is_op: false,
    create_at: "2022-12-31 17:01:49 广东",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "珍妮玛士多",
      quote_img: {
        quote_img_status: true,
        is_gif: false,
        quote_img_src: "1195-quote.png",
      },
    },
    cmt: {
      cmt_content: "第一次见👂🏻👂🏻",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "9",
  },
  {
    id: 1196,
    user_face: "1196-user-face.png",
    user_id: "打爆山根专家",
    is_op: false,
    create_at: "2022-12-31 17:09:31 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "这楼下来，凯源不会是假的，源凯才是真情侣吧。。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "56",
  },
  {
    id: 1197,
    user_face: "1197-user-face.png",
    user_id: "仙人掌味橡皮糖",
    is_op: false,
    create_at: "2022-12-31 17:25:00 海南",
    quote: {
      quote_status: true,
      quote_content:
        "哎呦我晕死了。。。。。。。谈过恋爱的哥哥肯定懂。。。。。这不是索吻撒娇是什么啊我老天。。。。。。。。。。。。。。。。。。。晕死了。。。。。。。。。。。。。。。。。",
      quote_user_id: "仙人掌味橡皮糖",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "再回味一下。。。。。三字对二字这个态度。。。。。哎呦真的像那种谈了很久的。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "65",
  },
  {
    id: 1198,
    user_face: "1198-user-face.png",
    user_id: "弦上看月-",
    is_op: false,
    create_at: "2022-12-31 17:30:01 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "@Summutumn 可以了！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1199,
    user_face: "1199-user-face.png",
    user_id: "明天更会快乐yo",
    is_op: false,
    create_at: "2022-12-31 17:36:59 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我嗑死在楼里了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1200,
    user_face: "1200-user-face.png",
    user_id: "没病走两步",
    is_op: false,
    create_at: "2022-12-31 17:39:14 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕鼠我了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1201,
    user_face: "1201-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 17:45:17 广东",
    quote: {
      quote_status: true,
      quote_content: "这楼下来，凯源不会是假的，源凯才是真情侣吧。。。。。。",
      quote_user_id: "打爆山根专家",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "不会。。。最多是323。。。wjk为爱躺平。。。不会是23。。。不会的。。。22在wjk面前真的甜。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "151",
  },
  {
    id: 1202,
    user_face: "1202-user-face.png",
    user_id: "今天也不想上班",
    is_op: false,
    create_at: "2022-12-31 18:11:10 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💚💙",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 1203,
    user_face: "1203-user-face.png",
    user_id: "Keanu",
    is_op: false,
    create_at: "2022-12-31 18:25:42 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "其实。。看过帝国这么多次打架。。。女嫂子根本分不到i2i3的目光。。。唯独提到对方。。才会开始撸起袖子干架。。。怎么不算是the one呢。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "250",
  },
  {
    id: 1204,
    user_face: "1204-user-face.png",
    user_id: "Keanu",
    is_op: false,
    create_at: "2022-12-31 18:28:01 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "而且。。当年二字唱我怀念的的时候。。。是我第一次。。。在内娱人身上。。。感觉到了一种。。。袒露的痛苦和不舍。。i2洗什么舍不得粉丝。。但是粉丝会和他无话不说。。一起做梦吗。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "236",
  },
  {
    id: 1205,
    user_face: "1205-user-face.png",
    user_id: "Keanu",
    is_op: false,
    create_at: "2022-12-31 18:28:45 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "后来才知道三字唱了词不达意。。而且他开始前的那番话也很好品。。。什么我其实是个嘴笨的人。。。妈呀。。。听完了只想说。。。三字。。。疯子。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "192",
  },
  {
    id: 1206,
    user_face: "1206-user-face.png",
    user_id: "NMIXX-金秋天",
    is_op: false,
    create_at: "2022-12-31 18:38:44 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑晕了啊啊啊啊",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1207,
    user_face: "1207-user-face.png",
    user_id: "珍珠奶茶不加冰",
    is_op: false,
    create_at: "2022-12-31 18:51:21 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1208,
    user_face: "1208-user-face.png",
    user_id: "起床困难症",
    is_op: false,
    create_at: "2022-12-31 21:34:13 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "祝福。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 1209,
    user_face: "1209-user-face.png",
    user_id: "富贵仙人掌🌵",
    is_op: false,
    create_at: "2022-12-31 21:49:13 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "破案了。。。因为电影。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 1210,
    user_face: "1210-user-face.png",
    user_id: "为终",
    is_op: false,
    create_at: "2022-12-31 22:40:29 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "码住",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "4",
  },
  {
    id: 1211,
    user_face: "1211-user-face.png",
    user_id: "momo",
    is_op: true,
    create_at: "2022-12-31 23:59:14 广东",
    quote: {
      quote_status: true,
      quote_content: "破案了。。。因为电影。。。。。",
      quote_user_id: "富贵仙人掌🌵",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "哥哥。。。从定这首歌开始。。。i3就说是电影了。。。不奇怪啊。。。嗑归嗑。。。反正嗑药剂可以没有道德的。。。随便嗑。。。。但是事实是这个也。。。正常",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "129",
  },
  {
    id: 1212,
    user_face: "1212-user-face.png",
    user_id: "暴走美玲",
    is_op: false,
    create_at: "2023-01-01 00:19:57 中国香港",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "马 ！",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1213,
    user_face: "1213-user-face.png",
    user_id: "IOUUOI",
    is_op: false,
    create_at: "2023-01-01 00:28:14 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "Kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1214,
    user_face: "1214-user-face.png",
    user_id: "一颗桑葚",
    is_op: false,
    create_at: "2023-01-01 01:00:36 河南",
    quote: {
      quote_status: true,
      quote_content:
        "没有这种可能。。。放弃幻想吧。。。。。i2姐姐威武。。。。。。。",
      quote_user_id: "泡",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "kswl呜呜呜呜",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1215,
    user_face: "1215-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2023-01-01 01:13:28 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1216,
    user_face: "1216-user-face.png",
    user_id: "沉默如海",
    is_op: false,
    create_at: "2023-01-01 01:15:19 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1217,
    user_face: "1217-user-face.png",
    user_id: "吃口蛋挞🧁",
    is_op: false,
    create_at: "2023-01-01 01:15:53 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "两个疯子谈恋爱。。。渴死我了😍😍",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "24",
  },
  {
    id: 1218,
    user_face: "1218-user-face.png",
    user_id: "沉默如海",
    is_op: false,
    create_at: "2023-01-01 01:40:24 湖北",
    quote: {
      quote_status: true,
      quote_content:
        "我草没嗑过的。。。渴死了。。。。啊啊啊啊啊。。。。💙果然是爹系男友。。。有这么爱吗。。。。。",
      quote_user_id: "嘻嘻",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "🐎",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1219,
    user_face: "1219-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2023-01-01 02:24:06 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1220,
    user_face: "1220-user-face.png",
    user_id: "honeyduchess",
    is_op: false,
    create_at: "2023-01-01 02:38:19 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑到了。。。2023。。。大吃一口。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "10",
  },
  {
    id: 1221,
    user_face: "1221-user-face.png",
    user_id: "Oblivion",
    is_op: false,
    create_at: "2023-01-01 03:20:22 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚狠好🥹",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 1222,
    user_face: "1222-user-face.png",
    user_id: "八倍手枪",
    is_op: false,
    create_at: "2023-01-01 03:45:34 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1223,
    user_face: "1223-user-face.png",
    user_id: "奶油er",
    is_op: false,
    create_at: "2023-01-01 03:46:39 江西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1224,
    user_face: "1224-user-face.png",
    user_id: "原田实（拖稿版",
    is_op: false,
    create_at: "2023-01-01 04:21:18 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "第一次磕到ky。。。。。太好嗑了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "12",
  },
  {
    id: 1225,
    user_face: "1225-user-face.png",
    user_id: "NobodyCares",
    is_op: false,
    create_at: "2023-01-01 04:26:56 湖北",
    quote: {
      quote_status: true,
      quote_content:
        "https://m.weibo.cn/6514786758/4248385495529369\n氮气事件。。。那种感觉。。。哥哥们审判审判我朋友的。。。儿媳妇吧。。。真的很会勾引nan人哦💙💚。。。",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "浅浅的…",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1226,
    user_face: "1226-user-face.png",
    user_id: "卧看星河尽意明",
    is_op: false,
    create_at: "2023-01-01 10:23:50 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "尊重祝福",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1227,
    user_face: "1227-user-face.png",
    user_id: "黄乐荣（当1中",
    is_op: false,
    create_at: "2023-01-01 10:26:45 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "尊重",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1228,
    user_face: "1228-user-face.png",
    user_id: "年度报告",
    is_op: false,
    create_at: "2023-01-01 10:51:20 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "狠狠磕到了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1229,
    user_face: "1229-user-face.png",
    user_id: "沉迷于此",
    is_op: false,
    create_at: "2023-01-01 11:16:02 甘肃",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1230,
    user_face: "1230-user-face.png",
    user_id: "食Kusa",
    is_op: false,
    create_at: "2023-01-01 11:22:04 河北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "磕鼠。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1231,
    user_face: "1231-user-face.png",
    user_id: "Mint",
    is_op: false,
    create_at: "2023-01-01 11:39:38 北京",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1232,
    user_face: "1232-user-face.png",
    user_id: "月亮也为你心动",
    is_op: false,
    create_at: "2023-01-01 12:26:34 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "kswl。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 1233,
    user_face: "1233-user-face.png",
    user_id: "匿名",
    is_op: false,
    create_at: "2023-01-01 14:36:38 美国",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "唯粉按头嗑，不得不嗑。。。还有之前hr写的那个长贴，越看越真。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "39",
  },
  {
    id: 1234,
    user_face: "1234-user-face.png",
    user_id: "你好我叫什么？",
    is_op: false,
    create_at: "2023-01-01 15:06:02 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "多云🤤😭",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1235,
    user_face: "1235-user-face.png",
    user_id: "格林赛茵",
    is_op: false,
    create_at: "2023-01-01 16:52:32 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "还有没有更新。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "5",
  },
  {
    id: 1236,
    user_face: "1236-user-face.png",
    user_id: "江瑚骗子",
    is_op: false,
    create_at: "2023-01-01 17:32:20 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚😋",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1237,
    user_face: "1237-user-face.png",
    user_id: "野原丸之助",
    is_op: false,
    create_at: "2023-01-01 19:12:40 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "看完了 太好嗑了 狠狠磕到",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "8",
  },
  {
    id: 1238,
    user_face: "1238-user-face.png",
    user_id: "一颗桃（很积极",
    is_op: false,
    create_at: "2023-01-01 22:49:33 浙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "渴死我了。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1239,
    user_face: "1239-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2023-01-01 22:54:33 湖北",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "感觉这俩年龄大了糊了后会双双过上自由相守的小日子。。。。三字虽然女友粉多，但是没有男友感。。。只在二字面前有。。。谁懂。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "158",
  },
  {
    id: 1240,
    user_face: "1240-user-face.png",
    user_id: "懒羊羊（减肥中",
    is_op: false,
    create_at: "2023-01-01 23:07:15 河南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "先🐴一个",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1241,
    user_face: "1241-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2023-01-01 23:19:42 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "好好嗑💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "3",
  },
  {
    id: 1242,
    user_face: "1242-user-face.png",
    user_id: "i恋爱禁区",
    is_op: false,
    create_at: "2023-01-02 02:01:37 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "还有周迅阿雅当时。。。。和2那个节目。。。。。那段讲话2真的是。。。。。。就差把自己是给子说出来了。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "80",
  },
  {
    id: 1243,
    user_face: "1243-user-face.png",
    user_id: "i恋爱禁区",
    is_op: false,
    create_at: "2023-01-02 02:02:29 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "还有啥来着。。。2自己手机壁纸。。。把原本是红色的真爱与自由。。。。p成蓝色了。。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "71",
  },
  {
    id: 1244,
    user_face: "1244-user-face.png",
    user_id: "夏天不是读书天",
    is_op: false,
    create_at: "2023-01-02 02:09:27 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1245,
    user_face: "1245-user-face.png",
    user_id: "果果字",
    is_op: false,
    create_at: "2023-01-02 03:31:16 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "【【凯源/y白】所以那些可能的都会是真的-哔哩哔哩】 https://b23.tv/z4fpZaY  组外哥哥投稿的。。。感兴趣y白的哥哥们可以看下",
      quote_user_id: "omom",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "💙💚",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 1246,
    user_face: "1246-user-face.png",
    user_id: "穿梭星海",
    is_op: false,
    create_at: "2023-01-03 00:44:53 四川",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "my i3闺蜜很久之前就对此表示，虽然隐隐约约有怀疑，但是作为妈粉和事业粉不磕也不骂，希望他脑子清醒一点，走好自己的路，路上能有人陪也不错😅",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "30",
  },
  {
    id: 1247,
    user_face: "1247-user-face.png",
    user_id: "🌙🌙🌙",
    is_op: false,
    create_at: "2023-01-03 00:51:24 重庆",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1248,
    user_face: "1248-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2023-01-03 00:52:32 山东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "🐴",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1249,
    user_face: "1249-user-face.png",
    user_id: "小菜咕噜噜",
    is_op: false,
    create_at: "2023-01-03 00:53:55 北京",
    quote: {
      quote_status: true,
      quote_content:
        "还有周迅阿雅当时。。。。和2那个节目。。。。。那段讲话2真的是。。。。。。就差把自己是给子说出来了。。。。。",
      quote_user_id: "i恋爱禁区",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content:
        "为哥哥补充这段对话，\nay:你有想几岁当爸爸吗?做爸爸这件事以你目前20岁来说你是觉得一定会发生还是觉得也不一定\nzx:不一定!\n2:反正我肯定是喜欢女生，但是，但是其他的我就不知道了\nay:你是说你会想要一个女儿还是说你是想要一定会想要交一个女朋友\n2:这个我不知道，但是我觉得如果是我的话我会比较喜欢小女孩吧 我 只知道这个\nzx:要不就一儿一女都有了\n（周迅一直意味不明的笑。。。还有斩钉截铁的说不一定。。。有点东西。。。而且2全程慌张摸头发哈哈哈。。。）",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "55",
  },
  {
    id: 1250,
    user_face: "1250-user-face.png",
    user_id: "游人",
    is_op: false,
    create_at: "2023-01-03 00:55:05 江苏",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑死",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1251,
    user_face: "1251-user-face.png",
    user_id: "快乐小孩哈哈哈",
    is_op: false,
    create_at: "2023-01-03 01:13:14 安徽",
    quote: {
      quote_status: true,
      quote_content:
        "还有周迅阿雅当时。。。。和2那个节目。。。。。那段讲话2真的是。。。。。。就差把自己是给子说出来了。。。。。",
      quote_user_id: "i恋爱禁区",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "沃趣那是什么节目",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1252,
    user_face: "1252-user-face.png",
    user_id: "🌙🌙🌙",
    is_op: false,
    create_at: "2023-01-03 01:18:55 重庆",
    quote: {
      quote_status: true,
      quote_content: "",
      quote_user_id: "momo",
      quote_img: {
        quote_img_status: true,
        is_gif: true,
        quote_img_src: "1252-quote.png",
      },
    },
    cmt: {
      cmt_content: "我擦。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1253,
    user_face: "1253-user-face.png",
    user_id: "心平气和",
    is_op: false,
    create_at: "2023-01-03 01:20:28 山东",
    quote: {
      quote_status: true,
      quote_content: "我擦。。",
      quote_user_id: "🌙🌙🌙",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "三根本没碰到二吧",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "10",
  },
  {
    id: 1254,
    user_face: "1254-user-face.png",
    user_id: "momo",
    is_op: false,
    create_at: "2023-01-03 01:58:13 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "lz记得存档。。。 我还没看完🥹",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1255,
    user_face: "1255-user-face.png",
    user_id: "琪可",
    is_op: false,
    create_at: "2023-01-03 01:58:35 江苏",
    quote: {
      quote_status: true,
      quote_content:
        "为哥哥补充这段对话，\nay:你有想几岁当爸爸吗?做爸爸这件事以你目前20岁来说你是觉得一定会发生还是觉得也不一定\nzx:不一定!\n2:反正我肯定是喜欢女生，但是，但是其他的我就不知道了\nay:你是说你会想要一个女儿还是说你是想要一定会想要交一个女朋友\n2:这个我不知道，但是我觉得如果是我的话我会比较喜欢小女孩吧 我 只知道这个\nzx:要不就一儿一女都有了\n（周迅一直意味不明的笑。。。还有斩钉截铁的说不一定。。。有点东西。。。而且2全程慌张摸头发哈哈哈。。。）",
      quote_user_id: "小菜咕噜噜",
      quote_img: {
        quote_img_status: false,
      },
    },
    cmt: {
      cmt_content: "深夜嗑别有趣味……",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "10",
  },
  {
    id: 1256,
    user_face: "1256-user-face.png",
    user_id: "已注销",
    is_op: false,
    create_at: "2023-01-03 02:47:49 广东",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content:
        "周迅那个节目我知道，二字主动提起说要克制自己不要陷入爱情，周迅都吓到了，我也咯噔了，偶像可以自己直接说的吗😂",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "50",
  },
  {
    id: 1257,
    user_face: "1257-user-face.png",
    user_id: "草莓味",
    is_op: false,
    create_at: "2023-01-03 10:44:08 湖南",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑一下。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "",
  },
  {
    id: 1258,
    user_face: "1258-user-face.png",
    user_id: "偷偷冒泡",
    is_op: false,
    create_at: "2023-01-03 12:14:10 辽宁",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "嗑。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1259,
    user_face: "1259-user-face.png",
    user_id: "煲仔小肥羊",
    is_op: false,
    create_at: "2023-01-03 14:12:56 福建",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "永远热恋。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1260,
    user_face: "1260-user-face.png",
    user_id: "o舆~",
    is_op: false,
    create_at: "2023-01-03 14:30:12 上海",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "我破防了",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "2",
  },
  {
    id: 1261,
    user_face: "1261-user-face.png",
    user_id: "夜神月",
    is_op: false,
    create_at: "2023-01-03 16:13:43 黑龙江",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "偶也需要同居领磕。。这对我很重要😢😢😢",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "7",
  },
  {
    id: 1262,
    user_face: "1262-user-face.png",
    user_id: "空空（在烦",
    is_op: false,
    create_at: "2023-01-03 18:40:02 陕西",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "窝终于。。。看完了。。。渴死窝了。。。。",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
  {
    id: 1263,
    user_face: "1263-user-face.png",
    user_id: "吃口蛋挞🧁",
    is_op: false,
    create_at: "2023-01-03 19:01:41 安徽",
    quote: {
      quote_status: false,
    },
    cmt: {
      cmt_content: "又来磕了🤤🤤",
      cmt_img: {
        cmt_img_status: false,
      },
    },
    like_cnt: "1",
  },
];
